webpackJsonp([9],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.API_ResetPwEn = exports.API__DailyStatistic = exports.API__Position = exports.API__common = exports.API_ActivityWarn = exports.API_Integral = exports.API_Man = exports.API_Stat = exports.API_control = exports.API_userCom = exports.API_Auth = exports.API_AIRilab = exports.API_Order = exports.API_Product = exports.API_Urls = exports.API_Menu = exports.API_User = exports.API_Admin = exports.API_Models = exports.API_Common = exports.API_trial = exports.API__account = exports.API__basic = exports.API__login = exports.imgURLs = exports.API__code = undefined;

var _promise = __webpack_require__(415);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _jsCookie = __webpack_require__(360);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _elementUi = __webpack_require__(403);

var _upload = __webpack_require__(932);

var _upload2 = _interopRequireDefault(_upload);

var _login = __webpack_require__(922);

var _login2 = _interopRequireDefault(_login);

var _product = __webpack_require__(928);

var _product2 = _interopRequireDefault(_product);

var _account = __webpack_require__(914);

var _account2 = _interopRequireDefault(_account);

var _trial = __webpack_require__(931);

var _trial2 = _interopRequireDefault(_trial);

var _common = __webpack_require__(919);

var _common2 = _interopRequireDefault(_common);

var _models = __webpack_require__(925);

var _models2 = _interopRequireDefault(_models);

var _admin = __webpack_require__(916);

var _admin2 = _interopRequireDefault(_admin);

var _user = __webpack_require__(934);

var _user2 = _interopRequireDefault(_user);

var _menu = __webpack_require__(924);

var _menu2 = _interopRequireDefault(_menu);

var _urls = __webpack_require__(933);

var _urls2 = _interopRequireDefault(_urls);

var _order = __webpack_require__(926);

var _order2 = _interopRequireDefault(_order);

var _AIRilab = __webpack_require__(912);

var _AIRilab2 = _interopRequireDefault(_AIRilab);

var _authorize = __webpack_require__(917);

var _authorize2 = _interopRequireDefault(_authorize);

var _userCom = __webpack_require__(935);

var _userCom2 = _interopRequireDefault(_userCom);

var _Management = __webpack_require__(913);

var _Management2 = _interopRequireDefault(_Management);

var _statistics = __webpack_require__(930);

var _statistics2 = _interopRequireDefault(_statistics);

var _manage = __webpack_require__(923);

var _manage2 = _interopRequireDefault(_manage);

var _integral = __webpack_require__(921);

var _integral2 = _interopRequireDefault(_integral);

var _activityWarn = __webpack_require__(915);

var _activityWarn2 = _interopRequireDefault(_activityWarn);

var _basic = __webpack_require__(918);

var _basic2 = _interopRequireDefault(_basic);

var _positionApi = __webpack_require__(927);

var _positionApi2 = _interopRequireDefault(_positionApi);

var _dailyStatistics = __webpack_require__(920);

var _dailyStatistics2 = _interopRequireDefault(_dailyStatistics);

var _resetPwEn = __webpack_require__(929);

var _resetPwEn2 = _interopRequireDefault(_resetPwEn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API__code = {
  SUCCESS: "200",
  ERROR401: "401",
  LOGONEXPIRES: "403",
  ERROR500: "500",
  NOAUTH: "505" };

_axios2.default.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

_axios2.default.interceptors.request.use(function (config) {
  var meta = config.meta || {};
  var token = _jsCookie2.default.get("dnnyptadmin_token");
  var checkCode = _jsCookie2.default.get("dnnyptadmin_checkCode");
  config.params = {
    token: token,
    checkCode: checkCode
  };

  if (config.method === "post" && meta.isSerialize === true) {
    config.data = serialize(config.data);
  }
  return config;
}, function (error) {
  return _promise2.default.reject(error);
});

_axios2.default.interceptors.response.use(function (res) {
  if (res.data.code == API__code.LOGONEXPIRES) {
    location.replace("/loginAdmin");
  }

  return res;
}, function (error) {
  return _promise2.default.reject(error);
});

var imgURLs = "http://106.14.238.88:8080/dnnCloud/";
exports.API__code = API__code;
exports.imgURLs = imgURLs;
exports.API__login = _login2.default;
exports.API__basic = _upload2.default;
exports.API__account = _account2.default;
exports.API_trial = _trial2.default;
exports.API_Common = _common2.default;
exports.API_Models = _models2.default;
exports.API_Admin = _admin2.default;
exports.API_User = _user2.default;
exports.API_Menu = _menu2.default;
exports.API_Urls = _urls2.default;
exports.API_Product = _product2.default;
exports.API_Order = _order2.default;
exports.API_AIRilab = _AIRilab2.default;
exports.API_Auth = _authorize2.default;
exports.API_userCom = _userCom2.default;
exports.API_control = _Management2.default;
exports.API_Stat = _statistics2.default;
exports.API_Man = _manage2.default;
exports.API_Integral = _integral2.default;
exports.API_ActivityWarn = _activityWarn2.default;
exports.API__common = _basic2.default;
exports.API__Position = _positionApi2.default;
exports.API__DailyStatistic = _dailyStatistics2.default;
exports.API_ResetPwEn = _resetPwEn2.default;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var imgURL, posUrl, wsURL;
var online = 'https://sea.dnnbim.com/dev/dnnCloud/interface';
var baseURL = online;
if (false) {

  exports.baseURL = baseURL = "/api";
} else if (false) {
  exports.baseURL = baseURL = "http://61.132.52.38:8001/dnnCloud/interface";
} else {
  baseURL == "https://sea.dnnbim.com/dev/dnnCloud/interface";
}
exports.baseURL = baseURL;
exports.wsURL = wsURL;
exports.imgURL = imgURL;

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1475)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(1714),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      maxTbHeight: 100
    };
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.setTableHeight);
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.setTableHeight();
    }, 100);
    window.addEventListener('resize', this.setTableHeight);
  },


  methods: {
    setTableHeight: function setTableHeight(extraHeight) {
      var viewBdH = document.querySelector("#app .base-container").clientHeight;
      var toolH = document.querySelector("#app .base-container .base-container-bd .content-hd").clientHeight;
      var theadH = document.querySelector("#app .base-container .base-container-bd .el-table__header-wrapper").clientHeight;
      this.maxTbHeight = viewBdH - toolH - 49 - 35;
      console.log('this.maxTbHeight==', this.maxTbHeight);
    }
  }

};

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1544)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(1769),
  /* scopeId */
  "data-v-aeec9f52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    },

    getCookie: function getCookie() {
        var loginPhone = "";
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; ');
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('=');
                if (arr2[0] == 'zsjty_phone') {
                    loginPhone = arr2[1];
                }
            }
        }
        return loginPhone;
    },

    getNowTime: function getNowTime() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth() + 1;
        var day = now.getDate();
        var hh = now.getHours();
        var mm = now.getMinutes();
        var ss = now.getSeconds();
        var clock = year + "-";

        if (month < 10) clock += "0";
        clock += month + "-";
        if (day < 10) clock += "0";
        clock += day + " ";

        return clock;
    },
    formatDateGu: function formatDateGu(cellval) {
        var dateVal = cellval + "";
        if (cellval != null) {
            var date = new Date(cellval);
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

            var returnDate = date.getFullYear() + "-" + month + "-" + currentDate;

            return returnDate;
        }
    },
    formatDateHMS: function formatDateHMS(cellval) {
        var dateVal = cellval + "";
        if (cellval != null) {
            var date = new Date(cellval);
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

            var returnDate = hours + ":" + minutes + ":" + seconds;

            return returnDate;
        }
    },

    getParamsByCookie: function getParamsByCookie() {
        var cookieInfo = {};
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; ');
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('=');
                if (arr2[0] == 'dnnyptadmin_token') {
                    cookieInfo.token = arr2[1];
                } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                    cookieInfo.checkCode = arr2[1];
                } else if (arr2[0] == 'dnnyptadmin_id') {
                    cookieInfo.id = arr2[1];
                }
            }
        }
        return cookieInfo;
    }

};

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1548)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(844),
  /* template */
  __webpack_require__(1772),
  /* scopeId */
  "data-v-dc814d08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1536)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(843),
  /* template */
  __webpack_require__(1761),
  /* scopeId */
  "data-v-7e3a0b60",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUser = exports.editUser = exports.batchRemoveUser = exports.removeUser = exports.getUserListPage = exports.getUserList = exports.requestLogin = undefined;

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = '';

var requestLogin = exports.requestLogin = function requestLogin(params) {
  return _axios2.default.post(base + '/login', params).then(function (res) {
    return res.data;
  });
};

var getUserList = exports.getUserList = function getUserList(params) {
  return _axios2.default.get(base + '/user/list', { params: params });
};

var getUserListPage = exports.getUserListPage = function getUserListPage(params) {
  return _axios2.default.get(base + '/user/listpage', { params: params });
};

var removeUser = exports.removeUser = function removeUser(params) {
  return _axios2.default.get(base + '/user/remove', { params: params });
};

var batchRemoveUser = exports.batchRemoveUser = function batchRemoveUser(params) {
  return _axios2.default.get(base + '/user/batchremove', { params: params });
};

var editUser = exports.editUser = function editUser(params) {
  return _axios2.default.get(base + '/user/edit', { params: params });
};

var addUser = exports.addUser = function addUser(params) {
  return _axios2.default.get(base + '/user/add', { params: params });
};

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1506)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(1741),
  /* scopeId */
  "data-v-55e231ff",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1477)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(883),
  /* template */
  __webpack_require__(1716),
  /* scopeId */
  "data-v-0fe42602",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1525)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(1753),
  /* scopeId */
  "data-v-72d1b936",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1541)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(845),
  /* template */
  __webpack_require__(1766),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1492)
__webpack_require__(1491)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(869),
  /* template */
  __webpack_require__(1728),
  /* scopeId */
  "data-v-2d0b8168",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1505)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(875),
  /* template */
  __webpack_require__(1740),
  /* scopeId */
  "data-v-53d17496",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1489)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(1726),
  /* scopeId */
  "data-v-25043029",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1526)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(887),
  /* template */
  __webpack_require__(1754),
  /* scopeId */
  "data-v-744b4f43",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1550)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(891),
  /* template */
  __webpack_require__(1774),
  /* scopeId */
  "data-v-e2547238",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1481)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(892),
  /* template */
  __webpack_require__(1720),
  /* scopeId */
  "data-v-1776f28a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1521)
__webpack_require__(1522)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(1751),
  /* scopeId */
  "data-v-6f53518a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1479)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(894),
  /* template */
  __webpack_require__(1718),
  /* scopeId */
  "data-v-15899b08",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1502)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(1737),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slideVerify = __webpack_require__(1656);

var _slideVerify2 = _interopRequireDefault(_slideVerify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = {
    install: function install(Vue) {
        Vue.component(_slideVerify2.default.name, _slideVerify2.default);
    }
};

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(_slideVerify2.default);
}

exports.default = plugins;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(1659);

var _Login2 = _interopRequireDefault(_Login);

var _Forget = __webpack_require__(1658);

var _Forget2 = _interopRequireDefault(_Forget);

var _Register = __webpack_require__(1662);

var _Register2 = _interopRequireDefault(_Register);

var _RegisterEn = __webpack_require__(1663);

var _RegisterEn2 = _interopRequireDefault(_RegisterEn);

var _ = __webpack_require__(1657);

var _2 = _interopRequireDefault(_);

var _Main = __webpack_require__(1661);

var _Main2 = _interopRequireDefault(_Main);

var _LoginAdmin = __webpack_require__(1660);

var _LoginAdmin2 = _interopRequireDefault(_LoginAdmin);

var _Account = __webpack_require__(1668);

var _Account2 = _interopRequireDefault(_Account);

var _Company = __webpack_require__(1669);

var _Company2 = _interopRequireDefault(_Company);

var _UserCom = __webpack_require__(1670);

var _UserCom2 = _interopRequireDefault(_UserCom);

var _userDetail = __webpack_require__(1679);

var _userDetail2 = _interopRequireDefault(_userDetail);

var _moduleDetail = __webpack_require__(1693);

var _moduleDetail2 = _interopRequireDefault(_moduleDetail);

var _moduleUserDetail = __webpack_require__(1694);

var _moduleUserDetail2 = _interopRequireDefault(_moduleUserDetail);

var _Admin = __webpack_require__(1680);

var _Admin2 = _interopRequireDefault(_Admin);

var _Module = __webpack_require__(1696);

var _Module2 = _interopRequireDefault(_Module);

var _Menu = __webpack_require__(1695);

var _Menu2 = _interopRequireDefault(_Menu);

var _Urls = __webpack_require__(1703);

var _Urls2 = _interopRequireDefault(_Urls);

var _ProductList = __webpack_require__(1702);

var _ProductList2 = _interopRequireDefault(_ProductList);

var _Management = __webpack_require__(1667);

var _Management2 = _interopRequireDefault(_Management);

var _OrderList = __webpack_require__(1701);

var _OrderList2 = _interopRequireDefault(_OrderList);

var _OrderAdd = __webpack_require__(1698);

var _OrderAdd2 = _interopRequireDefault(_OrderAdd);

var _OrderEdit = __webpack_require__(1700);

var _OrderEdit2 = _interopRequireDefault(_OrderEdit);

var _OrderDetail = __webpack_require__(1699);

var _OrderDetail2 = _interopRequireDefault(_OrderDetail);

var _AIRilab = __webpack_require__(1666);

var _AIRilab2 = _interopRequireDefault(_AIRilab);

var _exchange = __webpack_require__(1707);

var _exchange2 = _interopRequireDefault(_exchange);

var _query = __webpack_require__(1706);

var _query2 = _interopRequireDefault(_query);

var _userIntegral = __webpack_require__(1708);

var _userIntegral2 = _interopRequireDefault(_userIntegral);

var _AuthorizeList = __webpack_require__(1682);

var _AuthorizeList2 = _interopRequireDefault(_AuthorizeList);

var _ComorizeList = __webpack_require__(1683);

var _ComorizeList2 = _interopRequireDefault(_ComorizeList);

var _ApplyTrial = __webpack_require__(1681);

var _ApplyTrial2 = _interopRequireDefault(_ApplyTrial);

var _targetCustom = __webpack_require__(1678);

var _targetCustom2 = _interopRequireDefault(_targetCustom);

var _probationCustom = __webpack_require__(1675);

var _probationCustom2 = _interopRequireDefault(_probationCustom);

var _officialCustom = __webpack_require__(1674);

var _officialCustom2 = _interopRequireDefault(_officialCustom);

var _probationView = __webpack_require__(1676);

var _probationView2 = _interopRequireDefault(_probationView);

var _officalView = __webpack_require__(1673);

var _officalView2 = _interopRequireDefault(_officalView);

var _ResetPassword = __webpack_require__(1664);

var _ResetPassword2 = _interopRequireDefault(_ResetPassword);

var _ResetPasswordYn = __webpack_require__(1665);

var _ResetPasswordYn2 = _interopRequireDefault(_ResetPasswordYn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
  path: "/loginAdmin",
  component: _LoginAdmin2.default,
  name: "",
  hidden: true
}, {
  path: "/register",
  component: _RegisterEn2.default,
  name: "",
  hidden: true
}, {
  path: "/forget1",
  component: _ResetPasswordYn2.default,
  name: "",
  hidden: true
}, {
  path: "/forget",
  component: _ResetPassword2.default,
  name: "",
  hidden: true
}, {
  path: "/404",
  component: _2.default,
  name: "",
  hidden: true
}, {
  path: "/",
  component: function component() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1820));
  },
  name: "我的产品",


  children: [{
    path: "dailyStatistics",
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1822));
    },
    name: "日活统计",
    meta: {
      requireAuth: true
    }
  }, {
    path: "enterLoadIndex",
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1823));
    },
    name: "企业负载率指标",
    meta: {
      requireAuth: true
    }
  }, {
    path: "activityWarn",
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1821));
    },
    name: "活跃度预警",
    meta: {
      requireAuth: true
    }
  }, {
    path: "moduleIntegral",
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1825));
    },
    name: "模块积分统计",
    meta: {
      requireAuth: true
    }
  }, {
    path: "integralStatistics",
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1824));
    },
    name: "积分统计",
    meta: {
      requireAuth: true
    }
  }, {
    path: "salesWall",
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1826));
    },
    name: "销售挂图",
    meta: {
      requireAuth: true
    }
  }, {
    path: "userStatistics",
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1827));
    },
    name: "用户统计",
    meta: {
      requireAuth: true
    }
  }, {
    path: "management",
    component: _Management2.default,
    name: "控制台",
    meta: {
      requireAuth: true
    }
  }, {
    path: "module",
    component: _Module2.default,
    name: "模块管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "productList",
    component: _ProductList2.default,
    name: "产品管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "authorizeList",
    component: _AuthorizeList2.default,
    name: "个人产品",
    meta: {
      requireAuth: true
    }
  }, {
    path: "comorizeList",
    component: _ComorizeList2.default,
    name: "企业产品",
    meta: {
      requireAuth: true
    }
  }, {
    path: "exchange",
    component: _exchange2.default,
    name: "积分兑换",
    meta: {
      requireAuth: true
    }
  }, {
    path: "credits",
    component: _query2.default,
    name: "积分查询",
    meta: {
      requireAuth: true
    }
  }, {
    path: "AIRilab",
    component: _AIRilab2.default,
    name: "AI效果图管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "userIntegral",
    component: _userIntegral2.default,
    name: "用户积分明细",
    meta: {
      requireAuth: true
    }
  }, {
    path: "orderList",
    component: _OrderList2.default,
    name: "订单管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "orderAdd",
    component: _OrderAdd2.default,
    name: "新增订单",
    meta: {
      requireAuth: true
    }
  }, {
    path: "orderDetail",
    component: _OrderDetail2.default,
    name: "订单详情",
    meta: {
      requireAuth: true
    }
  }, {
    path: "orderEdit",
    component: _OrderEdit2.default,
    name: "编辑订单",
    meta: {
      requireAuth: true
    }
  }, {
    path: "admin",
    component: _Admin2.default,
    name: "管理员管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "account",
    component: _Account2.default,
    name: "用户管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "targetCustom",
    component: _targetCustom2.default,
    name: "目标客户池",
    meta: {
      requireAuth: true
    }
  }, {
    path: "probationCustom",
    component: _probationCustom2.default,
    name: "试用客户管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "officialCustom",
    component: _officialCustom2.default,
    name: "正式客户管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "company",
    component: _Company2.default,
    name: "企业管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "userCom",
    component: _UserCom2.default,
    name: "客户管理",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "probationView",
    component: _probationView2.default,
    name: "客户管理",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "officalView",
    component: _officalView2.default,
    name: "客户管理",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "userDetail",
    component: _userDetail2.default,
    name: "用户详情",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "moduleDetail",
    component: _moduleDetail2.default,
    name: "模块积分统计",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "moduleUserDetail",
    component: _moduleUserDetail2.default,
    name: "模块积分统计",
    hidden: true,
    meta: {
      requireAuth: true
    }
  }, {
    path: "menu",
    component: _Menu2.default,
    name: "软件类型",
    meta: {
      requireAuth: true
    }
  }, {
    path: "urls",
    component: _Urls2.default,
    name: "系统管理",
    meta: {
      requireAuth: true
    }
  }, {
    path: "applyTrial",
    component: _ApplyTrial2.default,
    name: "试用申请",
    meta: {
      requireAuth: true
    }
  }]
}, { path: "*", redirect: "/" }];

exports.default = routes;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(49);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(20);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);
var userInfoStr = localStorage.getItem("dnn_dnnCloud_admin_userInfo");
exports.default = new _vuex2.default.Store({
    state: {
        token: '',
        userInfo: userInfoStr ? JSON.parse(userInfoStr) : '',
        opened: true },

    getters: {
        userInfo: function userInfo(state) {
            return state.userInfo || (localStorage.getItem("dnn_dnnCloud_admin_userInfo") ? JSON.parse(localStorage.getItem("dnn_dnnCloud_admin_userInfo")) : '');
        },
        opened: function opened(state) {
            return state.opened;
        }
    },

    mutations: {
        set__token: function set__token(state, token) {
            state.token = token;
            sessionStorage.token = token;
        },
        del__token: function del__token(state) {
            state.token = '';
            sessionStorage.removeItem('token');
        },
        set__userinfo: function set__userinfo(state, userInfo) {
            state.userInfo = userInfo;
            localStorage.setItem("dnn_dnnCloud_admin_userInfo", (0, _stringify2.default)(userInfo));
        },
        toggle__SideBar: function toggle__SideBar(state) {
            console.log('state==', state);
            state.opened = !state.opened;
            console.log('state.opened==', state.opened);
        }
    }
});

/***/ }),
/* 791 */,
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */,
/* 798 */,
/* 799 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1556)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(841),
  /* template */
  __webpack_require__(1779),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 800 */,
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drawIcon = exports.changeMapSize = exports.toLonLat_ = exports.rewritePos = exports.addPoint = exports.addDrawPoint = exports.addProvinceVector = exports.addCricle = exports.Load_Map = exports.sendThis = undefined;

__webpack_require__(1467);

var _Map = __webpack_require__(680);

var _Map2 = _interopRequireDefault(_Map);

var _View = __webpack_require__(266);

var _View2 = _interopRequireDefault(_View);

var _Vector = __webpack_require__(187);

var _Vector2 = _interopRequireDefault(_Vector);

var _layer = __webpack_require__(1600);

var _coordinate = __webpack_require__(63);

var _Projection = __webpack_require__(219);

var _Projection2 = _interopRequireDefault(_Projection);

var _XYZ = __webpack_require__(736);

var _XYZ2 = _interopRequireDefault(_XYZ);

var _OSM = __webpack_require__(1627);

var _OSM2 = _interopRequireDefault(_OSM);

var _Feature = __webpack_require__(158);

var _Feature2 = _interopRequireDefault(_Feature);

var _geom = __webpack_require__(693);

var _style = __webpack_require__(739);

var _proj = __webpack_require__(18);

var _control = __webpack_require__(686);

var _Overlay = __webpack_require__(683);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _interaction = __webpack_require__(700);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _this = null;
var iMap = null;
var radius = 1;
var scale = 0.5;
var vectorSource = void 0,
    vectorLayer = void 0,
    element = void 0,
    popup = void 0,
    provinceSorce = void 0,
    provinLayer = void 0;

function sendThis(vm) {
  _this = vm;
}

function Load_Map(param) {
  iMap = null;
  var map = document.getElementById('map');
  map.innerHTML = '';
  var layer = new _layer.Tile({
    source: new _OSM2.default({
      url: param.photography ? "https://webst02.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}" : 'https://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}',
      crossOrigin: 'anonymous'
    })
  });
  vectorSource = new _Vector2.default();
  vectorLayer = new _layer.Vector({
    source: vectorSource
  });
  provinceSorce = new _Vector2.default();
  provinLayer = new _layer.Vector({
    source: provinceSorce
  });
  var mappParma = {
    zoom: 4.666666666666667,
    mapCenter: [109.5, 34.52]
  };
  if (param.mappParma) {
    mappParma = param.mappParma;
  }
  iMap = new _Map2.default({
    layers: [layer, provinLayer, vectorLayer],
    target: 'map',
    view: new _View2.default({
      projection: 'EPSG:3857',
      center: mappParma.mapCenter[0] > 200 ? mappParma.mapCenter : (0, _proj.fromLonLat)(mappParma.mapCenter),
      maxZoom: 22,
      minZoom: 3,
      zoom: mappParma.zoom
    })
  });
  if (param.popup) {
    element = document.getElementById('popup');
    element.innerHTML = '南京\r52个';
    popup = new _Overlay2.default({
      element: element,
      offset: [0, -12],
      positioning: 'bottom-center'
    });
    iMap.addOverlay(popup);

    iMap.on('pointermove', MapPointerMove);
    iMap.on('moveend', mapMoved);
    iMap.on('singleclick', MapPointerClickOpen);
  }
}

function addCricle(dataJson) {
  vectorSource.clear();
  dataJson.forEach(function (el) {
    var coordinate = [Number(el.longitudeAndLatitude.split(',')[0]), Number(el.longitudeAndLatitude.split(',')[1])];
    var feature = new _Feature2.default({
      geometry: new _geom.Point([coordinate[0] + (Math.floor(Math.random() * (1000 - 1) + 1) - 500) * 0.1, coordinate[1] + (Math.floor(Math.random() * (1000 - 1) + 1) - 500) * 0.1])
    });
    feature.set('radius', 10 / el.grade);
    feature.set('value', el.cou);
    feature.set('name', el.companyName);
    feature.set('_type', 'vector');
    feature.set('grade', el.grade);
    feature.set('compayId', el.id);
    var custom;
    if (el.grade == 1) {
      custom = '../../../../static/img/customer1.svg';
    } else if (el.grade == 5) {
      custom = '../../../../static/img/customer3.svg';
    } else {
      custom = '../../../../static/img/customer2.svg';
    }
    feature.setStyle([new _style.Style({
      image: new _style.Icon({
        scale: 0.5,
        src: custom
      })
    })]);
    vectorSource.addFeature(feature);
  });
}

function animation() {
  if (radius >= 40) {
    radius = 0;
  }
  var opacity = (40 - radius) / 40;
  var pointStyle = new _style.Style({
    image: new _style.Circle({
      fill: new _style.Fill({
        color: 'rgba(54,110,255,' + opacity + ')'
      }),
      radius: radius
    })
  });
  var features = vectorSource.getFeatures();
  features.forEach(function (element) {
    if (element.get('grade') == 1) {
      element.setStyle([pointStyle, new _style.Style({
        image: new _style.Circle({
          fill: new _style.Fill({
            color: 'rgba(54,110,255,0.5)'
          }),
          radius: 20
        })
      }), new _style.Style({
        image: new _style.Circle({
          fill: new _style.Fill({
            color: '#366EFF'
          }),
          stroke: new _style.Stroke({
            color: '#FFF',
            width: 2
          }),
          radius: 10
        })
      })]);
    }
  });

  radius = radius + 0.3;
  iMap.render();
}

function MapPointerMove(evt) {
  var pixel = iMap.getEventPixel(evt.originalEvent);
  var hit = iMap.hasFeatureAtPixel(pixel);
  if (hit) {
    var feature = iMap.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
      return feature;
    });
    if (feature) {
      if (feature.get('_type') == 'vector') {
        element.innerHTML = feature.get('name') + '\n' + feature.get('value') + '条';
        iMap.getTargetElement().style.cursor = 'pointer';
        popup.setPosition(feature.getGeometry().getCoordinates());
      } else {
        iMap.getTargetElement().style.cursor = '';
        popup.setPosition(undefined);
      }
    } else {
      iMap.getTargetElement().style.cursor = '';
    }
  } else {
    iMap.getTargetElement().style.cursor = '';
    popup.setPosition(undefined);
  }
}

function mapMoved(e) {
  var zoom = iMap.getView().getZoom();
  var features = vectorSource.getFeatures();
  if (zoom > 11) {
    if (scale != 11) {
      features.forEach(function (element) {
        var custom;
        if (element.get('grade') == 1) {
          custom = '../../../../static/img/customer1.svg';
        } else if (element.get('grade') == 5) {
          custom = '../../../../static/img/customer3.svg';
        } else {
          custom = '../../../../static/img/customer2.svg';
        }
        element.setStyle(new _style.Style({
          image: new _style.Icon({
            scale: 1,
            src: custom
          }),
          text: new _style.Text({
            font: 'bold 12px sans-serif',
            text: element.get('name'),
            textAlign: 'center',
            offsetY: 25,
            stroke: new _style.Stroke({
              color: 'white'
            }),
            fill: new _style.Fill({
              color: '#0079e9'
            })
          })
        }));
      });
      scale = 11;
    }
  } else if (zoom < 4) {
    if (scale != 4) {
      features.forEach(function (element) {
        var custom;
        if (element.get('grade') == 1) {
          custom = '../../../../static/img/customer1.svg';
        } else if (element.get('grade') == 5) {
          custom = '../../../../static/img/customer3.svg';
        } else {
          custom = '../../../../static/img/customer2.svg';
        }
        element.setStyle(new _style.Style({
          image: new _style.Icon({
            scale: 0.2,
            src: custom
          })
        }));
      });
      scale = 4;
    }
  } else {
    if (scale != 7) {
      features.forEach(function (element) {
        var custom;
        if (element.get('grade') == 1) {
          custom = '../../../../static/img/customer1.svg';
        } else if (element.get('grade') == 5) {
          custom = '../../../../static/img/customer3.svg';
        } else {
          custom = '../../../../static/img/customer2.svg';
        }
        element.setStyle(new _style.Style({
          image: new _style.Icon({
            scale: 0.5,
            src: custom
          })
        }));
      });
      scale = 7;
    }
  }
}

function MapPointerClickOpen(evt) {
  var pixel = iMap.getEventPixel(evt.originalEvent);
  var hit = iMap.hasFeatureAtPixel(pixel);
  if (hit) {
    var feature = iMap.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
      return feature;
    });
    if (feature) {
      _this.dataList = true;
      _this.queryList(feature.get('compayId'));
    }
  } else {
    _this.pageNumber = 1;
    _this.getTubiao(_this.param);
  }
}

function addProvinceVector() {
  var data = _this.provinceData.features;
  for (var i = 0; i < data.length; i++) {
    var _loop = function _loop(j) {
      var datajson = [];
      data[i]["geometry"]["coordinates"][j][0].forEach(function (item) {
        datajson.push((0, _proj.fromLonLat)(item));
      });
      feature = new _Feature2.default({
        geometry: new _geom.Polygon([datajson])

      });

      feature.setStyle(new _style.Style({
        stroke: new _style.Stroke({
          color: '#0066FF',
          width: 1
        }),
        fill: new _style.Fill({
          color: 'rgba(87, 124, 204, 0.2)'
        }),
        text: new _style.Text({
          font: '14px bold sans-serif',
          text: data[i]["properties"]["name"],
          fill: new _style.Fill({
            color: 'rgba(255,255,255,0.8)'
          }),
          stroke: new _style.Stroke({
            color: '#06798a',
            width: 0.5
          }),
          overflow: false
        })

      }));
      feature.set('_type', 'province');
      provinceSorce.addFeature(feature);
    };

    for (var j = 0; j < data[i]["geometry"]["coordinates"].length; j++) {
      var feature;

      _loop(j);
    }
  }
}

function addDrawPoint() {
  var _Draw = new _interaction.Draw({
    source: vectorSource,
    stopClick: true,
    type: 'Point'
  });
  iMap.addInteraction(_Draw);
  _Draw.on('drawend', function (evt) {
    var coordinate = evt.feature.getGeometry().getCoordinates();

    vectorSource.clear();
    var rome = new _Feature2.default({
      geometry: new _geom.Point(coordinate)
    });
    rome.setStyle(new _style.Style({
      image: new _style.Circle({
        fill: new _style.Fill({
          color: 'rgba(0,255,216,1)'
        }),
        radius: 10
      })
    }));
    vectorSource.addFeature(rome);
  });
}

function addPoint() {
  vectorSource.clear();
  if (_this.position != '') {
    if (_this.position[0] < 200) {
      _this.position = (0, _proj.fromLonLat)(_this.position);
    }
    var rome = new _Feature2.default({
      geometry: new _geom.Point(_this.position)
    });

    rome.setStyle(new _style.Style({
      image: new _style.Circle({
        fill: new _style.Fill({
          color: 'rgba(0,255,216,1)'
        }),
        radius: 10
      })
    }));
    vectorSource.addFeature(rome);
  }
}

function rewritePos(position) {
  _this.position = [(0, _proj.fromLonLat)(position)[0] - 724, (0, _proj.fromLonLat)(position)[1] - 724];

  iMap.getView().animate({
    center: _this.position,
    duration: 500
  });
  addPoint();
}

function lonLat2Mercator(lonlat) {
  var mercator = [];
  var earthRad = 6378137.0;
  mercator[0] = lonlat[0] * Math.PI / 180 * earthRad;
  var a = lonlat[1] * Math.PI / 180;
  mercator[1] = earthRad / 2 * Math.log((1.0 + Math.sin(a)) / (1.0 - Math.sin(a)));
  return mercator;
}

function toLonLat_(coordinate) {
  return (0, _proj.toLonLat)(coordinate);
}

function changeMapSize() {
  iMap.updateSize();
}

function drawIcon(coordinate, imageSrc, text, textStyle, offsetY, fillColor) {
  var pos;
  if (coordinate[0] < 200) {
    pos = (0, _proj.fromLonLat)(coordinate);
  } else {
    pos = coordinate;
  }
  var feature = new _Feature2.default({
    geometry: new _geom.Point(pos)
  });
  feature.setStyle(new _style.Style({
    image: new _style.Icon({
      color: '#BADA55',
      scale: 1,
      src: imageSrc
    }),
    text: new _style.Text({
      text: text,
      font: textStyle,
      textAlign: 'center',
      offsetY: offsetY,
      fill: new _style.Fill({
        color: fillColor
      })
    })
  }));
  provinceSorce.addFeature(feature);

  var room = new _Feature2.default({
    geometry: new _geom.Point(pos)
  });
  vectorSource.addFeature(room);
}

exports.sendThis = sendThis;
exports.Load_Map = Load_Map;
exports.addCricle = addCricle;
exports.addProvinceVector = addProvinceVector;
exports.addDrawPoint = addDrawPoint;
exports.addPoint = addPoint;
exports.rewritePos = rewritePos;
exports.toLonLat_ = toLonLat_;
exports.changeMapSize = changeMapSize;
exports.drawIcon = drawIcon;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1500)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(889),
  /* template */
  __webpack_require__(1735),
  /* scopeId */
  "data-v-46cf04cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	provide: function provide() {
		return {
			reload: this.reload
		};
	},
	data: function data() {
		return {
			isRouterAlive: true
		};
	},

	methods: {
		reload: function reload() {
			this.isRouterAlive = false;
			this.$nextTick(function () {
				this.isRouterAlive = true;
			});
		}
	},

	components: {}
};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "baseContainer",
  props: {
    isPageHd: {
      type: Boolean,
      default: false
    },
    isMainHd: {
      type: Boolean,
      default: true
    },

    isHasPageFt: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      loadingInstance: null
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo']), {
    getCurMenu: function getCurMenu() {
      return this.$route.name;
    }
  }),

  watch: {
    '$route': function $route() {}

  }

};

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    backRoute: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    param: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    getName: function getName() {
      return this.name == '' ? this.$route.name : this.name;
    }
  },
  methods: {
    backRoute_: function backRoute_() {
      if (this.backRoute == '') {
        this.$router.go(-1);
      } else {
        if (this.param != {}) {
          this.$router.push({
            path: this.backRoute,
            query: this.param
          });
        } else {
          this.$router.push(this.backRoute);
        }
      }
    }
  }
};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var _iMap = __webpack_require__(801);

exports.default = {
  props: {
    selected: {
      type: Object,
      default: function _default() {
        return { province: '320000', city: '320100', area: '320115', town: '320115010' };
      }
    },
    address: {
      type: String,
      default: ''
    },
    position_: {
      type: Array,
      default: function _default() {
        return [118.846567, 31.958527];
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      position: [118.846567, 31.958527],
      innerVisible: false,
      selected_: this.selected,
      address_: this.address,
      posValue: '',
      loading: false,
      options: [],
      selecedddd: '',
      index_: 0,
      shangxian: 1,
      loadingx: false,
      loadings: false,
      token: '',
      checkCode: '',
      id: '',
      ischange: true
    };
  },
  mounted: function mounted() {
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; ');
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=');
        if (arr2[0] == 'dnnyptadmin_token') {
          this.token = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_checkCode') {
          this.checkCode = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_id') {
          this.id = arr2[1];
        }
      }
    }
  },

  methods: {
    openMap: function openMap() {
      this.address_ = this.address_.split(' ').join('');
      this.innerVisible = true;
    },
    initMap: function initMap() {
      (0, _iMap.sendThis)(this);
      var param = {
        photography: false,
        popup: false,
        mappParma: {
          zoom: 12,
          mapCenter: this.position == '' ? [118.846567, 31.958527] : this.position
        }
      };
      (0, _iMap.Load_Map)(param);
      (0, _iMap.addDrawPoint)();
      (0, _iMap.addPoint)();
      this.posValue = '';

      this.initRemote(this.address_);
    },
    initRemote: function initRemote(query) {
      if (query != '') {
        var self = this;
        self.loadings = true;
        var params = {
          city: '全国',
          area: query,
          token: self.token,
          checkCode: self.checkCode
        };
        _index.API__Position.getPosition(params).then(function (res) {
          self.loadings = false;
          self.options = [];
          if (res.data.data.length != 0) {
            res.data.data.forEach(function (element) {
              self.options.push({
                address: element.address,
                name: element.name,
                location: [element.location.lng, element.location.lat]
              });
            });
            setTimeout(function () {
              self.posValue = self.options[0].location.toString();

              self.posChange();
            }, 100);
          }
        });
      }
    },
    positions: function positions(coordinate) {
      var _this = this;

      this.position = coordinate || this.posValue;
      var param = {
        pos: [(0, _iMap.toLonLat_)(coordinate)[1], (0, _iMap.toLonLat_)(coordinate)[0]],
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API__Position.getaddressfromposition(param).then(function (res) {
        _this.$emit('backPram', {
          position: _this.position,
          address: _this.address_,
          selected: {
            province: { key: '320105', value: res.data.data.result.addressComponent.province },
            city: { key: '320105', value: res.data.data.result.addressComponent.city },
            area: { key: '320105', value: res.data.data.result.addressComponent.district }
          }
        });
        _this.innerVisible = false;
      });
    },
    remoteMethod: function remoteMethod(query) {
      var _this2 = this;

      if (query !== '') {
        this.loading = true;
        var params = {
          city: '全国',
          area: query,
          token: this.token,
          checkCode: this.checkCode
        };
        _index.API__Position.getPosition(params).then(function (res) {
          _this2.loading = false;
          _this2.options = [];
          if (res.data.data.length != 0) {
            res.data.data.forEach(function (element) {
              _this2.options.push({
                address: element.address,
                name: element.name,
                location: [element.location.lng, element.location.lat]
              });
            });
          }
        });
      }
    },
    posChange: function posChange() {
      (0, _iMap.rewritePos)([Number(this.posValue.split(',')[0]), Number(this.posValue.split(',')[1])]);
    },
    changItem: function changItem(param) {
      this.address_ = param;
    },
    changePro: function changePro(param) {
      this.shangxian = 2;
      this.selected_ = param;
    },
    changePos: function changePos(pos) {
      var self = this;
      this.ischange = false;
      setTimeout(function () {
        self.position = pos;
      });
    },
    changeAddres: function changeAddres() {
      this.$emit('update:address', this.address_);
      this.ischange = true;
    }
  }
};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'pdfView',
  props: {
    pictureList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    isShowFt: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {};
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  }), {
    images: function images() {
      var imgs = [];
      imgs = this.pictureList.map(function (item) {
        return item.perfix + item.path;
      });
      return imgs;
    }
  }),

  created: function created() {},


  methods: {
    inited: function inited(viewer, index) {
      this['$viewer' + index] = viewer;
    },
    show: function show(e, index) {
      this['$viewer' + index].show();
    }
  }
};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Organization",
  inheritAttrs: false,
  props: {
    apiPath: {
      type: String
    },

    params: {
      type: Object,
      default: function _default() {}
    },

    keys: {
      type: Object,
      default: { label: 'label', value: 'value' }
    },

    defaultVal: {
      type: String,
      default: undefined
    },

    defaultValDisabled: {
      type: Boolean,
      default: false
    },

    selectFirst: {
      type: Boolean,
      default: false
    },

    method: {
      type: String,
      default: 'post'
    }

  },
  data: function data() {
    return {
      myDefaultVal: this.defaultVal ? this.defaultVal : '',

      list: [] };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  created: function created() {},
  mounted: function mounted() {
    this.getList();
  },


  methods: {
    handleChange: function handleChange(value) {
      var _this = this;

      if (typeof value == 'string') {
        value = [value];
      }
      var datas = [];
      if (value) {
        datas = this.list.filter(function (item) {
          return value.indexOf(item[_this.keys.value]) > -1;
        });
      }

      this.$emit('change', value || '', datas);
    },
    getList: function getList() {
      var _this2 = this;

      var params = {
        token: this.userInfo.phone,
        checkCode: this.userInfo.checkCode
      };

      params = (0, _extends3.default)({}, params, this.params);
      _index.API__common.getSelectCommonList(this.apiPath, params, this.method).then(function (res) {
        if (res.data.code == 200) {
          _this2.list = res.data.data.records ? res.data.data.records : res.data.data;
          if (_this2.selectFirst && !_this2.defaultVal) {
            _this2.myDefaultVal = _this2.list[0][_this2.keys.value];
            _this2.handleChange(_this2.myDefaultVal);
          }
        }
      }).catch(function (e) {});
    }
  },

  watch: {
    'defaultVal': function defaultVal() {
      this.myDefaultVal = this.defaultVal ? this.defaultVal : '';
    }

  }

};

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var PI = Math.PI;

function sum(x, y) {
    return x + y;
}

function square(x) {
    return x * x;
}
exports.default = {
    name: 'SlideVerify',
    props: {
        l: {
            type: Number,
            default: 42
        },

        r: {
            type: Number,
            default: 10
        },

        w: {
            type: Number,
            default: 350
        },

        h: {
            type: Number,
            default: 155
        },
        sliderText: {
            type: String,
            default: 'Slide filled right'
        }
    },
    data: function data() {
        return {
            containerActive: false,
            containerSuccess: false,
            containerFail: false,
            canvasCtx: null,
            blockCtx: null,
            block: null,
            block_x: undefined,
            block_y: undefined,
            L: this.l + this.r * 2 + 3,
            img: undefined,
            originX: undefined,
            originY: undefined,
            isMouseDown: false,
            trail: [],
            sliderLeft: 0,
            sliderMaskWidth: 0 };
    },
    mounted: function mounted() {
        this.init();
    },

    methods: {
        init: function init() {
            this.initDom();
            this.initImg();
            this.bindEvents();
        },
        initDom: function initDom() {
            this.block = this.$refs.block;
            this.canvasCtx = this.$refs.canvas.getContext('2d');
            this.blockCtx = this.block.getContext('2d');
        },
        initImg: function initImg() {
            var _this = this;

            var img = this.createImg(function () {
                _this.drawBlock();
                _this.canvasCtx.drawImage(img, 0, 0, _this.w, _this.h);
                _this.blockCtx.drawImage(img, 0, 0, _this.w, _this.h);
                var x = _this.block_x,
                    y = _this.block_y,
                    r = _this.r,
                    L = _this.L;

                var _y = y - r * 2 - 1;
                var ImageData = _this.blockCtx.getImageData(x, _y, L, L);
                _this.block.width = L;
                _this.blockCtx.putImageData(ImageData, 0, _y);
            });
            this.img = img;
        },
        drawBlock: function drawBlock() {
            this.block_x = this.getRandomNumberByRange(this.L + 10, this.w - (this.L + 10));
            this.block_y = this.getRandomNumberByRange(10 + this.r * 2, this.h - (this.L + 10));
            this.draw(this.canvasCtx, this.block_x, this.block_y, 'fill');
            this.draw(this.blockCtx, this.block_x, this.block_y, 'clip');
        },
        draw: function draw(ctx, x, y, operation) {
            var l = this.l,
                r = this.r;

            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.arc(x + l / 2, y - r + 2, r, 0.72 * PI, 2.26 * PI);
            ctx.lineTo(x + l, y);
            ctx.arc(x + l + r - 2, y + l / 2, r, 1.21 * PI, 2.78 * PI);
            ctx.lineTo(x + l, y + l);
            ctx.lineTo(x, y + l);
            ctx.arc(x + r - 2, y + l / 2, r + 0.4, 2.76 * PI, 1.24 * PI, true);
            ctx.lineTo(x, y);
            ctx.lineWidth = 2;
            ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
            ctx.strokeStyle = 'rgba(255, 255, 255, 0.7)';
            ctx.stroke();
            ctx[operation]();
            ctx.globalCompositeOperation = 'overlay';
        },
        createImg: function createImg(onload) {
            var _this2 = this;

            var img = document.createElement('img');
            img.crossOrigin = "Anonymous";
            img.onload = onload;
            img.onerror = function () {
                img.src = _this2.getRandomImg();
            };
            img.src = this.getRandomImg();
            return img;
        },
        getRandomImg: function getRandomImg() {
            return 'https://picsum.photos/300/150/?image=' + this.getRandomNumberByRange(0, 1084);
        },
        getRandomNumberByRange: function getRandomNumberByRange(start, end) {
            return Math.round(Math.random() * (end - start) + start);
        },
        refresh: function refresh() {
            this.reset();
            this.$emit('refresh');
        },
        sliderDown: function sliderDown(event) {
            this.originX = event.clientX;
            this.originY = event.clientY;
            this.isMouseDown = true;
        },
        touchStartEvent: function touchStartEvent(e) {
            this.originX = e.changedTouches[0].pageX;
            this.originY = e.changedTouches[0].pageY;
            this.isMouseDown = true;
        },
        bindEvents: function bindEvents() {
            var _this3 = this;

            document.addEventListener('mousemove', function (e) {
                if (!_this3.isMouseDown) return false;
                var moveX = e.clientX - _this3.originX;
                var moveY = e.clientY - _this3.originY;
                if (moveX < 0 || moveX + 38 >= _this3.w) return false;
                _this3.sliderLeft = moveX + 'px';
                var blockLeft = (_this3.w - 40 - 20) / (_this3.w - 40) * moveX;
                _this3.block.style.left = blockLeft + 'px';

                _this3.containerActive = true;
                _this3.sliderMaskWidth = moveX + 'px';
                _this3.trail.push(moveY);
            });
            document.addEventListener('mouseup', function (e) {
                if (!_this3.isMouseDown) return false;
                _this3.isMouseDown = false;
                if (e.clientX === _this3.originX) return false;
                _this3.containerActive = false;
                var _verify = _this3.verify(),
                    spliced = _verify.spliced,
                    TuringTest = _verify.TuringTest;

                if (spliced) {
                    if (TuringTest) {
                        _this3.containerSuccess = true;
                        _this3.$emit('success');
                    } else {
                        _this3.containerFail = true;
                        _this3.sliderText = 'try again';
                        _this3.reset();
                    }
                } else {
                    _this3.containerFail = true;
                    _this3.$emit('fail');
                    setTimeout(function () {
                        _this3.reset();
                    }, 1000);
                }
            });
        },
        touchMoveEvent: function touchMoveEvent(e) {
            if (!this.isMouseDown) return false;
            var moveX = e.changedTouches[0].pageX - this.originX;
            var moveY = e.changedTouches[0].pageY - this.originY;
            if (moveX < 0 || moveX + 38 >= this.w) return false;
            this.sliderLeft = moveX + 'px';
            var blockLeft = (this.w - 40 - 20) / (this.w - 40) * moveX;
            this.block.style.left = blockLeft + 'px';

            this.containerActive = true;
            this.sliderMaskWidth = moveX + 'px';
            this.trail.push(moveY);
        },
        touchEndEvent: function touchEndEvent(e) {
            var _this4 = this;

            if (!this.isMouseDown) return false;
            this.isMouseDown = false;
            if (e.changedTouches[0].pageX === this.originX) return false;
            this.containerActive = false;

            var _verify2 = this.verify(),
                spliced = _verify2.spliced,
                TuringTest = _verify2.TuringTest;

            if (spliced) {
                if (TuringTest) {
                    this.containerSuccess = true;
                    this.$emit('success');
                } else {
                    this.containerFail = true;
                    this.sliderText = 'try again';
                    this.reset();
                }
            } else {
                this.containerFail = true;
                this.$emit('fail');
                setTimeout(function () {
                    _this4.reset();
                }, 1000);
            }
        },
        verify: function verify() {
            var arr = this.trail;
            var average = arr.reduce(sum) / arr.length;
            var deviations = arr.map(function (x) {
                return x - average;
            });
            var stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length);
            var left = parseInt(this.block.style.left);
            return {
                spliced: Math.abs(left - this.block_x) < 10,
                TuringTest: average !== stddev };
        },
        reset: function reset() {
            this.containerActive = false;
            this.containerSuccess = false;
            this.containerFail = false;
            this.sliderLeft = 0;
            this.block.style.left = 0;
            this.sliderMaskWidth = 0;
            var w = this.w,
                h = this.h;

            this.canvasCtx.clearRect(0, 0, w, h);
            this.blockCtx.clearRect(0, 0, w, h);
            this.block.width = w;

            this.img.src = this.getRandomImg();
        }
    }
};

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _api = __webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      msg: '',
      texts: '滑动验证',
      disabled: false,
      time: 0,
      btntxt: "重新发送",
      radio: 3,
      logining: false,
      forgetForm: {
        phone: '',
        password: '',
        conpassword: '',
        smsCode: '' },
      rules2: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        conpassword: [{ required: true, message: '请确认密码', trigger: 'blur' }, { required: true, message: '密码至少8位', trigger: ['blur', 'change'], min: 8 }],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }, { required: true, message: '请输入6位验证码', trigger: ['blur', 'change'], len: 6 }]

      },
      checked: true
    };
  },
  mounted: function mounted() {},

  methods: {
    onSuccess: function onSuccess() {
      this.msg = 'success';
    },
    onFail: function onFail() {
      this.msg = '';
    },
    onRefresh: function onRefresh() {
      this.msg = '';
    },
    smsCode: function smsCode() {
      var _this = this;

      if (this.msg != "success") {
        this.$message.error('请拖到图片进行验证！');
        return;
      }

      var reg = /^1[3-9]\d{9}$/;
      if (this.forgetForm.phone == '') {
        this.$message({
          message: '手机号不能为空',
          center: true
        });
        return;
      }
      if (!reg.test(this.forgetForm.phone)) {
        this.$message({
          message: '请输入正确的手机号',
          center: true
        });
        return;
      } else {
        var para = {
          phone: this.forgetForm.phone
        };
        _index.API__login.sendSmsCode(para).then(function (res) {

          if (res.data.code == _index.API__code.SUCCESS) {
            _this.$message({
              message: '发送成功',
              type: 'success',
              center: true
            });
            _this.time = 60;
            _this.disabled = true;
            _this.timer();
          } else {
            _this.$message.error(res.data.message);
          }
        }).catch(function (err) {
          _this.$message.error('服务器异常，请您稍后再试..');
          _this.pageLoading = false;
        });
      }
    },
    timer: function timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    handleSubmit2: function handleSubmit2(formName) {
      var _this2 = this;

      this.$refs.forgetForm.validate(function (valid) {
        if (valid) {
          _this2.forget();
        } else {
          _this2.$message.error('请正确输入登录账号和密码..');
          return false;
        }
      });
    },
    forget: function forget() {
      var _this3 = this;

      this.pageLoading = true;
      var param = {
        password: this.forgetForm.password,
        phone: this.forgetForm.phone,

        smsCode: this.forgetForm.smsCode,
        conpassword: this.forgetForm.conpassword
      };

      _index.API__login.forget(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '修改成功',
            type: 'success'
          });
          _this3.$router.push({ path: 'login' });
        } else {
          _this3.$message.error(res.data.message);
        }
        _this3.pageLoading = false;
      }).catch(function (e) {
        _this3.$message.error('服务器异常，请您稍后再试..');
        _this3.pageLoading = false;
      });
    }
  }
};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _api = __webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      radio: 3,
      logining: false,
      loginForm: {
        phone: '',
        password: ''
      },
      rules2: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },
  mounted: function mounted() {
    this.clearCookie();
    this.getCookie();
  },

  methods: {
    handleSubmit2: function handleSubmit2(formName) {
      var _this = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this.login();
        } else {
          _this.$message.error('请正确输入登录账号和密码..');
          return false;
        }
      });
    },
    login: function login() {
      var _this2 = this;

      this.pageLoading = true;
      var param = {
        password: this.loginForm.password,
        phone: this.loginForm.phone,
        userType: '0' };
      _index.API__login.login(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: '登录成功',
            type: 'success'
          });

          var token = res.data.data.phone;
          _this2.setCookie("dnnyptInfo", "dnnypt_token", token);
          var name = res.data.data.name;
          if (name) {
            sessionStorage.setItem('user', name);
          } else {
            sessionStorage.setItem('user', token);
          }
          var modules = res.data.data.module;
          if (modules) {
            sessionStorage.setItem('module', modules);
          }
          var checkCode = res.data.data.checkCode;
          _this2.setCookie("dnnyptInfo", "dnnypt_checkCode", checkCode);
          var id = res.data.data.id;
          _this2.setCookie("dnnyptInfo", "dnnypt_id", id);

          _this2.$router.push({ path: 'productList' });
        } else {
          _this2.$message.error(res.data.message);
        }
        _this2.pageLoading = false;
      }).catch(function (e) {
        _this2.$message.error('服务器异常，请您稍后再试..');
        _this2.pageLoading = false;
      });
    },
    setCookie: function setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
      if (c_name == "dnnyptInfo") {
        window.document.cookie = c_pwd + "=" + exdays + ";path=/;expires=" + exdate.toGMTString();
      } else {
        window.document.cookie = "name" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie = "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      }
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'name') {
            this.loginForm.name = arr2[1];
          } else if (arr2[0] == 'password') {
            this.loginForm.password = arr2[1];
          }
        }
      }
    },

    clearCookie: function clearCookie() {
      this.setCookie("", "", -1);
    }
  }
};

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _api = __webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      myimg: __webpack_require__(1650),
      msg: '',
      texts: '滑动验证',
      radio: 3,
      logining: false,
      loginForm: {
        phone: '',
        password: ''
      },
      rules2: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true,
      loginLoading: false
    };
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    document.querySelector(".dnnCloud-login-box").style.backgroundImage = "url(./static/img/bg_login.png)";
  },


  methods: {
    checkTencentCaptcha: function checkTencentCaptcha(ticket, randstr, appid) {
      var _this2 = this;

      var ip = returnCitySN["cip"];
      var param = {
        Ticket: ticket,
        Randstr: randstr,
        UserIP: ip
      };
      _index.API__login.CheckTencentCaptcha(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.handleSubmit2();
        }
      });
    },
    handleSubmit2: function handleSubmit2(formName) {
      var _this3 = this;

      var _this = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this.login();
        } else {
          _this3.$message.error('请正确输入登录账号和密码');
          return false;
        }
      });
    },
    login: function login() {
      var _this4 = this;

      this.loginLoading = true;
      var param = {
        password: this.loginForm.password,
        user: this.loginForm.phone
      };
      _index.API__login.loginAdmin(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          sessionStorage.removeItem('user');
          sessionStorage.clear();
          _this4.setCookie("dnnyptInfo_admin", "dnnyptadmin_checkCode", "");
          _this4.setCookie("dnnyptInfo_admin", "dnnyptadmin_id", "");
          _this4.clearCookie();

          _this4.$message({
            message: '登录成功',
            type: 'success'
          });
          var data = res.data.data;
          var id = res.data.data.id;
          sessionStorage.setItem('dnnypt_id', id);

          if (res.data.data.checkCode) {
            var checkCode = res.data.data.checkCode;
            _this4.setCookie("dnnyptInfo_admin", "dnnyptadmin_checkCode", checkCode);
          }
          if (res.data.data.id) {
            var id = res.data.data.id;
            _this4.setCookie("dnnyptInfo_admin", "dnnyptadmin_id", id);
          }
          if (res.data.data.phone) {
            var token = res.data.data.phone;
            _this4.setCookie("dnnyptInfo_admin", "dnnyptadmin_token", token);
            _this4.$store.commit('set__token', token);
          }
          if (res.data.data.name) {
            var name = res.data.data.name;
            sessionStorage.setItem('user', name);
          }
          if (res.data.data.type) {
            var type = res.data.data.type;
            sessionStorage.setItem('type', type);
          }

          _this4.$store.commit('set__userinfo', data);

          res.data.data.type == '2' || res.data.data.type == '3' || res.data.data.type == '4' ? _this4.$router.push({ path: 'authorizeList' }) : _this4.$router.push({ path: 'management' });
        } else {
          _this4.$message.error(res.data.message);
        }
        _this4.loginLoading = false;
      }).catch(function (e) {
        _this4.$message.error('服务器异常，请您稍后再试..');
        _this4.loginLoading = false;
      });
    },
    setCookie: function setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
      if (c_name == "dnnyptInfo_admin") {
        window.document.cookie = c_pwd + "=" + exdays + ";path=/;expires=" + exdate.toGMTString();
      } else {
        window.document.cookie = "name" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie = "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      }
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'name') {
            this.loginForm.name = arr2[1];
          } else if (arr2[0] == 'password') {
            this.loginForm.password = arr2[1];
          }
        }
      }
    },

    clearCookie: function clearCookie() {
      this.setCookie("", "", -1);
    }
  }
};

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {};

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _api = __webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      msg: '',
      texts: '滑动验证',
      disabled: false,
      time: 0,
      btntxt: "重新发送",
      radio: 3,
      logining: false,
      registerForm: {
        phone: '',
        password: '',
        conpassword: '',
        smsCode: '' },
      rules2: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        conpassword: [{ required: true, message: '请确认密码', trigger: 'blur' }],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }, { required: true, message: '请输入6位验证码', trigger: ['blur', 'change'], len: 6 }]

      },
      checked: true
    };
  },
  mounted: function mounted() {},

  methods: {
    onSuccess: function onSuccess() {
      this.msg = 'success';
    },
    onFail: function onFail() {
      this.msg = '';
    },
    onRefresh: function onRefresh() {
      this.msg = '';
    },
    smsCode: function smsCode() {
      var _this = this;

      if (this.msg != "success") {
        this.$message.error('请拖到图片进行验证！');
        return;
      }

      var reg = /^1[3-9]\d{9}$/;
      if (this.registerForm.phone == '') {
        this.$message({
          message: '手机号不能为空',
          center: true
        });
        return;
      }
      if (!reg.test(this.registerForm.phone)) {
        this.$message({
          message: '请输入正确的手机号',
          center: true
        });
        return;
      } else {
        var para = {
          phone: this.registerForm.phone
        };
        _index.API__login.sendSmsCode(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this.$message({
              message: '发送成功',
              type: 'success',
              center: true
            });
            _this.time = 60;
            _this.disabled = true;
            _this.timer();
          } else {
            _this.$message.error(res.data.message);
          }
        }).catch(function (err) {
          _this.$message.error('服务器异常，请您稍后再试..');
          _this.pageLoading = false;
        });
      }
    },
    timer: function timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    handleSubmit2: function handleSubmit2(formName) {
      var _this2 = this;

      this.$refs.registerForm.validate(function (valid) {
        if (valid) {
          _this2.register();
        } else {
          _this2.$message.error('请正确输入登录账号和密码..');
          return false;
        }
      });
    },
    register: function register() {
      var _this3 = this;

      this.pageLoading = true;
      var param = {
        password: this.registerForm.password,
        conpassword: this.registerForm.conpassword,
        phone: this.registerForm.phone,
        userType: '0',
        smsCode: this.registerForm.smsCode
      };
      _index.API__login.register(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '注册成功',
            type: 'success'
          });
          _this3.$router.push({ path: 'login' });
        } else {
          _this3.$message.error(res.data.message);
        }
        _this3.pageLoading = false;
      }).catch(function (e) {
        _this3.$message.error('服务器异常，请您稍后再试..');
        _this3.pageLoading = false;
      });
    }
  }
};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(90);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(89);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      step: 1,
      loading: false,
      time: 0,
      disabled: false,
      timer: null,

      userForm: {
        FirstName: "",
        LastName: "",
        CompanyName: "",
        Email: "",
        Password: ""
      },
      emailChecked: false,
      userRules: {
        FirstName: [{
          required: true,
          message: "Please enter your first name.",
          trigger: ["blur", "change"]
        }],
        LastName: [{
          required: true,
          message: "Please enter your last name.",
          trigger: ["blur", "change"]
        }],
        CompanyName: [{
          required: true,
          message: "Please enter your company name.",
          trigger: ["blur", "change"]
        }],
        Email: [{
          required: true,
          message: "Please enter your Email address.",
          trigger: "blur"
        }, {
          type: "email",
          message: "Must be a valid Email",
          trigger: ["blur", "change"]
        }, {
          validator: this.checkVerificationEmail,
          trigger: "blur"
        }],
        Password: [{
          required: true,
          message: "Please enter your Password.",
          trigger: ["blur", "change"]
        }]
      },

      codeForm: {
        verificationCode: ""
      },
      codeRules: {
        verificationCode: [{
          required: true,
          message: "Please enter the verification code",
          trigger: "blur"
        }, {
          validator: this.checkVerificationCode,
          trigger: "change"
        }]
      },
      containsAtLeastEightCharacters: false,
      containsBothLowerUpper: false,
      containsNumberOrSymbol: false,
      doesNotContainEmail: false
    };
  },

  methods: {
    checkVerificationEmail: function checkVerificationEmail(rule, value, callback) {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.emailChecked) {
                  _context.next = 3;
                  break;
                }

                callback();
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return _index.API_ResetPwEn.verifyEmail({
                  phone: value
                });

              case 6:
                res = _context.sent;

                if (!(res.data.code == _index.API__code.SUCCESS)) {
                  _context.next = 12;
                  break;
                }

                _this.emailChecked = true;
                callback();
                _context.next = 13;
                break;

              case 12:
                throw new Error("An account with this email address already exists.");

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](3);

                callback(_context.t0);
              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 15]]);
      }))();
    },
    smsCode: function smsCode() {
      var _this2 = this;

      if (this.userForm.Email == "") {
        this.$message.error({
          message: "Email cannot be empty",
          center: true
        });
        return;
      }
      this.loading = true;
      var para = {
        phone: this.userForm.Email
      };
      _index.API_ResetPwEn.sendEmailCode(para).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: "Send successful",
            type: "success",
            center: true
          });
          _this2.step == 1 && (_this2.step = ++_this2.step);
          _this2.time = 60;
          _this2.disabled = true;
          _this2.timerFun();
        } else {
          _this2.$message.error(res.data.message);
        }
        _this2.loading = false;
      }).catch(function (err) {
        _this2.$message.error("Server exception, please try again later..");
        _this2.loading = false;
      });
    },
    timerFun: function timerFun() {
      if (this.time > 0) {
        this.time--;
        this.timer = setTimeout(this.timerFun, 1000);
      } else {
        this.time = 0;
        this.disabled = false;
      }
    },
    checkVerificationCode: function checkVerificationCode(rule, value, callback) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var params, res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (/^\d{6}$/.test(value)) {
                  _context2.next = 3;
                  break;
                }

                callback(new Error("Please enter a 6-digit verification code"));
                return _context2.abrupt("return");

              case 3:
                _this3.loading = true;
                params = {
                  phone: _this3.userForm.Email,
                  firstName: _this3.userForm.FirstName,
                  lastName: _this3.userForm.LastName,
                  company: _this3.userForm.CompanyName,
                  password: _this3.userForm.Password,
                  smsCode: _this3.codeForm.verificationCode
                };
                _context2.prev = 5;
                _context2.next = 8;
                return _index.API_ResetPwEn.registerUserByEmail(params);

              case 8:
                res = _context2.sent;

                if (!(res.data.code == _index.API__code.SUCCESS)) {
                  _context2.next = 15;
                  break;
                }

                _this3.$message({
                  message: "Verification successful",
                  type: "success",
                  center: true
                });
                callback();
                _this3.nextStep(2);
                _context2.next = 16;
                break;

              case 15:
                throw new Error("The verification code is incorrect or has expired! Try again.");

              case 16:
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](5);

                callback(_context2.t0);

              case 21:
                _context2.prev = 21;

                _this3.loading = false;
                return _context2.finish(21);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[5, 18, 21, 24]]);
      }))();
    },
    nextStep: function nextStep(curStep) {
      var _this4 = this;

      if (curStep == 1) {
        this.$refs.userForm.validate(function (valid) {
          if (valid && _this4.containsAtLeastEightCharacters && _this4.containsBothLowerUpper && _this4.containsNumberOrSymbol && _this4.doesNotContainEmail) {
            _this4.smsCode();
          } else {
            console.log("验证失败");
          }
        });
      } else if (curStep == 2) {
          this.step = ++curStep;
        }
    },
    preStep: function preStep() {
      this.step = --this.step;
      this.codeForm.verificationCode = "";
      this.timer = null;
      this.time = 0;
      this.disabled = false;
    },
    validateEmail: function validateEmail() {
      this.emailChecked = false;
    },
    validatePassword: function validatePassword(val) {
      var Email = this.userForm.Email;
      this.containsAtLeastEightCharacters = /.{8,}/.test(val);
      this.containsBothLowerUpper = /[a-z]/.test(val) && /[A-Z]/.test(val);
      this.containsNumberOrSymbol = /\d|[^a-zA-Z\d\s]/.test(val);
      this.doesNotContainEmail = !val.includes(Email);
    }
  }
};

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(90);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(89);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      step: 1,
      loading: false,
      time: 0,
      disabled: false,
      timer: null,

      emailForm: {
        Email: ""
      },
      emailChecked: false,
      emailRules: {
        Email: [{
          required: true,
          message: "Please enter your email address.",
          trigger: "blur"
        }, {
          type: "email",
          message: "Must be a valid email",
          trigger: ["blur", "change"]
        }, {
          validator: this.checkVerificationEmail,
          trigger: "blur"
        }]
      },

      codeForm: {
        verificationCode: ""
      },
      codeRules: {
        verificationCode: [{
          required: true,
          message: "Please enter the verification code",
          trigger: "blur"
        }, {
          validator: this.checkVerificationCode,
          trigger: "change"
        }]
      },

      resetForm: {
        newPassword: "",
        confirmPassword: ""
      },
      resetRules: {
        newPassword: [{
          required: true,
          message: "Please enter your new password",
          trigger: ["blur", "change"]
        }],
        confirmPassword: [{
          required: true,
          message: "Please confirm your password",
          trigger: ["blur", "change"]
        }, { validator: this.validateConfirmPassword, trigger: "blur" }]
      },
      containsAtLeastEightCharacters: false,
      containsBothLowerUpper: false,
      containsNumberOrSymbol: false,
      doesNotContainEmail: false
    };
  },

  methods: {
    checkVerificationEmail: function checkVerificationEmail(rule, value, callback) {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.emailChecked) {
                  _context.next = 3;
                  break;
                }

                callback();
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return _index.API_ResetPwEn.verifyEmail({
                  phone: value
                });

              case 6:
                res = _context.sent;

                if (!(res.data.code == _index.API__code.SUCCESS)) {
                  _context.next = 11;
                  break;
                }

                throw new Error("This email isn't registered. Please check your input or sign up.");

              case 11:
                _this.emailChecked = true;
                callback();

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](3);

                callback(_context.t0);
              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 15]]);
      }))();
    },
    smsCode: function smsCode() {
      var _this2 = this;

      if (this.emailForm.Email == "") {
        this.$message.error({
          message: "Email cannot be empty",
          center: true
        });
        return;
      }
      this.loading = true;
      var para = {
        phone: this.emailForm.Email
      };
      _index.API_ResetPwEn.sendEmailCode(para).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: "Send successful",
            type: "success",
            center: true
          });
          _this2.step == 1 && (_this2.step = ++_this2.step);
          _this2.time = 60;
          _this2.disabled = true;
          _this2.timerFun();
        } else {
          _this2.$message.error(res.data.message);
        }
        _this2.loading = false;
      }).catch(function (err) {
        _this2.$message.error("Server exception, please try again later..");
        _this2.loading = false;
      });
    },
    timerFun: function timerFun() {
      if (this.time > 0) {
        this.time--;
        this.timer = setTimeout(this.timerFun, 1000);
      } else {
        this.time = 0;
        this.disabled = false;
      }
    },
    checkVerificationCode: function checkVerificationCode(rule, value, callback) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var params, res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (/^\d{6}$/.test(value)) {
                  _context2.next = 3;
                  break;
                }

                callback(new Error("Please enter a 6-digit verification code"));
                return _context2.abrupt("return");

              case 3:
                _this3.loading = true;
                params = {
                  phone: _this3.emailForm.Email,
                  smsCode: _this3.codeForm.verificationCode
                };
                _context2.prev = 5;
                _context2.next = 8;
                return _index.API_ResetPwEn.verifyEmailCode(params);

              case 8:
                res = _context2.sent;

                if (!(res.data.code == _index.API__code.SUCCESS)) {
                  _context2.next = 15;
                  break;
                }

                _this3.$message({
                  message: "Verification successful",
                  type: "success",
                  center: true
                });
                callback();
                _this3.nextStep(2);
                _context2.next = 16;
                break;

              case 15:
                throw new Error("The verification code is incorrect or has expired! Try again.");

              case 16:
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](5);

                callback(_context2.t0);

              case 21:
                _context2.prev = 21;

                _this3.loading = false;
                return _context2.finish(21);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[5, 18, 21, 24]]);
      }))();
    },
    nextStep: function nextStep(curStep) {
      var _this4 = this;

      if (curStep == 1) {
        this.$refs.emailForm.validateField("Email", function (valid) {
          if (valid) {
            console.log("验证失败");
          } else {
            _this4.smsCode();
          }
        });
      } else if (curStep == 2) {
          this.step = ++curStep;
        }
    },
    preStep: function preStep() {
      this.step = --this.step;
      this.codeForm.verificationCode = "";
      this.timer = null;
      this.time = 0;
      this.disabled = false;
    },
    validateEmail: function validateEmail() {
      this.emailChecked = false;
    },
    validatePassword: function validatePassword(val) {
      var email = this.emailForm.Email;
      this.containsAtLeastEightCharacters = /.{8,}/.test(val);
      this.containsBothLowerUpper = /[a-z]/.test(val) && /[A-Z]/.test(val);
      this.containsNumberOrSymbol = /\d|[^a-zA-Z\d\s]/.test(val);
      this.doesNotContainEmail = !val.includes(email);
    },
    validateConfirmPassword: function validateConfirmPassword(rule, value, callback) {
      console.log("value", value);
      if (value !== this.resetForm.newPassword) {
        callback(new Error("The specified passwords must be identical"));
      } else {
        callback();
      }
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      this.$refs.resetForm.validate(function (valid) {
        if (valid && _this5.containsAtLeastEightCharacters && _this5.containsBothLowerUpper && _this5.containsNumberOrSymbol && _this5.doesNotContainEmail) {
          _this5.resetSubmit();
        } else {
          _this5.$message.error("Please correct the errors in the form.");
        }
      });
    },
    resetSubmit: function resetSubmit() {
      var _this6 = this;

      this.loading = true;
      var param = {
        password: this.resetForm.newPassword,
        conpassword: this.resetForm.confirmPassword,
        phone: this.emailForm.Email,
        smsCode: this.codeForm.verificationCode
      };
      _index.API_ResetPwEn.userPasswordEmail(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this6.$message({
            message: "Reset successful",
            type: "success"
          });
          _this6.step = ++_this6.step;
        } else {
          _this6.$message.error(res.data.message);
        }
        _this6.loading = false;
      }).catch(function (e) {
        console.log(e);
        _this6.$message.error("Server exception, please try again later..");
        _this6.loading = false;
      });
    }
  }
};

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(90);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(89);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      step: 1,
      loading: false,
      time: 0,
      disabled: false,
      timer: null,

      emailForm: {
        Email: ""
      },
      emailChecked: false,
      emailRules: {
        Email: [{
          required: true,
          message: "Please enter your email address.",
          trigger: "blur"
        }, {
          type: "email",
          message: "Must be a valid email",
          trigger: ["blur", "change"]
        }, {
          validator: this.checkVerificationEmail,
          trigger: "blur"
        }]
      },

      codeForm: {
        verificationCode: ""
      },
      codeRules: {
        verificationCode: [{
          required: true,
          message: "Please enter the verification code",
          trigger: "blur"
        }, {
          validator: this.checkVerificationCode,
          trigger: "change"
        }]
      },

      resetForm: {
        newPassword: "",
        confirmPassword: ""
      },
      resetRules: {
        newPassword: [{
          required: true,
          message: "Please enter your new password",
          trigger: ["blur", "change"]
        }],
        confirmPassword: [{
          required: true,
          message: "Please confirm your password",
          trigger: ["blur", "change"]
        }, { validator: this.validateConfirmPassword, trigger: "blur" }]
      },
      containsAtLeastEightCharacters: false,
      containsBothLowerUpper: false,
      containsNumberOrSymbol: false,
      doesNotContainEmail: false
    };
  },

  methods: {
    checkVerificationEmail: function checkVerificationEmail(rule, value, callback) {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.emailChecked) {
                  _context.next = 3;
                  break;
                }

                callback();
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return _index.API_ResetPwEn.verifyEmail({
                  phone: value
                });

              case 6:
                res = _context.sent;

                if (!(res.data.code == _index.API__code.SUCCESS)) {
                  _context.next = 11;
                  break;
                }

                throw new Error("This email isn't registered. Please check your input or sign up.");

              case 11:
                _this.emailChecked = true;
                callback();

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](3);

                callback(_context.t0);
              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 15]]);
      }))();
    },
    smsCode: function smsCode() {
      var _this2 = this;

      if (this.emailForm.Email == "") {
        this.$message.error({
          message: "Email cannot be empty",
          center: true
        });
        return;
      }
      this.loading = true;
      var para = {
        phone: this.emailForm.Email
      };
      _index.API_ResetPwEn.sendEmailCode(para).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: "Send successful",
            type: "success",
            center: true
          });
          _this2.step == 1 && (_this2.step = ++_this2.step);
          _this2.time = 60;
          _this2.disabled = true;
          _this2.timerFun();
        } else {
          _this2.$message.error(res.data.message);
        }
        _this2.loading = false;
      }).catch(function (err) {
        _this2.$message.error("Server exception, please try again later..");
        _this2.loading = false;
      });
    },
    timerFun: function timerFun() {
      if (this.time > 0) {
        this.time--;
        this.timer = setTimeout(this.timerFun, 1000);
      } else {
        this.time = 0;
        this.disabled = false;
      }
    },
    checkVerificationCode: function checkVerificationCode(rule, value, callback) {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var params, res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (/^\d{6}$/.test(value)) {
                  _context2.next = 3;
                  break;
                }

                callback(new Error("Please enter a 6-digit verification code"));
                return _context2.abrupt("return");

              case 3:
                _this3.loading = true;
                params = {
                  phone: _this3.emailForm.Email,
                  smsCode: _this3.codeForm.verificationCode
                };
                _context2.prev = 5;
                _context2.next = 8;
                return _index.API_ResetPwEn.verifyEmailCode(params);

              case 8:
                res = _context2.sent;

                if (!(res.data.code == _index.API__code.SUCCESS)) {
                  _context2.next = 15;
                  break;
                }

                _this3.$message({
                  message: "Verification successful",
                  type: "success",
                  center: true
                });
                callback();
                _this3.nextStep(2);
                _context2.next = 16;
                break;

              case 15:
                throw new Error("The verification code is incorrect or has expired! Try again.");

              case 16:
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](5);

                callback(_context2.t0);

              case 21:
                _context2.prev = 21;

                _this3.loading = false;
                return _context2.finish(21);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[5, 18, 21, 24]]);
      }))();
    },
    nextStep: function nextStep(curStep) {
      var _this4 = this;

      if (curStep == 1) {
        this.$refs.emailForm.validateField("Email", function (valid) {
          if (valid) {
            console.log("验证失败");
          } else {
            _this4.smsCode();
          }
        });
      } else if (curStep == 2) {
          this.step = ++curStep;
        }
    },
    preStep: function preStep() {
      this.step = --this.step;
      this.codeForm.verificationCode = "";
      this.timer = null;
      this.time = 0;
      this.disabled = false;
    },
    validateEmail: function validateEmail() {
      this.emailChecked = false;
    },
    validatePassword: function validatePassword(val) {
      var email = this.emailForm.Email;
      this.containsAtLeastEightCharacters = /.{8,}/.test(val);
      this.containsBothLowerUpper = /[a-z]/.test(val) && /[A-Z]/.test(val);
      this.containsNumberOrSymbol = /\d|[^a-zA-Z\d\s]/.test(val);
      this.doesNotContainEmail = !val.includes(email);
    },
    validateConfirmPassword: function validateConfirmPassword(rule, value, callback) {
      console.log("value", value);
      if (value !== this.resetForm.newPassword) {
        callback(new Error("The specified passwords must be identical"));
      } else {
        callback();
      }
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      this.$refs.resetForm.validate(function (valid) {
        if (valid && _this5.containsAtLeastEightCharacters && _this5.containsBothLowerUpper && _this5.containsNumberOrSymbol && _this5.doesNotContainEmail) {
          _this5.resetSubmit();
        } else {
          _this5.$message.error("Please correct the errors in the form.");
        }
      });
    },
    resetSubmit: function resetSubmit() {
      var _this6 = this;

      this.loading = true;
      var param = {
        password: this.resetForm.newPassword,
        conpassword: this.resetForm.confirmPassword,
        phone: this.emailForm.Email,
        smsCode: this.codeForm.verificationCode
      };
      _index.API_ResetPwEn.userPasswordEmail(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this6.$message({
            message: "Reset successful",
            type: "success"
          });
          _this6.step = ++_this6.step;
        } else {
          _this6.$message.error(res.data.message);
        }
        _this6.loading = false;
      }).catch(function (e) {
        console.log(e);
        _this6.$message.error("Server exception, please try again later..");
        _this6.loading = false;
      });
    }
  }
};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      token: "",
      checkCode: "",
      id: "",
      listLoading: false,
      dataList: [],
      souchs: {},
      pageNumber: this.$route.query.pageNumber ? this.$route.query.pageNumber : 1,
      pageSize: this.$route.query.pageSize ? this.$route.query.pageSize : 20,
      total: 0,
      userName: "",
      dynamicTags: [],
      imageShow: false,
      dialogVisible: false,
      detail: {},

      searchText: this.$route.query.searchText,
      successCount: 0,
      totalCount: 0
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["userInfo"])),

  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    handleRowClick: function handleRowClick(row) {
      this.handleDetail(row);
    },

    getList: function getList(page) {
      var _this = this;

      this.pageNumber = page ? page : this.pageNumber;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        userName: this.userName
      };
      this.listLoading = true;
      _index.API_AIRilab.getAIRilabStatistics().then(function (res) {
        _this.successCount = res.data.data.successCount;
        _this.totalCount = res.data.data.totalCount;
      });
      _index.API_AIRilab.getAIRilabList(param).then(function (res) {
        console.log(res);
        _this.dataList = res.data.data.list;
        _this.total = res.data.data.totalRow;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.$message.error("数据丢失，试试重新登陆！");
        _this.listLoading = false;
      });
    },

    dateTran: function dateTran(timestamp) {
      if (!timestamp) return "-";
      var date = new Date(timestamp);

      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      var hours = String(date.getHours()).padStart(2, "0");
      var minutes = String(date.getMinutes()).padStart(2, "0");
      var seconds = String(date.getSeconds()).padStart(2, "0");

      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    },

    formatDuration: function formatDuration(milliseconds) {
      if (!milliseconds || milliseconds < 0) return "-";

      var totalSeconds = Math.round(milliseconds / 1000);
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;

      return minutes + "\u5206\u949F" + String(seconds).padStart(2, "0") + "\u79D2";
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },
    handleDetail: function handleDetail(value) {
      this.dialogVisible = true;
      this.detail = value;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    }
  },

  created: function created() {
    this.getCookie();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(117);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

var _leftCharts = __webpack_require__(1686);

var _leftCharts2 = _interopRequireDefault(_leftCharts);

var _rightCharts = __webpack_require__(1687);

var _rightCharts2 = _interopRequireDefault(_rightCharts);

var _census = __webpack_require__(1684);

var _census2 = _interopRequireDefault(_census);

var _censusBar = __webpack_require__(1685);

var _censusBar2 = _interopRequireDefault(_censusBar);

var _modal = __webpack_require__(1689);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      token: "",
      checkCode: "",
      value: "1",
      value2: "1",
      chartsXAxis: [],

      chartsData: [],
      requestData: "",
      loading: true,
      chartsXAxisTwo: [],

      chartsDataTwo: [],
      options: [{
        value: "1",
        label: "最近一个月"
      }, {
        value: "3",
        label: "最近三个月"
      }, {
        value: "6",
        label: "最近半年"
      }, {
        value: "12",
        label: "最近一年"
      }],
      loading4: false,
      loading5: false,
      loading6: false,
      loading7: false,
      visitByMonth_Year: String(new Date().getFullYear()),
      visitByQuarter_Year: String(new Date().getFullYear()),
      yearPickerOptions: {
        disabledDate: function disabledDate(time) {
          var currentYear = new Date().getFullYear();
          var selectedYear = new Date(time).getFullYear();
          return selectedYear > currentYear;
        }
      },
      chartsXAxisThree: [],
      chartsDataThree: [],
      chartsXAxisFour: [],
      chartsDataFour: [],

      userGuishuPie: [],
      userGuishuBar: {}
    };
  },
  created: function created() {
    this.getCookie();
    this.getData();
    this.censusFun();
  },
  mounted: function mounted() {},


  methods: {
    censusFun: function censusFun() {
      var _this = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_control.getPeiAddress(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.userGuishuPie = res.data.data.pei;
          var bar = {
            x: res.data.data.zhuAddr,
            y: res.data.data.zhuCount
          };
          _this.userGuishuBar = bar;
        } else {
          _this.$message.error(res.data.message);
        }
      }).catch(function (err) {
        _this.loading = false;
        _this.$message.error("数据丢失，试试重新登陆！");
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    getData: function getData() {
      var _this2 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_control.getData(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.requestData = res.data.data;
          _this2.pointByHour();
          _this2.dayVisit();
          _this2.MonthVisit();
          _this2.QuarterVisit();
        } else {
          _this2.$message.error(res.data.message);
        }
      }).catch(function (err) {
        _this2.loading = false;
        _this2.$message.error("数据丢失，试试重新登陆！");
      });
    },
    pointByHour: function pointByHour(val) {
      var _this3 = this;

      var param = {
        count: this.value,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading4 = true;
      _index.API_control.pointByHour(param).then(function (res) {
        if (res.data.code == 200) {
          _this3.chartsXAxis = res.data.data.x;
          _this3.chartsData = res.data.data.y;
          _this3.getCharts();
          _this3.loading4 = false;
        }
      });
    },
    dayVisit: function dayVisit(val) {
      var _this4 = this;

      var param = {
        count: this.value2,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading5 = true;
      _index.API_control.dayVisit(param).then(function (res) {
        if (res.data.code == 200) {
          _this4.chartsXAxisTwo = res.data.data.x;
          _this4.chartsDataTwo = res.data.data.y;
          _this4.getChartsTwo();
          _this4.loading5 = false;
        }
      });
    },
    MonthVisit: function MonthVisit() {
      var _this5 = this;

      var param = {
        year: this.visitByMonth_Year,
        type: "month",
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading6 = true;
      _index.API_control.yaerVisit(param).then(function (res) {
        if (res.data.code == 200) {
          _this5.chartsXAxisThree = res.data.data.x;
          _this5.chartsDataThree = res.data.data.y;
          _this5.getChartsThree();
          _this5.loading6 = false;
        }
      });
    },
    QuarterVisit: function QuarterVisit() {
      var _this6 = this;

      var param = {
        year: this.visitByQuarter_Year,
        type: "quarter",
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading7 = true;
      _index.API_control.yaerVisit(param).then(function (res) {
        if (res.data.code == 200) {
          _this6.chartsXAxisFour = res.data.data.x;
          _this6.chartsDataFour = res.data.data.y;
          _this6.getChartsFour();
          _this6.loading7 = false;
        }
      });
    },
    getCharts: function getCharts() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box"));
      charts.showLoading();
      charts.setOption({
        title: [{
          text: "时程积分曲线",
          top: "top",
          left: "left",
          textStyle: {
            color: "#596471",
            fontSize: 17,
            fontWeight: 100
          }
        }],
        tooltip: {
          trigger: "axis",
          position: function position(pt) {
            return [pt[0], "10%"];
          },
          formatter: function formatter(params) {
            return params[0].name + "<br/>" + params[0].seriesName + ": " + (params[0].value + "").replace(/\B(?=(?:\d{3})+\b)/g, ",") + "\u5206";
          }
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxis,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          },
          splitArea: {}
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        series: [{
          name: "积分",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          itemStyle: {
            normal: {
              color: "#EF5350"
            }
          },
          areaStyle: {
            normal: {
              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#FFB87D"
              }, {
                offset: 1,
                color: "#ED7D76"
              }])
            }
          },
          data: this.chartsData,
          lineStyle: {
            normal: {
              color: "#EF5350"
            }
          }
        }]
      });
      charts.hideLoading();
      this.loading = false;
      window.addEventListener("resize", function () {
        charts.resize();
      });
    },
    getChartsTwo: function getChartsTwo() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-two"));
      charts.showLoading();
      charts.setOption({
        title: [{
          text: "时程日活曲线",
          top: "top",
          left: "10px",
          textStyle: {
            color: "#596471",
            fontSize: 17,
            fontWeight: 100
          }
        }],
        tooltip: {
          trigger: "axis",
          position: function position(pt) {
            return [pt[0], "10%"];
          },
          formatter: "{b0}<br/>{a0}: {c0}人"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisTwo,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          },
          splitArea: {}
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        series: [{
          name: "人",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          itemStyle: {
            normal: {
              color: "#448AFF"
            }
          },
          areaStyle: {
            normal: {
              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#74BCFF"
              }, {
                offset: 1,
                color: "#3575D6"
              }])
            }
          },
          data: this.chartsDataTwo,
          lineStyle: {
            normal: {
              color: "#448AFF"
            }
          }
        }]
      });
      charts.hideLoading();
      this.loading = false;
      window.addEventListener("resize", function () {
        charts.resize();
      });
    },
    getChartsThree: function getChartsThree() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-Three"));
      charts.showLoading();
      charts.setOption({
        title: [{
          text: "时程月活曲线",
          top: "top",
          left: "10px",
          textStyle: {
            color: "#596471",
            fontSize: 17,
            fontWeight: 100
          }
        }],
        tooltip: {
          trigger: "axis",
          position: function position(pt) {
            return [pt[0], "10%"];
          },
          formatter: "{b0}<br/>{a0}: {c0}人"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisThree,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        series: [{
          name: "人",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          itemStyle: {
            color: "#2E7D32" },
          areaStyle: {
            normal: {
              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#A5D6A7"
              }, {
                offset: 1,
                color: "#2E7D32"
              }])
            }
          },
          data: this.chartsDataThree,
          lineStyle: {
            color: "#2E7D32",
            width: 2
          }
        }]
      });
      charts.hideLoading();
      this.loading = false;
      window.addEventListener("resize", function () {
        charts.resize();
      });
    },
    getChartsFour: function getChartsFour() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-Four"));
      charts.showLoading();
      charts.setOption({
        title: [{
          text: "时程季活曲线",
          top: "top",
          left: "10px",
          textStyle: {
            color: "#596471",
            fontSize: 17,
            fontWeight: 100
          }
        }],
        tooltip: {
          trigger: "axis",
          position: function position(pt) {
            return [pt[0], "10%"];
          },
          formatter: "{b0}<br/>{a0}: {c0}人"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        dataZoom: {
          type: "inside",
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisFour,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        series: [{
          name: "人",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          itemStyle: {
            color: "#546E7A" },
          areaStyle: {
            normal: {
              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#90A4AE"
              }, {
                offset: 1,
                color: "#546E7A"
              }])
            }
          },
          data: this.chartsDataFour,
          lineStyle: {
            color: "#546E7A",
            width: 2
          }
        }]
      });
      charts.hideLoading();
      this.loading = false;
      window.addEventListener("resize", function () {
        charts.resize();
      });
    }
  },

  filters: {
    numberSlice: function numberSlice(val) {
      var num = (val + "").replace(/\B(?=(?:\d{3})+\b)/g, ",");
      if (num === "undefined") {
        num = "";
      }
      return num;
    }
  },

  components: {
    LeftCharts: _leftCharts2.default,
    RightCharts: _rightCharts2.default,
    Census: _census2.default,
    CensusBar: _censusBar2.default,
    ActiveModal: _modal2.default
  }
};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(90);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(89);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _SelectCommon = __webpack_require__(74);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _GisCommon = __webpack_require__(164);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cityOptions = ['模块1', '模块2', '模块3', '模块4', '模块5', '模块6'];
exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _this2 = this,
        _ref2;

    var validateAddress = function validateAddress(rule, value, callback) {
      if (_this2.editForm0.longitudeAndLatitude === '') {
        callback(new Error('请填写客户地址'));
      } else {
        if (_this2.editForm0.province == '' || _this2.editForm0.city == '' || _this2.editForm0.district == '' || _this2.editForm0.addressInfo == '') {
          _this2.$refs.editForm0.validateField('longitudeAndLatitude');
        }
        callback();
      }
    };

    var validatoPhone = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var reg, res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reg = /^1[3-9]\d{9}$/;

                if (_this2.editForm0.phone) {
                  _context.next = 5;
                  break;
                }

                callback("请输入手机号");
                _context.next = 14;
                break;

              case 5:
                if (reg.test(_this2.editForm0.phone)) {
                  _context.next = 9;
                  break;
                }

                callback(new Error("请输入正确的手机号"));
                _context.next = 14;
                break;

              case 9:
                if (!(_this2.oldPhone != _this2.editForm0.phone)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return _this2.checkPhone(_this2.editForm0.phone);

              case 12:
                res = _context.sent;

                !res ? callback('当前手机号已被注册') : callback();

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function validatoPhone(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    return _ref2 = {
      downHrefExcel: '',
      downHref: '',
      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName: "",
      searchName: this.$route.query.searchName ? this.$route.query.searchName : '',
      dynamicTags: [],
      optionsSouch: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '软件类型', label: '软件类型' }, { value: '邀请状态', label: '邀请状态' }, { value: '开始日期', label: '开始日期' }, { value: '结束日期', label: '结束日期' }],
      value: '',
      inviValues: [],
      softtypes: [],
      yhlx: [],
      zhlx: [],
      editLoading0: false,

      editForm0: {
        managerAdminuser: '',
        successfulManager: "",
        agencyManager: "",
        userType: 0,
        code: 0,

        province: '',
        city: '',
        district: '',
        longitudeAndLatitude: '',
        addressInfo: '',

        selected: { province: '320000', city: '320100', area: '320115', town: '320115010' },
        address: '',
        companyuseid: '',
        company: '',

        fileUploadName: ''
      },

      curCompanyId: '',

      editFormVisible0: false,
      rules: {
        phone: [{ required: true, message: '请输入邮箱', trigger: 'blur' }, { type: 'email', message: '邮箱格式不正确', trigger: ['blur', 'change'] }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        code: [{ required: false, message: '请选择软件类型', trigger: 'change' }],
        userType: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        company: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        companyuseid: [{ required: true, message: '请选择企业', trigger: 'change' }],
        passwordMo: [{ required: true, message: '请输入密码', trigger: 'blur' }],

        managerAdminuser: [{ required: true, message: '请选择客户经理', trigger: 'change' }],

        longitudeAndLatitude: [{ required: true, validator: validateAddress, trigger: 'change' }]

      },
      addCode: '0',

      falseLoading: false,
      cities: [],
      citiesd: [],
      userModule: [],
      editFormVisible: false,
      editForm: {},
      editLoading: false,
      options: [{
        value: '1',
        label: '一个月'
      }, {
        value: '2',
        label: '二个月'
      }, {
        value: '3',
        label: '三个月'
      }, {
        value: '4',
        label: '四个月'
      }, {
        value: '5',
        label: '五个月'
      }, {
        value: '6',
        label: '六个月'
      }],
      id: '',
      token: '',
      checkCode: '',
      listLoading: false,
      souchs: {
        phone: '',
        name: '',
        company: '',
        fromtime: this.$route.query.fromtime ? this.$route.query.fromtime : '',
        totime: this.$route.query.totime ? this.$route.query.totime : ''
      },
      orderStr: '',
      orderType: '',
      pageNumber: 1,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 20,
      total: 0,
      users: [],

      appFormVisible: false,
      appForm: {
        checkedCities: [],
        value: ''
      },
      appLoading: false

    }, (0, _defineProperty3.default)(_ref2, 'editForm', {
      checkedCities: [],
      value: ''
    }), (0, _defineProperty3.default)(_ref2, 'asTitle', '编辑'), (0, _defineProperty3.default)(_ref2, 'modalType', 0), (0, _defineProperty3.default)(_ref2, 'fileFormData', ''), (0, _defineProperty3.default)(_ref2, 'companyList', []), (0, _defineProperty3.default)(_ref2, 'fileUploadName', ''), (0, _defineProperty3.default)(_ref2, 'oldPhone', ''), (0, _defineProperty3.default)(_ref2, 'managerAdminuser', this.$route.query.managerAdminuser ? this.$route.query.managerAdminuser : ''), (0, _defineProperty3.default)(_ref2, 'isCompanyUser', this.$route.query.isCompanyUser ? this.$route.query.isCompanyUser : ''), (0, _defineProperty3.default)(_ref2, 'successfulManager', ''), (0, _defineProperty3.default)(_ref2, 'agencyManager', ""), (0, _defineProperty3.default)(_ref2, 'distribution', [{ value: '0', label: '未分配' }, { value: '1', label: '已分配' }]), (0, _defineProperty3.default)(_ref2, 'distributionStatus', this.$route.query.distributionStatus ? this.$route.query.distributionStatus : ''), (0, _defineProperty3.default)(_ref2, 'deptId', ''), (0, _defineProperty3.default)(_ref2, 'detpList', []), _ref2;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default,
    SelectCommon: _SelectCommon2.default,
    GisCommon: _GisCommon2.default
  },

  created: function created() {
    this.getCookie();
    this.getCode1();
    this.getCode2();
    if (this.$route.query.type == 1) {
      this.dynamicTags = this.$route.query.dynamicTags ? JSON.parse(this.$route.query.dynamicTags) : '';
      this.souchs = this.$route.query.souchs ? JSON.parse(this.$route.query.souchs) : {};
      this.pageNumber = this.$route.query.pageNumber ? JSON.parse(this.$route.query.pageNumber) : 1;
    }
    this.getUser();
    this.getModels();
    this.getCode();

    this.downHref = _index.API_Admin.userExcelTemplate() + "?token=" + this.token + "&checkCode=" + this.checkCode;
  },


  methods: {
    checkPhone: function checkPhone(phone) {
      return _index.API_Admin.checkPhoneUnique({ phone: phone }).then(function (res) {
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    handerChange: function handerChange(val, key) {
      this.detpList = [];
      if (key == 'addCode') {
        this.addCode = val + '';
        this.editForm0.userType = this.addCode;

        this.curCompanyId = '';
        this.editForm0.company = '';
        this.editForm0.companyuseid = '';
        this.editForm0.managerAdminuser = this.userInfo.type == 2 ? this.userInfo.id : '';
        this.editForm0.successfulManager = this.userInfo.type == 3 ? this.userInfo.id : '';
        this.editForm0.agencyManager = this.userInfo.type == 4 ? this.userInfo.id : '';

        this.initMap({
          addressInfo: '',
          longitudeAndLatitude: '',
          province: "{\"key\":\"320000\",\"value\":\"江苏省\"}",
          city: "{\"key\":\"320100\",\"value\":\"南京市\"}",
          district: "{\"key\":\"320115\",\"value\":\"江宁区\"}"
        });
      } else {
        this[key] = val;

        if (key == 'curCompanyId') {
          var data = this.companyList.find(function (item) {
            return item.id == val;
          });
          this.initMap(data);
          this.getDeptList(val);
        }
      }
    },
    importFile: function importFile(form) {
      var _this3 = this;

      var _self = this;
      this.$refs[form].validate(function (valid) {
        if (valid) {
          var file = _this3.fileFormData;
          if (!file) {
            _self.$message.error('请选择文件');
            return;
          }

          var formData = new FormData();
          formData.append("file", file);
          var createAdminUser = _this3.userInfo.id;
          var password = _this3.editForm0.passwordMo ? _this3.editForm0.passwordMo : '123456';
          var companyuseid = '';
          var company = '';
          var addCode = _this3.addCode;
          var code = _this3.editForm0.code;
          if (_this3.addCode == 1) {
            companyuseid = _this3.editForm0.companyuseid;
            var list = (0, _assign2.default)([], _this3.companyList);
            var name = '';
            for (var p in list) {
              if (list[p].id == _this3.editForm0.companyuseid) {
                name = list[p].name;
              }
            }
            formData.append("company", name);
            company = decodeURIComponent(name);
          } else {
            formData.append("company", _this3.editForm0.company);
            companyuseid = '';
          }
          _this3.editLoading0 = true;
          var _this = _this3;

          var _editForm = _this3.editForm0,
              province = _editForm.province,
              city = _editForm.city,
              district = _editForm.district;


          formData.append("addressInfo", _this3.editForm0.addressInfo);
          formData.append("city", city);
          formData.append("province", province);
          formData.append("district", district);
          var param = 'usertype=' + addCode + '&password=' + password + '&companyuseid=' + companyuseid + '&code=' + (code + '') + '&createAdminUser=' + createAdminUser + '&longitudeAndLatitude=' + _this3.editForm0.longitudeAndLatitude + '&deptid=' + _this3.deptId + '&managerAdminuser=' + _this3.editForm0.managerAdminuser + '&successfulManager=' + _this3.editForm0.successfulManager + '&agencyManager=' + _this3.editForm0.agencyManager;

          _index.API_Admin.importUserExcelfile(param, formData).then(function (res) {
            if (res.data.code == '401') {
              _this.$message.error(res.data.message);
            } else {
              _this.$message.success('导入成功！');
              _this.getUser();
              _this.$refs.clearFileModal.value = "";
              _this.editFormVisible0 = false;
              _this.$refs[form].resetFields();
              _this.deptId = '';
            }
            _this.editLoading0 = false;
          }).catch(function (err) {
            _this.$message.error('导入失败！');
            _this.editLoading0 = false;
          });
        } else {
          return false;
        }
      });
    },
    fileInputChange: function fileInputChange(files) {
      var file = files.target.files[0];
      var type = file.type;
      if (type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || type == "application/vnd.ms-excel") {
        this.fileFormData = file;
        this.fileUploadName = file.name;
        this.$refs.clearFileModal.value = "";
      } else {
        this.$message.error('请上传xlsx/xls格式文件！');
      }
    },
    backPram: function backPram(param) {
      this.editForm0.province = (0, _stringify2.default)(param.selected.province);
      this.editForm0.city = (0, _stringify2.default)(param.selected.city);
      this.editForm0.district = (0, _stringify2.default)(param.selected.area);
      this.editForm0.longitudeAndLatitude = param.position.toString();
      this.editForm0.addressInfo = param.address;
      this.$refs.editForm0.validateField('longitudeAndLatitude');
    },
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.editForm0[key] = value[0];
      this.$refs.editForm0.validateField(key);
    },
    addUser: function addUser(type) {
      this.asTitle = type == 1 ? '新增' : '导入';
      this.editFormVisible0 = true;
      this.modalType = type;

      this.rules.passwordMo[0].required = true;

      this.editForm0 = {
        managerAdminuser: this.userInfo.type == 2 ? this.userInfo.id : '',
        successfulManager: this.userInfo.type == 3 ? this.userInfo.id : '',
        agencyManager: this.userInfo.type == 4 ? this.userInfo.id : '',
        code: 0,

        province: '',
        city: '',
        district: '',
        longitudeAndLatitude: '',
        addressInfo: '',

        selected: { province: '320000', city: '320100', area: '320115', town: '320115010' },
        address: '',
        company: ''
      }, this.addCode = '0';
      this.editForm0.userType = '0';
      this.fileUploadName = '';
      this.$refs['editForm0'] && this.$refs['editForm0'].resetFields();
    },
    handleClose: function handleClose(tag) {
      if (tag == "账号") {
        this.souchs.phone = '';
        if (this.value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs.name = '';
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.company = '';
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "软件类型") {
        this.souchs.softtype = "";
      }
      if (tag == "邀请状态") {
        this.souchs.invitValue = "";
      }
      if (tag == "开始日期") {
        this.souchs.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs.totime = "";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },


    delTags: function delTags() {
      this.souchs = {};
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getUser();
    },

    readUser: function readUser(index, row) {
      this.$router.push({
        path: '/userDetail',
        query: {
          userId: row.id,
          name: row.name,
          dynamicTags: (0, _stringify2.default)(this.dynamicTags),
          souchs: (0, _stringify2.default)(this.souchs),
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          searchName: this.searchName,
          isCompanyUser: this.isCompanyUser,
          fromtime: this.souchs.fromtime,
          totime: this.souchs.totime,
          managerAdminuser: this.managerAdminuser,
          distributionStatus: this.distributionStatus,
          phone: row.phone
        }
      });
    },

    changeSouch: function changeSouch(val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName = this.souchs.phone;
        this.disSouch = true;
      } else if (val == "姓名") {
        this.proName = this.souchs.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs.company;
        this.disSouch = true;
      } else if (val == "软件类型") {
        this.disSofttype = true;
      } else if (val == "邀请状态") {
        this.disinvit = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "phone") {
          this.orderStr = "phoneOrder";
        } else if (val.prop == "name") {
          this.orderStr = "nameOrder";
        } else if (val.prop == "point") {
          this.orderStr = "pointOrder";
        } else if (val.prop == "userName") {
          this.orderStr = "usertypeOrder";
        } else if (val.prop == "softtype") {
          this.orderStr = "codeOrder";
        } else if (val.prop == "registertime") {
          this.orderStr = "registertimeOrder";
        } else if (val.prop == "company") {
          this.orderStr = "companyOrder";
        } else if (val.prop == "adminName") {
          this.orderStr = "managerAdminuser";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getUser();
    },

    falseSubmit: function falseSubmit() {
      var _this4 = this;

      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + 1;
      var day = nowDate.getDate();
      var hours = nowDate.getHours();
      var minutes = nowDate.getMinutes();
      var seconds = nowDate.getSeconds();
      if (seconds < 10) {
        seconds = '0' + seconds;
      }

      var itime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      var monthNum = -this.appForm.value;
      var days = new Date(year, month, 0);
      days = days.getDate();
      var year2 = year;
      var month2 = parseInt(month) - monthNum;
      if (month2 <= 0) {
        year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : parseInt(month2) / 12);
        month2 = 12 - Math.abs(month2) % 12;
      }
      var day2 = parseInt(day) + 1;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = '01';
        month2 = parseInt(month2) + 1;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2 + ' 23-59-59';

      var userModuled = {
        "status": false,
        "date": itime,
        "time": t2,
        "duration": this.appForm.value,
        "module": this.userModule
      };
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.appForm.id,

        userModule: []
      };
      this.appLoading = true;
      _index.API_Admin.setUserModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: '审批成功',
            type: 'success'
          });
          _this4.appFormVisible = false;
          _this4.getUser();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
        _this4.appLoading = false;
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
        _this4.appLoading = false;
      });
    },

    editSubmit: function editSubmit() {
      var _this5 = this;

      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + 1;
      var day = nowDate.getDate();
      var hours = nowDate.getHours();
      var minutes = nowDate.getMinutes();
      var seconds = nowDate.getSeconds();
      if (seconds < 10) {
        seconds = '0' + seconds;
      }

      var itime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      var monthNum = -this.editForm.value;
      var days = new Date(year, month, 0);
      days = days.getDate();
      var year2 = year;
      var month2 = parseInt(month) - monthNum;
      if (month2 <= 0) {
        year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : parseInt(month2) / 12);
        month2 = 12 - Math.abs(month2) % 12;
      }
      var day2 = parseInt(day) + 1;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = '01';
        month2 = parseInt(month2) + 1;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2 + ' 23-59-59';

      var userModuled = {
        "status": true,
        "date": itime,
        "time": t2,
        "duration": this.editForm.value,
        "module": this.userModule
      };
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.editForm.id,
        userModule: (0, _stringify2.default)(userModuled)
      };
      this.editLoading = true;
      _index.API_Admin.setUserModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.$message({
            message: '授权成功',
            type: 'success'
          });
          _this5.editFormVisible = false;
          _this5.getUser();
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.editLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.editLoading = false;
      });
    },

    appSubmit: function appSubmit() {
      var _this6 = this;

      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month = nowDate.getMonth() + 1;
      var day = nowDate.getDate();
      var hours = nowDate.getHours();
      var minutes = nowDate.getMinutes();
      var seconds = nowDate.getSeconds();
      if (seconds < 10) {
        seconds = '0' + seconds;
      }

      var itime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      var monthNum = -this.appForm.value;
      var days = new Date(year, month, 0);
      days = days.getDate();
      var year2 = year;
      var month2 = parseInt(month) - monthNum;
      if (month2 <= 0) {
        year2 = parseInt(year2) - parseInt(month2 / 12 == 0 ? 1 : parseInt(month2) / 12);
        month2 = 12 - Math.abs(month2) % 12;
      }
      var day2 = parseInt(day) + 1;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = '01';
        month2 = parseInt(month2) + 1;
      }
      if (month2 < 10) {
        month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2 + ' 23-59-59';

      var userModuled = {
        "status": true,
        "date": itime,
        "time": t2,
        "duration": this.appForm.value,
        "module": this.userModule
      };
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.appForm.id,
        userModule: (0, _stringify2.default)(userModuled),
        moduleStatus: '1',
        phone: this.token
      };
      this.appLoading = true;
      _index.API_Admin.setUserModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this6.$message({
            message: '审批成功',
            type: 'success'
          });
          _this6.appFormVisible = false;
          _this6.getUser();
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
        _this6.appLoading = false;
      }).catch(function (err) {
        _this6.$message.error('数据丢失，试试重新登陆！');
        _this6.appLoading = false;
      });
    },

    editSubmit0: function editSubmit0(form) {
      var _this7 = this;

      this.$refs[form].validate(function (valid) {
        if (valid) {
          var param = void 0;

          _this7.editLoading0 = true;
          var methods = 'modifyUser';
          if (_this7.modalType == 1) {
            methods = 'addUserSingle';
            param = {
              token: _this7.token,
              checkCode: _this7.checkCode,
              mode: 'update',
              name: _this7.editForm0.name,
              phone: _this7.editForm0.phone,
              code: _this7.editForm0.code,
              company: _this7.editForm0.company,
              id: _this7.editForm0.id,
              userType: _this7.addCode,
              password: _this7.editForm0.passwordMo ? _this7.editForm0.passwordMo : '',
              companyuseid: '',

              province: _this7.editForm0.province,
              city: _this7.editForm0.city,
              district: _this7.editForm0.district,
              longitudeAndLatitude: _this7.editForm0.longitudeAndLatitude,
              addressInfo: _this7.editForm0.addressInfo,
              managerAdminuser: _this7.editForm0.managerAdminuser,
              createAdminUser: _this7.userInfo.id,
              successfulManager: _this7.editForm0.successfulManager,
              agencyManager: _this7.editForm0.agencyManager };
            param['password'] = _this7.editForm0.passwordMo ? _this7.editForm0.passwordMo : '123456';
          } else {
            param = {
              token: _this7.token,
              checkCode: _this7.checkCode,
              mode: 'update',
              name: _this7.editForm0.name,
              phone: _this7.editForm0.phone,
              code: _this7.editForm0.code,
              company: _this7.editForm0.company,
              id: _this7.editForm0.id,
              usertype: _this7.addCode,
              password: _this7.editForm0.passwordMo ? _this7.editForm0.passwordMo : '',
              companyuseid: '',

              province: _this7.editForm0.province,
              city: _this7.editForm0.city,
              district: _this7.editForm0.district,
              longitudeAndLatitude: _this7.editForm0.longitudeAndLatitude,
              addressInfo: _this7.editForm0.addressInfo,
              managerAdminuser: _this7.editForm0.managerAdminuser,
              createAdminUser: _this7.userInfo.id,
              successfulManager: _this7.editForm0.successfulManager,
              agencyManager: _this7.editForm0.agencyManager };
            param['registertime'] = _this7.editForm0.registertimeyuan;
          }

          if (_this7.addCode == 1) {
            param['companyuseid'] = _this7.editForm0.companyuseid;
            var list = (0, _assign2.default)([], _this7.companyList);
            var name = '';
            for (var p in list) {
              if (list[p].id == _this7.editForm0.companyuseid) {
                name = list[p].name;
              }
            }
            param['company'] = name;
          }

          _index.API_Admin[methods](param).then(function (res) {
            if (res.data.code == _index.API__code.SUCCESS) {
              _this7.$message({
                message: _this7.modalType == 0 ? '修改成功' : '新增成功',
                type: 'success'
              });
              _this7.editFormVisible0 = false;
              _this7.$refs[form].resetFields();
              _this7.getUser();
            } else {
              _this7.$message.error(res.data.message);
              _this7.editForm0.passwordMo = '';
              if (res.data.code == 403) {
                _this7.$router.push({ path: 'loginAdmin' });
              }
            }
            _this7.editLoading0 = false;
          }).catch(function (err) {
            _this7.$message.error('数据丢失，试试重新登陆！');
            _this7.editLoading0 = false;
          });
        } else {
          return false;
        }
      });
    },

    initMap: function initMap(mapData) {
      var _this8 = this;

      var mapDataBack = JSON.parse((0, _stringify2.default)(mapData));
      try {
        var province = mapData.province,
            city = mapData.city,
            district = mapData.district,
            addressInfo = mapData.addressInfo,
            _mapData$longitudeAnd = mapData.longitudeAndLatitude,
            longitudeAndLatitude = _mapData$longitudeAnd === undefined ? '' : _mapData$longitudeAnd;

        province = JSON.parse(province);
        city = JSON.parse(city);
        district = JSON.parse(district);
        setTimeout(function () {
          _this8.editForm0.selecteds = { province: province.key, city: city.key, area: district.key, town: '' };
          _this8.editForm0.address = addressInfo;
          _this8.$refs.GisCommon.changePro(_this8.editForm0.selecteds);
          _this8.$refs.GisCommon.changItem(addressInfo);
          longitudeAndLatitude = longitudeAndLatitude ? longitudeAndLatitude.split(',').map(function (item) {
            return parseInt(item);
          }) : '';
          _this8.$refs.GisCommon.changePos(longitudeAndLatitude);

          _this8.editForm0.longitudeAndLatitude = typeof longitudeAndLatitude === 'string' ? longitudeAndLatitude : longitudeAndLatitude.join();
          _this8.editForm0.province = mapDataBack.province;
          _this8.editForm0.city = mapDataBack.city;
          _this8.editForm0.district = mapDataBack.district;
          _this8.editForm0.addressInfo = mapDataBack.addressInfo;

          _this8.$refs.editForm0.validateField('longitudeAndLatitude');
        }, 100);
      } catch (e) {
        this.editForm0.selecteds = { province: '320000', city: '320100', area: '320115', town: '' };
        this.editForm0.address = '';
      }
    },

    handleEdit0: function handleEdit0(index, row) {
      this.editFormVisible0 = true;
      this.asTitle = '编辑';
      this.modalType = 0;

      this.rules.passwordMo[0].required = false;
      this.editForm0 = (0, _assign2.default)({}, row);
      this.addCode = this.editForm0.companyuseid ? '1' : '0';

      this.editForm0.userType = this.addCode;
      this.oldPhone = this.editForm0.phone;
      this.initMap(row);
    },

    handledel: function handledel(index, row) {
      var _this9 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this9.token,
          checkCode: _this9.checkCode,
          id: row.id
        };
        _index.API_Admin.delUser(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this9.$message({
              message: '删除成功',
              type: 'success'
            });
            _this9.getUser();
          } else {
            _this9.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this9.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this9.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },

    handleEdit2: function handleEdit2(index, row) {
      this.userModule = [];
      this.appForm.checkedCities = [];
      this.appForm.id = row.id;
      var moduled = JSON.parse(row.module);
      this.appForm.value = moduled.duration;
      for (var i = 0; i < this.citiesd.length; i++) {
        for (var k = 0; k < moduled.module.length; k++) {
          if (moduled.module[k].id == this.citiesd[i].id) {
            this.appForm.checkedCities.push(this.citiesd[i].modulename);
            var jsoned = { "id": this.citiesd[k].id };
            this.userModule.push(jsoned);
          }
        }
      }

      this.appFormVisible = true;
    },

    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      this.userModule = [];
      for (var i = 0; i < value.length; i++) {
        for (var k = 0; k < this.citiesd.length; k++) {
          if (value[i] == this.citiesd[k].modulename) {
            var jsoned = { "id": this.citiesd[k].id };
            this.userModule.push(jsoned);
          }
        }
      }
    },

    handleEdit: function handleEdit(index, row) {
      this.editForm = {
        checkedCities: [],
        value: '',
        id: row.id
      };
      this.editFormVisible = true;
    },

    forType: function forType(row, column) {
      if (row.usertype == 1) {
        return row.userType = '企业账号';
      } else {
        return row.userType = '个人账号';
      }
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref3) {
      var row = _ref3.row,
          column = _ref3.column,
          rowIndex = _ref3.rowIndex,
          columnIndex = _ref3.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },

    getUser: function getUser(val) {
      var _this10 = this;

      if (this.value == "账号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.company = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }

      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        userType: '',

        username: this.souchs.name,
        phone: this.souchs.phone,
        company: this.souchs.company,
        registertimefrom: this.souchs.fromtime,
        registertimeto: this.souchs.totime,
        softtype: this.souchs.softtype,
        invitestatus: this.souchs.invitValue,
        fpFlg: this.distributionStatus,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        managerAdminuser: this.managerAdminuser,
        successfulManager: this.successfulManager,
        agencyManager: this.agencyManager,
        searchName: this.searchName,
        isCompanyUser: this.isCompanyUser

      };

      this.downHrefExcel = _index.API_User.allUserByExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&registertimefrom=" + (this.souchs.fromtime || '') + "&registertimeto=" + (this.souchs.totime || '') + "&softtype=" + (this.souchs.softtype || '') + "&invitestatus=" + (this.souchs.invitestatus || '') + "&phone=" + (this.souchs.phone || '') + "&company=" + (this.souchs.company || '') + "&searchName=" + this.searchName + "&isCompanyUser=" + this.isCompanyUser + "&managerAdminuser=" + this.managerAdminuser + "&fpFlg=" + this.distributionStatus + "&username=" + (this.souchs.name || '') + "";
      this.listLoading = true;
      _index.API_User.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              res.data.data.list[i].registertimeyuan = res.data.data.list[i].registertime;
              if (res.data.data.list[i].registertime) {
                res.data.data.list[i].registertime = res.data.data.list[i].registertime.substring(0, 10);
              }
            }
            _this10.total = res.data.data.totalRow;
            _this10.users = res.data.data.list;
            _this10.listLoading = false;
          }
        } else {
          _this10.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this10.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this10.$message.error('数据丢失，试试重新登陆！');
      });
    },
    getModels: function getModels() {
      var _this11 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Models.getAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this11.models = res.data.data;
          _this11.cities = [];
          _this11.citiesd = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this11.cities.push(res.data.data[i].modulename);
            var jsones = { "modulename": res.data.data[i].modulename, "id": res.data.data[i].id };
            _this11.citiesd.push(jsones);
          }
        } else {
          _this11.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this11.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this11.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },

    getCode1: function getCode1() {
      var _this12 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        role: this.userInfo.type,
        userId: this.userInfo.id
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.yhlx = [];
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.yhlx.push(jsons);
            var json = { 'value': res.data.data[i].code, 'label': res.data.data[i].name };
            _this.softtypes.push(json);
          }
        } else {
          _this12.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this12.$router.push({ path: 'loginAdmin' });
          }
        }
      });
      param.userType = this.userInfo.type;
      _index.API_Admin.tbCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this12.companyList = res.data.data;
        }
      });
    },
    getCode2: function getCode2() {
      var _this13 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.AccList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.zhlx = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.zhlx.push(jsons);
          }
        } else {
          _this13.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this13.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },

    getCode: function getCode() {
      var _this14 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "label": res.data.data[i].name };
            _this.inviValues.push(jsons);
          }
        } else {
          _this14.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this14.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    getDeptList: function getDeptList(companyid) {
      var _this15 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: companyid
      };
      _index.API_userCom.getDepartList(param).then(function (res) {
        if (res.data.code == 200) {
          _this15.detpList = res.data.data;
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    cancelHandler: function cancelHandler() {
      this.editFormVisible0 = false;
      this.deptId = '';
    },

    dialogClose: function dialogClose() {
      console.log('dialogClose');
      this.deptId = '';
    }
  }

};

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(90);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(89);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _GisCommon = __webpack_require__(164);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _addAdmin = __webpack_require__(758);

var _addAdmin2 = _interopRequireDefault(_addAdmin);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _SelectCommon = __webpack_require__(74);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

var _targetCustomDialog = __webpack_require__(753);

var _targetCustomDialog2 = _interopRequireDefault(_targetCustomDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _this2 = this;

    var validatorCompany = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.addForm.name) {
                  _context.next = 4;
                  break;
                }

                callback("请输入企业名称");
                _context.next = 8;
                break;

              case 4:
                _context.next = 6;
                return _this2.checkCompany(_this2.addForm.name);

              case 6:
                res = _context.sent;

                !res ? callback("企业名称已存在") : callback();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function validatorCompany(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      beformAddImg: "",
      editImageUrl: "",
      adminVisible: false,
      imageUrl: "",
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: _index.API_Common.setCompanyPic(),
        dialogImageUrl: "",
        dialogVisible: false,
        data: {
          mode: "save",
          token: this.token,
          checkCode: this.checkCode,
          type: 1
        }
      },

      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName2: "",
      dynamicTags2: [],
      optionsSouch2: [{ value: "账号", label: "账号" }, { value: "姓名", label: "姓名" }, { value: "企业", label: "企业" }, { value: "软件类型", label: "软件类型" }, { value: "邀请状态", label: "邀请状态" }, { value: "开始日期", label: "开始日期" }, { value: "结束日期", label: "结束日期" }],
      value2: "",
      inviValues: [],
      softtypes: [],

      proName: "",
      dynamicTags: [],
      options: [{ value: "ID", label: "ID" }, { value: "企业名称", label: "企业名称" }, { value: "管理员", label: "管理员" }],
      value: "",

      rname: "",
      companyId: "",
      orderLoading: false,
      userLoading: false,
      orderVisible: false,
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      userList: [],
      souchs2: {
        name: "",
        phone: "",
        company: "",
        invitestatus: "",
        softtype: "",
        fromtime: "",
        totime: ""
      },
      flag: false,
      checkUserId: "",
      checkUserIdOld: "",
      token: this.token,
      checkCode: this.checkCode,
      id: this.id,
      souchs: {
        name: ""
      },
      total: 0,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 20,
      pageNumber: 1,
      proList: [],
      listLoading: false,
      sels: [],

      addFormVisible: false,
      addLoading: false,
      addForm: {
        name: "",
        showname: "",
        province: "",
        city: "",
        district: "",
        longitudeAndLatitude: "",
        addressInfo: "",
        managerAdminuser: "",
        managerAdminuserName: ""
      },

      addFormRules: {
        name: [{ required: true, validator: validatorCompany, trigger: "change" }],
        showname: [{ required: true, message: "请输入地区", trigger: "blur" }]
      },

      editFormVisible: false,
      editLoading: false,
      editForm: {
        name: ""
      },
      editFormRules: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }]
      },
      orderType: "",
      orderStr: "",

      userSelection: [],
      UserSelection: [],
      searchText: this.$route.query.searchText ? this.$route.query.searchText : "",
      selected: {
        province: "320000",
        city: "320100",
        area: "320115",
        town: "320115010"
      },
      address: "",

      comLists: [],

      statusArr: [{ value: 1, label: "拜访" }, { value: 2, label: "试用 " }, { value: 3, label: "正式" }],
      gradeArr: [{ value: '1', label: "综合甲" }, { value: '2', label: "公路甲 " }, { value: '3', label: "市政甲" }, { value: '4', label: "公路市政甲" }, { value: '5', label: "公路乙" }, { value: '6', label: "市政乙" }, { value: '7', label: "公路市政乙" }, { value: '9', label: "高校" }, { value: '10', label: "施工单位" }, { value: '8', label: "其他" }],
      gradeValue: [],
      status: this.$route.query.status ? this.$route.query.status : "",
      distribution: [{ value: "0", label: "未分配" }, { value: "1", label: "已分配" }],
      distributionStatus: this.$route.query.distributionStatus ? this.$route.query.distributionStatus : "",
      managerAdminuser: this.$route.query.managerAdminuserName,
      successfulManager: '',
      agencyManager: "",
      targetTotal: 0,
      qualityTotal: 0,
      collegesTotal: 0,
      regionCodeList: [{
        value: "1",
        label: "华东大区"
      }, {
        value: "2",
        label: "华北大区"
      }, {
        value: "3",
        label: "西北大区"
      }, {
        value: "4",
        label: "华南大区"
      }, {
        value: "5",
        label: "西南大区"
      }],
      regionCode: ""
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["userInfo"])),

  components: {
    BaseContainer: _BaseContainer2.default,
    SelectCommon: _SelectCommon2.default,
    Admin: _addAdmin2.default,
    GisCommon: _GisCommon2.default,
    TargetCustomDialog: _targetCustomDialog2.default
  },
  methods: {
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    },
    querySearch: function querySearch(queryString, cb) {
      var comLists = this.comLists;
      var results = queryString ? comLists.filter(this.createFilter(queryString)) : comLists;

      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    loadCompany: function loadCompany() {
      this.getCompanySearch();
    },
    handleSelect: function handleSelect(item) {
      console.log("select==", this.addForm.name, item);
    },
    getCompanySearch: function getCompanySearch() {
      var _this3 = this;

      _index.API_User.getCompanySearch().then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var data = res.data.data;
          _this3.comLists = data.map(function (item) {
            return { value: item };
          });
          sessionStorage.setItem("comLists", (0, _stringify2.default)(_this3.comLists));
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: "loginAdmin" });
          }
        }
      }).catch(function (err) {});
    },
    checkCompany: function checkCompany(name) {
      return _index.API_User.checkCompanyUnique({ name: name }).then(function (res) {
        console.log("ressss--", res);
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    closedialog: function closedialog() {
      this.selected = {
        province: "320000",
        city: "320100",
        area: "320115",
        town: "320115010"
      };
      this.addForm.longitudeAndLatitude = "";
      this.addForm.addressInfo = "";
      this.addForm.managerAdminuser = "";
      this.imageUrl = "";
      this.beformAddImg = "";
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.addForm.managerAdminuser = value[0];
    },
    addAdmin: function addAdmin() {
      this.getUser();
      this.userSelection = [];
      this.orderVisible = true;
    },
    adminVisibleClose: function adminVisibleClose(type) {
      this.adminVisible = false;
      if (type == 1) {
        this.getList();
      }
    },
    handleUserSelectionChange: function handleUserSelectionChange(rowSelect) {
      var jc = [];
      var row = [];
      for (var p in rowSelect) {
        if (jc.indexOf(rowSelect[p].id) == -1) {
          jc.push(rowSelect[p].id);
          row.push(rowSelect[p]);
        }
      }
      this.userSelection = row;
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;
        this.imageUrl = URL.createObjectURL(file.raw);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error("请选择图片文件");
      }
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "id") {
          this.orderStr = "idpx";
        } else if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "managername") {
          this.orderStr = "managernamepx";
        } else if (val.prop == "showname") {
          this.orderStr = "shownamepx";
        } else if (val.prop == "regionCode") {
          this.orderStr = "regionCodepx";
        } else if (val.prop == "grade") {
          this.orderStr = "gradepx";
        } else if (val.prop == "natrue") {
          this.orderStr = "natruepx";
        } else if (val.prop == "userScale") {
          this.orderStr = "userScalepx";
        } else if (val.prop == "level") {
          this.orderStr = "levelpx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch2: function changeSouch2(val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName2 = this.souchs2.phone;
        this.disSouch = true;
      } else if (val == "姓名") {
        this.proName2 = this.souchs2.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName2 = this.souchs2.company;
        this.disSouch = true;
      } else if (val == "软件类型") {
        this.disSofttype = true;
      } else if (val == "邀请状态") {
        this.disinvit = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },
    handleClose2: function handleClose2(tag) {
      if (tag == "账号") {
        this.souchs2.phone = "";
        if (this.value2 == "账号") {
          this.proName2 = "";
        }
      }
      if (tag == "姓名") {
        this.souchs2.name = "";
        if (this.value2 == "姓名") {
          this.proName2 = "";
        }
      }
      if (tag == "企业") {
        this.souchs2.company = "";
        if (this.value2 == "企业") {
          this.proName2 = "";
        }
      }
      if (tag == "软件类型") {
        this.souchs2.softtype = "";
      }
      if (tag == "邀请状态") {
        this.souchs2.invitValue = "";
      }
      if (tag == "开始日期") {
        this.souchs2.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs2.totime = "";
      }
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1);
    },

    delTags2: function delTags2() {
      this.souchs2 = {};
      this.proName2 = "";
      this.value2 = "";
      this.dynamicTags2 = [];
      this.pageNumber2 = 1;
      this.getUser();
    },

    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getUser();
    },
    clickUserSelection: function clickUserSelection() {
      var _this = this;
      var list = (0, _assign2.default)([], this.userSelection);
      this.UserSelection = list;
      this.orderVisible = false;
    },

    orderUserSubmit: function orderUserSubmit(rows) {
      var _this4 = this;

      console.log(rows);
      var _this = this;

      var list = (0, _assign2.default)([], rows);

      var UserIds = [];
      for (var p in list) {
        UserIds.push(list[p].id);
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyId,
        userid: UserIds.toString()
      };
      _index.API_User.setCompanyManager(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: "保存成功",
            type: "success"
          });
          _this4.adminVisible = false;
          _this4.getList();
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: "loginAdmin" });
          }
        }
      }).catch(function (err) {
        _this.$message.error("数据丢失，试试重新登陆！");
      });
    },
    changeFun: function changeFun(e, val) {
      if (!e) {
        this.checkUserId = "";
      }
      if (e && !this.flag) {
        this.checkUserId = this.checkUserIdOld;
      }
      this.flag = false;
    },
    handleSelectionChange: function handleSelectionChange(row) {
      this.flag = true;
      this.userList.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
        }
        if (item.id == row.id) {
          item.checked = true;
        }
      });
      if (row.name == null) {
        row.name = "";
      }
      if (row.phone == null) {
        row.phone = "";
      }
      this.checkUserId = row.id;
      this.checkUserIdOld = row.id;
    },

    getUser: function getUser(val) {
      var _this = this;
      if (this.value2 == "账号") {
        this.souchs2.phone = this.proName2;
      }
      if (this.value2 == "企业") {
        this.souchs2.company = this.proName2;
      }
      if (this.value2 == "姓名") {
        this.souchs2.name = this.proName2;
      }
      var flag2 = true;
      if (val == 1) {
        this.pageNumber2 = 1;
        if (this.value2) {
          if (this.dynamicTags2.length > 0) {
            for (var i = 0; i < this.dynamicTags2.length; i++) {
              if (this.value2 == this.dynamicTags2[i]) {
                flag2 = false;
              }
            }
          }
          if (flag2) {
            this.dynamicTags2.push(this.value2);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        listType: "page",
        userType: "",

        username: this.souchs2.name,
        phone: this.souchs2.phone,
        company: this.souchs2.company,
        registertimefrom: this.souchs2.fromtime,
        registertimeto: this.souchs2.totime,
        softtype: this.souchs2.softtype,
        invitestatus: this.souchs2.invitValue
      };
      _index.API_User.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            _this.total2 = res.data.data.totalRow;
            _this.userList = res.data.data.list;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: "loginAdmin" });
          }
        }
      }).catch(function (err) {
        _this.$message.error("数据丢失，试试重新登陆！");
      });
    },
    handleUser: function handleUser(index, row) {
      this.companyId = "";
      this.companyId = row.id;
      this.rname = "";
      this.rname = row.managerid;
      this.souchs2 = {}, this.dynamicTags2 = [];
      this.proName2 = "";
      this.value2 = "";
      this.adminList = [];
      this.adminVisible = true;
    },
    editSubmit: function editSubmit() {
      var _this = this;

      if (!this.editForm.name) {
        this.$message.error("请输入企业名称!");
        return;
      }

      if (!this.editImageUrl && !this.beformAddImg) {
        this.$message.error("请上传图片!");
        return;
      }

      if (this.beformAddImg) {
        var var_this = this;
        var formData = new FormData();
        formData.append("pic", this.beformAddImg.raw);
        formData.append("token", this.token);
        formData.append("checkCode", this.checkCode);
        formData.append("showpicid", this.editForm.showpicid);
        formData.append("mode", "save");
        var config = {
          "Content-Type": "multipart/form-data"
        };
        _axios2.default.post(this.upload.postURL, formData, config).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this.editSave(res.data.data);
            _this.$refs.upload.clearFiles();
          } else {
            _this.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this.$router.push({ path: "loginAdmin" });
            }
            return;
          }
        }).catch(function (error) {
          console.log(error);
          return;
        });
      } else {
        this.editSave();
      }
    },
    editSave: function editSave(val) {
      var _this5 = this;

      var param = void 0;
      if (val) {
        var newlbtPath = val.pic;
        var newId = val.id;
        param = {
          token: this.token,
          checkCode: this.checkCode,
          mode: "",
          id: this.editForm.id,
          name: this.editForm.name,
          logoid: newlbtPath,
          showpicid: newId,
          showname: this.editForm.showname
        };
      } else {
        param = {
          token: this.token,
          checkCode: this.checkCode,
          mode: "",
          id: this.editForm.id,
          name: this.editForm.name,
          showname: this.editForm.showname
        };
      }
      this.editLoading = true;
      _index.API_User.addCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.$message({
            message: "保存成功",
            type: "success"
          });
          _this5.getList();
          _this5.editFormVisible = false;
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: "loginAdmin" });
          }
        }
        _this5.editLoading = false;
      }).catch(function (err) {
        _this5.$message.error("数据丢失，试试重新登陆！");
        _this5.editLoading = false;
      });
    },

    addSubmit: function addSubmit() {
      var _this6 = this;

      var _this = this;
      this.$refs["addForm"].validate(function (valid) {
        if (valid) {
          if (_this6.addLoading) {
            return;
          }
          if (!_this6.beformAddImg) {
            _this6.$message.error("请上传图片!");
            return;
          }

          if (!_this6.addForm.longitudeAndLatitude) {
            _this6.$message.error("请在GIS地图中确认位置!");
            return;
          }

          if (!_this6.addForm.managerAdminuser) {
            _this6.$message.error("请选择客户经理");
            return;
          }

          _this6.addLoading = true;
          var formData = new FormData();
          formData.append("pic", _this6.beformAddImg.raw);
          formData.append("token", _this6.token);
          formData.append("checkCode", _this6.checkCode);
          formData.append("mode", "save");
          var config = {
            "Content-Type": "multipart/form-data"
          };

          _axios2.default.post(_this6.upload.postURL, formData, config).then(function (res) {
            if (res.data.code == _index.API__code.SUCCESS) {
              _this.addSubmit2(res.data.data);
              _this.$refs.upload.clearFiles();
            } else {
              _this.$message.error(res.data.message);
              if (res.data.code == 403) {
                _this.$router.push({ path: "loginAdmin" });
              }
              return;
            }
          }).catch(function (error) {
            console.log(error);
            return;
          });
        }
      });
    },
    addSubmit2: function addSubmit2(val) {
      var _this7 = this;

      var newlbtPath = val.pic;
      var newId = val.id;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: "save",
        name: this.addForm.name,
        logoid: newlbtPath,
        showpicid: newId,
        showname: this.addForm.showname,
        createUser: this.userInfo.id,
        province: this.addForm.province,
        city: this.addForm.city,
        district: this.addForm.district,
        longitudeAndLatitude: this.addForm.longitudeAndLatitude,
        addressInfo: this.addForm.addressInfo,
        managerAdminuser: this.addForm.managerAdminuser,
        isbinding: 0
      };
      _index.API_User.addCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this7.$message({
            message: "保存成功",
            type: "success"
          });
          _this7.getList();
          _this7.addFormVisible = false;
          _this7.resetForm("addForm");
        } else {
          _this7.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this7.$router.push({ path: "loginAdmin" });
          }
        }
        _this7.addLoading = false;
      }).catch(function (err) {
        _this7.$message.error("数据丢失，试试重新登陆！");
        _this7.addLoading = false;
      });
    },
    resetForm: function resetForm(formName) {
      this.imageUrl = "";
      this.editImageUrl = "";
      this.$refs[formName].resetFields();
    },
    handerClose: function handerClose(visibleFlag, formRef) {
      this[visibleFlag] = false;
      this.resetForm(formRef);
    },


    handleDel: function handleDel(index, row) {
      var _this8 = this;

      this.$confirm("确认删除吗?", "提示", {
        type: "warning"
      }).then(function () {
        var para = {
          token: _this8.token,
          checkCode: _this8.checkCode,
          id: row.id
        };
        _index.API_User.delCompanyList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this8.$message({
              message: "删除成功",
              type: "success"
            });
            _this8.getList();
          } else {
            _this8.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this8.$router.push({ path: "loginAdmin" });
            }
          }
        }).catch(function (err) {
          _this8.$message.error("数据丢失，试试重新登陆！");
        });
      }).catch(function (err) {});
    },
    handleCom: function handleCom(index, row) {
      var _query;

      this.$router.push({
        path: "/userCom",
        query: (_query = {
          companyId: row.id,
          managerId: row.managerid,
          companyName: row.name,
          isbinding: row.isbinding,
          dynamicTags: (0, _stringify2.default)(this.dynamicTags),
          souchs: (0, _stringify2.default)(this.souchs),
          searchText: this.searchText,
          distributionStatus: this.distributionStatus,
          managerAdminuser: this.managerAdminuser,
          status: this.status,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          regionCode: this.regionCode,
          successfulManager: this.successfulManager,
          agencyManager: this.agencyManager
        }, (0, _defineProperty3.default)(_query, "distributionStatus", this.distributionStatus), (0, _defineProperty3.default)(_query, "gradeValue", this.gradeValue.length ? this.gradeValue.join(',') : ''), _query)
      });
    },
    handleEdit: function handleEdit(index, row) {
      this.beformAddImg = "";
      this.editFormVisible = true;
      this.editImageUrl = row.pic;
      this.editForm = (0, _assign2.default)({}, row);

      this.editFormVisible = true;
    },
    handleAdd: function handleAdd() {
      this.$refs.targetcustomdialogRef.init();
    },
    delTags: function delTags() {
      this.souchs = {}, this.value = "";
      this.proName = "";
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == "ID") {
        this.souchs.id = "";
        if (this.value == "ID") {
          this.proName = "";
        }
      }
      if (tag == "企业名称") {
        this.souchs.company = "";
        if (this.value == "企业名称") {
          this.proName = "";
        }
      }
      if (tag == "管理员") {
        this.souchs.managername = "";
        if (this.value == "管理员") {
          this.proName = "";
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    changeSouch: function changeSouch(val) {
      if (val == "ID") {
        this.proName = this.souchs.id;
      } else if (val == "企业名称") {
        this.proName = this.souchs.company;
      } else if (val == "管理员") {
        this.proName = this.souchs.managername;
      }
    },
    getList: function getList(val) {
      var _this9 = this;

      if (this.value == "ID") {
        this.souchs.id = this.proName;
      }
      if (this.value == "企业名称") {
        this.souchs.company = this.proName;
      }
      if (this.value == "管理员") {
        this.souchs.managername = this.proName;
      }
      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        listType: "page",
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        managename: this.souchs.managename,
        id: this.souchs.id,
        company: this.souchs.company,
        fpFlg: this.distributionStatus,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        managerAdminuser: this.managerAdminuser,
        searchText: this.searchText,
        status: 1,
        regionCode: this.regionCode,
        successfulManager: this.successfulManager,
        agencyManager: this.agencyManager,
        userType: this.userInfo.type,
        grade: this.gradeValue.length ? this.gradeValue.join(',') : ''
      };
      this.listLoading = true;

      _index.API_User.companyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data) {
            _this9.total = res.data.data.totalRow;
            _this9.proList = res.data.data.list;
            _this9.targetTotal = res.data.c1;
            _this9.qualityTotal = res.data.c2;
            _this9.collegesTotal = res.data.c4;
          }
        } else {
          _this9.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this9.$router.push({ path: "loginAdmin" });
          }
        }
        _this9.listLoading = false;
      }).catch(function (err) {
        _this9.$message.error("数据丢失，试试重新登陆！");
        _this9.listLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    },
    getCode1: function getCode1() {
      var _this10 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.yhlx = [];
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = {
              value: res.data.data[i].code,
              text: res.data.data[i].name
            };
            _this.yhlx.push(jsons);
            var json = {
              value: res.data.data[i].code,
              label: res.data.data[i].name
            };
            _this.softtypes.push(json);
          }
        } else {
          _this10.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this10.$router.push({ path: "loginAdmin" });
          }
        }
      });
    },
    getCode: function getCode() {
      var _this11 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = {
              value: res.data.data[i].code,
              label: res.data.data[i].name
            };
            _this.inviValues.push(jsons);
          }
        } else {
          _this11.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this11.$router.push({ path: "loginAdmin" });
          }
        }
      });
    },
    backPram: function backPram(param) {
      this.addForm.province = (0, _stringify2.default)(param.selected.province);
      this.addForm.city = (0, _stringify2.default)(param.selected.city);
      this.addForm.district = (0, _stringify2.default)(param.selected.area);
      this.addForm.longitudeAndLatitude = param.position.toString();
      this.addForm.addressInfo = param.address;
    },
    initSearchParams: function initSearchParams() {
      var _$route$query = this.$route.query,
          regionCode = _$route$query.regionCode,
          searchText = _$route$query.searchText,
          managerAdminuser = _$route$query.managerAdminuser,
          successfulManager = _$route$query.successfulManager,
          agencyManager = _$route$query.agencyManager,
          distributionStatus = _$route$query.distributionStatus,
          gradeValue = _$route$query.gradeValue;

      this.regionCode = regionCode || '';
      this.searchText = searchText || '';
      this.managerAdminuser = managerAdminuser || '';
      this.successfulManager = successfulManager || '';
      this.agencyManager = agencyManager || '';
      this.distributionStatus = distributionStatus || '';
      gradeValue = typeof gradeValue === 'number' ? gradeValue + '' : gradeValue;
      this.gradeValue = gradeValue ? gradeValue.split(',') : [];
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.getCookie();

    this.initSearchParams();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _CompamySetting = __webpack_require__(390);

var _CompamySetting2 = _interopRequireDefault(_CompamySetting);

var _index = __webpack_require__(392);

var _index2 = _interopRequireDefault(_index);

var _Companyed = __webpack_require__(391);

var _Companyed2 = _interopRequireDefault(_Companyed);

var _index3 = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      activeIndex: '1',
      href: '',
      options: [{
        value: '1',
        label: '最近一个月'
      }, {
        value: '3',
        label: '最近三个月'
      }, {
        value: '6',
        label: '最近半年'
      }, {
        value: '12',
        label: '最近一年'
      }],
      value: '',
      count: 1,
      token: '',
      checkCode: ''
    };
  },

  components: {
    CompamySetting: _CompamySetting2.default,
    TrackManage: _index2.default,
    company: _Companyed2.default
  },
  created: function created() {
    this.getCookie();
    this.href = _index3.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    pointByHour: function pointByHour(val) {
      this.count = val;
      this.href = _index3.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
    },


    bak: function bak() {
      var _query;

      this.$router.push({
        path: '/company',
        query: (_query = {
          dynamicTags: this.$route.query.dynamicTags,
          souchs: this.$route.query.souchs,
          type: 1,
          pageNumber: this.$route.query.pageNumber,
          pageSize: this.$route.query.pageSize,
          companyName: this.$route.query.companyName,
          searchText: this.$route.query.searchText,
          status: this.$route.query.status,
          managerAdminuserName: this.$route.query.managerAdminuser,
          managerAdminuser: this.$route.query.managerAdminuser,
          distributionStatus: this.$route.query.distributionStatus,
          regionCode: this.$route.query.regionCode,
          successfulManager: this.$route.query.successfulManager,
          agencyManager: this.$route.query.agencyManager
        }, (0, _defineProperty3.default)(_query, 'distributionStatus', this.$route.query.distributionStatus), (0, _defineProperty3.default)(_query, 'gradeValue', this.$route.query.gradeValue), _query)
      });
    },

    handleSelect: function handleSelect(key, keyPath) {
      sessionStorage.setItem('admin_menu', key);
      this.activeIndex = key;
    }
  },

  mounted: function mounted() {
    var Index = sessionStorage.getItem('admin_menu');
    if (['7', '8'].includes(Index)) {
      this.activeIndex = Index;
    } else {
      this.activeIndex = '1';
    }
    sessionStorage.setItem('admin_menu', this.activeIndex);
  }
};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  data: function data() {
    return {
      currentDay: 1,

      currentWeek: 1,

      showDayNum: 42,
      days: [],
      class: "active",
      arrWeek: [],
      selectedWeek: [],
      options: [],
      children: [{
        value: "01",
        label: "1月"
      }, {
        value: "02",
        label: "2月"
      }, {
        value: "03",
        label: "3月"
      }, {
        value: "04",
        label: "4月"
      }, {
        value: "05",
        label: "5月"
      }, {
        value: "06",
        label: "6月"
      }, {
        value: "07",
        label: "7月"
      }, {
        value: "08",
        label: "8月"
      }, {
        value: "09",
        label: "9月"
      }, {
        value: "10",
        label: "10月"
      }, {
        value: "11",
        label: "11月"
      }, {
        value: "12",
        label: "12月"
      }],
      valueYearMonth: [],
      inspectionTimeCon: [],
      currentYear: '',
      currentMonth: '',
      loginRecord: 0,
      token: '',
      checkCode: ''
    };
  },

  props: {},
  watch: {},
  created: function created() {
    this.getCookie();

    var date = new Date();

    this.currentYear = date.getFullYear();
    this.currentMonth = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    console.log('this.currentYear==', this.currentYear);
    this.valueYearMonth = [this.currentYear, this.currentMonth + ""];

    for (var i = 3; i >= 0; i--) {
      var year = this.currentYear - i;
      this.options.push({
        value: year,
        label: year + '年',
        children: this.children
      });
    }


    this.getData();
  },
  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    getData: function getData() {
      var _this = this;

      var param = {
        month: this.valueYearMonth[1],
        year: this.valueYearMonth[0],
        userid: this.$route.query.userId,

        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.loginRecord(param).then(function (res) {
        if (res.data.code == 200) {
          _this.inspectionTimeCon = res.data.data;
          _this.loginRecord = res.data.sum;
          _this.initData(null);
        }
      });
    },
    handleChange: function handleChange(val) {
      console.log('val==', val);
      this.currentYear = val[0];
      this.currentMonth = val[1];
      this.valueYearMonth = val;
      console.log(this.currentMonth);
      this.getData();
    },

    initData: function initData(cur) {
      var leftcount = 0;
      var date;
      if (cur) {
        date = new Date(cur);
      } else {
        var now = new Date();
        var d = new Date(this.formatDate(this.currentYear, this.currentMonth - 1, 1));
        d.setDate(this.showDayNum);
        date = new Date(this.formatDate(this.currentYear, this.currentMonth, 1));
      }
      this.currentDay = date.getDate();

      this.currentWeek = date.getDay();
      var str = this.formatDate(this.currentYear, this.currentMonth, this.currentDay);
      this.days.length = 0;

      for (var i = this.currentWeek; i >= 0; i--) {
        var d = new Date(str);
        d.setDate(d.getDate() - i);
        var dayobject = {};
        dayobject.day = d;
        this.days.push(dayobject);
      }

      for (var i = 1; i < this.showDayNum - this.currentWeek; i++) {
        var d = new Date(str);
        d.setDate(d.getDate() + i);
        var dayobject = {};
        dayobject.day = d;
        this.days.push(dayobject);
      }
      this.days.splice(35, 7);
      this.shwoActiveDate(this.inspectionTimeCon);
    },
    pickYear: function pickYear(year, month) {
      alert(year + "," + month);
    },

    formatDate: function formatDate(year, month, day) {
      var y = year;
      var m = month;
      if (m < 10) m = "0" + m;
      var d = day;
      if (d < 10) d = "0" + d;
      return y + "-" + m + "-" + d;
    },

    cancelActive: function cancelActive() {
      var arr = this.$refs.dayLi;
      if (arr != undefined) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].getAttribute("class") == "active") {
            arr[i].setAttribute("class", "");
          }
        }
      }
      this.selectedWeek = [];
    },
    outputHeighLight: function outputHeighLight() {
      var arr = this.$refs.dayLi;
      var activeText = [];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].getAttribute("class") == "active") {
          var HeighLightDay = new Date(this.currentYear, this.currentMonth - 1, Number(arr[i].innerText));
          activeText.push(HeighLightDay);
        }
      }
      this.$emit("childByValue", activeText);
    },
    selectDay: function selectDay(event) {
      return;
      if (event.currentTarget.getAttribute("class") == "active") {
        event.currentTarget.setAttribute("class", "");
      } else {
        event.currentTarget.setAttribute("class", "active");
      }
      this.outputHeighLight();
    },
    interVal: function interVal(startNum, endNum, intervalNum) {
      var arr = this.$refs.dayLi;
      for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (Number(arr[i].innerText) > Number(arr[j].innerText)) {
            var t = arr[i];
            arr[i] = arr[j];
            arr[j] = t;
          }
        }
      }
      if (endNum > arr.length) endNum = arr.length;
      while (Number(startNum) <= Number(endNum)) {
        arr[startNum - 1].setAttribute("class", "active");
        startNum = Number(startNum) + Number(intervalNum) + Number(1);
      }
    },
    chooseWeek: function chooseWeek(arrWeek) {
      var arr = this.$refs.dayLi;
      for (var i = 0; i < arr.length; i++) {
        var t = new Date(this.currentYear, this.currentMonth - 1, Number(arr[i].innerText));

        if (arrWeek.indexOf(t.getDay()) != -1) {
          arr[i].setAttribute("class", "active");
        }
      }
    },
    shwoActiveDate: function shwoActiveDate(inspectionTimeCon) {
      var _this2 = this;

      this.$nextTick(function () {
        var list = [];
        for (var k = 0; k < inspectionTimeCon.length; k++) {
          var dateStr = inspectionTimeCon[k];
          list.push(dateStr);
        }

        var arr = _this2.$refs.dayLi;
        for (var i = 0; i < arr.length; i++) {
          for (var j = 0; j < list.length; j++) {
            if (_this2.currentYear + "-" + _this2.currentMonth + "-" + (arr[i].innerText < 10 ? '0' + arr[i].innerText : arr[i].innerText) == list[j]) {
              arr[i].setAttribute("class", "active");
            }
          }
        }
      });
    },
    formatDateGu: function formatDateGu(cellval) {
      var dateVal = cellval + "";
      if (cellval != null) {
        var date = new Date(cellval);
        var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        var currentDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

        var returnDate = date.getFullYear() + "-" + month + "-" + currentDate;
        return returnDate;
      }
    }
  }
};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(117);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['userid'],
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      value: "1",
      loading: false,
      options: [{
        value: "1",
        label: "最近一个月"
      }, {
        value: "3",
        label: "最近三个月"
      }, {
        value: "6",
        label: "最近半年"
      }, {
        value: "12",
        label: "最近一年"
      }],
      chartPie: [],
      legend: [],
      chartsXAxisTwo: [],
      chartsDataTwo: [],
      token: '',
      checkCode: ''
    };
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    getData: function getData() {
      this.adminModulePointPie();
    },
    adminModulePointPie: function adminModulePointPie(val) {
      var _this = this;

      var param = {
        count: this.value,
        userid: this.userid,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading = true;
      _index.API_Admin.pointByPerson(param).then(function (res) {
        if (res.data.code == 200) {
          _this.chartsXAxisTwo = res.data.data.x;
          _this.chartsDataTwo = res.data.data.y;
          _this.initCharts();
          _this.loading = false;
        }
      });
    },
    initCharts: function initCharts() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box"));
      charts.showLoading();
      charts.setOption({
        title: [{
          text: "积分统计",
          top: "top",
          left: "left",
          textStyle: {
            color: "#596471",
            fontSize: 18,
            fontWeight: 400,
            fontFamily: 'SourceHanSansCN'
          }
        }],
        tooltip: {
          trigger: "axis",
          position: function position(point, params, dom, rect, size) {
            if (size.viewSize[0] / 2 >= point[0]) {
              return [point[0], '10%'];
            } else {
              return [point[0] - 80, '10%'];
            }
          },
          formatter: function formatter(params) {
            return params[0].name + "<br/>" + params[0].seriesName + ": " + (params[0].value + "").replace(/\B(?=(?:\d{3})+\b)/g, ",") + "\u5206";
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        dataZoom: [{
          type: 'inside'
        }],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chartsXAxisTwo,
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            },
            rotate: 20
          },
          splitArea: {}
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: "#E8E9EB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        },
        series: [{
          name: "积分统计",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          itemStyle: {
            normal: {
              color: "#EF5350"
            }
          },
          areaStyle: {
            normal: {
              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#FFB87D"
              }, {
                offset: 1,
                color: "#ED7D76"
              }])
            }
          },
          data: this.chartsDataTwo,
          lineStyle: {
            normal: {
              color: "#EF5350"
            }
          }
        }]
      });
      charts.hideLoading();
      this.loading = false;
      window.addEventListener("resize", function () {
        charts.resize();
      });
    }
  }
};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Companyed = __webpack_require__(391);

var _Companyed2 = _interopRequireDefault(_Companyed);

var _Device = __webpack_require__(756);

var _Device2 = _interopRequireDefault(_Device);

var _WeProduct = __webpack_require__(757);

var _WeProduct2 = _interopRequireDefault(_WeProduct);

var _static = __webpack_require__(759);

var _static2 = _interopRequireDefault(_static);

var _system = __webpack_require__(760);

var _system2 = _interopRequireDefault(_system);

var _CompamySetting = __webpack_require__(390);

var _CompamySetting2 = _interopRequireDefault(_CompamySetting);

var _index = __webpack_require__(755);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(392);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            activeIndex: '',
            showCom: true,
            showDev: false,
            showWeP: false,
            showFx: false,
            showSystem: false,
            href: '',
            options: [{
                value: '1',
                label: '最近一个月'
            }, {
                value: '3',
                label: '最近三个月'
            }, {
                value: '6',
                label: '最近半年'
            }, {
                value: '12',
                label: '最近一年'
            }],
            value: '',
            count: 1,
            token: '',
            checkCode: ''
        };
    },

    components: {
        company: _Companyed2.default,
        device: _Device2.default,
        weProduct: _WeProduct2.default,
        Static: _static2.default,
        System: _system2.default,
        CompamySetting: _CompamySetting2.default,
        DepartManage: _index2.default,
        TrackManage: _index4.default
    },
    created: function created() {
        this.getCookie();
        this.href = _index5.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
    },

    methods: {
        getCookie: function getCookie() {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; ');
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('=');
                    if (arr2[0] == 'dnnyptadmin_token') {
                        this.token = arr2[1];
                    } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                        this.checkCode = arr2[1];
                    }
                }
            }
        },

        pointByHour: function pointByHour(val) {
            this.count = val;
            this.href = _index5.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
        },


        bak: function bak() {
            this.$router.push({
                path: '/officialCustom',
                query: {
                    dynamicTags: this.$route.query.dynamicTags,
                    souchs: this.$route.query.souchs,
                    type: 1,
                    pageNumber: this.$route.query.pageNumber,
                    pageSize: this.$route.query.pageSize,
                    companyName: this.$route.query.companyName,
                    searchText: this.$route.query.searchText,
                    status: this.$route.query.status,
                    managerAdminuserName: this.$route.query.managerAdminuser,
                    managerAdminuser: this.$route.query.managerAdminuser,
                    distributionStatus: this.$route.query.distributionStatus,
                    regionCode: this.$route.query.regionCode,
                    successfulManager: this.$route.query.successfulManager,
                    agencyManager: this.$route.query.agencyManager,
                    deadTime: this.$route.query.deadTime
                }
            });
        },
        handleSelect: function handleSelect(key, keyPath) {
            this.showCom = false;
            this.showWeP = false;
            this.showDev = false;
            this.showFx = false;
            this.showSystem = false;
            if (key == '1') {
                this.showCom = true;
                sessionStorage.setItem('admin_menu', '1');
            } else if (key == '2') {
                this.showWeP = true;
                sessionStorage.setItem('admin_menu', '2');
            } else if (key == '3') {
                this.showDev = true;
                sessionStorage.setItem('admin_menu', '3');
            } else if (key == '4') {
                this.showFx = true;
                sessionStorage.setItem('admin_menu', '4');
            } else if (key == '5') {
                this.showSystem = true;
                sessionStorage.setItem('admin_menu', '5');
            }
            sessionStorage.setItem('admin_menu', key);
            this.activeIndex = key;
        }
    },

    mounted: function mounted() {
        this.activeIndex = sessionStorage.getItem('admin_menu');
        this.activeIndex = this.activeIndex ? this.activeIndex : '1';
        if (this.activeIndex == '2') {
            this.showCom = false;
            this.showDev = false;
            this.showWeP = true;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 2);
        } else if (this.activeIndex == '3') {
            this.showDev = true;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 3);
        } else if (this.activeIndex == '4') {
            this.showDev = false;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = true;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 4);
        } else if (this.activeIndex == '5') {
            this.showDev = false;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = true;
            sessionStorage.setItem('admin_menu', 5);
        } else {
            this.showCom = true;
            this.showDev = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 1);
        }
        if (['6', '7', '8'].includes(this.activeIndex)) {
            this.showCom = false;
            this.showDev = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', this.activeIndex);
        }
    }
};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(90);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(89);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _GisCommon = __webpack_require__(164);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _addAdmin = __webpack_require__(758);

var _addAdmin2 = _interopRequireDefault(_addAdmin);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _SelectCommon = __webpack_require__(74);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _this2 = this,
        _ref2;

    var validatorCompany = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.addForm.name) {
                  _context.next = 4;
                  break;
                }

                callback("请输入企业名称");
                _context.next = 8;
                break;

              case 4:
                _context.next = 6;
                return _this2.checkCompany(_this2.addForm.name);

              case 6:
                res = _context.sent;

                !res ? callback('企业名称已存在') : callback();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function validatorCompany(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    return _ref2 = {
      beformAddImg: '',
      editImageUrl: '',
      adminVisible: false,
      imageUrl: '',
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: _index.API_Common.setCompanyPic(),
        dialogImageUrl: '',
        dialogVisible: false,
        data: {
          mode: 'save',
          token: this.token,
          checkCode: this.checkCode,
          type: 1
        }
      },

      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName2: '',
      dynamicTags2: [],
      optionsSouch2: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '软件类型', label: '软件类型' }, { value: '邀请状态', label: '邀请状态' }, { value: '开始日期', label: '开始日期' }, { value: '结束日期', label: '结束日期' }],
      value2: '',
      inviValues: [],
      softtypes: [],

      proName: '',
      dynamicTags: [],
      options: [{ value: 'ID', label: 'ID' }, { value: '企业名称', label: '企业名称' }, { value: '管理员', label: '管理员' }],
      value: '',

      rname: '',
      companyId: '',
      orderLoading: false,
      userLoading: false,
      orderVisible: false,
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      userList: [],
      souchs2: {
        name: '',
        phone: '',
        company: '',
        invitestatus: '',
        softtype: '',
        fromtime: '',
        totime: ''
      },
      flag: false,
      checkUserId: '',
      checkUserIdOld: '',
      token: this.token,
      checkCode: this.checkCode,
      id: this.id,
      souchs: {
        name: ''
      },
      total: 0,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 20,
      pageNumber: 1,
      proList: [],
      listLoading: false,
      sels: [],

      addFormVisible: false,
      addLoading: false,
      addForm: {
        name: '',
        showname: '',
        province: '',
        city: '',
        district: '',
        longitudeAndLatitude: '',
        addressInfo: '',
        managerAdminuser: '',
        managerAdminuserName: ''
      },

      addFormRules: {
        name: [{ required: true, validator: validatorCompany, trigger: 'change' }],
        showname: [{ required: true, message: '请输入地区', trigger: 'blur' }]
      },

      editFormVisible: false,
      editLoading: false,
      editForm: {
        name: ''
      },
      editFormRules: {
        name: [{ required: true, message: '请输入企业名称', trigger: 'blur' }]
      },
      orderType: '',
      orderStr: '',

      userSelection: [],
      UserSelection: [],
      searchText: this.$route.query.searchText ? this.$route.query.searchText : '',
      selected: { province: '320000', city: '320100', area: '320115', town: '320115010' },
      address: '',

      comLists: [],

      status: this.$route.query.status ? this.$route.query.status : '',

      distributionStatus: this.$route.query.distributionStatus ? this.$route.query.distributionStatus : '',
      managerAdminuser: this.$route.query.managerAdminuserName,
      successfulManager: '',
      agencyManager: ''
    }, (0, _defineProperty3.default)(_ref2, 'total', 0), (0, _defineProperty3.default)(_ref2, 'levelTotal', 0), (0, _defineProperty3.default)(_ref2, 'tryTotal', 0), (0, _defineProperty3.default)(_ref2, 'collegesTotal', 0), (0, _defineProperty3.default)(_ref2, 'instituteTotal', 0), (0, _defineProperty3.default)(_ref2, 'regionCodeList', [{
      value: '1',
      label: '华东大区'
    }, {
      value: '2',
      label: '华北大区'
    }, {
      value: '3',
      label: '西北大区'
    }, {
      value: '4',
      label: '华南大区'
    }, {
      value: '5',
      label: '西南大区'
    }]), (0, _defineProperty3.default)(_ref2, 'regionCode', ''), (0, _defineProperty3.default)(_ref2, 'deadTime', ''), _ref2;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default,
    SelectCommon: _SelectCommon2.default,
    Admin: _addAdmin2.default,
    GisCommon: _GisCommon2.default
  },
  methods: {
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    },
    querySearch: function querySearch(queryString, cb) {
      var comLists = this.comLists;
      var results = queryString ? comLists.filter(this.createFilter(queryString)) : comLists;

      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    loadCompany: function loadCompany() {
      this.getCompanySearch();
    },
    handleSelect: function handleSelect(item) {
      console.log('select==', this.addForm.name, item);
    },
    getCompanySearch: function getCompanySearch() {
      var _this3 = this;

      _index.API_User.getCompanySearch().then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var data = res.data.data;
          _this3.comLists = data.map(function (item) {
            return { value: item };
          });
          sessionStorage.setItem('comLists', (0, _stringify2.default)(_this3.comLists));
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {});
    },
    checkCompany: function checkCompany(name) {
      return _index.API_User.checkCompanyUnique({ name: name }).then(function (res) {
        console.log('ressss--', res);
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    closedialog: function closedialog() {
      this.selected = { province: '320000', city: '320100', area: '320115', town: '320115010' };
      this.addForm.longitudeAndLatitude = '';
      this.addForm.addressInfo = '';
      this.addForm.managerAdminuser = '';
      this.imageUrl = '';
      this.beformAddImg = '';
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.addForm.managerAdminuser = value[0];
    },
    addAdmin: function addAdmin() {
      this.getUser();
      this.userSelection = [];
      this.orderVisible = true;
    },
    adminVisibleClose: function adminVisibleClose(type) {
      this.adminVisible = false;
      if (type == 1) {
        this.getList();
      }
    },
    handleUserSelectionChange: function handleUserSelectionChange(rowSelect) {
      var jc = [];
      var row = [];
      for (var p in rowSelect) {
        if (jc.indexOf(rowSelect[p].id) == -1) {
          jc.push(rowSelect[p].id);
          row.push(rowSelect[p]);
        }
      }
      this.userSelection = row;
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;
        this.imageUrl = URL.createObjectURL(file.raw);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error('请选择图片文件');
      }
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == 'id') {
          this.orderStr = 'idpx';
        } else if (val.prop == 'name') {
          this.orderStr = 'namepx';
        } else if (val.prop == 'managername') {
          this.orderStr = 'managernamepx';
        } else if (val.prop == 'showname') {
          this.orderStr = 'shownamepx';
        } else if (val.prop == 'regionCode') {
          this.orderStr = 'regionCodepx';
        } else if (val.prop == 'grade') {
          this.orderStr = 'gradepx';
        } else if (val.prop == 'natrue') {
          this.orderStr = 'natruepx';
        } else if (val.prop == 'userScale') {
          this.orderStr = 'userScalepx';
        }
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
      }
      this.getList();
    },
    changeSouch2: function changeSouch2(val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == '账号') {
        this.proName2 = this.souchs2.phone;
        this.disSouch = true;
      } else if (val == '姓名') {
        this.proName2 = this.souchs2.name;
        this.disSouch = true;
      } else if (val == '企业') {
        this.proName2 = this.souchs2.company;
        this.disSouch = true;
      } else if (val == '软件类型') {
        this.disSofttype = true;
      } else if (val == '邀请状态') {
        this.disinvit = true;
      } else if (val == '开始日期') {
        this.disTime1 = true;
      } else if (val == '结束日期') {
        this.disTime2 = true;
      }
    },
    handleClose2: function handleClose2(tag) {
      if (tag == '账号') {
        this.souchs2.phone = '';
        if (this.value2 == '账号') {
          this.proName2 = '';
        }
      }
      if (tag == '姓名') {
        this.souchs2.name = '';
        if (this.value2 == '姓名') {
          this.proName2 = '';
        }
      }
      if (tag == '企业') {
        this.souchs2.company = '';
        if (this.value2 == '企业') {
          this.proName2 = '';
        }
      }
      if (tag == '软件类型') {
        this.souchs2.softtype = '';
      }
      if (tag == '邀请状态') {
        this.souchs2.invitValue = '';
      }
      if (tag == '开始日期') {
        this.souchs2.fromtime = '';
      }
      if (tag == '结束日期') {
        this.souchs2.totime = '';
      }
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1);
    },

    delTags2: function delTags2() {
      this.souchs2 = {};
      this.proName2 = '';
      this.value2 = '';
      this.dynamicTags2 = [];
      this.pageNumber2 = 1;
      this.getUser();
    },

    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getUser();
    },
    clickUserSelection: function clickUserSelection() {
      var _this = this;
      var list = (0, _assign2.default)([], this.userSelection);
      this.UserSelection = list;
      this.orderVisible = false;
    },

    orderUserSubmit: function orderUserSubmit(rows) {
      var _this4 = this;

      console.log(rows);
      var _this = this;

      var list = (0, _assign2.default)([], rows);

      var UserIds = [];
      for (var p in list) {
        UserIds.push(list[p].id);
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyId,
        userid: UserIds.toString()
      };
      _index.API_User.setCompanyManager(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: '保存成功',
            type: 'success'
          });
          _this4.adminVisible = false;
          _this4.getList();
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    changeFun: function changeFun(e, val) {
      if (!e) {
        this.checkUserId = '';
      }
      if (e && !this.flag) {
        this.checkUserId = this.checkUserIdOld;
      }
      this.flag = false;
    },
    handleSelectionChange: function handleSelectionChange(row) {
      this.flag = true;
      this.userList.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
        }
        if (item.id == row.id) {
          item.checked = true;
        }
      });
      if (row.name == null) {
        row.name = '';
      }
      if (row.phone == null) {
        row.phone = '';
      }
      this.checkUserId = row.id;
      this.checkUserIdOld = row.id;
    },

    getUser: function getUser(val) {
      var _this = this;
      if (this.value2 == '账号') {
        this.souchs2.phone = this.proName2;
      }
      if (this.value2 == '企业') {
        this.souchs2.company = this.proName2;
      }
      if (this.value2 == '姓名') {
        this.souchs2.name = this.proName2;
      }
      var flag2 = true;
      if (val == 1) {
        this.pageNumber2 = 1;
        if (this.value2) {
          if (this.dynamicTags2.length > 0) {
            for (var i = 0; i < this.dynamicTags2.length; i++) {
              if (this.value2 == this.dynamicTags2[i]) {
                flag2 = false;
              }
            }
          }
          if (flag2) {
            this.dynamicTags2.push(this.value2);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        listType: 'page',
        userType: '',

        username: this.souchs2.name,
        phone: this.souchs2.phone,
        company: this.souchs2.company,
        registertimefrom: this.souchs2.fromtime,
        registertimeto: this.souchs2.totime,
        softtype: this.souchs2.softtype,
        invitestatus: this.souchs2.invitValue
      };
      _index.API_User.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            _this.total2 = res.data.data.totalRow;
            _this.userList = res.data.data.list;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    handleUser: function handleUser(index, row) {
      this.companyId = '';
      this.companyId = row.id;
      this.rname = '';
      this.rname = row.managerid;this.souchs2 = {}, this.dynamicTags2 = [];
      this.proName2 = '';
      this.value2 = '';
      this.adminList = [];
      this.adminVisible = true;
    },
    editSubmit: function editSubmit() {
      var _this = this;

      if (!this.editForm.name) {
        this.$message.error('请输入企业名称!');
        return;
      }

      if (!this.editImageUrl && !this.beformAddImg) {
        this.$message.error('请上传图片!');
        return;
      }

      if (this.beformAddImg) {
        var var_this = this;
        var formData = new FormData();
        formData.append('pic', this.beformAddImg.raw);
        formData.append('token', this.token);
        formData.append('checkCode', this.checkCode);
        formData.append('showpicid', this.editForm.showpicid);
        formData.append('mode', 'save');
        var config = {
          'Content-Type': 'multipart/form-data'
        };
        _axios2.default.post(this.upload.postURL, formData, config).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this.editSave(res.data.data);
            _this.$refs.upload.clearFiles();
          } else {
            _this.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this.$router.push({ path: 'loginAdmin' });
            }
            return;
          }
        }).catch(function (error) {
          console.log(error);
          return;
        });
      } else {
        this.editSave();
      }
    },
    editSave: function editSave(val) {
      var _this5 = this;

      var param = void 0;
      if (val) {
        var newlbtPath = val.pic;
        var newId = val.id;
        param = {
          token: this.token,
          checkCode: this.checkCode,
          mode: '',
          id: this.editForm.id,
          name: this.editForm.name,
          logoid: newlbtPath,
          showpicid: newId,
          showname: this.editForm.showname
        };
      } else {
        param = {
          token: this.token,
          checkCode: this.checkCode,
          mode: '',
          id: this.editForm.id,
          name: this.editForm.name,
          showname: this.editForm.showname
        };
      }
      this.editLoading = true;
      _index.API_User.addCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.$message({
            message: '保存成功',
            type: 'success'
          });
          _this5.getList();
          _this5.editFormVisible = false;
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.editLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.editLoading = false;
      });
    },

    addSubmit: function addSubmit() {
      var _this6 = this;

      var _this = this;
      this.$refs['addForm'].validate(function (valid) {
        if (valid) {
          if (_this6.addLoading) {
            return;
          }
          if (!_this6.beformAddImg) {
            _this6.$message.error('请上传图片!');
            return;
          }

          if (!_this6.addForm.longitudeAndLatitude) {
            _this6.$message.error('请在GIS地图中确认位置!');
            return;
          }

          if (!_this6.addForm.managerAdminuser) {
            _this6.$message.error('请选择客户经理');
            return;
          }

          _this6.addLoading = true;
          var formData = new FormData();
          formData.append('pic', _this6.beformAddImg.raw);
          formData.append('token', _this6.token);
          formData.append('checkCode', _this6.checkCode);
          formData.append('mode', 'save');
          var config = {
            'Content-Type': 'multipart/form-data'
          };

          _axios2.default.post(_this6.upload.postURL, formData, config).then(function (res) {
            if (res.data.code == _index.API__code.SUCCESS) {
              _this.addSubmit2(res.data.data);
              _this.$refs.upload.clearFiles();
            } else {
              _this.$message.error(res.data.message);
              if (res.data.code == 403) {
                _this.$router.push({ path: 'loginAdmin' });
              }
              return;
            }
          }).catch(function (error) {
            console.log(error);
            return;
          });
        }
      });
    },
    addSubmit2: function addSubmit2(val) {
      var _this7 = this;

      var newlbtPath = val.pic;
      var newId = val.id;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        name: this.addForm.name,
        logoid: newlbtPath,
        showpicid: newId,
        showname: this.addForm.showname,
        createUser: this.userInfo.id,
        province: this.addForm.province,
        city: this.addForm.city,
        district: this.addForm.district,
        longitudeAndLatitude: this.addForm.longitudeAndLatitude,
        addressInfo: this.addForm.addressInfo,
        managerAdminuser: this.addForm.managerAdminuser,
        isbinding: 0
      };
      _index.API_User.addCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this7.$message({
            message: '保存成功',
            type: 'success'
          });
          _this7.getList();
          _this7.addFormVisible = false;
          _this7.resetForm('addForm');
        } else {
          _this7.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this7.$router.push({ path: 'loginAdmin' });
          }
        }
        _this7.addLoading = false;
      }).catch(function (err) {
        _this7.$message.error('数据丢失，试试重新登陆！');
        _this7.addLoading = false;
      });
    },
    resetForm: function resetForm(formName) {
      this.imageUrl = '';
      this.editImageUrl = '';
      this.$refs[formName].resetFields();
    },
    handerClose: function handerClose(visibleFlag, formRef) {
      this[visibleFlag] = false;
      this.resetForm(formRef);
    },


    handleDel: function handleDel(index, row) {
      var _this8 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var para = {
          token: _this8.token,
          checkCode: _this8.checkCode,
          id: row.id
        };
        _index.API_User.delCompanyList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this8.$message({
              message: '删除成功',
              type: 'success'
            });
            _this8.getList();
          } else {
            _this8.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this8.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this8.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    handleCom: function handleCom(index, row) {
      this.$router.push({
        path: '/officalView',
        query: {
          companyId: row.id,
          managerId: row.managerid,
          companyName: row.name,
          isbinding: row.isbinding,
          dynamicTags: (0, _stringify2.default)(this.dynamicTags),
          souchs: (0, _stringify2.default)(this.souchs),
          searchText: this.searchText,
          distributionStatus: this.distributionStatus,
          managerAdminuser: this.managerAdminuser,
          status: this.status,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          regionCode: this.regionCode,
          successfulManager: this.successfulManager,
          agencyManager: this.agencyManager,
          deadTime: this.deadTime
        }
      });
    },
    handleEdit: function handleEdit(index, row) {
      this.beformAddImg = '';
      this.editFormVisible = true;
      this.editImageUrl = row.pic;
      this.editForm = (0, _assign2.default)({}, row);

      this.editFormVisible = true;
    },
    handleAdd: function handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
      this.addLoading = false;
    },
    delTags: function delTags() {
      ;this.souchs = {}, this.value = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == 'ID') {
        this.souchs.id = '';
        if (this.value == 'ID') {
          this.proName = '';
        }
      }
      if (tag == '企业名称') {
        this.souchs.company = '';
        if (this.value == '企业名称') {
          this.proName = '';
        }
      }
      if (tag == '管理员') {
        this.souchs.managername = '';
        if (this.value == '管理员') {
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    changeSouch: function changeSouch(val) {
      if (val == 'ID') {
        this.proName = this.souchs.id;
      } else if (val == '企业名称') {
        this.proName = this.souchs.company;
      } else if (val == '管理员') {
        this.proName = this.souchs.managername;
      }
    },
    getList: function getList(val) {
      var _this9 = this;

      if (this.value == 'ID') {
        this.souchs.id = this.proName;
      }
      if (this.value == '企业名称') {
        this.souchs.company = this.proName;
      }
      if (this.value == '管理员') {
        this.souchs.managername = this.proName;
      }
      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        managename: this.souchs.managename,
        id: this.souchs.id,
        company: this.souchs.company,
        fpFlg: this.distributionStatus,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        managerAdminuser: this.managerAdminuser,
        successfulManager: this.successfulManager,
        agencyManager: this.agencyManager,
        searchText: this.searchText,
        status: 3,
        regionCode: this.regionCode,
        deadTime: this.deadTime
      };
      this.listLoading = true;
      _index.API_User.companyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data) {
            _this9.total = res.data.data.totalRow;
            _this9.levelTotal = res.data.c2;
            _this9.tryTotal = res.data.c3;
            _this9.collegesTotal = res.data.c4;
            _this9.instituteTotal = res.data.c5;
            _this9.proList = res.data.data.list;
          }
        } else {
          _this9.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this9.$router.push({ path: 'loginAdmin' });
          }
        }
        _this9.listLoading = false;
      }).catch(function (err) {
        _this9.$message.error('数据丢失，试试重新登陆！');
        _this9.listLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref3) {
      var row = _ref3.row,
          column = _ref3.column,
          rowIndex = _ref3.rowIndex,
          columnIndex = _ref3.columnIndex;

      if (rowIndex == 0) {
        return 'background:#F5F7FA';
      } else {
        return '';
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    getCode1: function getCode1() {
      var _this10 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.yhlx = [];
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = {
              value: res.data.data[i].code,
              text: res.data.data[i].name
            };
            _this.yhlx.push(jsons);
            var json = {
              value: res.data.data[i].code,
              label: res.data.data[i].name
            };
            _this.softtypes.push(json);
          }
        } else {
          _this10.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this10.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    getCode: function getCode() {
      var _this11 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = {
              value: res.data.data[i].code,
              label: res.data.data[i].name
            };
            _this.inviValues.push(jsons);
          }
        } else {
          _this11.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this11.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    backPram: function backPram(param) {
      this.addForm.province = (0, _stringify2.default)(param.selected.province);
      this.addForm.city = (0, _stringify2.default)(param.selected.city);
      this.addForm.district = (0, _stringify2.default)(param.selected.area);
      this.addForm.longitudeAndLatitude = param.position.toString();
      this.addForm.addressInfo = param.address;
    },
    initDate: function initDate() {
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var statDateStart = myDate.getFullYear().toString() + month + "01";
      var dayEnd = new Date(myDate.getFullYear(), month, 0).getDate();
      var statDateEnd = myDate.getFullYear().toString() + '-' + month + '-' + dayEnd;
      console.log(statDateStart);
      console.log(statDateEnd);
      this.deadTime = statDateEnd;
    },
    initSearchParams: function initSearchParams() {
      var _$route$query = this.$route.query,
          regionCode = _$route$query.regionCode,
          searchText = _$route$query.searchText,
          managerAdminuser = _$route$query.managerAdminuser,
          successfulManager = _$route$query.successfulManager,
          agencyManager = _$route$query.agencyManager,
          deadTime = _$route$query.deadTime;

      this.regionCode = regionCode || '';
      this.searchText = searchText || '';
      this.managerAdminuser = managerAdminuser || '';
      this.successfulManager = successfulManager || '';
      this.agencyManager = agencyManager || '';
      if (deadTime) {
        this.deadTime = deadTime;
      }
    }
  },
  mounted: function mounted() {
    console.log(this.$route.query.distributionStatus);
  },
  created: function created() {
    this.getCookie();
    this.initDate();
    this.loadCompany();
    this.initSearchParams();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
    this.getCode();
    this.getCode1();
  }
};

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _GisCommon = __webpack_require__(164);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _SelectCommon = __webpack_require__(74);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _ref;

    return _ref = {
      proName: '',
      dynamicTags: [],
      value: '',
      rname: '',
      token: this.token,
      checkCode: this.checkCode,
      id: this.id,
      souchs: {
        name: ''
      },
      total: 0,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 20,
      pageNumber: 1,
      proList: [],
      listLoading: false,
      sels: [],
      orderType: '',
      orderStr: '',
      userSelection: [],
      searchText: this.$route.query.searchText ? this.$route.query.searchText : '',
      address: '',
      comLists: [],
      status: this.$route.query.status ? this.$route.query.status : '',
      distributionStatus: this.$route.query.distributionStatus ? this.$route.query.distributionStatus : '',
      managerAdminuser: this.$route.query.managerAdminuserName,
      successfulManager: '',
      agencyManager: ''
    }, (0, _defineProperty3.default)(_ref, 'total', 0), (0, _defineProperty3.default)(_ref, 'levelTotal', 0), (0, _defineProperty3.default)(_ref, 'tryTotal', 0), (0, _defineProperty3.default)(_ref, 'collegesTotal', 0), (0, _defineProperty3.default)(_ref, 'instituteTotal', 0), (0, _defineProperty3.default)(_ref, 'regionCodeList', [{
      value: '1',
      label: '华东大区'
    }, {
      value: '2',
      label: '华北大区'
    }, {
      value: '3',
      label: '西北大区'
    }, {
      value: '4',
      label: '华南大区'
    }, {
      value: '5',
      label: '西南大区'
    }]), (0, _defineProperty3.default)(_ref, 'regionCode', ''), _ref;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default,
    SelectCommon: _SelectCommon2.default,
    GisCommon: _GisCommon2.default
  },
  methods: {
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == 'id') {
          this.orderStr = 'idpx';
        } else if (val.prop == 'name') {
          this.orderStr = 'namepx';
        } else if (val.prop == 'managername') {
          this.orderStr = 'managernamepx';
        } else if (val.prop == 'showname') {
          this.orderStr = 'shownamepx';
        } else if (val.prop == 'regionCode') {
          this.orderStr = 'regionCodepx';
        } else if (val.prop == 'grade') {
          this.orderStr = 'gradepx';
        } else if (val.prop == 'natrue') {
          this.orderStr = 'natruepx';
        } else if (val.prop == 'userScale') {
          this.orderStr = 'userScalepx';
        }
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
      }
      this.getList();
    },

    handleDel: function handleDel(index, row) {
      var _this = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var para = {
          token: _this.token,
          checkCode: _this.checkCode,
          id: row.id
        };
        _index.API_User.delCompanyList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this.$message({
              message: '删除成功',
              type: 'success'
            });
            _this.getList();
          } else {
            _this.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },

    handleCom: function handleCom(index, row) {
      this.$router.push({
        path: '/probationView',
        query: {
          companyId: row.id,
          managerId: row.managerid,
          companyName: row.name,
          isbinding: row.isbinding,
          dynamicTags: (0, _stringify2.default)(this.dynamicTags),
          souchs: (0, _stringify2.default)(this.souchs),
          searchText: this.searchText,
          distributionStatus: this.distributionStatus,
          managerAdminuser: this.managerAdminuser,
          status: this.status,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          regionCode: this.regionCode,
          successfulManager: this.successfulManager,
          agencyManager: this.agencyManager
        }
      });
    },

    getList: function getList(val) {
      var _this2 = this;

      if (this.value == 'ID') {
        this.souchs.id = this.proName;
      }
      if (this.value == '企业名称') {
        this.souchs.company = this.proName;
      }
      if (this.value == '管理员') {
        this.souchs.managername = this.proName;
      }
      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        listType: 'page',
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        managename: this.souchs.managename,
        id: this.souchs.id,
        company: this.souchs.company,
        fpFlg: this.distributionStatus,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        managerAdminuser: this.managerAdminuser,
        successfulManager: this.successfulManager,
        agencyManager: this.agencyManager,
        searchText: this.searchText,
        status: 2,
        regionCode: this.regionCode
      };
      this.listLoading = true;
      _index.API_User.companyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data) {
            _this2.total = res.data.data.totalRow;
            _this2.levelTotal = res.data.c2;
            _this2.tryTotal = res.data.c3;
            _this2.collegesTotal = res.data.c4;
            _this2.instituteTotal = res.data.c5;
            _this2.proList = res.data.data.list;
          }
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.listLoading = false;
      });
    },

    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return 'background:#F5F7FA';
      } else {
        return '';
      }
    },


    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    initSearchParams: function initSearchParams() {
      var _$route$query = this.$route.query,
          regionCode = _$route$query.regionCode,
          searchText = _$route$query.searchText,
          managerAdminuser = _$route$query.managerAdminuser,
          successfulManager = _$route$query.successfulManager,
          agencyManager = _$route$query.agencyManager,
          distributionStatus = _$route$query.distributionStatus,
          gradeValue = _$route$query.gradeValue;

      this.regionCode = regionCode || '';
      this.searchText = searchText || '';
      this.managerAdminuser = managerAdminuser || '';
      this.successfulManager = successfulManager || '';
      this.agencyManager = agencyManager || '';
    }
  },
  mounted: function mounted() {
    console.log(this.$route.query.distributionStatus);
  },
  created: function created() {
    this.getCookie();
    this.initSearchParams();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Companyed = __webpack_require__(391);

var _Companyed2 = _interopRequireDefault(_Companyed);

var _Device = __webpack_require__(756);

var _Device2 = _interopRequireDefault(_Device);

var _WeProduct = __webpack_require__(757);

var _WeProduct2 = _interopRequireDefault(_WeProduct);

var _static = __webpack_require__(759);

var _static2 = _interopRequireDefault(_static);

var _system = __webpack_require__(760);

var _system2 = _interopRequireDefault(_system);

var _CompamySetting = __webpack_require__(390);

var _CompamySetting2 = _interopRequireDefault(_CompamySetting);

var _index = __webpack_require__(755);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(392);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            activeIndex: '',
            showCom: true,
            showDev: false,
            showWeP: false,
            showFx: false,
            showSystem: false,
            href: '',
            options: [{
                value: '1',
                label: '最近一个月'
            }, {
                value: '3',
                label: '最近三个月'
            }, {
                value: '6',
                label: '最近半年'
            }, {
                value: '12',
                label: '最近一年'
            }],
            value: '',
            count: 1,
            token: '',
            checkCode: ''
        };
    },

    components: {
        company: _Companyed2.default,
        device: _Device2.default,
        weProduct: _WeProduct2.default,
        Static: _static2.default,
        System: _system2.default,
        CompamySetting: _CompamySetting2.default,
        DepartManage: _index2.default,
        TrackManage: _index4.default
    },
    created: function created() {
        this.getCookie();
        this.href = _index5.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
    },

    methods: {
        getCookie: function getCookie() {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; ');
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('=');
                    if (arr2[0] == 'dnnyptadmin_token') {
                        this.token = arr2[1];
                    } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                        this.checkCode = arr2[1];
                    }
                }
            }
        },

        pointByHour: function pointByHour(val) {
            this.count = val;
            this.href = _index5.API_Admin.exportPointExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&companyid=" + this.$route.query.companyId + "&count=" + this.count + "&companyname=" + this.$route.query.companyName + "";
        },


        bak: function bak() {
            this.$router.push({
                path: '/probationCustom',
                query: {
                    dynamicTags: this.$route.query.dynamicTags,
                    souchs: this.$route.query.souchs,
                    type: 1,
                    pageNumber: this.$route.query.pageNumber,
                    pageSize: this.$route.query.pageSize,
                    companyName: this.$route.query.companyName,
                    searchText: this.$route.query.searchText,
                    status: this.$route.query.status,
                    managerAdminuserName: this.$route.query.managerAdminuser,
                    managerAdminuser: this.$route.query.managerAdminuser,
                    distributionStatus: this.$route.query.distributionStatus,
                    regionCode: this.$route.query.regionCode,
                    successfulManager: this.$route.query.successfulManager,
                    agencyManager: this.$route.query.agencyManager
                }
            });
        },
        handleSelect: function handleSelect(key, keyPath) {
            this.showCom = false;
            this.showWeP = false;
            this.showDev = false;
            this.showFx = false;
            this.showSystem = false;
            if (key == '1') {
                this.showCom = true;
                sessionStorage.setItem('admin_menu', '1');
            } else if (key == '2') {
                this.showWeP = true;
                sessionStorage.setItem('admin_menu', '2');
            } else if (key == '3') {
                this.showDev = true;
                sessionStorage.setItem('admin_menu', '3');
            } else if (key == '4') {
                this.showFx = true;
                sessionStorage.setItem('admin_menu', '4');
            } else if (key == '5') {
                this.showSystem = true;
                sessionStorage.setItem('admin_menu', '5');
            }
            sessionStorage.setItem('admin_menu', key);
            this.activeIndex = key;
        }
    },

    mounted: function mounted() {
        this.activeIndex = sessionStorage.getItem('admin_menu');
        this.activeIndex = this.activeIndex ? this.activeIndex : '1';
        if (this.activeIndex == '2') {
            this.showCom = false;
            this.showDev = false;
            this.showWeP = true;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 2);
        } else if (this.activeIndex == '3') {
            this.showDev = true;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 3);
        } else if (this.activeIndex == '4') {
            this.showDev = false;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = true;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 4);
        } else if (this.activeIndex == '5') {
            this.showDev = false;
            this.showCom = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = true;
            sessionStorage.setItem('admin_menu', 5);
        } else {
            this.showCom = true;
            this.showDev = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', 1);
        }
        if (['6', '7', '8'].includes(this.activeIndex)) {
            this.showCom = false;
            this.showDev = false;
            this.showWeP = false;
            this.showFx = false;
            this.showSystem = false;
            sessionStorage.setItem('admin_menu', this.activeIndex);
        }
    }
};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(117);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['userid'],
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      value: "1",
      loading: false,
      options: [{
        value: "1",
        label: "最近一个月"
      }, {
        value: "3",
        label: "最近三个月"
      }, {
        value: "6",
        label: "最近半年"
      }, {
        value: "12",
        label: "最近一年"
      }],
      chartPie: [],
      legend: [],
      checkCode: '',
      token: ''
    };
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getData();
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    getData: function getData() {
      this.adminModulePointPieCopy();
    },
    adminModulePointPieCopy: function adminModulePointPieCopy(val) {
      var _this = this;

      var param = {
        count: this.value,
        userid: this.userid,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading = true;
      _index.API_Admin.getUserModulePointPie(param).then(function (res) {
        if (res.data.code == 200) {
          var list = [];
          var data = res.data.data;
          var legend = [];
          for (var p in data) {
            list.push({ name: data[p].modulename, value: data[p].sumpoint });
            legend.push(data[p].modulename);
          }
          _this.chartPie = list;
          _this.legend = legend;
          _this.initCharts();
          _this.loading = false;
        }
      });
    },
    initCharts: function initCharts() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-copy-lpie"));
      charts.showLoading();
      charts.setOption({
        title: {
          text: "模块使用情况分析",
          top: "top",
          left: "left",
          textStyle: {
            color: "#596471",
            fontSize: 18,
            fontWeight: 400,
            fontFamily: 'SourceHanSansCN'
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "horizontal",
          left: 10,
          data: this.legend,
          bottom: 0
        },
        series: [{
          name: "模块使用情况分析",
          type: "pie",
          radius: "55%",
          center: ["50%", "45%"],
          data: this.chartPie,
          emphasis: {

            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          },
          label: {
            show: true,
            color: 'black',
            formatter: function formatter(params) {
              return params.value;
            }
          }
        }],
        color: ['#FF6383', '#FF9F40', '#FFCB48', '#5C89FF', '#7C6AF2', '#C95FF2']
      });
      charts.hideLoading();
    }
  }
};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

var _targetCustomDialog = __webpack_require__(753);

var _targetCustomDialog2 = _interopRequireDefault(_targetCustomDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	mixins: [_fitTableHeight2.default],
	data: function data() {
		return {
			listLoading: false,
			options: [{
				value: '选项1',
				label: '黄金糕'
			}, {
				value: '选项2',
				label: '双皮奶'
			}, {
				value: '选项3',
				label: '蚵仔煎'
			}, {
				value: '选项4',
				label: '龙须面'
			}, {
				value: '选项5',
				label: '北京烤鸭'
			}],
			souchs: {
				value1: '',
				value2: '',
				value3: '',
				input: ''
			},

			tableData: [{
				date: '2016-05-02',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1518 弄'
			}, {
				date: '2016-05-04',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1517 弄'
			}, {
				date: '2016-05-01',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1519 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}, {
				date: '2016-05-03',
				name: '王小虎',
				address: '上海市普陀区金沙江路 1516 弄'
			}],
			pageNumber: 1,
			pageSize: 10,
			total: 50
		};
	},

	computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

	components: {
		BaseContainer: _BaseContainer2.default,
		TargetCustomDialog: _targetCustomDialog2.default
	},

	mounted: function mounted() {},

	methods: {
		check: function check() {
			console.log('check');
		},
		add: function add() {
			console.log('add');
			this.$refs.targetcustomdialogRef.init();
		},
		indexMethod: function indexMethod(index) {
			return index + 1;
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.pageNumber = val;
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
		},
		getRowClass: function getRowClass(_ref) {
			var row = _ref.row,
			    column = _ref.column,
			    rowIndex = _ref.rowIndex,
			    columnIndex = _ref.columnIndex;

			if (rowIndex == 0) {
				return 'background:#F5F7FA';
			} else {
				return '';
			}
		},
		handleSortChange: function handleSortChange(val) {
			console.log('handleSortChange', val);
		}
	}
};

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(90);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(89);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = __webpack_require__(20);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _SelectCommon = __webpack_require__(74);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _GisCommon = __webpack_require__(164);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _this2 = this;

    var validatorCompany = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.addForm.name) {
                  _context.next = 4;
                  break;
                }

                callback("请输入企业名称");
                _context.next = 8;
                break;

              case 4:
                _context.next = 6;
                return _this2.checkCompany(_this2.addForm.name);

              case 6:
                res = _context.sent;

                !res ? callback("企业名称已存在") : callback();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function validatorCompany(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    var validatorLevel = function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(rule, value, callback) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (value === 0) {
                  callback("请选择企业分级");
                } else {
                  callback();
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function validatorLevel(_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }();
    var validatorAddress = function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(rule, value, callback) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this2.addForm.addressInfo) {
                  callback("请输入企业位置");
                } else {
                  if (!_this2.addForm.longitudeAndLatitude) {
                    callback("请在GIS地图中确认位置");
                  } else {
                    callback();
                  }
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function validatorAddress(_x7, _x8, _x9) {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      dialogVisible: false,
      addLoading: false,
      selected: {
        province: "320000",
        city: "320100",
        area: "320115",
        town: "320115010"
      },
      address: "",
      managerAdminuser: "",
      successfulManager: "",
      agencyManager: "",
      addForm: {
        name: "",
        showname: "",
        level: 0,
        natrue: "",
        userScale: "",
        province: "",
        city: "",
        district: "",
        longitudeAndLatitude: "",
        addressInfo: "",
        linker: "",
        linkerPhone: "",
        remarks: ""
      },
      regionCodeList: [{
        value: "1",
        label: "华东大区"
      }, {
        value: "2",
        label: "华北大区"
      }, {
        value: "3",
        label: "西北大区"
      }, {
        value: "4",
        label: "华南大区"
      }, {
        value: "5",
        label: "西南大区"
      }],
      gradeList: [{
        value: "1",
        label: "综合甲"
      }, {
        value: "2",
        label: "公路甲"
      }, {
        value: "3",
        label: "市政甲"
      }, {
        value: "4",
        label: "公路市政甲"
      }, {
        value: "5",
        label: "公路乙"
      }, {
        value: "6",
        label: "市政乙"
      }, {
        value: "7",
        label: "公路市政乙"
      }, {
        value: "9",
        label: "高校"
      }, {
        value: "10",
        label: "施工单位"
      }, {
        value: "8",
        label: "其他"
      }],
      natureList: [{
        value: "1",
        label: "央企"
      }, {
        value: "2",
        label: "国企"
      }, {
        value: "3",
        label: "民营上市"
      }, {
        value: "4",
        label: "民营"
      }, {
        value: "5",
        label: "高校"
      }],
      addFormRules: {
        name: [{ required: true, validator: validatorCompany, trigger: "change" }],
        showname: [{
          required: true,
          message: "请输入地区",
          trigger: ["blur", "change"]
        }],
        regionCode: [{
          required: true,
          message: "请选择大区代号",
          trigger: ["blur", "change"]
        }],
        grade: [{
          required: true,
          message: "请选择资质等级",
          trigger: ["blur", "change"]
        }],
        natrue: [{
          required: true,
          message: "请选择企业性质",
          trigger: ["blur", "change"]
        }],
        userScale: [{
          required: true,
          message: "请输入用户规模",
          trigger: ["blur", "change"]
        }],
        addressInfo: [{ required: true, validator: validatorAddress, trigger: "change" }],
        level: [{
          required: true,
          validator: validatorLevel,
          trigger: ["blur", "change"]
        }]
      },
      imageUrl: "",
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: _index.API_Common.setCompanyPic(),
        dialogImageUrl: "",
        dialogVisible: false,
        data: {
          mode: "save",
          token: this.token,
          checkCode: this.checkCode,
          type: 1
        }
      },
      beformAddImg: "",
      editImageUrl: ""
    };
  },

  components: {
    SelectCommon: _SelectCommon2.default,
    GisCommon: _GisCommon2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["userInfo"])),
  mounted: function mounted() {},
  created: function created() {
    this.getCookie();
  },


  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    },
    init: function init() {
      this.dialogVisible = true;
    },
    addSubmit: function addSubmit() {
      var _this3 = this;

      this.$refs["addForm"].validate(function (valid) {
        if (valid) {
          if (_this3.addLoading) return;
          _this3.addLoading = true;
          if (_this3.beformAddImg) {
            var _this = _this3;
            var formData = new FormData();
            formData.append("pic", _this3.beformAddImg.raw);
            formData.append("token", _this3.token);
            formData.append("checkCode", _this3.checkCode);
            formData.append("mode", "save");
            var config = {
              "Content-Type": "multipart/form-data"
            };
            _axios2.default.post(_this3.upload.postURL, formData, config).then(function (res) {
              if (res.data.code == _index.API__code.SUCCESS) {
                _this.addHandler(res.data.data);
                _this.$refs.upload.clearFiles();
              } else {
                _this.$message.error(res.data.message);
                if (res.data.code == 403) {
                  _this.$router.push({ path: "loginAdmin" });
                }
                return;
              }
            }).catch(function (error) {
              console.log(error);
              return;
            });
          } else {
            _this3.addHandler();
          }
        }
      });
    },
    addHandler: function addHandler(val) {
      var _this4 = this;

      if (val) {
        var newlbtPath = val.pic;
        var newId = val.id;
      }

      var param = (0, _extends3.default)({}, this.addForm, {
        logoid: newlbtPath,
        showpicid: newId,
        token: this.token,
        checkCode: this.checkCode,
        mode: "save",
        createUser: this.userInfo.id,
        addressInfo: this.addForm.addressInfo,
        managerAdminuser: this.managerAdminuser,
        successfulManager: this.successfulManager,
        agencyManager: this.agencyManager,
        isbinding: 0
      });
      _index.API_User.addCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: "保存成功",
            type: "success"
          });
          _this4.$emit("getList", 1);
          _this4.handleClose();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: "loginAdmin" });
          }
        }
        _this4.addLoading = false;
      }).catch(function (err) {
        _this4.$message.error("数据丢失，试试重新登陆！");
        _this4.addLoading = false;
      });
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs["addForm"].clearValidate();
      this.$refs["addForm"].resetFields();
    },
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    },
    backPram: function backPram(param) {
      this.addForm.province = (0, _stringify2.default)(param.selected.province);
      this.addForm.city = (0, _stringify2.default)(param.selected.city);
      this.addForm.district = (0, _stringify2.default)(param.selected.area);
      this.addForm.longitudeAndLatitude = param.position.toString();
      this.addForm.addressInfo = param.address;
    },
    checkCompany: function checkCompany(name) {
      return _index.API_User.checkCompanyUnique({ name: name }).then(function (res) {
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;
        console.log("ile.raw", file.raw);
        this.imageUrl = URL.createObjectURL(file.raw);
        console.log("this.imageUrl", this.imageUrl);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error("请选择图片文件");
      }
    }
  }
};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var _charts = __webpack_require__(1672);

var _charts2 = _interopRequireDefault(_charts);

var _rightCharts = __webpack_require__(1677);

var _rightCharts2 = _interopRequireDefault(_rightCharts);

var _calender = __webpack_require__(1671);

var _calender2 = _interopRequireDefault(_calender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      textarea: "",
      listLoading: false,
      loginInfoLoading: false,
      notes: [],
      allcount: 0,
      token: "",
      checkCode: "",
      id: "",

      users: [],

      expired: 0,
      company: 0,

      sum: 0,
      showRecords: true,

      lastLogin_time: 0,
      lastLogin_location: "",
      infos: [],
      countNum: 0,
      phone: ""
    };
  },
  created: function created() {
    this.getCookie();
    this.getUserNote();
  },

  methods: {
    back: function back() {
      if (this.$route.query.shengfeng) {
        this.$router.push({
          path: "/activityWarn",
          query: {
            datanum: this.$route.query.datanum,
            zhanghao: this.$route.query.zhanghao,
            accountManager: this.$route.query.accountManager,
            pageNumber: this.$route.query.pageNumber,
            pageSize: this.$route.query.pageSize
          }
        });
      } else if (this.$route.query.jiangshi) {
        this.$router.push({
          path: "/dailyStatistics",
          query: {
            managerAdminuser: this.$route.query.managerAdminuser,
            pageNumber: this.$route.query.pageNumber,
            pageSize: this.$route.query.pageSize,
            jiangshi: 1
          }
        });
      } else {
        this.$router.push({
          path: "/account",
          query: {
            dynamicTags: this.$route.query.dynamicTags,
            souchs: this.$route.query.souchs,
            type: 1,
            pageNumber: this.$route.query.pageNumber,
            pageSize: this.$route.query.pageSize,
            searchName: this.$route.query.searchName,
            isCompanyUser: this.$route.query.isCompanyUser,
            fromtime: this.$route.query.fromtime,
            totime: this.$route.query.totime,
            managerAdminuser: this.$route.query.managerAdminuser,
            distributionStatus: this.$route.query.distributionStatus
          }
        });
      }
    },
    getData: function getData() {
      var _this2 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: 1,
        pageSize: 999,
        listType: "paged",
        userid: this.$route.query.userId
      };
      this.listLoading = true;
      _index.API_Admin.getList(param).then(function (res) {
        if (res.data.code == 200) {
          _this2.users = res.data.data;
          _this2.sum = res.data.data.length;
          _this2.expired = res.data.expired;
          _this2.company = res.data.company;
        }
        _this2.listLoading = false;
      }).catch(function (e) {
        _this2.listLoading = false;
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
          if (arr2[0] == "dnnyptadmin_token") {
            this.phone = arr2[1];
          }
        }
      }
      this.getData();

      if (this.$route.query.notShowRecords) {
        this.showRecords = false;
        return;
      }
      this.getLoginInfor();
    },
    handleDel: function handleDel(index, row) {
      var _this3 = this;

      this.$confirm("确认禁用吗?", "提示", {
        type: "warning"
      }).then(function () {
        var ids;
        ids = row.id;
        var param = {
          token: _this3.token,
          checkCode: _this3.checkCode,
          ids: ids,
          usingstatus: 3
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this3.$message({
              message: "禁用成功",
              type: "success"
            });
            _this3.getData();
          }
        }).catch(function (err) {
          _this3.$message.error("数据丢失，试试重新登陆！");
        });
      }).catch(function () {});
    },
    handleOpen: function handleOpen(index, row) {
      var _this4 = this;

      var _this = this;
      this.$confirm("确认启用吗?", "提示", {
        type: "warning"
      }).then(function () {
        var ids;
        ids = row.id;
        var param = {
          token: _this4.token,
          checkCode: _this4.checkCode,
          ids: ids,
          usingstatus: 1
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this4.$message({
              message: "启用成功",
              type: "success"
            });
            _this4.getData();
          }
        }).catch(function (err) {
          _this4.$message.error("数据丢失，试试重新登陆！");
        });
      }).catch(function () {});
    },
    addUserNote: function addUserNote() {
      var _this5 = this;

      if (this.textarea == "") {
        this.$message.error("数据不能为空");
      } else {
        var params = {
          token: this.token,
          checkCode: this.checkCode,
          note: this.textarea,
          userId: this.$route.query.userId
        };
        _index.API_Auth.addUserNote(params).then(function (res) {
          if (res.data.code == 200) {
            _this5.$message({
              message: "提交成功",
              type: "success"
            });
            _this5.textarea = "";
            _this5.getUserNote();
          }
        });
      }
    },
    getUserNote: function getUserNote() {
      var _this6 = this;

      var params = {
        token: this.token,
        checkCode: this.checkCode,
        userId: this.$route.query.userId
      };
      _index.API_Auth.getUserNote(params).then(function (res) {
        if (res.data.code == 200) {
          _this6.notes = res.data.data;
          _this6.allcount = res.data.data.length;
        }
      });
    },

    getLoginInfor: function getLoginInfor() {
      var _this7 = this;

      this.loginInfoLoading = true;
      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: this.$route.query.userId
      };
      _index.API_Man.getLoginInfor(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var arr = [];
          for (var i = 0; i < res.data.data.loginInfor.length; i++) {
            if (res.data.data.loginInfor[i].time) {
              res.data.data.loginInfor[i].date = res.data.data.loginInfor[i].time.substring(5, 10);
              res.data.data.loginInfor[i].date = res.data.data.loginInfor[i].date.replace(/-/g, "月") + "日";
              res.data.data.loginInfor[i].times = res.data.data.loginInfor[i].time.substring(11, 16);
            }
            if (arr.length > 0) {
              for (var k = 0; k < arr.length; k++) {
                if (res.data.data.loginInfor[i].date == arr[k]) {
                  res.data.data.loginInfor[i].date = "";
                }
              }
            }
            arr.push(res.data.data.loginInfor[i].date);
          }
          if (res.data.data.loginInfor.length > 0) {
            _this.lastLogin_time = res.data.data.loginInfor[0].time;
            _this.lastLogin_location = res.data.data.loginInfor[0].location;
          }
          _this.infos = res.data.data.loginInfor;
          _this.countNum = res.data.data.loginCount;
        }
        _this7.loginInfoLoading = false;
      }).catch(function (err) {
        _this7.loginInfoLoading = false;
        _this7.$message.error("数据丢失，试试重新登陆！");
      });
    }
  },
  components: {
    LeftCharts: _charts2.default,
    RightCharts: _rightCharts2.default,
    Calendar: _calender2.default
  }
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      types: [{ value: '1', label: '系统管理员' }, { value: '2', label: '客户经理' }, { value: '3', label: '客户成功经理' }, { value: '4', label: '经销商' }],

      total: 0,
      pageNumber: 1,
      pageSize: 20,
      id: '',
      token: '',
      checkCode: '',
      users: [],
      listLoading: false,
      souchs: {},
      addFormVisible: false,
      addForm: {},
      addLoading: false,
      addFormRules: {
        user: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },

      editForm: {
        name: '',
        phone: '',
        type: '',
        password: '',
        conpassword: ''
      },
      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        user: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        password: [{ required: false, message: '密码', trigger: 'blur' }],
        conpassword: [{ required: false, message: '确认密码', trigger: 'blur' }]
      }
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    editSubmit: function editSubmit() {
      var _this2 = this;

      this.$refs['editForm'].validate(function (valid) {
        if (valid) {
          _this2.editLoading = true;
          var param = {
            token: _this2.token,
            checkCode: _this2.checkCode,
            id: _this2.editForm.id,
            user: _this2.editForm.phone,
            name: _this2.editForm.name,
            type: _this2.editForm.type
          };
          if (_this2.editForm.password) {
            param.password = _this2.editForm.password;
            param.conpassword = _this2.editForm.conpassword;
          }
          _index.API_Admin.editAdmin(param).then(function (res) {
            if (res.data.code == _index.API__code.SUCCESS) {
              _this2.$message({
                message: '修改成功',
                type: 'success'
              });
              _this2.editFormVisible = false;
              _this2.getUser();
            } else {
              _this2.$message.error(res.data.message);
              if (res.data.code == 403) {
                _this2.$router.push({ path: 'loginAdmin' });
              }
            }
            _this2.editLoading = false;
          }).catch(function (err) {
            _this2.editLoading = false;
            _this2.$message.error('服务器异常，请您稍后再试..');
          });
        }
      });
    },

    handleEdit: function handleEdit(index, row) {

      this.editFormVisible = true;
      this.editForm.id = row.id;
      this.editForm.phone = row.phone;
      this.editForm.name = row.name;
      this.editForm.type = row.type;
    },

    handleDel: function handleDel(index, row) {
      var _this3 = this;

      this.$confirm('确认删除该用户吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var para = {
          id: row.id,
          token: _this3.token,
          checkCode: _this3.checkCode
        };
        _index.API_Admin.delAdmin(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this3.$message({
              message: '删除成功',
              type: 'success'
            });
            _this3.getUser();
          } else {
            _this3.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this3.$router.push({ path: 'loginAdmin' });
            }
          }
        });
      });
    },
    addSubmit: function addSubmit() {
      var _this4 = this;

      this.$refs['addForm'].validate(function (valid) {
        if (valid) {
          var param = {
            token: _this4.token,
            checkCode: _this4.checkCode,
            user: _this4.addForm.user,
            password: _this4.addForm.password,
            name: _this4.addForm.name,
            type: _this4.addForm.type
          };
          _this4.addLoading = true;
          _index.API_Admin.setAdmin(param).then(function (res) {
            if (res.data.code == _index.API__code.SUCCESS) {
              _this4.$message({
                message: '新增成功',
                type: 'success',
                center: true
              });

              _this4.addFormVisible = false;
              _this4.addForm = {};
              _this4.getUser();
            } else {
              _this4.$message.error(res.data.message);
              if (res.data.code == 403) {
                _this4.$router.push({ path: 'loginAdmin' });
              }
            }
            _this4.addLoading = false;
          }).catch(function (err) {
            _this4.$message.error('服务器异常，请您稍后再试..');
            _this4.addLoading = false;
          });
        }
      });
    },
    closeAddform: function closeAddform() {
      this.$refs['addForm'].clearValidate();
    },
    closeeditForm: function closeeditForm() {
      this.$refs['editForm'].clearValidate();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },

    handleAdd: function handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return 'background:#F5F7FA';
      } else {
        return '';
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == 'name') {
          this.orderStr = 'namepx';
        } else if (val.prop == 'phone') {
          this.orderStr = 'phonepx';
        } else if (val.prop == 'intime') {
          this.orderStr = 'intimepx';
        }
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
      }
      this.getUser();
    },
    getUser: function getUser(val) {
      var _this5 = this;

      var _this = this;
      if (val == 1) {
        this.pageNumber = 1;
      }
      var param = {
        searchName: this.souchs.name,
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,

        orderStr: this.orderStr,
        orderType: this.orderType
      };
      this.listLoading = true;
      _index.API_Admin.getAdminList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            _this.total = res.data.data.totalRow;
          }
          _this.users = res.data.data.list;
          for (var i = 0; i < _this5.users.length; i++) {
            if (_this.users[i].phone == _this5.token) {
              _this.users[i].delShow = true;
            } else {
              _this.users[i].delShow = false;
            }

            if (_this.users[i].type == 1) {
              _this.users[i].types = '系统管理员';
            } else {
              _this.users[i].types = '普通管理员';
            }
          }
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.listLoading = false;
      }).catch(function (err) {
        _this5.$message.error('服务器异常，请您稍后再试..');
        _this5.listLoading = false;
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getUser();
  }
};

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      viewForm: {
        usename: '',
        phone: '',
        qq: '',
        company: '',
        adress: '',
        bumenzhiwei: ''
      },
      viewVisible: false,
      value: '',
      dynamicTags: [],
      options: [{ value: '姓名', label: '姓名' }, { value: '电话', label: '电话' }, { value: 'QQ', label: 'QQ' }, { value: '公司', label: '公司' }, { value: '部门职位', label: '部门职位' }, { value: '地址', label: '地址' }],
      souchs: {},
      proName: '',

      proList: [],
      token: '',
      checkCode: '',
      id: '',
      listLoading: false,
      pageNumber: 1,
      total: 0,
      pageSize: 20,
      orderType: "",
      orderStr: '',

      searchText: ''

    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },
  methods: {
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;


      if (row.status == '1') {
        return 'warning-row';
      }

      return '';
    },
    handleClose: function handleClose(tag) {
      if (tag == "姓名") {
        this.souchs.usename = '';
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "电话") {
        this.souchs.phone = '';
        if (this.value == "电话") {
          this.proName = '';
        }
      }
      if (tag == "QQ") {
        this.souchs.qq = '';
        if (this.value == "QQ") {
          this.proName = '';
        }
      }
      if (tag == "公司") {
        this.souchs.company = '';
        if (this.value == "公司") {
          this.proName = '';
        }
      }
      if (tag == "部门职位") {
        this.souchs.bumenzhiwei = '';
        if (this.value == "部门职位") {
          this.proName = '';
        }
      }
      if (tag == "地址") {
        this.souchs.adress = '';
        if (this.value == "地址") {
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    delTags: function delTags() {
      this.souchs = {}, this.value = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getProList(1);
    },
    changeSouch: function changeSouch(val) {
      if (val == "姓名") {
        this.proName = this.souchs.usename;
      } else if (val == "电话") {
        this.proName = this.souchs.phone;
      } else if (val == "QQ") {
        this.proName = this.souchs.qq;
      } else if (val == "公司") {
        this.proName = this.souchs.company;
      } else if (val == "部门职位") {
        this.proName = this.souchs.bumenzhiwei;
      } else if (val == "地址") {
        this.proName = this.souchs.adress;
      }
    },

    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "usename") {
          this.orderStr = "namepx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "qq") {
          this.orderStr = "qqpx";
        } else if (val.prop == "company") {
          this.orderStr = "companypx";
        } else if (val.prop == "bumenzhiwei") {
          this.orderStr = "bumenzhiweipx";
        } else if (val.prop == "adress") {
          this.orderStr = "adresspx";
        } else if (val.prop == "statusname") {
          this.orderStr = "statuspx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getProList();
    },
    handleEdit: function handleEdit(index, row) {
      var _this = this;

      this.$confirm('确认已处理该申请?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this.token,
          checkCode: _this.checkCode,
          id: row.id,
          status: 1,
          mode: 'update'
        };
        _index.API_trial.setList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this.$message({
              message: "已处理成功",
              type: 'success'
            });
            _this.getProList();
          } else {
            _this.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    handleView: function handleView(index, row) {
      this.viewVisible = true;
      this.viewForm = (0, _assign2.default)({}, row);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getProList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getProList();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },


    getProList: function getProList(val) {
      var _this2 = this;

      if (this.value == "姓名") {
        this.souchs.usename = this.proName;
      }
      if (this.value == "电话") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "QQ") {
        this.souchs.qq = this.proName;
      }
      if (this.value == "公司") {
        this.souchs.company = this.proName;
      }
      if (this.value == "部门职位") {
        this.souchs.bumenzhiwei = this.proName;
      }
      if (this.value == "地址") {
        this.souchs.adress = this.proName;
      }
      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,

        name: this.souchs.usename,
        phone: this.souchs.phone,
        qq: this.souchs.qq,
        company: this.souchs.company,
        bumenzhiwei: this.souchs.bumenzhiwei,
        adress: this.souchs.adress,

        orderStr: this.orderStr,
        orderType: this.orderType,
        searchText: this.searchText

      };
      this.listLoading = true;
      _index.API_trial.getList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.proList = res.data.data.list;
          _this2.total = res.data.data.totalRow;
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.listLoading = false;
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.getProList();
  },
  created: function created() {
    this.getCookie();
  }
};

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _detail = __webpack_require__(754);

var _detail2 = _interopRequireDefault(_detail);

var _SelectCommon = __webpack_require__(74);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _ref;

    return _ref = {
      adminVisible: false,
      detailOrderId: false,
      checkType: '',
      disCheckBox: false,
      checked: false,
      detailIDS: '',
      pruductJson: [],
      userid: '',
      allPrice: 0,
      orderUser: '',
      orderId: '',
      dataList2: [],
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      editlistLoading: false,
      editFormVisible: false,
      editLoading: false,
      editForm: {},
      ygPrice: 0
    }, (0, _defineProperty3.default)(_ref, 'allPrice', 0), (0, _defineProperty3.default)(_ref, 'disSouch', true), (0, _defineProperty3.default)(_ref, 'disType1', false), (0, _defineProperty3.default)(_ref, 'disType2', false), (0, _defineProperty3.default)(_ref, 'sels', []), (0, _defineProperty3.default)(_ref, 'sels1', []), (0, _defineProperty3.default)(_ref, 'sels3', []), (0, _defineProperty3.default)(_ref, 'token', ''), (0, _defineProperty3.default)(_ref, 'checkCode', ""), (0, _defineProperty3.default)(_ref, 'id', ""), (0, _defineProperty3.default)(_ref, 'listLoading', false), (0, _defineProperty3.default)(_ref, 'dataList', []), (0, _defineProperty3.default)(_ref, 'pageNumber', 1), (0, _defineProperty3.default)(_ref, 'pageSize', 20), (0, _defineProperty3.default)(_ref, 'total', 0), (0, _defineProperty3.default)(_ref, 'souchs', {
      id: '',
      phone: '',
      name: '',
      souType: '',
      status: ""
    }), (0, _defineProperty3.default)(_ref, 'proName', ''), (0, _defineProperty3.default)(_ref, 'options', [{ value: 'ID', label: 'ID' }, { value: '姓名', label: '姓名' }, { value: '手机号', label: '手机号' }, { value: '名称', label: '名称' }, { value: '企业', label: '企业' }, { value: '类型', label: '类型' }, { value: '状态', label: '状态' }]), (0, _defineProperty3.default)(_ref, 'value', ''), (0, _defineProperty3.default)(_ref, 'types', [{ value: '1', label: '试用' }, { value: '2', label: '正式' }]), (0, _defineProperty3.default)(_ref, 'types2', [{ value: '1', label: '正常使用' }, { value: '2', label: '到期' }, { value: '3', label: '禁用' }]), (0, _defineProperty3.default)(_ref, 'typeValue', ''), (0, _defineProperty3.default)(_ref, 'typeValue2', ''), (0, _defineProperty3.default)(_ref, 'dynamicTags', []), (0, _defineProperty3.default)(_ref, 'orderType', ""), (0, _defineProperty3.default)(_ref, 'orderStr', ''), (0, _defineProperty3.default)(_ref, 'searchText', ''), (0, _defineProperty3.default)(_ref, 'managerAdminuser', ''), _ref;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default,
    Detail: _detail2.default,
    SelectCommon: _SelectCommon2.default
  },

  methods: {
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.managerAdminuser = value[0];
    },


    checkboxOnclick: function checkboxOnclick() {
      if (this.checked) {
        this.disCheckBox = true;
      } else {
        this.disCheckBox = false;
      }
    },
    adminVisibleClose: function adminVisibleClose(type) {
      this.adminVisible = false;
    },
    handleAbout: function handleAbout(index, item) {
      console.log(item);
      this.detailOrderId = item.id;
      this.adminVisible = true;
    },

    priceloseF: function priceloseF() {
      if (this.allPrice) {
        if (isNaN(this.allPrice)) {
          this.allPrice = this.allPrice.replace(/[^\.\d]/g, '');
        }
        if (parseFloat(this.allPrice).toString() == "NaN") {
          this.$message.error("指标数为大于0的数, 请重新输入");
          return;
        } else if (this.allPrice < 0) {
          this.$message.error("指标数为大于0的数, 请重新输入");
          this.allPrice = 0;
          return;
        } else {
          this.allPrice = parseFloat(this.allPrice);
          this.allPrice = this.allPrice.toLocaleString();
        }
      } else {
        this.allPrice = 0;
        return;
      }
    },
    loseFcousMonth: function loseFcousMonth(index, row) {
      if (row.purchaseMonth) {
        var falg = this.isInteger(row.purchaseMonth);
        if (!falg) {
          this.$message.error('请输入月份为大于或等于0的整数!');
          return row.purchaseMonth = "";
        }
        if (row.purchaseMonth < 0) {
          this.$message.error('请输入月份为大于或等于0的整数!');
          return row.purchaseMonth = "";
        }
        this.ygPrice = 0;
        for (var i = 0; i < this.dataList2.length; i++) {
          if (this.dataList2[i].purchaseMonth && this.dataList2[i].price) {
            this.ygPrice = parseInt(this.ygPrice) + parseInt(this.dataList2[i].purchaseMonth) * parseInt(this.dataList2[i].price);
          }
        }
        if (this.ygPrice) {
          this.ygPrice = parseFloat(this.ygPrice);
          this.ygPrice = this.ygPrice.toLocaleString();
        }
      }
    },
    isInteger: function isInteger(obj) {
      obj = parseFloat(obj);
      return Math.floor(obj) === obj;
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        console.log(val);
        if (val.prop == "id") {
          this.orderStr = "idpx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "productname") {
          this.orderStr = "productnamepx";
        } else if (val.prop == "typename") {
          this.orderStr = "typepx";
        } else if (val.prop == "createtime") {
          this.orderStr = "createtimepx";
        } else if (val.prop == "duetime") {
          this.orderStr = "duetimepx";
        } else if (val.prop == "usingstatus") {
          this.orderStr = "statuspx";
        } else if (val.prop == "usercompany") {
          this.orderStr = "usercompanypx";
        } else if (val.prop == "effectivetime") {
          this.orderStr = "effectivetime";
        }

        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch: function changeSouch(val) {
      if (val == "类型") {
        this.disSouch = false;
        this.disType1 = true;
        this.disType2 = false;
        this.proName = '';
        this.typeValue = this.souchs.souType;
      } else if (val == "状态") {
        this.disSouch = false;
        this.disType1 = false;
        this.disType2 = true;
        this.proName = '';
        this.typeValue2 = this.souchs.status;
      } else if (val == "ID") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.id;
      } else if (val == "手机号") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.phone;
      } else if (val == "姓名") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.name;
      } else if (val == "名称") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.productname;
      } else if (val == "企业") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.usercompany;
      }
    },
    getList: function getList(val) {
      var _this2 = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      if (this.value == "ID") {
        this.souchs.id = this.proName;
      }
      if (this.value == "手机号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }
      if (this.value == "名称") {
        this.souchs.productname = this.proName;
      }
      if (this.value == "类型") {
        this.souchs.souType = this.typeValue;
      }
      if (this.value == "状态") {
        this.souchs.status = this.typeValue2;
      }
      if (this.value == "企业") {
        this.souchs.usercompany = this.proName;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        id: this.souchs.id,
        name: this.souchs.name,
        phone: this.souchs.phone,
        usercompany: this.souchs.usercompany,
        productname: this.souchs.productname,
        type: this.souchs.souType,
        status: this.souchs.status,
        orderType: this.orderType,
        orderStr: this.orderStr,
        accountType: 0,
        searchText: this.searchText,
        managerAdminuser: this.managerAdminuser,
        role: this.userInfo.type,
        userId: this.userInfo.id
      };
      this.listLoading = true;
      _index.API_Auth.getAutoList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].usingstatus == 1) {
              res.data.data.list[i].usingstatus1 = "正常使用";
            } else if (res.data.data.list[i].usingstatus == 3) {
              res.data.data.list[i].usingstatus1 = "禁用";
              res.data.data.list[i].usingstatus2 = true;
            } else if (res.data.data.list[i].usingstatus == 2) {
              res.data.data.list[i].usingstatus1 = "过期";
            }
          }
          _this2.dataList = res.data.data.list;
          _this2.total = res.data.data.totalRow;
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.listLoading = false;
      });
    },
    delTags: function delTags() {
      this.souchs = {}, this.souchs.souType = '';
      this.souchs.status = '';
      this.value = '';
      this.proName = '';
      this.typeValue = '';
      this.typeValue2 = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == "ID") {
        this.souchs.id = "";
        if (this.value == "ID") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs.name = "";
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "手机号") {
        this.souchs.phone = "";
        if (this.value == "手机号") {
          this.proName = '';
        }
      }
      if (tag == "名称") {
        this.souchs.productname = "";
        if (this.value == "名称") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.usercompany = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "类型") {
        this.souchs.souType = "";
        this.typeValue = '';
      }
      if (tag == "状态") {
        this.souchs.status = "";
        this.typeValue2 = '';
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    handleSizeChange2: function handleSizeChange2(val) {
      this.pageSize2 = val;
      this.handleEdit();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.handleEdit();
    },

    handleOpen: function handleOpen(index, row) {
      var _this3 = this;

      var _this = this;
      this.$confirm('确认启用吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var ids;
        if (row) {
          ids = row.id;
        } else {
          ids = _this.sels3.map(function (item) {
            return item.id;
          }).toString();
        }
        var param = {
          token: _this3.token,
          checkCode: _this3.checkCode,
          ids: ids,
          usingstatus: 1
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this3.$message({
              message: '启用成功',
              type: 'success'
            });
            _this3.getList();
          } else {
            _this3.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this3.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this3.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function () {});;
    },

    handleDel: function handleDel(index, row) {
      var _this4 = this;

      this.$confirm('确认禁用吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var ids;
        if (row) {
          ids = row.id;
        } else {
          ids = _this4.sels1.map(function (item) {
            return item.id;
          }).toString();
        }
        var param = {
          token: _this4.token,
          checkCode: _this4.checkCode,
          ids: ids,
          usingstatus: 3
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this4.$message({
              message: '禁用成功',
              type: 'success'
            });
            _this4.getList();
          } else {
            _this4.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this4.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this4.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function () {});;
    },
    handleEdit: function handleEdit(index, row) {
      this.allPrice = 0;
      this.ygPrice = 0;
      var ids2;

      if (!row) {
        for (var i = 0; i < this.sels.length; i++) {
          if (this.sels[0].phone != this.sels[i].phone) {
            this.$message.error('请选择同一用户下的订单！');
            return;
          }
        }
        this.userid = this.sels[0].userid;
        if (!this.sels[0].name || this.sels[0].name == null) {
          this.sels[0].name = "";
        }
        if (!this.sels[0].phone || this.sels[0].phone == null) {
          this.sels[0].phone = "";
        }
        this.orderUser = this.sels[0].name + "" + this.sels[0].phone;
        ids2 = this.sels.map(function (item) {
          return item.id;
        }).toString();
      } else {
        ids2 = row.id;
        this.userid = row.userid;
        this.orderUser = row.name + "" + row.phone;
      }


      this.getDetial(ids2);
      this.editFormVisible = true;
    },
    editSubmit: function editSubmit() {
      var _this5 = this;

      for (var i = 0; i < this.dataList2.length; i++) {
        if (!this.dataList2[i].purchaseMonth) {
          this.$message.error('列表中的续费时长(月)，不可为空！');
          return;
        }
      }

      if (!this.checked) {
        this.checkType = 2;
        if (!this.allPrice || this.allPrice == 0) {
          this.$message.error('总价不可为空或者0！');
          return;
        } else {
          if (isNaN(this.allPrice)) {
            this.allPrice = this.allPrice.replace(/[^\.\d]/g, '');
          }
        }
      } else {
        this.checkType = 1;
        this.allPrice = 0;
      }
      this.pruductJson = [];
      for (var i = 0; i < this.dataList2.length; i++) {
        var jsonid = [this.dataList2[i].id];
        var jsons = {
          "authorizedProductId": jsonid,
          "singlePrice": this.dataList2[i].price,
          "productId": this.dataList2[i].productid,
          "purchaseMonth": this.dataList2[i].purchaseMonth,
          "purchaseNum": "1",
          "productName": this.dataList2[i].name
        };
        this.pruductJson.push(jsons);
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: this.userid,
        price: this.allPrice,
        pruductJson: (0, _stringify2.default)(this.pruductJson),
        adminuserid: this.id,
        type: this.checkType
      };
      this.editLoading = true;
      _index.API_Auth.autoOrder(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.$message({
            message: '续费成功',
            type: 'success'
          });
          _this5.getList();
          _this5.editFormVisible = false;
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.editLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.editLoading = false;
      });
    },
    getDetial: function getDetial(ids) {
      var _this6 = this;

      this.detailIDS = ids;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        ids: ids
      };
      this.editlistLoading = true;
      _index.API_Auth.autoDetail(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].logo) {

              res.data.data[i].logo2 = res.data.data[i].logo;
            }
            if (res.data.data[i].price) {
              res.data.data[i].price = parseFloat(res.data.data[i].price);
              res.data.data[i].price2 = res.data.data[i].price.toLocaleString();
            }
          }

          _this6.dataList2 = res.data.data;
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
        _this6.editlistLoading = false;
      }).catch(function (err) {
        _this6.$message.error('数据丢失，试试重新登陆！');
        _this6.editlistLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    indexMethod2: function indexMethod2(index) {
      return index + 1 + (this.pageNumber2 - 1) * this.pageSize2;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(row) {
      this.sels1 = [];
      this.sels3 = [];
      for (var i = 0; i < row.length; i++) {
        if (row[i].usingstatus == "1") {
          var json1 = { "id": row[i].id };
          this.sels1.push(json1);
        }
        if (row[i].usingstatus == "3") {
          var json3 = { "id": row[i].id };
          this.sels3.push(json3);
        }
      }
      this.sels = row;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  created: function created() {
    this.getCookie();
  }
};

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _detail = __webpack_require__(754);

var _detail2 = _interopRequireDefault(_detail);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _SelectCommon = __webpack_require__(74);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    var _ref;

    return _ref = {
      adminVisible: false,
      detailOrderId: false,
      checkType: '',
      disCheckBox: false,
      checked: false,
      detailIDS: '',
      pruductJson: [],
      companyid: '',
      allPrice: 0,
      orderUser: '',
      orderId: '',
      dataList2: [],
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      editlistLoading: false,
      editFormVisible: false,
      editLoading: false,
      editForm: {},
      ygPrice: 0
    }, (0, _defineProperty3.default)(_ref, 'allPrice', 0), (0, _defineProperty3.default)(_ref, 'disSouch', true), (0, _defineProperty3.default)(_ref, 'disType1', false), (0, _defineProperty3.default)(_ref, 'disType2', false), (0, _defineProperty3.default)(_ref, 'sels', []), (0, _defineProperty3.default)(_ref, 'sels1', []), (0, _defineProperty3.default)(_ref, 'sels3', []), (0, _defineProperty3.default)(_ref, 'token', ''), (0, _defineProperty3.default)(_ref, 'checkCode', ""), (0, _defineProperty3.default)(_ref, 'id', ""), (0, _defineProperty3.default)(_ref, 'listLoading', false), (0, _defineProperty3.default)(_ref, 'dataList', []), (0, _defineProperty3.default)(_ref, 'pageNumber', 1), (0, _defineProperty3.default)(_ref, 'pageSize', 20), (0, _defineProperty3.default)(_ref, 'total', 0), (0, _defineProperty3.default)(_ref, 'souchs', {
      id: '',
      phone: '',
      name: '',
      souType: '',
      status: ""
    }), (0, _defineProperty3.default)(_ref, 'proName', ''), (0, _defineProperty3.default)(_ref, 'options', [{ value: 'ID', label: 'ID' }, { value: '用户', label: '用户' }, { value: '手机号', label: '手机号' }, { value: '企业', label: '企业' }, { value: '名称', label: '名称' }, { value: '类型', label: '类型' }, { value: '状态', label: '状态' }]), (0, _defineProperty3.default)(_ref, 'value', ''), (0, _defineProperty3.default)(_ref, 'types', [{ value: '1', label: '试用' }, { value: '2', label: '正式' }]), (0, _defineProperty3.default)(_ref, 'types2', [{ value: '1', label: '正常使用' }, { value: '2', label: '到期' }, { value: '3', label: '禁用' }]), (0, _defineProperty3.default)(_ref, 'typeValue', ''), (0, _defineProperty3.default)(_ref, 'typeValue2', ''), (0, _defineProperty3.default)(_ref, 'dynamicTags', []), (0, _defineProperty3.default)(_ref, 'orderType', ""), (0, _defineProperty3.default)(_ref, 'orderStr', ''), (0, _defineProperty3.default)(_ref, 'searchText', ''), (0, _defineProperty3.default)(_ref, 'managerAdminuser', ''), _ref;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default,
    Detail: _detail2.default,
    SelectCommon: _SelectCommon2.default
  },

  methods: {
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.managerAdminuser = value[0];
    },
    adminVisibleClose: function adminVisibleClose(type) {
      this.adminVisible = false;
    },
    handleAbout: function handleAbout(index, item) {
      this.detailOrderId = item.id;
      this.adminVisible = true;
    },

    checkboxOnclick: function checkboxOnclick() {
      if (this.checked) {
        this.disCheckBox = true;
      } else {
        this.disCheckBox = false;
      }
    },
    priceloseF: function priceloseF() {
      if (this.allPrice) {
        if (isNaN(this.allPrice)) {
          this.allPrice = this.allPrice.replace(/[^\.\d]/g, '');
        }
        if (parseFloat(this.allPrice).toString() == "NaN") {
          this.$message.error("指标数为大于0的数, 请重新输入");
          return;
        } else if (this.allPrice < 0) {
          this.$message.error("指标数为大于0的数, 请重新输入");
          this.allPrice = 0;
          return;
        } else {
          this.allPrice = parseFloat(this.allPrice);
          this.allPrice = this.allPrice.toLocaleString();
        }
      } else {
        this.allPrice = 0;
        return;
      }
    },
    loseFcousMonth: function loseFcousMonth(index, row) {
      if (row.purchaseMonth) {
        var falg = this.isInteger(row.purchaseMonth);
        if (!falg) {
          this.$message.error('请输入月份为大于或等于0的整数!');
          return row.purchaseMonth = "";
        }
        if (row.purchaseMonth < 0) {
          this.$message.error('请输入月份为大于或等于0的整数!');
          return row.purchaseMonth = "";
        }
        this.ygPrice = 0;
        for (var i = 0; i < this.dataList2.length; i++) {
          if (this.dataList2[i].purchaseMonth && this.dataList2[i].price) {
            this.ygPrice = parseInt(this.ygPrice) + parseInt(this.dataList2[i].purchaseMonth) * parseInt(this.dataList2[i].price);
          }
        }
        if (this.ygPrice) {
          this.ygPrice = parseFloat(this.ygPrice);
          this.ygPrice = this.ygPrice.toLocaleString();
        }
      }
    },
    isInteger: function isInteger(obj) {
      obj = parseFloat(obj);
      return Math.floor(obj) === obj;
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "id") {
          this.orderStr = "idpx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "productname") {
          this.orderStr = "productnamepx";
        } else if (val.prop == "typename") {
          this.orderStr = "typepx";
        } else if (val.prop == "createtime") {
          this.orderStr = "createtimepx";
        } else if (val.prop == "duetime") {
          this.orderStr = "duetimepx";
        } else if (val.prop == "usingstatus1") {
          this.orderStr = "statuspx";
        } else if (val.prop == "userdeptname") {
          this.orderStr = "userdeptnamepx";
        }

        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch: function changeSouch(val) {
      if (val == "类型") {
        this.disSouch = false;
        this.disType1 = true;
        this.disType2 = false;
        this.proName = '';
        this.typeValue = this.souchs.souType;
      } else if (val == "状态") {
        this.disSouch = false;
        this.disType1 = false;
        this.disType2 = true;
        this.proName = '';
        this.typeValue2 = this.souchs.status;
      } else if (val == "ID") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.id;
      } else if (val == "手机号") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.phone;
      } else if (val == "用户") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.name;
      } else if (val == "名称") {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.productname;
      } else if (val == '企业') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.companyname;
      } else if (val == '部门') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.userdeptname;
      }
    },
    getList: function getList(val) {
      var _this2 = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      if (this.value == "ID") {
        this.souchs.id = this.proName;
      }
      if (this.value == "手机号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "用户") {
        this.souchs.name = this.proName;
      }
      if (this.value == "名称") {
        this.souchs.productname = this.proName;
      }
      if (this.value == '企业') {
        this.souchs.companyname = this.proName;
      }
      if (this.value == '部门') {
        this.souchs.userdeptname = this.proName;
      }
      if (this.value == "类型") {
        this.souchs.souType = this.typeValue;
      }
      if (this.value == "状态") {
        this.souchs.status = this.typeValue2;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        id: this.souchs.id,
        name: this.souchs.name,
        phone: this.souchs.phone,
        productname: this.souchs.productname,
        companyname: this.souchs.companyname,
        userdeptname: this.souchs.userdeptname,
        type: this.souchs.souType,
        status: this.souchs.status,
        orderType: this.orderType,
        orderStr: this.orderStr,
        accountType: 1,
        searchText: this.searchText,
        managerAdminuser: this.managerAdminuser,
        role: this.userInfo.type,
        userId: this.userInfo.id
      };
      this.listLoading = true;
      _index.API_Auth.getAutoList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].usingstatus == 1) {
              res.data.data.list[i].usingstatus1 = "正常使用";
            } else if (res.data.data.list[i].usingstatus == 3) {
              res.data.data.list[i].usingstatus1 = "禁用";
              res.data.data.list[i].usingstatus2 = true;
            } else if (res.data.data.list[i].usingstatus == 2) {
              res.data.data.list[i].usingstatus1 = "过期";
            }
          }
          _this2.dataList = res.data.data.list;
          _this2.total = res.data.data.totalRow;
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.listLoading = false;
      });
    },
    delTags: function delTags() {
      this.souchs = {}, this.souchs.souType = '';
      this.souchs.status = '';
      this.value = '';
      this.proName = '';
      this.typeValue = '';
      this.typeValue2 = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == "ID") {
        this.souchs.id = "";
        if (this.value == "ID") {
          this.proName = '';
        }
      }
      if (tag == "用户") {
        this.souchs.name = "";
        if (this.value == "用户") {
          this.proName = '';
        }
      }
      if (tag == "手机号") {
        this.souchs.phone = "";
        if (this.value == "手机号") {
          this.proName = '';
        }
      }
      if (tag == "名称") {
        this.souchs.productname = "";
        if (this.value == "名称") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.companyname = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "部门") {
        this.souchs.userdeptname = "";
        if (this.value == "部门") {
          this.proName = '';
        }
      }
      if (tag == "类型") {
        this.souchs.souType = "";
        this.typeValue = '';
      }
      if (tag == "状态") {
        this.souchs.status = "";
        this.typeValue2 = '';
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    handleSizeChange2: function handleSizeChange2(val) {
      this.pageSize2 = val;
      this.handleEdit();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.handleEdit();
    },

    handleOpen: function handleOpen(index, row) {
      var _this3 = this;

      var _this = this;
      this.$confirm('确认启用吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var ids;
        if (row) {
          ids = row.id;
        } else {
          ids = _this.sels3.map(function (item) {
            return item.id;
          }).toString();
        }
        var param = {
          token: _this3.token,
          checkCode: _this3.checkCode,
          ids: ids,
          usingstatus: 1
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this3.$message({
              message: '启用成功',
              type: 'success'
            });
            _this3.getList();
          } else {
            _this3.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this3.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this3.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function () {});;
    },

    handleDel: function handleDel(index, row) {
      var _this4 = this;

      this.$confirm('确认禁用吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var ids;
        if (row) {
          ids = row.id;
        } else {
          ids = _this4.sels1.map(function (item) {
            return item.id;
          }).toString();
        }
        var param = {
          token: _this4.token,
          checkCode: _this4.checkCode,
          ids: ids,
          usingstatus: 3
        };
        _index.API_Auth.delAutoList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this4.$message({
              message: '禁用成功',
              type: 'success'
            });
            _this4.getList();
          } else {
            _this4.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this4.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this4.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function () {});;
    },
    handleEdit: function handleEdit(index, row) {
      this.allPrice = 0;
      this.ygPrice = 0;
      var ids2;
      var nameds = '';
      var phoneds = '';
      if (!row) {
        for (var i = 0; i < this.sels.length; i++) {
          if (this.sels[0].companyid != this.sels[i].companyid) {
            this.$message.error('请选择同一用企业的订单！');
            return;
          }
        }
        this.companyid = this.sels[0].companyid;
        if (!this.sels[0].name || this.sels[0].name == null) {
          this.sels[0].name = "";
        }
        if (!this.sels[0].phone || this.sels[0].phone == null) {
          this.sels[0].phone = "";
        }
        if (this.sels[0].name) {
          nameds = this.sels[0].name;
        }
        if (this.sels[0].phone) {
          phoneds = this.sels[0].phone;
        }
        this.orderUser = nameds + "" + phoneds;
        ids2 = this.sels.map(function (item) {
          return item.id;
        }).toString();
      } else {
        ids2 = row.id;
        this.companyid = row.companyid;
        if (row.name) {
          nameds = row.name;
        }
        if (row.phone) {
          phoneds = row.phone;
        }
        this.orderUser = nameds + "" + phoneds;
      }
      this.dataList2 = [];
      this.getDetial(ids2);
      this.editFormVisible = true;
    },
    editSubmit: function editSubmit() {
      var _this5 = this;

      for (var i = 0; i < this.dataList2.length; i++) {
        if (!this.dataList2[i].purchaseMonth) {
          this.$message.error('列表中的续费时长(月)，不可为空！');
          return;
        }
      }
      if (!this.checked) {
        this.checkType = 2;
        if (!this.allPrice || this.allPrice == 0) {
          this.$message.error('总价不可为空或者0！');
          return;
        } else {
          if (isNaN(this.allPrice)) {
            this.allPrice = this.allPrice.replace(/[^\.\d]/g, '');
          }
        }
      } else {
        this.checkType = 1;
        this.allPrice = 0;
      }
      this.pruductJson = [];
      for (var i = 0; i < this.dataList2.length; i++) {
        var jsonid = [this.dataList2[i].id];
        var jsons = {
          "authorizedProductId": jsonid,
          "singlePrice": this.dataList2[i].price,
          "productId": this.dataList2[i].productid,
          "purchaseMonth": this.dataList2[i].purchaseMonth,
          "purchaseNum": "1",
          "productName": this.dataList2[i].name
        };
        this.pruductJson.push(jsons);
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyid,
        price: this.allPrice,
        pruductJson: (0, _stringify2.default)(this.pruductJson),
        adminuserid: this.id,
        type: this.checkType
      };
      this.editLoading = true;
      _index.API_Auth.autoOrder(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.$message({
            message: '续费成功',
            type: 'success'
          });
          _this5.getList();
          _this5.editFormVisible = false;
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.editLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.editLoading = false;
      });
    },
    getDetial: function getDetial(ids) {
      var _this6 = this;

      this.detailIDS = ids;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        ids: ids
      };
      this.editlistLoading = true;
      _index.API_Auth.autoDetail(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].logo) {
              res.data.data[i].logo2 = res.data.data[i].logo;
            }
            if (res.data.data[i].price) {
              res.data.data[i].price = parseFloat(res.data.data[i].price);
              res.data.data[i].price2 = res.data.data[i].price.toLocaleString();
            }
          }

          _this6.dataList2 = res.data.data;
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
        _this6.editlistLoading = false;
      }).catch(function (err) {
        _this6.$message.error('数据丢失，试试重新登陆！');
        _this6.editlistLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    indexMethod2: function indexMethod2(index) {
      return index + 1 + (this.pageNumber2 - 1) * this.pageSize2;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(row) {
      this.sels1 = [];
      this.sels3 = [];
      for (var i = 0; i < row.length; i++) {
        if (row[i].usingstatus == "1") {
          var json1 = { "id": row[i].id };
          this.sels1.push(json1);
        }
        if (row[i].usingstatus == "3") {
          var json3 = { "id": row[i].id };
          this.sels3.push(json3);
        }
      }
      this.sels = row;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  created: function created() {
    this.getCookie();
  }
};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  props: {
    adminVisible: {
      type: Boolean,
      default: false
    },
    authProductId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      userSelection: [],
      adminList: [],
      userLoading: false,
      orderLoading: false,
      token: '',
      checkCode: ''
    };
  },

  watch: {},
  mounted: function mounted() {
    this.getCookie();
    this.getCompanyManage();
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    adminVisibleClose: function adminVisibleClose() {
      this.$emit("adminVisibleClose");
    },
    getCompanyManage: function getCompanyManage(id) {
      var _this = this;

      var param = {
        authProductId: this.authProductId,
        token: this.token,
        checkCode: this.checkCode
      };
      this.userLoading = true;
      _index.API_Auth.getDetailByAuthProductId(param).then(function (res) {
        if (res.data.code == 200) {
          var list = JSON.parse(res.data.data.product);
          console.log(list);
          _this.adminList = list;
        }
        _this.userLoading = false;
      });
    }
  }
};

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _echarts = __webpack_require__(117);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['userGuishuPie'],
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      loading: true,
      chartPie: [],
      token: '',
      checkCode: '',
      otherList: [],
      numRecord: 0
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    'userGuishuPie': function userGuishuPie(val) {
      this.adminModulePointPie();
    }
  },
  methods: {
    adminModulePointPie: function adminModulePointPie(val) {

      var list = [];
      var data = this.userGuishuPie;
      var num = 0;
      for (var p in data) {
        num = num + data[p].value;
      }

      this.numRecord = num;


      this.chartPie = data;

      this.initCharts();
      this.loading = false;
    },
    initCharts: function initCharts() {
      var _this = this;
      var charts = null;

      var allcount = 0;
      var selected = {};
      for (var i = 0; i < this.chartPie.length; i++) {
        allcount += this.chartPie[i].value;
      }

      for (var _i = 0; _i < this.chartPie.length; _i++) {
        var name = this.chartPie[_i].name;
        selected[name] = this.chartPie[_i].value / allcount > 0.05;
      }
      charts = _echarts2.default.init(document.getElementById("charts-box-copy-lpie-census"));
      charts.showLoading();
      charts.setOption({
        title: {
          text: "用户手机号归属地统计",
          top: "top",
          left: "left",
          textStyle: {
            color: "#596471",
            fontSize: 17,
            fontWeight: 100
          }
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 0,
          top: 20,
          bottom: 0,
          selected: selected },
        series: [{
          name: "用户手机号归属地统计",
          type: "pie",
          radius: "20%",
          center: ["30%", "55%"],
          data: this.chartPie,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          },
          label: {
            show: true,
            color: 'black',
            fontSize: 10,
            formatter: function formatter(params) {
              return params.name + ": " + params.value;
            }
          },
          labelLine: {
            normal: (0, _defineProperty3.default)({
              length: 4
            }, "length", 12)
          }
        }],
        color: ['#FF6383', '#FFCB48', '#5C89FF', '#7C6AF2', '#C95FF2', '#52c41a', '#13c2c2', '#c41d7f', '#a0d911', '#f5222d', '#096dd9', '#a0d911', '#2f54eb', '#fa541c', '#fadb14', '#13c2c2', '#2f54eb']
      });
      charts.hideLoading();
    }
  }
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _echarts = __webpack_require__(117);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['userGuishuBar'],
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      chart: {
        x: ['2020-01', '2020-02', '2020-03', '2020-04', '2020-05', '2020-06', '2020-07'],
        y3: [150, 232, 201, 154, 190, 330, 410]
      },
      value: '1',
      loading: true,
      chartPie: [],
      token: '',
      checkCode: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    userGuishuBar: function userGuishuBar(val) {
      this.registerCount();
    }
  },
  methods: {
    registerCount: function registerCount(val) {
      this.chart.x = [];
      console.log(this.userGuishuBar);

      this.chart.x = this.userGuishuBar.x;
      this.chart.y3 = this.userGuishuBar.y;
      this.initBar();
      this.loading = false;
    },
    initBar: function initBar() {
      var echartsbar = _echarts2.default.init(document.getElementById('charts-box-copy-lbar-census'));
      echartsbar.clear();
      echartsbar.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow' },
          formatter: '{b0}: {c0}人'
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '0',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: this.chart.x,
          axisLine: {
            lineStyle: {
              color: '#EBEBEB'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#6E6E6E'
            }
          }
        }],
        dataZoom: {
          type: 'inside',
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        yAxis: [(0, _defineProperty3.default)({
          type: 'value',
          splitLine: {
            show: false
          },
          axisTick: {
            show: false,
            alignWithLabel: false
          },
          axisLine: {
            lineStyle: {
              color: '#EBEBEB'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#596471'
            }
          }
        }, 'splitLine', {
          show: false
        })],
        series: [{
          name: '人数',
          type: 'bar',
          stack: '广告',
          data: this.chart.y3,
          barMaxWidth: 60
        }],
        color: ['#13c2c2']
      });
    }
  }
};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _echarts = __webpack_require__(117);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      chart: {
        x: []

      },
      value: "1",
      loading: false,
      options: [{
        value: "1",
        label: "最近一个月"
      }, {
        value: "3",
        label: "最近三个月"
      }, {
        value: "6",
        label: "最近半年"
      }, {
        value: "12",
        label: "最近一年"
      }],
      chartPie: [],
      firstLabelList: [],
      secondLabelList: [],
      pieList: [],
      token: "",
      checkCode: "",
      officalList: [],
      tryList: [] };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getCookie();
    this.getData();
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    getData: function getData() {
      this.registerCount();
    },
    registerCount: function registerCount(val) {
      var _this = this;

      var param = {
        count: this.value,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading = true;
      _index.API_control.registerCount(param).then(function (res) {
        if (res.data.code == 200) {
          _this.chart.x = res.data.data.x;
          var offical = [];
          var tryList = [];
          res.data.data.y.map(function (item) {
            var list = item.split(',');
            offical.push(list[0]);
            tryList.push(list[1]);
          });
          _this.officalList = offical;
          _this.tryList = tryList;
          _this.firstLabelList = [{ name: "正式授权(活跃)", value: res.data.proActiveCount }, { name: "正式授权(不活跃)", value: res.data.proInactiveCount }, { name: "总数", value: res.data.proCount }];
          _this.secondLabelList = [{ name: "试用授权(活跃)", value: res.data.testActiveCount }, { name: "试用授权(不活跃)", value: res.data.testInactiveCount }, { name: "总数", value: res.data.testCount }];
          _this.chartPie = [{ name: "正式授权(活跃)", value: res.data.proActiveCount }, { name: "正式授权(不活跃)", value: res.data.proInactiveCount }, { name: "试用授权(活跃)", value: res.data.testActiveCount }, { name: "试用授权(不活跃)", value: res.data.testInactiveCount }];
          _this.initCharts();
          _this.initBar();
          _this.loading = false;
        }
      });
    },
    initCharts: function initCharts() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-copy-l"));
      charts.showLoading();
      charts.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        title: {
          text: "注册用户情况统计",
          top: "top",
          left: "left",
          textStyle: {
            color: "#666666",
            fontSize: 16,
            fontWeight: 500
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "0%",
          containLabel: true
        },
        series: [{
          name: "注册用户情况统计",
          type: "pie",
          radius: ["40%", "58%"],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: "center"
            }
          },

          hoverAnimation: false,
          emphasis: {
            label: {
              show: true,
              formatter: function formatter(params) {
                return "{nm|" + params.data.name + "}" + "\n\n{p|" + params.data.value + "}";
              },
              rich: {
                p: {
                  fontSize: 20,
                  backgroundColor: "white",
                  color: "#666666",
                  fontWeight: "700"
                },
                nm: {
                  color: "#666666",
                  fontSize: 14,
                  backgroundColor: "white",
                  fontWeight: "400"
                }
              }
            }
          },
          labelLine: {
            show: false
          },
          center: ["45%", "50%"],
          data: this.chartPie
        }],
        color: ["#669DF0", "#1D55AA", "#BE74D9", "#6D3780"]
      });
      charts.hideLoading();
      var index = 0;
      var myChart = charts;
      myChart.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: 0
      });
      myChart.on("mouseover", function (e) {
        if (e.dataIndex != index) {
          myChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: index
          });
        }
      });
      myChart.on("mouseout", function (e) {
        index = e.dataIndex;
        myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: e.dataIndex
        });
      });
    },
    initBar: function initBar() {
      var echartsbar = _echarts2.default.init(document.getElementById("charts-box-copy-lbar"));
      echartsbar.clear();
      echartsbar.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow" }
        },
        title: {
          text: "新注册用户统计",
          top: "top",
          left: "left",
          textStyle: {
            color: "#666666",
            fontSize: 16,
            fontWeight: 500
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "0",
          containLabel: true
        },
        xAxis: [{
          type: "category",
          data: this.chart.x,
          axisLine: {
            lineStyle: {
              color: "#EBEBEB"
            }
          },
          axisLabel: {
            show: true,


            textStyle: {
              color: "#6E6E6E"
            }
          }
        }],

        yAxis: [(0, _defineProperty3.default)({
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            show: false,
            alignWithLabel: false
          },
          axisLine: {
            lineStyle: {
              color: "#EBEBEB"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#596471"
            }
          }
        }, "splitLine", {
          show: false
        })],
        series: [{
          name: "正式用户",
          type: "bar",
          stack: "one",
          barMaxWidth: 24,
          data: this.officalList
        }, {
          name: "试用用户",
          type: "bar",
          stack: "one",
          barMaxWidth: 24,
          data: this.tryList
        }],

        dataZoom: {
          type: 'inside',
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0]
        },
        color: ["#669DF0", "#BE74D9"]
      });
    }
  }
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(117);

var _echarts2 = _interopRequireDefault(_echarts);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      chartsXAxis: [],

      chartsData: [],
      value: "1",
      loading: false,
      options: [{
        value: "1",
        label: "最近一个月"
      }, {
        value: "3",
        label: "最近三个月"
      }, {
        value: "6",
        label: "最近半年"
      }, {
        value: "12",
        label: "最近一年"
      }],
      chartPie: [],
      legend: [],
      token: "",
      checkCode: "",
      colorList: ["#FF6383", "#FF9F40", "#FFCB48", "#5C89FF", "#7C6AF2", "#C95FF2", "#52c41a", "#13c2c2", "#c41d7f"]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getCookie();
    this.getData();
  },


  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; ");
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("=");
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    getData: function getData() {
      this.adminModulePointPie();
    },
    adminModulePointPie: function adminModulePointPie(val) {
      var _this = this;

      var param = {
        count: this.value,
        token: this.token,
        checkCode: this.checkCode
      };
      this.loading = true;
      _index.API_control.adminModulePointPie(param).then(function (res) {
        if (res.data.code == 200) {
          var list = [];
          var data = res.data.data;
          var legend = [];
          for (var p in data) {
            list.push({ name: data[p].modulename, value: data[p].sumpoint });
            legend.push(data[p].modulename);
          }

          list.map(function (item, index) {
            item.label = {
              formatter: function formatter(params) {
                return "{nm|" + params.data.name + "}" + "\n\n{zz|" + params.data.value + "}";
              },
              rich: {
                zz: {
                  align: "right",
                  fontSize: 16,
                  backgroundColor: "white",
                  color: _this.colorList[index],
                  fontWeight: "700"
                },
                nm: {
                  color: "#666666",
                  fontSize: 14,
                  backgroundColor: "white",
                  fontWeight: "400"
                }
              }

            };
            return item;
          });
          _this.chartPie = list;
          _this.legend = legend;
          _this.initCharts();
          _this.loading = false;
        }
      });
    },
    initCharts: function initCharts() {
      var charts = null;
      charts = _echarts2.default.init(document.getElementById("charts-box-copy-lpie"));
      charts.showLoading();
      charts.setOption({
        title: {
          text: "模块使用情况",
          top: "top",
          left: "left",
          textStyle: {
            color: "#666666",
            fontSize: 16,
            fontWeight: 500
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },

        series: [{
          name: "模块使用情况",
          type: "pie",
          avoidLabelOverlap: true,

          radius: "35%",
          center: ["50%", "70%"],
          data: this.chartPie,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          },
          label: {
            show: true,
            alignTo: "edge",
            margin: 5,
            lineHeight: 10 }
        }],
        color: ["#FF6383", "#FF9F40", "#FFCB48", "#5C89FF", "#7C6AF2", "#C95FF2", "#52c41a", "#13c2c2", "#c41d7f"]
      });
      charts.hideLoading();
    }
  }
};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var _jquery = __webpack_require__(359);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var date = new Date();
exports.default = {
  data: function data() {
    return {
      downHref: '',
      disSouch: true,
      disTime2: false,
      proName: "",
      dynamicTags: [],
      optionsSouch: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }],
      value: '账号',
      yhlx: [],
      zhlx: [],
      cities: [],
      citiesd: [],
      id: '',
      token: '',
      checkCode: '',
      listLoading: false,
      souchs: {
        phone: '',
        name: '',
        company: '',
        fromtime: ''
      },
      LogDate: [],
      orderStr: '',
      orderType: '',
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      users: [],

      companyList: []

    };
  },

  methods: {
    handleClose: function handleClose(tag) {
      if (tag == "账号") {
        this.souchs.phone = '';
        if (this.value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs.name = '';
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.company = '';
        if (this.value == "企业") {
          this.proName = '';
        }
      }

      if (tag == "开始日期") {
        this.souchs.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs.totime = "";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    delTags: function delTags() {
      this.souchs = {
        name: '',
        phone: '',
        company: ''
      };
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getUser();
    },
    changeSouch: function changeSouch(val) {
      this.souchs = {
        name: '',
        phone: '',
        company: ''
      };
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "phone") {
          this.orderStr = "phoneOrder";
        } else if (val.prop == "name") {
          this.orderStr = "nameOrder";
        } else if (val.prop == "point") {
          this.orderStr = "pointOrder";
        } else if (val.prop == "userName") {
          this.orderStr = "usertypeOrder";
        } else if (val.prop == "registertime") {
          this.orderStr = "registertimeOrder";
        } else if (val.prop == "company") {
          this.orderStr = "companyOrder";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getUser();
    },
    forType: function forType(row, column) {
      if (row.usertype == 1) {
        return row.userType = '企业账号';
      } else {
        return row.userType = '个人账号';
      }
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },
    downFile: function downFile() {
      if (this.value == "账号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.company = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }
      this.downHref = _index.API_User.userListByExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&dBegin=" + this.$moment(this.LogDate[0]).format('YYYY-MM-DD') + "&dEnd=" + this.$moment(this.LogDate[1]).format('YYYY-MM-DD') + "&phone=" + this.souchs.phone + "&company=" + this.souchs.company + "&username=" + this.souchs.name + "";

      var a = document.createElement('a');

      fetch(this.downHref).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        a.href = URL.createObjectURL(blob);
        a.download = '日活用户统计';
        document.body.appendChild(a);
        a.click();
      });
    },

    getUser: function getUser(val) {
      var _this2 = this;

      if (this.value == "账号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.company = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }

      this.downHref = _index.API_User.userListByExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&dBegin=" + this.$moment(this.LogDate[0]).format('YYYY-MM-DD') + "&dEnd=" + this.$moment(this.LogDate[1]).format('YYYY-MM-DD') + "&phone=" + this.souchs.phone + "&company=" + this.souchs.company + "&username=" + this.souchs.name + "";

      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        userType: '',

        username: this.souchs.name,
        phone: this.souchs.phone,
        company: this.souchs.company,
        dBegin: this.$moment(this.LogDate[0]).format('YYYY-MM-DD'),
        dEnd: this.$moment(this.LogDate[1]).format('YYYY-MM-DD'),


        orderType: this.orderType,
        orderStr: this.orderStr
      };
      this.listLoading = true;
      _index.API_User.userListByDay(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              res.data.data.list[i].registertimeyuan = res.data.data.list[i].registertime;
              if (res.data.data.list[i].registertime) {
                res.data.data.list[i].registertime = res.data.data.list[i].registertime.substring(0, 10);
              }
            }
            _this2.total = res.data.data.totalRow;
            _this2.users = res.data.data.list;
            _this2.listLoading = false;
          }
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
      });
    },
    getModels: function getModels() {
      var _this3 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Models.getAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.models = res.data.data;
          _this3.cities = [];
          _this3.citiesd = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this3.cities.push(res.data.data[i].modulename);
            var jsones = { "modulename": res.data.data[i].modulename, "id": res.data.data[i].id };
            _this3.citiesd.push(jsones);
          }
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },

    getCode1: function getCode1() {
      var _this4 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };

      _index.API_Admin.tbCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.companyList = res.data.data;
        }
      });
    },
    getCode2: function getCode2() {
      var _this5 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.AccList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.zhlx = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.zhlx.push(jsons);
          }
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    }

  },

  created: function created() {
    var d = new Date();
    var year1 = void 0,
        month1 = void 0,
        day1 = void 0;var _ref2 = [d.getFullYear(), d.getMonth(), d.getDate()];
    year1 = _ref2[0];
    month1 = _ref2[1];
    day1 = _ref2[2];

    var date1 = new Date(year1, month1, day1, 7);
    var year2 = void 0,
        month2 = void 0,
        day2 = void 0;
    d.setTime(d.getTime() - 30 * 24 * 60 * 60 * 1000);var _ref3 = [d.getFullYear(), d.getMonth(), d.getDate()];
    year2 = _ref3[0];
    month2 = _ref3[1];
    day2 = _ref3[2];

    var date2 = new Date(year2, month2, day2, 7);
    this.LogDate = [date2, date1];

    this.getCookie();
    this.getCode1();
    this.getCode2();

    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getUser();
    this.getModels();
  },
  mounted: function mounted() {}
};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Account = __webpack_require__(1688);

var _Account2 = _interopRequireDefault(_Account);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['dialogVisible'],
  methods: {
    handleClose: function handleClose() {
      this.$emit('update:dialogVisible', false);
    }
  },
  components: {
    Account: _Account2.default
  }
};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(90);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(89);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _index = __webpack_require__(6);

var _vuex = __webpack_require__(20);

var _GisCommon = __webpack_require__(164);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _SelectCommon = __webpack_require__(74);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    editLevel: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    var _this = this,
        _ref3;

    var validatorCompany = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.form.name) {
                  _context.next = 4;
                  break;
                }

                callback("请输入企业名称");
                _context.next = 9;
                break;

              case 4:
                if (!(_this.oldname != value)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.checkCompanyFun(_this.form.name);

              case 7:
                res = _context.sent;

                !res ? callback('企业名称已存在') : callback();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function validatorCompany(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();
    var validatorAddress = function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(rule, value, callback) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this.form.address) {
                  callback("请输入企业位置");
                } else {
                  if (!_this.position_) {
                    callback('请在GIS地图中确认位置');
                  } else {
                    callback();
                  }
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function validatorAddress(_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }();
    return _ref3 = {
      loginType: sessionStorage.getItem('type'),
      oldname: '',
      form: {
        name: '',
        showname: '',
        grade: '',
        userScale: '',
        natrue: '',
        regionCode: '',
        address: '',
        level: 0
      },
      beformAddImg: '',
      imageUrl: '',
      editImageUrl: '',
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: _index.API_Common.setCompanyPic(),
        dialogImageUrl: '',
        dialogVisible: false,
        data: {
          mode: 'save',
          token: this.token,
          checkCode: this.checkCode,
          type: 1
        }
      },
      token: '',
      checkCode: '',
      id: '',
      adminuserlist: [],
      adminuser: '',
      companyManages: [],
      company: '',
      isbinding: 1,
      selected: { province: '320000', city: '320100', area: '320115', town: '320115010' },
      address: '',
      selected_: '',
      address_: ''
    }, (0, _defineProperty3.default)(_ref3, 'token', ''), (0, _defineProperty3.default)(_ref3, 'checkCode', ''), (0, _defineProperty3.default)(_ref3, 'id', ''), (0, _defineProperty3.default)(_ref3, 'position_', ''), (0, _defineProperty3.default)(_ref3, 'comLists', []), (0, _defineProperty3.default)(_ref3, 'oldCompanyName', ''), (0, _defineProperty3.default)(_ref3, 'regionCode', '1'), (0, _defineProperty3.default)(_ref3, 'regionCodeList', [{
      value: "1",
      label: "华东大区"
    }, {
      value: "2",
      label: "华北大区"
    }, {
      value: "3",
      label: "西北大区"
    }, {
      value: "4",
      label: "华南大区"
    }, {
      value: "5",
      label: "西南大区"
    }]), (0, _defineProperty3.default)(_ref3, 'gradeList', [{
      value: "1",
      label: "综合甲"
    }, {
      value: "2",
      label: "公路甲"
    }, {
      value: "3",
      label: "市政甲"
    }, {
      value: "4",
      label: "公路市政甲"
    }, {
      value: "5",
      label: "公路乙"
    }, {
      value: "6",
      label: "市政乙"
    }, {
      value: "7",
      label: "公路市政乙"
    }, {
      value: "9",
      label: "高校"
    }, {
      value: "10",
      label: "施工单位"
    }, {
      value: "8",
      label: "其他"
    }]), (0, _defineProperty3.default)(_ref3, 'natureList', [{
      value: '1',
      label: '央企'
    }, {
      value: '2',
      label: '国企'
    }, {
      value: '3',
      label: '民营上市'
    }, {
      value: '4',
      label: '民营'
    }, {
      value: "5",
      label: "高校"
    }]), (0, _defineProperty3.default)(_ref3, 'linker', ''), (0, _defineProperty3.default)(_ref3, 'linkerPhone', ''), (0, _defineProperty3.default)(_ref3, 'managerAdminuser', ""), (0, _defineProperty3.default)(_ref3, 'successfulManager', ""), (0, _defineProperty3.default)(_ref3, 'agencyManager', ""), (0, _defineProperty3.default)(_ref3, 'note', ''), (0, _defineProperty3.default)(_ref3, 'formRules', {
      name: [{ required: true, validator: validatorCompany, trigger: 'blur' }],

      grade: [{ required: true, message: '请选择资质等级', trigger: ['change'] }],
      natrue: [{ required: true, message: '请选择企业性质', trigger: ['change'] }],
      userScale: [{ required: true, message: '请输入用户规模', trigger: ['blur', 'change'] }],
      address: [{ validator: validatorAddress, trigger: ['blur', 'change'] }],
      level: [{ required: true, message: '请选择客户分级', trigger: ['blur', 'change'] }],
      showname: [{ required: true, message: '请输入地区', trigger: ['blur', 'change'] }]

    }), _ref3;
  },


  components: {
    GisCommon: _GisCommon2.default,
    SelectCommon: _SelectCommon2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  mounted: function mounted() {
    var _this2 = this;

    try {
      this.comLists = JSON.parse(sessionStorage.getItem('comLists'));
    } catch (e) {
      _index.API_User.getCompanySearch().then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var data = res.data.data;
          _this2.comLists = data.map(function (item) {
            return { value: item };
          });
          sessionStorage.setItem('comLists', (0, _stringify2.default)(_this2.comLists));
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    }
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; ');
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=');
        if (arr2[0] == 'dnnyptadmin_token') {
          this.token = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_checkCode') {
          this.checkCode = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_id') {
          this.id = arr2[1];
        }
      }
    }
    var param = {
      token: this.token,
      checkCode: this.checkCode,
      id: this.id,
      companyId: this.$route.query.companyId
    };
    _index.API_User.getCompanyUser(param).then(function (res) {
      _this2.companyManages = res.data.data;
    });
    var paramx = {
      token: this.token,
      checkCode: this.checkCode
    };
    _index.API_User.allAdminuser(paramx).then(function (res) {
      _this2.adminuserlist = res.data.data;
    });
    _index.API_User.getComputeDetail(this.$route.query.companyId).then(function (res) {
      _this2.form.name = res.data.data.name;
      _this2.oldname = res.data.data.name;
      _this2.oldCompanyName = res.data.data.name;
      _this2.form.showname = res.data.data.showname;
      _this2.imageUrl = res.data.data.sltUrl;

      _this2.adminuser = _this2.userInfo.type == 1 ? res.data.data.managerAdminuser : _this2.userInfo.id;
      _this2.isbinding = res.data.data.isbinding;
      _this2.form.regionCode = res.data.data.regionCode;
      _this2.form.grade = res.data.data.grade;
      _this2.form.natrue = res.data.data.natrue;
      _this2.form.userScale = res.data.data.userScale;
      _this2.linker = res.data.data.linker;
      _this2.linkerPhone = res.data.data.linkerPhone;
      _this2.managerAdminuser = res.data.data.managerAdminuser;
      _this2.agencyManager = res.data.data.agencyManager;
      _this2.successfulManager = res.data.data.successfulManager;
      _this2.form.level = Number(res.data.data.level);
      _this2.note = res.data.data.note;
      if (res.data.data.managerid) {
        _this2.company = res.data.data.managerid.split(',');
      }
      _this2.selected = {
        province: res.data.data.province ? JSON.parse(res.data.data.province).key : '',
        city: res.data.data.city ? JSON.parse(res.data.data.city).key : '',
        area: res.data.data.district ? JSON.parse(res.data.data.district).key : '',
        town: ''
      };
      if (res.data.data.longitudeAndLatitude) {
        _this2.position_ = [Number(res.data.data.longitudeAndLatitude.split(',')[0]), Number(res.data.data.longitudeAndLatitude.split(',')[1])];
      }
      _this2.$refs.GisCommon.changItem(res.data.data.addressInfo);
      _this2.$refs.GisCommon.changePro(_this2.selected);
      _this2.$refs.GisCommon.changePos(_this2.position_);
      _this2.form.address = res.data.data.addressInfo, _this2.selected_ = {
        province: res.data.data.province ? JSON.parse(res.data.data.province) : '',
        city: res.data.data.city ? JSON.parse(res.data.data.city) : '',
        district: res.data.data.district ? JSON.parse(res.data.data.district) : '',
        town: null
      };
      _this2.$refs.form.clearValidate();
    });
  },


  methods: {
    checkCompanyFun: function checkCompanyFun(name) {
      return _index.API_User.checkCompanyUnique({ name: name }).then(function (res) {
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    querySearch: function querySearch(queryString, cb) {
      var comLists = this.comLists;
      var results = queryString ? comLists.filter(this.createFilter(queryString)) : comLists;

      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (restaurant) {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
        this.queryData();
      }
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;
        this.imageUrl = URL.createObjectURL(file.raw);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error('请选择图片文件');
      }
    },
    backPram: function backPram(param) {
      ;this.position_ = param.position, this.form.address = param.address, this.selected_ = param.selected;
    },
    saveData: function saveData() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var param;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                param = (0, _extends3.default)({
                  token: _this3.token,
                  checkCode: _this3.checkCode,
                  mode: '',
                  id: _this3.$route.query.companyId,
                  logoid: _this3.imageUrl,
                  managerid: _this3.company.toString(),
                  createUser: _this3.userInfo.id,
                  province: (0, _stringify2.default)(_this3.selected_.province),
                  city: (0, _stringify2.default)(_this3.selected_.city),
                  district: (0, _stringify2.default)(_this3.selected_.area),
                  longitudeAndLatitude: _this3.position_.toString(),
                  addressInfo: _this3.form.address,
                  managerAdminuser: _this3.managerAdminuser,
                  agencyManager: _this3.agencyManager,
                  successfulManager: _this3.successfulManager,
                  isbinding: _this3.isbinding
                }, _this3.form, {
                  linker: _this3.linker,
                  linkerPhone: _this3.linkerPhone,
                  note: _this3.note
                });

                _this3.$refs['form'].validate(function (valid) {
                  if (valid) {
                    if (_this3.beformAddImg) {
                      var formData = new FormData();
                      formData.append('pic', _this3.beformAddImg.raw);
                      formData.append('token', _this3.token);
                      formData.append('checkCode', _this3.checkCode);
                      formData.append('mode', 'save');
                      var config = {
                        'Content-Type': 'multipart/form-data'
                      };
                      _axios2.default.post(_this3.upload.postURL, formData, config).then(function (res) {
                        if (res.data.code == 200) {
                          var _res$data$data = res.data.data,
                              pic = _res$data$data.pic,
                              id = _res$data$data.id;

                          param.logoid = pic;
                          param.showpicid = id;
                          _this3.editSave(param);
                          _this3.$refs.upload.clearFiles();
                        } else {
                          _this3.$message.error(res.data.message);
                          if (res.data.code == 403) {
                            _this3.$router.push({ path: 'loginAdmin' });
                          }
                          return;
                        }
                      }).catch(function (error) {
                        console.log(error);
                        return;
                      });
                    } else {
                      _this3.editSave(param);
                    }
                  }
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    editSave: function editSave(param) {
      var _this4 = this;

      var paramx = {
        companyid: this.$route.query.companyId,
        userid: this.company.toString(),
        toke: this.token,
        checkCode: this.checkCode
      };
      _index.API_User.setCompanyManager(paramx).then(function (res) {
        if (res.data.code != 200) {
          _this4.$message.error(res.data.message);
        } else {
          _index.API_User.addCompanyList(param).then(function (res) {
            if (res.data.code == 200) {
              _this4.$message({ message: '编辑成功', type: 'success' });
              _this4.oldCompanyName == _this4.form.name;
            } else {
              _this4.$message.error(res.data.message);
            }
          }).catch(function (err) {
            _this4.$message.error('数据丢失，试试重新登陆！');
          });
        }
      });
    },
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this[key] = value[0];
    }
  }
};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  inject: ['reload'],
  data: function data() {
    var checkPhone = function checkPhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        var reg = /^1[3-9]\d{9}$/;
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    return {
      searchText: '',
      deptId: '',
      detpList: [],

      inviValues: [],
      softtypes: [],
      checkUserId: '',
      checkUserIdOld: '',
      pageSize2: 10,
      pageNumber2: 1,
      total2: 1,
      companyList: [],
      disSofttype2: false,
      disSouch2: true,

      disTime1: false,
      disTime2: false,
      proName2: "",
      dynamicTags2: [],
      optionsSouch2: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '软件类型', label: '软件类型' }, { value: '开始日期', label: '开始日期' }, { value: '结束日期', label: '结束日期' }],
      value2: '',
      souchs2: {
        name: '',
        phone: '',
        company: '',
        invitestatus: '',
        softtype: '',
        fromtime: '',
        totime: ''
      },

      disSouch: true,
      disType: false,
      souchs: {
        phone: '',
        name: '',
        company: '',
        invitestatusname: ''
      },
      proName: '',
      typeValue: '',
      types: [{ value: '1', label: '邀请中' }, { value: '2', label: '邀请通过' }],
      options: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '状态', label: '状态' }],
      value: '',
      dynamicTags: [],

      addFormVisible: false,
      addLoading: false,
      addForm: {},
      addFormRules: {
        phone: [{ validator: checkPhone, trigger: 'blur' }]
      },
      userList: [],
      listLoading: false,
      pageSize: 20,
      pageNumber: 1,
      total: 0,

      token: '',
      checkCode: '',
      id: '',
      companymanageid: '',
      sels: [],
      sels2: [],
      orderType: '',
      orderStr: ""
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  methods: {
    handleSelectionChange: function handleSelectionChange(row) {
      this.flag = true;
      this.userList.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
        }
        if (item.id == row.id) {
          item.checked = true;
        }
      });
      if (row.name == null) {
        row.name = "";
      }
      if (row.phone == null) {
        row.phone = "";
      }
      this.checkUserId = row.id;
      this.checkUserIdOld = row.id;
    },
    changeSouch2: function changeSouch2(val) {
      this.disSouch2 = false;

      this.disSofttype2 = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName2 = this.souchs2.phone;
        this.disSouch2 = true;
      } else if (val == "姓名") {
        this.proName2 = this.souchs2.name;
        this.disSouch2 = true;
      } else if (val == "企业") {
        this.proName2 = this.souchs2.company;
        this.disSouch2 = true;
      } else if (val == "软件类型") {
        this.disSofttype2 = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },
    handleClose2: function handleClose2(tag) {
      if (tag == "账号") {
        this.souchs2.phone = '';
        if (this.value2 == "账号") {
          this.proName2 = '';
        }
      }
      if (tag == "姓名") {
        this.souchs2.name = '';
        if (this.value2 == "姓名") {
          this.proName2 = '';
        }
      }
      if (tag == "企业") {
        this.souchs2.company = '';
        if (this.value2 == "企业") {
          this.proName2 = '';
        }
      }
      if (tag == "软件类型") {
        this.souchs2.softtype = "";
      }

      if (tag == "开始日期") {
        this.souchs2.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs2.totime = "";
      }
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1);
    },

    delTags2: function delTags2() {
      this.souchs2 = {};
      this.proName2 = '';
      this.value2 = '';
      this.dynamicTags2 = [];
      this.getComUser();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getComUser();
    },
    handleSizeChange2: function handleSizeChange2(val) {
      if (!val) {
        this.getComUser(9);
      } else {
        this.pageSize2 = val;
        this.getComUser();
      }
    },

    getComUser: function getComUser(val) {
      var _this = this;
      if (this.value2 == "账号") {
        this.souchs2.phone = this.proName2;
      }
      if (this.value2 == "企业") {
        this.souchs2.company = this.proName2;
      }
      if (this.value2 == "姓名") {
        this.souchs2.name = this.proName2;
      }
      var flag2 = true;
      if (val == 1) {
        if (this.value2) {
          if (this.dynamicTags2.length > 0) {
            for (var i = 0; i < this.dynamicTags2.length; i++) {
              if (this.value2 == this.dynamicTags2[i]) {
                flag2 = false;
              }
            }
          }
          if (flag2) {
            this.dynamicTags2.push(this.value2);
          }
        }
      }
      var param = void 0;
      if (val == 9) {
        param = {
          token: this.token,
          checkCode: this.checkCode,

          username: this.souchs2.name,
          phone: this.souchs2.phone,
          company: this.souchs2.company,
          registertimefrom: this.souchs2.fromtime,
          registertimeto: this.souchs2.totime,
          softtype: this.souchs2.softtype,
          invitestatus: '0'

        };
      } else {
        param = {
          token: this.token,
          checkCode: this.checkCode,
          pageNumber: this.pageNumber2,
          pageSize: this.pageSize2,
          listType: 'page',
          userType: '',

          username: this.souchs2.name,
          phone: this.souchs2.phone,
          company: this.souchs2.company,
          registertimefrom: this.souchs2.fromtime,
          registertimeto: this.souchs2.totime,
          softtype: this.souchs2.softtype,
          invitestatus: '0'
        };
      }


      _index.API_User.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.list) {
            _this.total2 = res.data.data.totalRow;
            _this.companyList = res.data.data.list;
          } else {
            _this.companyList = res.data.data;
            _this.total2 = 1;
            _this.pageNumber2 = 1;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "invitestatusname") {
          this.orderStr = "invitestatusnamepx";
        } else if (val.prop == "point") {
          this.orderStr = "pointpx";
        } else if (val.prop == "company") {
          this.orderStr = "companypx";
        } else if (val.prop == "deptname") {
          this.orderStr = "deptpx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getUser();
    },

    batchRemove: function batchRemove(index, row) {
      var _this2 = this;

      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(function () {
        var ids;
        if (row) {
          ids = row.id;
        } else {
          ids = _this2.sels.map(function (item) {
            return item.id;
          }).toString();
        }
        _this2.listLoading = true;
        var para = {
          token: _this2.token,
          checkCode: _this2.checkCode,
          companyid: _this2.$route.query.companyId,
          userids: ids
        };
        _index.API_userCom.delComUserList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this2.listLoading = false;
            _this2.$message({
              message: '删除成功',
              type: 'success'
            });
            _this2.getUser();
          } else {
            _this2.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'login' });
            }
          }
        }).catch(function (err) {
          _this2.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    selsChange2: function selsChange2(sels) {
      this.sels2 = sels;
    },
    selectInit: function selectInit(row, index) {
      if (row.companymanageid || row.deptList && row.deptList.length > 0) {
        return 0;
      } else {
        return 1;
      }
    },
    delTags: function delTags() {
      this.souchs = {}, this.value = '';
      this.typeValue = '';
      this.proName = '';
      this.dynamicTags = [];
      this.getUser();
    },
    handleClose: function handleClose(tag) {
      if (tag == "账号") {
        this.souchs.phone = "";
        if (this.value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs.name = "";
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.company = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "状态") {
        this.souchs.invitestatusname = "";
        this.typeValue = '';
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    changeSouch: function changeSouch(val) {
      if (val == "账号") {
        this.proName = this.souchs.phone;
        this.disSouch = true;
        this.disType = false;
      } else if (val == "姓名") {
        this.proName = this.souchs.name;
        this.disSouch = true;
        this.disType = false;
      } else if (val == "企业") {
        this.proName = this.souchs.company;
        this.disSouch = true;
        this.disType = false;
      } else if (val == "状态") {
        this.typeValue = this.souchs.invitestatusname;
        this.disSouch = false;
        this.disType = true;
      }
    },
    addSubmit: function addSubmit(addForm) {
      var _this3 = this;

      var ids = this.sels2.map(function (item) {
        return item.id;
      }).toString();
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.$route.query.companyId,
        userids: ids
      };
      _index.API_userCom.addComUserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '添加成功',
            type: 'success'
          });
          _this3.addFormVisible = false;
          _this3.getUser();
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'login' });
          }
        }
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },
    addList: function addList() {
      this.getComUser();
      this.addFormVisible = true;
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },

    getUser: function getUser(val) {
      var _this4 = this;

      if (this.value == "账号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.company = this.proName;
      }
      if (this.value == "状态") {
        this.souchs.invitestatusname = this.typeValue;
      }
      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        companyid: _this.$route.query.companyId,

        company: this.souchs.company,
        phone: this.souchs.phone,
        username: this.souchs.name,

        orderType: this.orderType,
        orderStr: this.orderStr,
        invitestatus: this.typeValue,
        searchText: this.searchText,
        deptid: this.deptId
      };
      this.listLoading = true;
      _index.API_userCom.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i].companymanageid || res.data.data.list[i].deptList && res.data.data.list[i].deptList.length > 0) {
                res.data.data.list[i].delShow = true;
              } else {
                res.data.data.list[i].delShow = false;
              }
            }
            _this.userList = res.data.data.list;
            _this.total = res.data.data.totalRow;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'login' });
          }
        }
        _this4.listLoading = false;
      }).catch(function (err) {
        _this4.listLoading = false;
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getDeptList: function getDeptList() {
      var _this5 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.$route.query.companyId
      };
      _index.API_userCom.getDepartList(param).then(function (res) {
        if (res.data.code == 200) {
          _this5.detpList = res.data.data;
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },


    handledel: function handledel(index, row) {
      var param = {
        id: row.id
      };
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    getCode1: function getCode1() {
      var _this6 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.yhlx = [];
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.yhlx.push(jsons);
            var json = { 'value': res.data.data[i].code, 'label': res.data.data[i].name };
            _this.softtypes.push(json);
          }
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    getCode: function getCode() {
      var _this7 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "label": res.data.data[i].name };
            _this.inviValues.push(jsons);
          }
        } else {
          _this7.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this7.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    }

  },
  created: function created() {
    this.getCookie();
    this.getDeptList();
  },
  mounted: function mounted() {
    this.getUser();
    this.getCode();
    this.getCode1();
  }
};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(416);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(90);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(89);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(103);

var _index3 = _interopRequireDefault(_index2);

var _SelectCommon = __webpack_require__(74);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    mode: {
      type: String,
      default: 'save'
    },

    visible: {
      type: Boolean,
      default: false
    },

    processDetail: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    var _this = this;

    var validatorDept = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(rule, value, callback) {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.ruleForm.deptname) {
                  _context.next = 4;
                  break;
                }

                callback("请输入部门名称");
                _context.next = 9;
                break;

              case 4:
                if (!(_this.oldDepartName != _this.ruleForm.deptname)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return _this.checkDepart(_this.ruleForm.deptname);

              case 7:
                res = _context.sent;

                !res ? callback('部门名称已存在') : callback();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function validatorDept(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      myVisible: false,
      searchText: '',
      listLoading: false,
      confirmLoading: false,
      pageSize: 10,
      pageNumber: 1,
      total: 0,

      token: '',
      checkCode: '',
      companyList: [],
      title: '',

      selectedUserIdBack: [],

      rules: {
        deptname: [{ required: true, validator: validatorDept, trigger: 'change' }],

        deptmanager: [{ required: false, message: '请选择部门管理员', trigger: 'change' }],

        useridList: [{ required: false, message: '请选择部门人员', trigger: 'change' }]
      },

      flag: '-1',
      allCompanyList: [],

      ruleForm: {
        deptname: '',
        deptmanager: '',
        useridList: [],
        companyid: this.$route.query.companyId
      },

      oldDepartName: '' };
  },


  components: {
    SelectCommon: _SelectCommon2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    this.myVisible = this.visible;
  },
  mounted: function mounted() {
    var _this2 = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
      var _utils$getParamsByCoo, token, checkCode, res;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _utils$getParamsByCoo = _index3.default.getParamsByCookie(), token = _utils$getParamsByCoo.token, checkCode = _utils$getParamsByCoo.checkCode;

              _this2.token = token;
              _this2.checkCode = checkCode;

              if (!(_this2.mode == 'save')) {
                _context2.next = 8;
                break;
              }

              _this2.title = '新增部门';
              _this2.getComUser(0);
              _context2.next = 13;
              break;

            case 8:
              _this2.title = '编辑部门';
              _context2.next = 11;
              return _this2.getDetail();

            case 11:
              res = _context2.sent;

              if (res) {
                _this2.getComUser(0);
              }

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },


  methods: {
    checkDepart: function checkDepart(name) {
      return _index.API_userCom.checkDepartUnique({ deptname: name, companyid: this.ruleForm.companyid }).then(function (res) {
        console.log('ressss--', res);
        if (res.data.code == 401) {
          return false;
        }
        return true;
      }).catch(function (err) {
        return true;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.$route.query.companyId,
        id: this.processDetail.id
      };
      this.listLoading = true;
      return _index.API_userCom.getDepartDetail(param).then(function (res) {
        if (res.data.code == 200) {
          var data = res.data.data;
          var deptname = data.deptname,
              deptmanager = data.deptmanager,
              _data$userList = data.userList,
              userList = _data$userList === undefined ? [] : _data$userList;

          _this3.ruleForm.useridList = userList.map(function (item) {
            return { id: item.id };
          });
          _this3.ruleForm.deptname = deptname;
          _this3.ruleForm.deptmanager = deptmanager;
          _this3.oldDepartName = deptname;

          return true;
        } else {
          _this3.listLoading = false;
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
          return false;
        }
      }).catch(function (err) {
        _this3.listLoading = false;
        _this3.$message.error('数据丢失，试试重新登录1！');
        return false;
      });
    },
    getComUser: function getComUser(flag) {
      var _this4 = this;

      this.flag = flag;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.$route.query.companyId,
        searchText: this.searchText
      };
      this.listLoading = true;
      return _index.API_userCom.getCompanyUser(param).then(function (res) {
        if (res.data.code == 200) {
          _this4.companyList = res.data.data;

          if (!_this4.searchText) {
            _this4.allCompanyList = JSON.parse((0, _stringify2.default)(_this4.companyList));
            _this4.ruleForm.useridList = [].concat((0, _toConsumableArray3.default)(_this4.ruleForm.useridList), (0, _toConsumableArray3.default)(JSON.parse((0, _stringify2.default)(_this4.selectedUserIdBack))));

            _this4.ruleForm.useridList = _this4.uniqObj(_this4.ruleForm.useridList, 'id');
          } else {
            _this4.selectedUserIdBack = [].concat((0, _toConsumableArray3.default)(JSON.parse((0, _stringify2.default)(_this4.ruleForm.useridList))), (0, _toConsumableArray3.default)(_this4.selectedUserIdBack));
            _this4.selectedUserIdBack = _this4.uniqObj(_this4.selectedUserIdBack, 'id');
          }
          _this4.listLoading = false;
          setTimeout(function () {
            _this4.initSelectedUser();
          }, 100);
          return true;
        } else {
          _this4.listLoading = false;
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
          return false;
        }
      }).catch(function (err) {
        _this4.listLoading = false;
        _this4.$message.error('数据丢失，试试重新登录1！');
        return false;
      });
    },
    uniqObj: function uniqObj(array, field) {
      var tempObj = {};
      array = array.reduce(function (cur, next) {
        tempObj[next[field]] ? "" : tempObj[next[field]] = true && cur.push(next);
        return cur;
      }, []);
      return array;
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.ruleForm[key] = value[0];
      this.$refs.ruleForm.validateField(key);
    },
    handerSectionChange: function handerSectionChange(data, column, event) {
      if (this.flag == 1 && this.ruleForm.useridList.length > 0) {
        this.flag = -1;
        return;
      }
      var selectedUserId = data.length > 0 ? data.map(function (item) {
        return { id: item.id };
      }) : [];

      this.ruleForm.useridList = selectedUserId;

      this.$refs.ruleForm.validateField('useridList');
    },
    handerRowClick: function handerRowClick(row, column, event) {
      this.$set(row, 'selected', !row.selected);
      this.$refs.companyRef.toggleRowSelection(row);
    },
    handerChkSelect: function handerChkSelect(selection, row) {
      this.handerRowClick(row);
    },
    initSelectedUser: function initSelectedUser() {
      var _this5 = this;

      var selectedList = this.ruleForm.useridList;
      this.companyList.forEach(function (list) {
        selectedList.forEach(function (item) {
          if (list.id == item.id) {
            _this5.handerRowClick(list);
          }
        });
      });
    },
    handerSubmit: function handerSubmit(formName) {
      var _this6 = this;

      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          if (_this6.confirmLoading) {
            return;
          }
          _this6.confirmLoading = true;

          _this6.ruleForm.useridList = [].concat((0, _toConsumableArray3.default)(_this6.ruleForm.useridList), (0, _toConsumableArray3.default)(JSON.parse((0, _stringify2.default)(_this6.selectedUserIdBack))));

          _this6.ruleForm.useridList = _this6.uniqObj(_this6.ruleForm.useridList, 'id');
          var useridList = _this6.ruleForm.useridList.map(function (item) {
            return item.id;
          });
          var data = (0, _extends3.default)({}, _this6.ruleForm);
          data.useridList = useridList.length > 0 ? useridList.join() : '';
          data.createUser = _this6.userId;
          _this6.mode == 'save' ? _this6.handerSave(data) : _this6.handerUpdate(data);
        }
      });
    },
    handerSave: function handerSave(data) {
      var _this7 = this;

      _index.API_userCom.addDept(data).then(function (res) {
        if (res.data.code == 200) {
          _this7.$message.success('新增成功');
          _this7.$emit('getList');
          _this7.handerClose();
        } else {
          if (res.data.code == 403) {
            _this7.$router.push({ path: 'loginAdmin' });
          }
        }
        _this7.confirmLoading = false;
      }).catch(function (err) {
        _this7.confirmLoading = false;
      });
    },
    handerUpdate: function handerUpdate(data) {
      var _this8 = this;

      data.id = this.processDetail.id;
      _index.API_userCom.editDept(data).then(function (res) {
        if (res.data.code == 200) {
          _this8.$message.success('编辑成功');
          _this8.$emit('getList');
          _this8.handerClose();
        } else {
          if (res.data.code == 403) {
            _this8.$router.push({ path: 'loginAdmin' });
          }
        }
        _this8.confirmLoading = false;
      }).catch(function (err) {
        _this8.confirmLoading = false;
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handerClose: function handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false);
    }
  }
};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(103);

var _index3 = _interopRequireDefault(_index2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    mode: {
      type: String,
      default: 'save'
    },

    visible: {
      type: Boolean,
      default: false
    },

    processDetail: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {

    return {
      myVisible: false,
      listLoading: false,

      token: '',
      checkCode: '',

      departDetail: null
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    this.myVisible = this.visible;

    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.checkCode = checkCode;
    this.getDetail();
  },


  methods: {
    getDetail: function getDetail() {
      var _this = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.$route.query.companyId,
        id: this.processDetail.id
      };
      this.listLoading = true;
      _index.API_userCom.getDepartDetail(param).then(function (res) {
        if (res.data.code == 200) {
          var data = res.data.data;
          _this.departDetail = data;
        } else {
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
        _this.$message.error('数据丢失，试试重新登录1！');
      });
    },
    handerClose: function handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false);
    }
  }
};

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _ModalForm = __webpack_require__(1690);

var _ModalForm2 = _interopRequireDefault(_ModalForm);

var _ModalFormView = __webpack_require__(1691);

var _ModalFormView2 = _interopRequireDefault(_ModalFormView);

var _index2 = __webpack_require__(103);

var _index3 = _interopRequireDefault(_index2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      listLoading: false,
      dataList: [],

      pageNumber: 1,
      pageSize: 20,
      total: 0,
      token: '',

      visible: false,
      visibleView: false,
      mode: 'save',

      searchText: '',
      selectedUserId: [],

      processDetail: null
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default,
    ModalForm: _ModalForm2.default,
    ModalFormView: _ModalFormView2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.getList();
  },


  methods: {
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      var data = {
        token: this.token,
        companyid: this.$route.query.companyId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        searchText: this.searchText
      };
      _index.API_userCom.getDepartList(data).then(function (res) {
        if (res.data.code == 200) {
          var _data = res.data.data;
          _this.dataList = _data.list;
          _this.total = _data.totalRow;
        } else {
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handerSectionChange: function handerSectionChange(data, column, event) {
      console.log("handerSectionChange==", data);
      this.selectedUserId = data.length > 0 ? data.map(function (item) {
        return item.id;
      }) : [];
    },
    handerRowClick: function handerRowClick(row, column, event) {
      if (event.target.className.indexOf('dnnfont') > -1) {
        return;
      }
      this.$refs.companyTabRef.toggleRowSelection(row);
    },
    addForm: function addForm() {
      this.visible = true;
      this.mode = 'save';
    },
    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this2.token,
          checkCode: _this2.checkCode,
          id: row.id
        };
        _index.API_userCom.delDepart(param).then(function (res) {
          if (res.data.code == 200) {
            _this2.$message({ message: '删除成功', type: 'success' });
            _this2.getList();
          } else {
            _this2.$message.error('删除失败');
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this2.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    handleEdit: function handleEdit(index, row) {
      this.processDetail = row;
      this.visible = true;
      this.mode = 'update';
    },
    handleDetail: function handleDetail(index, row) {
      this.processDetail = row;
      this.visibleView = true;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    }
  }
};

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _index = __webpack_require__(6);

var _jquery = __webpack_require__(359);

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = __webpack_require__(360);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  inject: ['reload'],
  data: function data() {
    return {
      searchText: '',
      companymanageid: '',
      souchs: {
        hardHash: '',
        comment: '',
        deptname: ''
      },
      dynamicTags: [],
      proName: '',
      options: [{ value: '硬件码', label: '硬件码' }, { value: '备注', label: '备注' }, { value: '部门', label: '部门' }],
      value: "",
      token: '',
      checkCode: '',
      id: '',
      total: 1,
      pageSize: 20,
      pageNumber: 1,
      proList: [],
      listLoading: false,
      sels: [],
      addFormVisible: false,
      addForm: {
        hardHash: '',
        comment: '',
        deptname: ''
      },
      addLoading: false,
      addFormRules: {
        hardHash: [{ required: true, message: '请输入硬件码', trigger: 'blur' }]
      },
      editFormVisible: false,
      editForm: {
        hardHash: '',
        comment: '',
        deptname: ''
      },
      editLoading: false,
      editFormRules: {
        hardHash: [{ required: true, message: '请输入硬件码', trigger: 'blur' }],
        deptname: [{ required: true, message: '请输入部门', trigger: 'blur' }]
      },
      orderType: '',
      orderStr: '',
      hrefUrl: ''
    };
  },

  methods: {
    importFile: function importFile(filex) {
      var file = filex.target.files[0];
      var formData = new FormData();
      formData.append('file', file);
      if (!file) {
        _this.$message.error('请选择文件！');
        return;
      }
      var _this = this;
      _this.listLoading = true;
      _jquery2.default.ajax({
        url: _index.API_userCom.companyBatchAdd() + "?companyid=" + this.$route.query.companyId + "" + '&checkCode=' + _jsCookie2.default.get("dnnyptadmin_checkCode") + '&token=' + _jsCookie2.default.get("dnnyptadmin_token"),
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        dataType: "json",
        timeout: 180000,
        success: function success(res) {
          if (res.code == 200) {
            _this.$message.success('导入成功！');
          } else {
            _this.$message.error(res.message);
          }
          _this.getList();
          _this.$refs.clearFileModal.value = "";
        },
        error: function error(err) {
          _this.$message.error(res.message);
          _this.listLoading = false;
        },
        complete: function complete() {}
      });
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "hardHash") {
          this.orderStr = "hardHashpx";
        } else if (val.prop == "comment") {
          this.orderStr = "commentpx";
        } else if (val.prop == "deptname") {
          this.orderStr = "deptnamepx";
        } else if (val.prop == "intime") {
          this.orderStr = "intimepx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch: function changeSouch(val) {
      if (val == "硬件码") {
        this.proName = this.souchs.hardHash;
      } else if (val == "备注") {
        this.proName = this.souchs.comment;
      } else if (val == "部门") {
        this.proName = this.souchs.deptname;
      }
    },
    delTags: function delTags() {
      this.souchs = {}, this.value = '';
      this.proName = '';
      this.dynamicTags = [];
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == "硬件码") {
        this.souchs.hardHash = "";
        if (this.value == "硬件码") {
          this.proName = '';
        }
      }
      if (tag == "部门") {
        this.souchs.deptname = "";
        if (this.value == "部门") {
          this.proName = '';
        }
      }
      if (tag == "备注") {
        this.souchs.comment = "";
        if (this.value == "备注") {
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    editSubmit: function editSubmit() {
      var _this2 = this;

      if (!this.editForm.hardHash) {
        this.$message.error('硬件码不可为空！');
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: '',
        id: this.editForm.id,
        comment: this.editForm.comment,
        hardHash: this.editForm.hardHash,
        deptname: this.editForm.deptname,

        companyid: this.$route.query.companyId
      };
      this.editLoading = true;
      _index.API_userCom.addSBList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: "保存成功",
            type: 'success'
          });
          _this2.getList();
          _this2.editFormVisible = false;
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'login' });
          }
        }
        _this2.editLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.editLoading = false;
      });
    },
    addSubmit: function addSubmit() {
      var _this3 = this;

      if (!this.addForm.hardHash) {
        this.$message.error('硬件码不可为空！');
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        comment: this.addForm.comment,
        hardHash: this.addForm.hardHash,
        deptname: this.addForm.deptname,

        companyid: this.$route.query.companyId
      };
      this.addLoading = true;
      _index.API_userCom.addSBList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: "保存成功",
            type: 'success'
          });
          _this3.getList();
          _this3.addFormVisible = false;
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'login' });
          }
        }
        _this3.addLoading = false;
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
        _this3.addLoading = false;
      });
    },
    handleDel: function handleDel(index, row) {
      var _this4 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this4.token,
          checkCode: _this4.checkCode,
          id: row.id
        };
        _index.API_userCom.delSBList(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this4.$message({
              message: "删除成功",
              type: 'success'
            });
            _this4.getList();
          } else {
            _this4.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this4.$router.push({ path: 'login' });
            }
          }
        }).catch(function (err) {
          _this4.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    handleEdit: function handleEdit(index, row) {
      this.editForm = (0, _assign2.default)({}, row);
      this.editFormVisible = true;
    },
    handleAdd: function handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    getList: function getList(val) {
      var _this5 = this;

      if (this.value == "硬件码") {
        this.souchs.hardHash = this.proName;
      }
      if (this.value == "部门") {
        this.souchs.deptname = this.proName;
      }
      if (this.value == "备注") {
        this.souchs.comment = this.proName;
      }
      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,

        companyid: this.$route.query.companyId,
        comment: this.souchs.comment,
        hardHash: this.souchs.hardHash,
        deptname: this.souchs.deptname,
        orderType: this.orderType,
        orderStr: this.orderStr,
        searchText: this.searchText
      };
      this.listLoading = true;
      _index.API_userCom.getSBList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.list) {
            _this5.proList = res.data.data.list;
            if (res.data.data.totalRow) {
              _this5.total = res.data.data.totalRow;
            }
          }
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'login' });
          }
        }
        _this5.listLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.listLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  created: function created() {
    this.getCookie();
    this.hrefUrl = _index.API_userCom.companyTemplate();
  }
};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(90);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(89);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(103);

var _index3 = _interopRequireDefault(_index2);

var _SelectCommon = __webpack_require__(74);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _GisCommon = __webpack_require__(164);

var _GisCommon2 = _interopRequireDefault(_GisCommon);

var _proj = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    mode: {
      type: String,
      default: 'save'
    },

    visible: {
      type: Boolean,
      default: false
    },

    visitStatusList: {
      type: Array,
      default: function _default() {}
    },
    processDetail: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },

  data: function data() {
    var _this = this;

    var validateFile = function validateFile(rule, value, callback) {
      if (!_this.ruleForm.pic) {
        callback(new Error('请上传现场照片'));
      } else {
        callback();
      }
    };
    return {
      myVisible: false,
      searchText: '',
      listLoading: false,
      confirmLoading: false,
      pageSize: 10,
      pageNumber: 1,
      total: 0,

      token: '',
      checkCode: '',
      companyList: [],
      title: '',

      selectedUserId: [],

      rules: {
        departName: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],

        payVisitDate: [{ required: true, message: '请选择拜访日期', trigger: 'change' }],

        contactUser: [{ required: true, message: '请输入联系人', trigger: 'change' }],

        contactPhone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],

        position: [{ required: true, message: '请输入职位', trigger: 'blur' }],

        payVisitInfo: [{ required: true, message: '请输入拜访详情', trigger: 'blur' }],

        payVisitStatus: [{ required: true, message: '请选择拜访状态', trigger: 'blur' }]

      },

      ruleForm: {
        companyName: this.$route.query.companyName,
        companyId: this.$route.query.companyId,
        adminUser: '',
        payVisitDate: '',
        contactUser: '',
        contactPhone: '',
        position: '',
        payVisitInfo: '',
        payVisitStatus: '',
        successfulManager: "",
        agencyManager: "",
        pic: ''
      },

      companyId: this.$route.query.companyId,
      fileList: [],
      removeUploadFileIds: [],
      uploadURL: ''

    };
  },


  components: {
    SelectCommon: _SelectCommon2.default,
    GisCommon: _GisCommon2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    this.myVisible = this.visible;
  },
  mounted: function mounted() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.checkCode = checkCode;

    if (this.mode == 'save') {
      this.title = '新增';
    } else {
      this.title = '编辑';
      var myDetail = JSON.parse((0, _stringify2.default)(this.processDetail));
      myDetail.auditStatus = myDetail.auditStatus + '';
      myDetail.payVisitStatus = myDetail.payVisitStatus + '';

      var fileList = myDetail.picList;
      fileList.forEach(function (item) {
        item.uid = item.id;
        item.name = item.fileName;
        item.url = item.sltUrl;
      });
      myDetail.picList = fileList;
      this.fileList = fileList;
      this.ruleForm = (0, _extends3.default)({}, this.ruleForm, myDetail);
    }
  },


  methods: {
    handerUploadChange: function handerUploadChange(file, fileList) {
      this.fileList.push(file);
      this.ruleForm.pic = this.fileList.length > 0 ? this.fileList.map(function (item) {
        return item.uid;
      }).join() : '';
      this.$refs.ruleForm.validateField('pic');
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      console.log("remove==");
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = this.fileList.filter(function (item) {
        return item.uid != file.uid;
      });
      this.ruleForm.pic = this.fileList.length > 0 ? this.fileList.map(function (item) {
        return item.uid;
      }).join() : '';

      if (file.id) {
        this.removeUploadFileIds.push(file.id);
      }

      this.$refs.ruleForm.validateField('pic');
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.ruleForm[key] = value[0];
      this.$refs.ruleForm.validateField(key);
      if (key === 'contactUser') {
        this.ruleForm.contactPhone = datas[0].phone;
      }
    },
    handleSelectCommonFilter: function handleSelectCommonFilter(value, datas, key) {
      this.ruleForm[key] = value[0];
    },
    submitUpload: function submitUpload() {
      this.$refs.upload.submit();
    },
    uploadPic: function uploadPic(formData) {
      var _this2 = this;

      return _index.API_userCom.uploadPic(formData).then(function (res) {
        if (res.data.code == 200) {
          var data = res.data.data;
          var picIds = data.length > 0 ? data.map(function (item) {
            return item.id;
          }).join() : '';
          return picIds;
        } else {
          _this2.$message.error('上传图片出错');
        }
        return false;
      }).catch(function (err) {
        _this2.confirmLoading = false;
        _this2.$message.error('上传图片出错');
        return false;
      });
    },
    delPic: function delPic() {
      var _this3 = this;

      var data = {
        picId: this.removeUploadFileIds.join(),
        id: this.ruleForm.id
      };
      return _index.API_userCom.delPic(data).then(function (res) {
        if (res.data.code == 200) {
          return true;
        } else {
          _this3.$message.error('删除图片出错');
        }
        return false;
      }).catch(function (err) {
        _this3.confirmLoading = false;
        _this3.$message.error('删除图片出错');
        return false;
      });
    },
    handerSubmit: function handerSubmit(formName) {
      var _this4 = this;

      this.$refs['ruleForm'].validate(function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(valid) {
          var data, fileRawList, res, formData, picIds;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 27;
                    break;
                  }

                  data = (0, _extends3.default)({}, _this4.ruleForm);

                  data.createUser = _this4.userInfo.id;
                  delete data.companyName;
                  _this4.confirmLoading = true;
                  fileRawList = _this4.fileList.filter(function (item) {
                    return item.raw;
                  });

                  if (!(data.payVisitStatus == 2 || data.payVisitStatus == 3)) {
                    _context.next = 25;
                    break;
                  }

                  if (!(_this4.removeUploadFileIds.length > 0)) {
                    _context.next = 13;
                    break;
                  }

                  _context.next = 10;
                  return _this4.delPic();

                case 10:
                  res = _context.sent;

                  if (res) {
                    _context.next = 13;
                    break;
                  }

                  return _context.abrupt('return');

                case 13:
                  if (!(fileRawList.length > 0)) {
                    _context.next = 22;
                    break;
                  }

                  formData = new FormData();

                  fileRawList.map(function (item) {
                    formData.append('pic', item.raw);
                  });
                  _context.next = 18;
                  return _this4.uploadPic(formData);

                case 18:
                  picIds = _context.sent;

                  if (picIds) {
                    data.pic = picIds;
                    _this4.mode == 'save' ? _this4.handerSave(data) : _this4.handerUpdate(data);
                  }
                  _context.next = 23;
                  break;

                case 22:
                  _this4.mode == 'save' ? _this4.handerSave(data) : _this4.handerUpdate(data);

                case 23:
                  _context.next = 27;
                  break;

                case 25:
                  _this4.confirmLoading = true;
                  _this4.mode == 'save' ? _this4.handerSave(data) : _this4.handerUpdate(data);

                case 27:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this4);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handerSave: function handerSave(data) {
      var _this5 = this;

      data.payVisitDate = data.payVisitDate + ' 00:00:00';
      _index.API_userCom.addTrack(data).then(function (res) {
        if (res.data.code == 200) {
          _this5.$message.success('新增成功');
          _this5.$emit('getList');
          _this5.handerClose();
        }
        _this5.confirmLoading = false;
      }).catch(function (err) {
        _this5.confirmLoading = false;
      });
    },
    handerUpdate: function handerUpdate(data) {
      var _this6 = this;

      var date = data.payVisitDate;
      data.payVisitDate = date.indexOf('00:00:00') > -1 ? date : date + ' 00:00:00';
      delete data.contactUserName;
      delete data.adminUserName;
      _index.API_userCom.updateTrack(data).then(function (res) {
        if (res.data.code == 200) {
          _this6.$message.success('编辑成功');
          _this6.$emit('getList');
          _this6.handerClose();
        }
        _this6.confirmLoading = false;
      }).catch(function (err) {
        _this6.confirmLoading = false;
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handerClose: function handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false);
    }
  }

};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(103);

var _index3 = _interopRequireDefault(_index2);

var _PictureList = __webpack_require__(752);

var _PictureList2 = _interopRequireDefault(_PictureList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    processDetail: {
      type: Object,
      default: function _default() {
        return null;
      }
    }

  },

  data: function data() {
    return {

      listLoading: false,
      confirmLoading: false,

      token: '',
      checkCode: '',
      myDetail: null,
      myVisible: false,
      commentNote: undefined,
      postLoading: false,
      commentList: [],
      isReply: false,
      replyObj: '',
      replyNote: undefined
    };
  },


  components: {
    PictureList: _PictureList2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    this.myVisible = this.visible;
  },
  mounted: function mounted() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.checkCode = checkCode;
    this.myDetail = JSON.parse((0, _stringify2.default)(this.processDetail));
    this.getCommentList();
  },


  methods: {
    handerSubmit: function handerSubmit(processInfo) {
      var _this = this;

      var data = JSON.parse((0, _stringify2.default)(processInfo));

      var param = {
        id: data.id,
        auditStatus: '2',
        companyId: data.companyId
      };
      _index.API_userCom.updateTrack(param).then(function (res) {
        if (res.data.code == 200) {
          _this.$message.success('审核成功');
          _this.$emit('getList');
          _this.handerClose();
        }
        _this.confirmLoading = false;
      }).catch(function (err) {
        _this.confirmLoading = false;
      });
    },
    handerClose: function handerClose() {
      console.log('handerCLose=');
      this.myVisible = false;
      this.$emit('update:visible', false);
    },
    getCommentList: function getCommentList() {
      var _this2 = this;

      console.log('userInfo', this.userInfo);
      var marketid = this.myDetail.id;
      _index.API_userCom.getComment(marketid).then(function (res) {
        if (res.data.code == 200) {
          _this2.commentList = res.data.data;
          var listDom = document.getElementsByClassName('list');
          console.log(218, listDom);
          listDom[0].scrollTop = 0;
        }
      }).catch(function (err) {});
    },
    postComment: function postComment() {
      var _this3 = this;

      this.postLoading = true;
      var params = {
        marketid: this.myDetail.id,
        userid: this.userInfo.id,
        note: this.commentNote
      };
      _index.API_userCom.addComment(params).then(function (res) {
        if (res.data.code == 200) {
          _this3.$message.success('评论成功');
          _this3.commentNote = undefined;
          _this3.getCommentList();
        } else {
          _this3.$message.error(res.data.message);
        }
        _this3.postLoading = false;
      }).catch(function () {
        _this3.postLoading = false;
      });
    },
    deleteComment: function deleteComment(item) {
      var _this4 = this;

      console.log(item, this.userInfo.id);
      if (item.userid != this.userInfo.id) {
        this.$message.warning('不允许删除别人的评论');
        return false;
      }
      _index.API_userCom.delComment(item.id).then(function (res) {
        console.log('delComment', res);
        if (res.data.code == 200) {
          _this4.$message.success('删除成功');
          _this4.getCommentList();
        } else {
          _this4.$message.error(res.data.message);
        }
      }).catch(function () {});
    },
    reply: function reply(item) {
      if (item.userid != this.userInfo.id) {
        this.replyObj = item.username;
        this.isReply = true;
      }
    },
    closeReply: function closeReply() {
      this.isReply = false;
      this.replyObj = '';
    },
    replyComment: function replyComment() {
      var _this5 = this;

      this.postLoading = true;
      var params = {
        marketid: this.myDetail.id,
        userid: this.userInfo.id,
        note: this.replyNote
      };
      _index.API_userCom.addComment(params).then(function (res) {
        if (res.data.code == 200) {
          _this5.$message.success('回复成功');
          _this5.replyNote = undefined;
          _this5.isReply = false;
          _this5.replyObj = '';
          _this5.getCommentList();
        } else {
          _this5.$message.error(res.data.message);
        }
        _this5.postLoading = false;
      }).catch(function () {
        _this5.postLoading = false;
      });
    }
  }
};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _SelectCommon = __webpack_require__(74);

var _SelectCommon2 = _interopRequireDefault(_SelectCommon);

var _ModalForm = __webpack_require__(1692);

var _ModalForm2 = _interopRequireDefault(_ModalForm);

var _ModalFormView = __webpack_require__(802);

var _ModalFormView2 = _interopRequireDefault(_ModalFormView);

var _index2 = __webpack_require__(103);

var _index3 = _interopRequireDefault(_index2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      listLoading: false,
      dataList: [],

      pageNumber: 1,
      pageSize: 20,
      total: 0,

      visible: false,
      visibleView: false,
      mode: 'save',

      searchVal: {
        searchText: '',
        payVisitStatus: '',
        auditStatus: '',
        managerAdminuser: '',
        payVisitDate: ''
      },

      selectedUserId: [],
      visitStatusList: [{ label: '电话沟通', value: '1' }, { label: '客户现场', value: '2' }, { label: '视频会议', value: '3' }],

      checkStatusList: [{ label: '待审核', value: '1' }, { label: '已审核', value: '2' }],

      processDetail: null,
      token: ''
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default,
    SelectCommon: _SelectCommon2.default,
    ModalForm: _ModalForm2.default,
    ModalFormView: _ModalFormView2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.getList();
  },


  methods: {
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      var data = (0, _extends3.default)({
        token: this.token,
        compayId: this.$route.query.companyId,
        page: this.pageNumber,
        size: this.pageSize
      }, this.searchVal);
      _index.API_userCom.getTrackList(data).then(function (res) {
        if (res.data.code == 200) {
          var _data = res.data.data;
          _this.dataList = _data.list;
          _this.total = _data.totalRow;
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSelectCommon: function handleSelectCommon(value, datas, key) {
      this.searchVal.managerAdminuser = value[0];
    },
    handerSectionChange: function handerSectionChange(data, column, event) {
      this.selectedUserId = data.length > 0 ? data.map(function (item) {
        return item.id;
      }) : [];
    },
    handerRowClick: function handerRowClick(row, column, event) {
      if (event.target.className.indexOf('dnnfont') > -1) {
        return;
      }
      this.$refs.companyTabRef.toggleRowSelection(row);
    },
    addForm: function addForm() {
      this.processDetail = null;
      this.visible = true;
      this.mode = 'save';
    },
    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this2.token,
          checkCode: _this2.checkCode,
          id: row.id,
          del: 0
        };
        _index.API_userCom.updateTrack(param).then(function (res) {
          if (res.data.code == 200) {
            _this2.$message({ message: '删除成功', type: 'success' });
            _this2.getList();
          } else {
            _this2.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this2.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    handleEdit: function handleEdit(index, row) {
      this.processDetail = row;
      this.visible = true;
      this.mode = 'update';
      console.log("handleEdit==", this.visible);
    },
    handleDetail: function handleDetail(index, row) {
      this.processDetail = row;
      this.visibleView = true;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    }
  }
};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  inject: ['reload'],
  data: function data() {
    return (0, _defineProperty3.default)({
      ProductSelection: [],
      userSelection: [],
      disSouch2: true,
      fpTypes2: false,
      showDepart: false,
      fpType: '',
      dynamicTags2: [],
      souchs2: {},
      proName2: '',
      value2: '',
      deptid: '',
      fpType2: '',
      optionsSouch2: [{ value: '姓名', label: '姓名' }, { value: '账号', label: '账号' }, { value: '状态', label: '状态' }, { value: '部门', label: '部门' }],
      fpTypes: [{ value: '1', label: '已有产品' }, { value: '0', label: '未有产品' }],

      disSouch: true,
      disType1: false,
      disType2: false,
      souchs: {
        id: '',
        phone: '',
        name: '',
        souType: '',
        status: ''
      },
      proName: '',
      value: '',
      types: [{ value: '1', label: '试用' }, { value: '2', label: '正式' }],
      types2: [{ value: '1', label: '正常使用' }, { value: '3', label: '禁用' }],
      typeValue: '',
      typeValue2: '',
      dynamicTags: [],

      token: '',
      checkCode: '',
      id: '',
      proList: [],
      listLoading: false,
      pageNumber: 1,
      pageSize: 20,
      total: 1,
      companymanageid: '',
      pageNumber2: 1,
      pageSize2: 10,
      total2: 1,
      userList: [],
      userLoading: false,
      editLoading: false,
      editFormVisible: false,
      rname: '',
      checkUserId: '',
      checkUserIdOld: '',
      flag: false,
      productid: '',
      orderType: '',
      orderStr: '',

      batchType: 0,
      searchText: '',

      visibleDispatch: false,
      dispatchForm: {
        deptid: ''
      },
      dispatchRules: {
        deptid: [{ required: true, message: '请选择部门', trigger: 'change' }]
      },
      confirmDispatchLoading: false,
      departList: [],

      deptpx: ''
    }, 'orderType', '');
  },

  methods: {
    getDepartList: function getDepartList() {
      var _this2 = this;

      var data = {
        token: this.token,
        companyid: this.$route.query.companyId
      };
      _index.API_userCom.getDepartList(data).then(function (res) {
        if (res.data.code == 200) {
          _this2.departList = res.data.data || [];
        } else {
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {});
    },
    handerSubmitDispatch: function handerSubmitDispatch() {
      var _this3 = this;

      this.$refs['dispatchForm'].validate(function (valid) {
        if (valid) {
          _this3.confirmDispatchLoading = true;
          var data = {
            auproductid: _this3.ProductSelection.join(),
            deptid: _this3.dispatchForm.deptid
          };
          _index.API_userCom.dispatchProductToDepart(data).then(function (res) {
            if (res.data.code == 200) {
              _this3.$message.success('产品分配成功');
              _this3.handerCloseDispatch();
              _this3.getProList(1);
            } else {
              _this3.$message.error(res.data.message);
              if (res.data.code == 403) {
                _this3.$router.push({ path: 'loginAdmin' });
              }
            }
            _this3.confirmDispatchLoading = false;
          }).catch(function (err) {
            _this3.confirmDispatchLoading = false;
          });
        }
      });
    },
    handerCloseDispatch: function handerCloseDispatch() {
      this.visibleDispatch = false;
      this.$refs['dispatchForm'].resetFields();
    },
    selectTable: function selectTable(selection, row) {
      if (selection.length > this.ProductSelection.length) {
        var del_row = selection.shift();

        this.$refs.userList.toggleRowSelection(del_row, false);
      }
    },


    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == 'id') {
          this.orderStr = 'idpx';
        } else if (val.prop == 'productname') {
          this.orderStr = 'productnamepx';
        } else if (val.prop == 'name') {
          this.orderStr = 'namepx';
        } else if (val.prop == 'phone') {
          this.orderStr = 'phonepx';
        } else if (val.prop == 'duetime1') {
          this.orderStr = 'duetimepx';
        } else if (val.prop == 'typename') {
          this.orderStr = 'typepx';
        } else if (val.prop == 'usingstatusname') {
          this.orderStr = 'statuspx';
        } else if (val.prop == 'deptname') {
          this.orderStr = 'deptidpx';
        } else if (val.prop == 'userdeptname') {
          this.orderStr = 'userdeptnamepx';
        }
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
      }
      this.getProList();
    },
    changeSouch2: function changeSouch2(val) {
      if (val == '姓名') {
        this.disSouch2 = true;
        this.fpTypes2 = false;
        this.showDepart = false;
        this.proName2 = this.souchs2.name;
      } else if (val == '账号') {
        this.disSouch2 = true;
        this.fpTypes2 = false;
        this.showDepart = false;
        this.proName2 = this.souchs2.phone;
      } else if (val == '状态') {
        this.disSouch2 = false;
        this.showDepart = false;
        this.fpTypes2 = true;
      } else if (val == '部门') {
        this.disSouch2 = false;
        this.fpTypes2 = false;
        this.showDepart = true;
      }
    },
    delTags2: function delTags2() {
      ;this.souchs2 = {}, this.value2 = '';
      this.fpType = '';
      this.proName2 = '';
      this.dynamicTags2 = [];
      this.getUser();
    },
    handleClose2: function handleClose2(tag) {
      if (tag == '姓名') {
        this.souchs2.name = '';
        if (this.value2 == '姓名') {
          this.proName2 = '';
        }
      }
      if (tag == '账号') {
        this.souchs2.phone = '';
        if (this.value2 == '账号') {
          this.proName2 = '';
        }
      }
      if (tag == '状态') {
        this.souchs2.fpType = '';
        this.fpType = '';
      }
      if (tag == '部门') {
        this.deptid = '';
      }
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1);
    },


    delTags: function delTags() {
      ;this.souchs = {}, this.souchs.souType = '';
      this.souchs.status = '';
      this.value = '';
      this.proName = '';
      this.typeValue = '';
      this.typeValue2 = '';
      this.dynamicTags = [];
      this.getProList();
    },
    handleClose: function handleClose(tag) {
      if (tag == 'ID') {
        this.souchs.id = '';
        if (this.value == 'ID') {
          this.proName = '';
        }
      }
      if (tag == '用户') {
        this.souchs.name = '';
        if (this.value == '用户') {
          this.proName = '';
        }
      }
      if (tag == '账号') {
        this.souchs.phone = '';
        if (this.value == '账号') {
          this.proName = '';
        }
      }
      if (tag == '名称') {
        this.souchs.productname = '';
        if (this.value == '名称') {
          this.proName = '';
        }
      }
      if (tag == '类型') {
        this.souchs.souType = '';
        this.typeValue = '';
      }
      if (tag == '状态') {
        this.souchs.status = '';
        this.typeValue2 = '';
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    changeSouch: function changeSouch(val) {
      if (val == '类型') {
        this.disSouch = false;
        this.disType1 = true;
        this.disType2 = false;
        this.proName = '';
        this.typeValue = this.souchs.souType;
      } else if (val == '状态') {
        this.disSouch = false;
        this.disType1 = false;
        this.disType2 = true;
        this.proName = '';
        this.typeValue2 = this.souchs.status;
      } else if (val == 'ID') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.id;
      } else if (val == '账号') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.phone;
      } else if (val == '用户') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.name;
      } else if (val == '名称') {
        this.disSouch = true;
        this.disType1 = false;
        this.disType2 = false;
        this.proName = this.souchs.productname;
      }
    },
    editSubmit: function editSubmit(type) {
      var _this4 = this;

      if (!this.checkUserId && type == 0) {
        this.$message.error('用户不可为空，请选择！');
        return;
      }
      var methods = 'setProduct';
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        managerid: this.$route.query.managerId,
        productid: this.productid,
        userid: this.checkUserId };
      if (type == 1) {
        methods = 'companyProductBatchDistribute';
        param['userid'] = this.userSelection + '';
        param['productid'] = this.ProductSelection + '';
      }
      this.editLoading = true;
      _index.API_userCom[methods](param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: '分配完成',
            type: 'success',
            center: true
          });
          _this4.editFormVisible = false;
          _this4.getProList();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'login' });
          }
        }
        _this4.editLoading = false;
      }).catch(function (err) {
        _this4.editLoading = false;
        _this4.$message.error('数据丢失，试试重新登陆！');
      });
    },

    changeFun: function changeFun() {
      var falg = false;
      for (var i = 0; i < this.userList.length; i++) {
        if (this.userList[i].checked == true) {
          falg = true;
          this.checkUserId = this.userList[i].id;
        }
      }
      if (!falg) {
        this.checkUserId = '';
      }
    },

    handleProductSelectionChange: function handleProductSelectionChange(row) {
      var list = [];
      if (row.length != 0) {
        row.map(function (item) {
          list.push(item.id);
        });
      }
      this.ProductSelection = list;
    },
    handleUserSelectionChange: function handleUserSelectionChange(row) {
      var list = [];
      if (row.length != 0) {
        row.map(function (item) {
          list.push(item.id);
        });
      }
      this.userSelection = list;
    },
    handleSelectionChange: function handleSelectionChange(row) {
      if (this.batchType == 0) {
        this.flag = true;
        if (row) {
          this.userList.forEach(function (item) {
            if (item.id !== row.id) {
              item.checked = false;
            }
            if (item.id == row.id) {
              item.checked = true;
            }
          });
        } else {
          this.userList.forEach(function (item) {
            item.checked = false;
          });
        }

        if (row.name == null) {
          row.name = '';
        }
        if (row.phone == null) {
          row.phone = '';
        }
        this.checkUserId = row.id;
        this.checkUserIdOld = row.id;
      }
    },


    getUser: function getUser(val) {
      var _this5 = this;

      if (this.value2 == '账号') {
        this.souchs2.phone = this.proName2;
      }
      if (this.value2 == '姓名') {
        this.souchs2.name = this.proName2;
      }
      if (this.value2 == '状态') {
        this.souchs2.fpType = this.fpType;
      }
      var flag = true;
      if (val == 1) {
        this.pageNumber2 = 1;

        if (this.value2) {
          if (this.dynamicTags2.length > 0) {
            for (var i = 0; i < this.dynamicTags2.length; i++) {
              if (this.value2 == this.dynamicTags2[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags2.push(this.value2);
          }
        }
      }

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        listType: 'page',
        companyid: this.$route.query.companyId,

        phone: this.souchs2.phone,
        username: this.souchs2.name,
        hasproduct: this.souchs2.fpType,
        orderStr: this.deptpx,
        orderType: this.orderType,
        deptid: this.value2 == '部门' ? this.deptid : '' };
      this.userLoading = true;
      _index.API_userCom.userList(param).then(function (res) {
        _this5.userLoading = false;
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.list) {
            _this.userList = res.data.data.list;
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i]) {
                if (_this.rname && res.data.data.list[i].id == _this.rname) {
                  res.data.data.list[i].checked = true;
                } else {
                  res.data.data.list[i].checked = false;
                }
              }
            }
            if (res.data.data.totalRow) {
              _this.total2 = res.data.data.totalRow;
            }
          }
        } else {
          _this5.userLoading = false;
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'login' });
          }
        }
      }).catch(function (err) {
        _this5.userLoading = false;
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    handleDel: function handleDel(index, row) {
      var _this6 = this;

      this.$confirm('确认撤销吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this6.token,
          checkCode: _this6.checkCode,

          productid: row.id };
        _index.API_userCom.delProduct(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this6.$message({
              message: '撤销成功',
              type: 'success',
              center: true
            });
            _this6.getProList();
          } else {
            _this6.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this6.$router.push({ path: 'login' });
            }
          }
        }).catch(function (err) {
          _this6.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },

    handleDelDepart: function handleDelDepart(index, row) {
      var _this7 = this;

      this.$confirm('确认撤销吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this7.token,
          checkCode: _this7.checkCode,
          id: row.id };
        _index.API_userCom.delProductDepart(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this7.$message({ message: '撤销成功', type: 'success', center: true });
            _this7.getProList();
          } else {
            _this7.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this7.$router.push({ path: 'login' });
            }
          }
        }).catch(function (err) {
          _this7.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },

    handleEdit: function handleEdit(index, row) {
      this.productid = row.id;
      this.rname = '';
      this.rname = row.userid;
      this.batchType = 0;
      this.getUser();
      this.editFormVisible = true;
    },
    batch: function batch() {
      this.productid = '';
      this.rname = '';
      this.getUser();
      this.batchType = 1;
      this.editFormVisible = true;
    },

    getProList: function getProList(val) {
      var _this8 = this;

      if (this.value == 'ID') {
        this.souchs.id = this.proName;
      }
      if (this.value == '账号') {
        this.souchs.phone = this.proName;
      }
      if (this.value == '用户') {
        this.souchs.name = this.proName;
      }
      if (this.value == '名称') {
        this.souchs.productname = this.proName;
      }
      if (this.value == '类型') {
        this.souchs.souType = this.typeValue;
      }
      if (this.value == '状态') {
        this.souchs.status = this.typeValue2;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        companyid: this.$route.query.companyId,
        id: this.souchs.id,
        name: this.souchs.name,
        phone: this.souchs.phone,
        productname: this.souchs.productname,

        type: this.typeValue,

        status: this.typeValue2,
        orderType: this.orderType,
        orderStr: this.orderStr,
        searchText: this.searchText
      };
      this.listLoading = true;
      _index.API_userCom.getList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].userid) {
              res.data.data.list[i].delShow = false;
            } else {
              res.data.data.list[i].delShow = true;
            }
            if (res.data.data.list[i].duetime) {
              res.data.data.list[i].duetime1 = res.data.data.list[i].duetime.substring(0, 10);
            }
          }
          _this8.proList = res.data.data.list;
          _this8.total = res.data.data.totalRow;
        } else {
          _this8.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this8.$router.push({ path: 'login' });
          }
        }
        _this8.listLoading = false;
      }).catch(function (err) {
        _this8.listLoading = false;
        _this8.$message.error('数据丢失，试试重新登陆！');
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return 'background:#F5F7FA';
      } else {
        return '';
      }
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getUser();
    },
    handleSizeChange2: function handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getUser();
    },
    handleSortChange2: function handleSortChange2(val) {
      if (val.order == null) {
        this.deptpx = '';
        this.orderType = '';
        this.getUser();
      } else {
        var order;
        if (val.order == 'descending') {
          order = 'desc';
        } else {
          order = 'asc';
        }
        this.deptpx = 'deptpx';
        this.orderType = order;
        this.getUser();
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getProList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getProList();
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  created: function created() {
    this.getCookie();
    this.getDepartList();
  },
  mounted: function mounted() {
    this.getProList();
  }
};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  props: {
    adminVisible: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: String,
      default: ''
    },
    UserSelection: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      userSelection: [],
      adminList: [],
      userLoading: false,
      orderLoading: false,
      checkCode: '',
      token: ''
    };
  },

  watch: {
    UserSelection: function UserSelection(val) {
      this.adminList = this.adminList.concat(val);
    }
  },
  mounted: function mounted() {
    this.getCookie();
    this.getCompanyManage();
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    addAdmin: function addAdmin() {
      this.$emit("addAdmin");
    },
    adminVisibleClose: function adminVisibleClose() {
      this.$emit("adminVisibleClose");
    },
    getCompanyManage: function getCompanyManage(id) {
      var _this = this;

      var param = {
        companyId: this.companyId,
        token: this.token,
        checkCode: this.checkCode
      };
      this.userLoading = true;
      _index.API_Admin.getCompanyManage(param).then(function (res) {
        if (res.data.code == 200) {
          _this.adminList = res.data.data;
        }
        _this.userLoading = false;
      });
    },
    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm("确认删除吗?", "提示", {
        type: "warning"
      }).then(function () {
        _this2.adminList.splice(index, 1);
      });
    },
    orderUserSubmit: function orderUserSubmit() {
      this.$emit("orderUserSubmit", this.adminList);
    }
  }
};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var echarts = __webpack_require__(117);
exports.default = {
  props: ['defalutd', 'comId'],

  data: function data() {
    return {
      creditLoading: false,
      rankLoading: false,
      moduleLoading: false,
      productLoading: false,
      deviceLoading: false,

      modulePieArr: [],
      chartObjArr: [],

      staTime: '1',
      moduleTime: '1',
      pieColor: ['#5C89FF', '#7C6AF2', ' #C95FF2', '#FF6383', '#5C89FF', '#FF9F40', '#FFCB48'],

      lineVisible: false,
      pieVisible: false,

      pageNumber: 1,
      pageSize: 6,
      total: 1,
      proCPlist: false,
      checkPerson2: '',
      person2: '1',
      funCheck: 1,
      products: [],
      proNum: 0,
      proXZ: 0,
      proGQ: 0,
      proJGQ: 0,

      optionsSouch: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '积分', label: '积分' }],

      checkCode: '',
      token: '',
      id: '',
      companyuseid: '',
      checkUser: '',
      checkUser2: '',
      checkUserId: "",
      checkUserId2: "",
      personVisible: false,
      pageSize2: 10,
      pageNumber2: 1,
      total2: 1,
      users: [],
      times: [{ value: '1', text: '最近一个月' }, { value: '3', text: '最近三个月' }, { value: '6', text: '最近六个月' }, { value: '12', text: '最近一年' }],
      persons: [{ value: "1", text: "企业" }, { value: "2", text: "个人" }],
      checkPerson: '',
      person: '1',
      values: [],


      customColor: '#409eff',
      customColors: [{ color: '#f56c6c', percentage: 20 }, { color: '#e6a23c', percentage: 40 }, { color: '#5cb87a', percentage: 60 }, { color: '#1989fa', percentage: 80 }, { color: '#6f7ad3', percentage: 100 }],
      flag: false,
      dynamicTags: [],
      proName: '',
      souchs: {},
      souch_value: '',
      dateTime: [],
      dataNum: [],
      masg: false,
      masg2: false,
      pieName: '',
      lineName: '',
      ranked: false,
      deviceCount: '1' };
  },

  methods: {
    handleLine: function handleLine(id, name) {
      this.lineName = name;
      this.lineVisible = true;
      this.getUserMonthPointBrokenLine2(id);
    },
    handlePie: function handlePie(id, name) {
      this.pieName = name;
      this.pieVisible = true;
      this.getCompanyUserMonthModulePointPie2(id);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      if (this.ranked) {
        this.getCompanyUserMonthPointList();
      } else {
        this.getCompanyUserPointList();
      }
    },

    changeTime: function changeTime(method) {
      this[method]();
    },


    userSubmit: function userSubmit() {
      if (this.funCheck == 1) {
        this.checkPerson2 = this.checkUser2;
        this.getCompanyUserMonthModulePointPie(this.checkUserId2);
      } else {
        this.checkPerson = this.checkUser;
        this.getUserMonthPointBrokenLine(this.checkUserId);
      }
      this.personVisible = false;
    },
    changeSouch: function changeSouch(val) {
      if (val == "姓名") {
        this.proName = this.souchs.name;
      } else if (val == "账号") {
        this.proName = this.souchs.phone;
      } else if (val == "积分") {
        this.proName = this.souchs.point;
      }
    },
    delTags2: function delTags2() {
      this.souchs = {};
      this.proName = '';
      this.dynamicTags = [];
      this.getUser();
    },
    handleClose: function handleClose(tag) {
      if (tag == "姓名") {
        this.souchs.name = "";
        if (this.souch_value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "账号") {
        this.souchs.phone = "";
        if (this.souch_value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "积分") {
        this.souchs.point = "";
        if (this.souch_value == "积分") {
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
    },

    changeFun: function changeFun() {
      var falg = false;
      if (this.funCheck == 1) {
        for (var i = 0; i < this.users.length; i++) {
          if (this.users[i].checked == true) {
            falg = true;
            this.checkUserId2 = this.users[i].id;
          }
        }
        if (!falg) {
          this.checkUserId2 = "";
        }
      } else {
        for (var i = 0; i < this.users.length; i++) {
          if (this.users[i].checked == true) {
            falg = true;
            this.checkUserId = this.users[i].id;
          }
        }
        if (!falg) {
          this.checkUserId = "";
        }
      }
    },
    handleSelectionChange: function handleSelectionChange(row) {
      this.flag = true;
      this.users.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
        }
        if (item.id == row.id) {
          item.checked = true;
        }
      });
      if (row.name == null) {
        row.name = "";
      }
      if (row.phone == null) {
        row.phone = "";
      }
      if (this.funCheck == 1) {
        this.checkUser2 = row.name;
        this.checkUserId2 = row.id;
      } else {
        this.checkUser = row.name;
        this.checkUserId = row.id;
      }
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    handleUser: function handleUser(val) {
      this.funCheck = val;
      this.personVisible = true;
      this.getUser();
    },
    getUser: function getUser() {
      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        listType: 'page',

        companyid: this.comId
      };
      _index.API_Company.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i]) {
                if (_this.funCheck == 1) {
                  if (_this.checkUserId2 && res.data.data.list[i].id == _this.checkUserId2) {
                    res.data.data.list[i].checked = true;
                  } else {
                    res.data.data.list[i].checked = false;
                  }
                } else {
                  if (_this.checkUserId && res.data.data.list[i].id == _this.checkUserId) {
                    res.data.data.list[i].checked = true;
                  } else {
                    res.data.data.list[i].checked = false;
                  }
                }
              }
            }
            _this.total2 = res.data.data.totalRow;
            _this.users = res.data.data.list;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'login' });
          }
        }
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    creditDrawLine: function creditDrawLine(dataTime, dataNumber) {
      var myChart = echarts.init(document.getElementById('creditLine'));
      this.chartObjArr.push(myChart);

      myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '3.5%',
          left: '2%',
          right: '6%',
          bottom: '5%',
          containLabel: true
        },

        dataZoom: [{
          type: 'inside'
        }],

        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dataTime,
          axisLine: {
            lineStyle: {
              color: '#DBDBDB'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#666",
              margin: 15
            }
          }
        },

        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: "#DBDBDB"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#666",
              margin: 15
            }
          },
          splitLine: {
            show: false
          }
        },
        series: [{
          name: '积分',
          type: 'line',
          stack: '总量',
          data: dataNumber,
          showBackground: false,
          smooth: true,
          color: '#F66B3D',
          symbol: 'none',
          areaStyle: {
            normal: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(249, 91, 71, 0.35)' }, {
                  offset: 0.7,
                  color: 'rgba(249, 91, 71, 0.01)' }],
                globalCoord: false }
            }
          }
        }]
      });
    },


    echart4: function echart4(dataTime, dataNumber) {
      var myChart = echarts.init(document.getElementById('echartZXT2'));
      myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '8%',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        dataZoom: [{
          type: 'inside'
        }],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dataTime,
          axisLine: {
            lineStyle: {
              color: '#DBDBDB'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#666",
              margin: 15
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: "#DBDBDB"
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#666",
              margin: 15
            }
          },
          splitLine: {
            show: false
          }
        },
        series: [{
          name: '积分',
          type: 'line',
          stack: '总量',
          data: dataNumber,
          showBackground: false,
          smooth: true,
          color: '#F66B3D',
          symbol: 'none',
          areaStyle: {
            normal: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(249, 91, 71, 0.35)' }, {
                  offset: 0.7,
                  color: 'rgba(249, 91, 71, 0.01)' }],
                globalCoord: false }
            }
          }
        }]
      });
    },

    echartModule: function echartModule(data1, data2) {
      var _self = this;
      var myChart = echarts.init(document.getElementById('echartModule'));

      myChart.setOption({

        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },

        legend: {
          bottom: 10,
          left: 'center',
          data: data1,
          show: false
        },
        color: _self.pieColor,
        series: [{
          name: '模块名称',
          type: 'pie',
          radius: '50%',
          center: ['50%', '50%'],
          data: data2,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      });
    },


    echart3: function echart3(data1, data2) {
      var myChart = echarts.init(document.getElementById('echartBT2'));

      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: data1
        },
        series: [{
          name: '模块名称',
          type: 'pie',
          radius: '55%',
          center: ['50%', '45%'],
          data: data2,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
            normal: {
              color: function color(params) {
                var colorList = ['#CDDC39', '#E6EE9C', '#AEEA00', '#FFEA00', '#FFA000', '#FFCC80', '#F48FB1', '#FF5722', '#D50000', '#7B1FA2', '#7C4DFF', '#B388FF', '#3949AB', '#536DFE', '#8C9EFF', '#64B5F6', '#2196F3', '#607D8B', '#4CAF50', '#00E5FF', '#64FFDA'];
                return colorList[params.dataIndex];
              }
            }
          }
        }]
      });
    },

    getCookie: function getCookie() {
      this.id = sessionStorage.getItem('dnnypt_id');
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnypt_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnypt_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },

    getProductSum: function getProductSum() {
      var _this2 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.comId
      };
      _index.API_Stat.getProductSum(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this2.proNum = res.data.data[0].num;
          }
        }
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getGroupProductSum: function getGroupProductSum() {
      var _this3 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.comId
      };
      this.productLoading = true;
      _index.API_Stat.getGroupProductSum(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this3.proCPlist = true;
            _this.products = res.data.data;
          } else {
            _this3.proCPlist = false;
          }
          _this3.productLoading = false;
        }
      }).catch(function (err) {
        _this3.productLoading = false;
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getDueProductSum: function getDueProductSum() {
      var _this4 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.comId
      };
      _index.API_Stat.getDueProductSum(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this4.proGQ = res.data.data[0].num;
          }
        }
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getUnusedProductSum: function getUnusedProductSum() {
      var _this5 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.comId
      };
      _index.API_Stat.getUnusedProductSum(param).then(function (res) {

        if (res.data.code == _index.API__code.SUCCESS) {

          if (res.data.data.length > 0) {
            _this5.proXZ = res.data.data[0].num;
          }
        }
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getDueInMonthProductSum: function getDueInMonthProductSum() {
      var _this6 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.comId
      };
      _index.API_Stat.getDueInMonthProductSum(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this6.proJGQ = res.data.data[0].num;
          }
        }
      }).catch(function (err) {
        _this6.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCompanyUserPointList: function getCompanyUserPointList() {
      var _this7 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyuseid,

        pageNumber: 1,
        pageSize: 1000,
        listType: 'page'
      };
      this.rankLoading = true;
      _index.API_Stat.getCompanyUserPointList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.list.length > 0) {
            _this7.masg2 = true;
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i].sumpoint) {
                res.data.data.list[i].num = parseInt(res.data.data.list[i].sumpoint / res.data.maxPoint * 100);
                if (res.data.data.list[i].num < 30) {
                  _this7.customColor = '#f56c6c';
                } else if (res.data.data.list[i].num < 70) {
                  _this7.customColor = '#5cb87a';
                } else {
                  _this7.customColor = '#67c23a';
                }
              }
            }
            _this7.values = res.data.data.list;
            _this7.total = res.data.data.totalRow;
          } else {
            _this7.masg2 = false;
          }
          _this7.rankLoading = false;
        }
      }).catch(function (err) {
        _this7.rankLoading = false;
        _this7.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCompanyUserMonthPointList: function getCompanyUserMonthPointList() {
      var _this8 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyuseid,

        pageNumber: 1,
        pageSize: 1000,
        listType: 'page'
      };
      this.rankLoading = true;
      _index.API_Stat.getCompanyUserMonthPointList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.list.length > 0) {
            _this8.masg2 = true;
            var allsumpoint = 0;
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i].sumpoint) {
                res.data.data.list[i].num = parseInt(res.data.data.list[i].sumpoint / res.data.maxPoint * 100);
                if (res.data.data.list[i].num < 30) {
                  _this8.customColor = '#f56c6c';
                } else if (res.data.data.list[i].num < 70) {
                  _this8.customColor = '#5cb87a';
                } else {
                  _this8.customColor = '#67c23a';
                }
              }
            }
            _this8.values = res.data.data.list;
            _this8.total = res.data.data.totalRow;
          } else {
            _this8.masg2 = false;
          }
          _this8.rankLoading = false;
        }
      }).catch(function (err) {
        _this8.rankLoading = false;
        _this8.$message.error('数据丢失，试试重新登陆！');
      });
    },

    ranking: function ranking(val) {
      if (val == 1) {
        this.ranked = false;
        this.getCompanyUserPointList();
      } else {
        this.ranked = true;
        this.getCompanyUserMonthPointList();
      }
    },

    getCompanyMonthPointBrokenLine: function getCompanyMonthPointBrokenLine() {
      var _this9 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyuseid,
        count: this.staTime
      };
      this.creditLoading = true;
      _index.API_Stat.getCompanyMonthPointBrokenLine(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this9.dateTime = [];
          _this9.dataNum = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this9.dateTime.push(res.data.data[i].date);
            _this9.dataNum.push(res.data.data[i].sumpoint);
          }
          _this9.creditDrawLine(_this9.dateTime, _this9.dataNum);
          _this9.creditLoading = false;
        }
      });
    },

    getUserMonthPointBrokenLine: function getUserMonthPointBrokenLine(id) {
      var _this10 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: id
      };
      _index.API_Stat.getUserMonthPointBrokenLine(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this10.dateTime = [];
          _this10.dataNum = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this10.dateTime.push(res.data.data[i].date.substring(6));
            _this10.dataNum.push(res.data.data[i].sumpoint);
          }
          _this10.creditDrawLine(_this10.dateTime, _this10.dataNum);
        }
      });
    },

    getUserMonthPointBrokenLine2: function getUserMonthPointBrokenLine2(id) {
      var _this11 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: id
      };
      _index.API_Stat.getUserMonthPointBrokenLine(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this11.dateTime = [];
          _this11.dataNum = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this11.dateTime.push(res.data.data[i].date.substring(5).replace(/-/g, "月") + '日');
            _this11.dataNum.push(res.data.data[i].sumpoint);
          }
          _this11.echart4(_this11.dateTime, _this11.dataNum);
        }
      });
    },

    getCompanyMonthModulePointPie: function getCompanyMonthModulePointPie() {
      var _this12 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        companyid: this.companyuseid,
        count: this.moduleTime
      };
      this.moduleLoading = true;
      _index.API_Stat.getCompanyMonthModulePointPie(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this12.masg = false;
          } else {
            _this12.masg = true;
          }
          _this12.modulePieArr = res.data.data;
          var modulenames = [];
          var modul = [];
          for (var i = 0; i < res.data.data.length; i++) {
            modulenames.push(res.data.data[i].modulename);
            var json = { value: res.data.data[i].sumpoint, name: res.data.data[i].modulename };
            modul.push(json);
          }
          _this12.echartModule(modulenames, modul);
          _this12.moduleLoading = false;
        }
      });
    },

    getCompanyUserMonthModulePointPie: function getCompanyUserMonthModulePointPie(id) {
      var _this13 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: id
      };
      _index.API_Stat.getCompanyUserMonthModulePointPie(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this13.masg = false;
          } else {
            _this13.masg = true;
          }
          var modulenames = [];
          var modul = [];
          for (var i = 0; i < res.data.data.length; i++) {
            modulenames.push(res.data.data[i].modulename);
            var json = { value: res.data.data[i].sumpoint, name: res.data.data[i].modulename };
            modul.push(json);
          }

          _this13.echartModule(modulenames, modul);
        }
      });
    },

    getCompanyUserMonthModulePointPie2: function getCompanyUserMonthModulePointPie2(id) {
      var _this14 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: id
      };
      _index.API_Stat.getCompanyUserMonthModulePointPie(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.length > 0) {
            _this14.masg = false;
          } else {
            _this14.masg = true;
          }
          var modulenames = [];
          var modul = [];
          for (var i = 0; i < res.data.data.length; i++) {
            modulenames.push(res.data.data[i].modulename);
            var json = { value: res.data.data[i].sumpoint, name: res.data.data[i].modulename };
            modul.push(json);
          }
          _this14.echart3(modulenames, modul);
        }
      });
    },

    getOptionBar: function getOptionBar(data) {
      var option = {
        color: ['#F66B3D', '#3DBFF6'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          }
        },
        grid: {
          left: '95px',
          right: '6%',
          top: '1%',
          bottom: '0'
        },

        xAxis: {
          type: 'value',

          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          }

        },

        yAxis: {
          type: 'category',
          data: ['企业用户(人)', '登录设备(台)'],

          splitLine: {
            show: false
          },

          axisTick: { show: false },

          axisLine: {
            show: false
          },

          axisLabel: {
            show: true,
            margin: 12,
            fontSize: '14',
            color: '#666'
          }
        },

        series: [{
          type: 'bar',
          data: [data.userCount, data.hardHashCount],
          barGap: '50%',
          barWidth: 20,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'right',
                textStyle: {
                  fontSize: 14
                }
              },
              color: function color(params) {
                var colorList = ['#3DBFF6', '#F66B3D'];
                return colorList[params.dataIndex];
              }
            }
          }
        }]
      };
      return option;
    },
    initChartDevice: function initChartDevice(data) {
      var myChart = echarts.init(document.getElementById('device-chart'));

      var option = this.getOptionBar(data);
      option && myChart.setOption(option);
      this.chartObjArr.push(myChart);
    },
    getDeviceInfo: function getDeviceInfo() {
      var _this15 = this;

      console.log('getDeviceInfo');
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: this.id,
        count: this.deviceCount,
        companyid: this.$route.query.companyId
      };
      this.deviceLoading = true;
      _index.API_Stat.getLoginDevice(param).then(function (res) {
        if (res.data.code == 200) {
          var data = res.data.data;
          data.userCount = parseInt(data.userCount);
          _this15.initChartDevice(res.data.data);
          console.log('res.data==getDeviceInfo', res.data);
        }
        _this15.deviceLoading = false;
      }).then(function (err) {
        _this15.deviceLoading = false;
      });
    },
    chartResize: function chartResize() {
      if (this.chartObjArr.length > 0) {
        this.chartObjArr.forEach(function (item) {
          return item.resize();
        });
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.chartResize);
  },
  mounted: function mounted() {

    window.addEventListener("resize", this.chartResize);
    this.getProductSum();
    this.getGroupProductSum();
    this.getDueProductSum();
    this.getUnusedProductSum();
    this.getDueInMonthProductSum();
    this.getCompanyUserMonthPointList();
    this.getCompanyMonthPointBrokenLine();
    this.getCompanyMonthModulePointPie();

    this.getDeviceInfo();
  },

  watch: {},
  created: function created() {
    this.companyuseid = this.comId;
    this.getCookie();
  }
};

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  data: function data() {
    return {
      value1: true,
      checkCode: '',
      token: ''
    };
  },
  created: function created() {
    var _this = this;

    this.getCookie();
    var param = {
      id: this.$route.query.companyId,
      token: this.token,
      checkCode: this.checkCode
    };
    _index.API_Admin.getCompany(param).then(function (res) {
      _this.value1 = res.data.data.isbinding == 1 ? true : false;
    });
  },

  methods: {
    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          }
        }
      }
    },
    submit: function submit() {
      var _this2 = this;

      var param = {
        id: this.$route.query.companyId,
        isbinding: this.value1 ? 1 : 0,
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.hardwareBinding(param).then(function (res) {
        _this2.$message.success("修改成功");
      });
    }
  }
};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DetailPage = __webpack_require__(226);

var _DetailPage2 = _interopRequireDefault(_DetailPage);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      modulename: this.$route.query.modulename,
      tiemSlot: [this.$route.query.startData, this.$route.query.endDate],
      order: '',
      orderType: 'desc',
      showzero: 1,
      mokuais: [{
        value: 1,
        label: '显示不为0的数据'
      }, {
        value: 2,
        label: '显示为0的数据'
      }],
      count: this.$route.query.count,
      jifen: this.$route.query.jifen,
      token: '',
      checkCode: '',
      id: '',
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      moduleid: this.$route.query.moduleid,
      list: [],
      params: {
        type: this.$route.query.type,
        pageNumber: this.$route.query.pageNumber,
        pageSize: this.$route.query.pageSize
      }
    };
  },

  components: {
    DetailPage: _DetailPage2.default
  },
  mounted: function mounted() {
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; ');
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=');
        if (arr2[0] == 'dnnyptadmin_token') {
          this.token = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_checkCode') {
          this.checkCode = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_id') {
          this.id = arr2[1];
        }
      }
    }
    this.getData();
  },

  methods: {
    downFile: function downFile() {
      var _this = this;

      var downHref = _index.API__DailyStatistic.exportmodellist() + '?token=' + this.token + '&checkCode=' + this.checkCode + '&orderType=' + this.orderType + '&moduleid=' + this.moduleid + '&dBegin=' + this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD') + '&dEnd=' + this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD') + '&order=' + this.order + '&listType=page' + '&pageSize=9999' + '&pageNumber=1' + '&showzero=1' + '&modulename=' + this.modulename;

      var a = document.createElement('a');

      fetch(downHref).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        a.href = URL.createObjectURL(blob);
        a.download = _this.modulename;
        document.body.appendChild(a);
        a.click();
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleSortChange: function handleSortChange(val) {
      if (val.order == null) {
        this.order = '';
        this.orderType = '';
        this.getData();
      } else {
        this.order = val.prop;
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
        this.getData();
      }
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    create: function create(item) {
      var idStr = Date.now().toString(36);
      idStr += Math.random().toString(36).substr(3);
      return idStr;
    },
    changeData: function changeData() {
      this.getData();
    },
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        order: this.order,
        orderType: this.orderType,
        moduleid: this.moduleid,
        dBegin: this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD'),
        dEnd: this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD'),
        showzero: this.showzero
      };
      _index.API__DailyStatistic.getTbModuleDetails(param).then(function (res) {
        _this2.loading = false;
        _this2.list = res.data.data.list;
        _this2.total = res.data.data.totalRow;
        _this2.count = res.data.data.totalRow;
      });
    },
    indexchange: function indexchange(index) {
      if (index == 0) {
        return 'contextEc1';
      } else if (index == 1) {
        return 'contextEc2';
      } else {
        if (index % 2 == 0) {
          return 'contextEc3';
        } else {
          return 'contextEc4';
        }
      }
    }
  }
};

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DetailPage = __webpack_require__(226);

var _DetailPage2 = _interopRequireDefault(_DetailPage);

var _index = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      modulename: this.$route.query.modulename,
      tiemSlot: [this.$route.query.startData, this.$route.query.endDate],
      order: '',
      orderType: 'desc',
      mokuais: [{
        value: 1,
        label: '显示不为0的数据'
      }, {
        value: 2,
        label: '显示为0的数据'
      }],
      count: this.$route.query.count,
      jifen: this.$route.query.jifen,
      token: '',
      checkCode: '',
      id: '',
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      moduleid: this.$route.query.moduleid,
      list: [],
      params: {
        type: this.$route.query.type,
        moduleid: this.$route.query.moduleid,
        pageNumber: this.$route.query.pageNumber,
        pageSize: this.$route.query.pageSize
      }
    };
  },

  components: {
    DetailPage: _DetailPage2.default
  },
  mounted: function mounted() {
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; ');
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=');
        if (arr2[0] == 'dnnyptadmin_token') {
          this.token = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_checkCode') {
          this.checkCode = arr2[1];
        } else if (arr2[0] == 'dnnyptadmin_id') {
          this.id = arr2[1];
        }
      }
    }
    this.getData();
  },

  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleSortChange: function handleSortChange(val) {
      if (val.order == null) {
        this.order = '';
        this.orderType = '';
        this.getData();
      } else {
        this.order = val.prop;
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
        this.getData();
      }
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    create: function create(item) {
      var idStr = Date.now().toString(36);
      idStr += Math.random().toString(36).substr(3);
      return idStr;
    },
    changeData: function changeData() {
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      this.loading = true;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        order: this.order,
        orderType: this.orderType,
        moduleid: this.moduleid,
        dBegin: this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD'),
        dEnd: this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD')
      };
      _index.API__DailyStatistic.getModuleUser(param).then(function (res) {
        _this.loading = false;
        _this.list = res.data.data.list;
        _this.total = res.data.data.totalRow;
        _this.count = res.data.data.totalRow;
      });
    },
    indexchange: function indexchange(index) {
      if (index == 0) {
        return 'contextEc1';
      } else if (index == 1) {
        return 'contextEc2';
      } else {
        if (index % 2 == 0) {
          return 'contextEc3';
        } else {
          return 'contextEc4';
        }
      }
    },
    downFile: function downFile() {
      var downHref = _index.API__DailyStatistic.getUserPointExcel() + '?token=' + this.token + '&checkCode=' + this.checkCode + '&orderType=' + this.orderType + '&moduleid=' + this.moduleid + '&dBegin=' + this.$moment(this.tiemSlot[0]).format('YYYY-MM-DD') + '&dEnd=' + this.$moment(this.tiemSlot[1]).format('YYYY-MM-DD') + '&order=' + this.order + '&listType=page' + '&pageSize=' + this.count;

      var a = document.createElement('a');

      fetch(downHref).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        a.href = URL.createObjectURL(blob);
        a.download = '模块用户积分列表';
        document.body.appendChild(a);
        a.click();
      });
    }
  }
};

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      token: '',
      checkCode: '',
      id: '',
      souchs: {},
      typeList: [],
      listLoading: false,
      pageNumber: 1,
      total: 0,
      pageSize: 20,

      addForm: {},
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: '请输入类型名称', trigger: 'blur' }]

      },

      editFormVisible: false,
      editForm: {},
      editLoading: false,
      editFormRules: {
        name: [{ required: true, message: '请输入类型名称', trigger: 'blur' }]
      },
      orderType: '',
      orderStr: ''
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
    },
    editSubmit: function editSubmit() {
      var _this = this;

      if (!this.editForm.name) {
        this.$message.error('类型名称不可为空！');
        return;
      }
      if (!this.editForm.code && this.editForm.code != 0) {
        this.$message.error('类型ID不可为空！');
        return;
      }
      var param = {
        id: this.editForm.id,
        token: this.token,
        checkCode: this.checkCode,
        mode: '',
        code: this.editForm.code,
        name: this.editForm.name
      };
      this.editLoading = true;
      _index.API_Menu.upTypeList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.$message({
            message: '修改成功',
            type: 'success'
          });
          _this.getTypeList();
        } else {
          _this.$message.error(res.data.message);
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.editLoading = false;
        _this.editFormVisible = false;
      }).catch(function (err) {
        _this.editLoading = false;
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm('确认删除该类型吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var para = {
          id: row.id,
          token: _this2.token,
          checkCode: _this2.checkCode
        };
        _index.API_Menu.delTypeList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this2.$message({
              message: '删除成功',
              type: 'success'
            });
            _this2.getTypeList();
          } else {
            _this2.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function () {
          _this2.$message.error('服务器异常，请您稍后再试..');
        });
      });
    },

    addSubmit: function addSubmit() {
      var _this3 = this;

      if (!this.addForm.name) {
        this.$message.error('类型名称不可为空！');
        return;
      }
      if (!this.addForm.code && this.addForm.code != 0) {
        this.$message.error('类型ID不可为空！');
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        code: this.addForm.code,
        name: this.addForm.name
      };
      this.addLoading = true;
      _index.API_Menu.upTypeList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '添加成功',
            type: 'success'
          });
          _this3.getTypeList();
        } else {
          _this3.$message.error(res.data.message);
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
        _this3.addLoading = false;
        _this3.addFormVisible = false;
      }).catch(function (err) {
        _this3.addLoading = false;
        _this3.$message.error('服务器异常，请您稍后再试..');
      });
    },
    handleAdd: function handleAdd() {
      this.addFormVisible = true;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getTypeList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTypeList();
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "code") {
          this.orderStr = "codepx";
        } else if (val.prop == "intime") {
          this.orderStr = "intimepx";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getTypeList();
    },
    getTypeList: function getTypeList(val) {
      var _this4 = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        searchStr: this.souchs.name,
        orderType: this.orderType,
        orderStr: this.orderStr
      };
      _index.API_Menu.getTypeList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.total = res.data.data.totalPage;
          _this4.typeList = res.data.data.list;
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this4.$message.error('服务器异常，请您稍后再试..');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }

  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getTypeList();
  }
};

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      editFormList: {},
      editVisibleList: false,
      editLoadingList: false,
      editListSouch: {},

      addListVisible: false,
      addListForm: {},
      addListLoading: false,

      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,

      souchs: {
        modelName: ''
      },
      token: '',
      checkCode: '',
      id: '',
      listLoading: false,
      models: [],
      total: 0,
      pageNumber: 1,
      pageSize: 20,
      addForm: {
        moduleid: '',
        modulename: ''
      },
      addFormRules: {
        modulename: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        moduleid: [{ required: true, message: '请输入模块ID', trigger: 'blur' }]
      },
      addFormVisible: false,
      addLoading: false,

      editForm: {
        moduleid: '',
        modulename: ''
      },
      editLoading: false,
      editFormRules: {
        modulename: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        moduleid: [{ required: true, message: '请输入模块ID', trigger: 'blur' }]
      },
      editFormVisible: false,

      modulenames: '',
      moduleids: '',
      editList: [],
      editListVisible: false,
      editListLoading: false,
      orderType: '',
      orderStr: ''
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    editSubmit: function editSubmit() {
      var _this = this;

      if (!this.editForm.modulename && this.editForm.modulename != 0) {
        this.$message.error('名称不可为空！');
        return;
      };
      if (!this.editForm.moduleid && this.editForm.moduleid != 0) {
        this.$message.error('模块ID不可为空！');
        return;
      };
      var param = {
        id: this.editForm.id,
        token: this.token,
        checkCode: this.checkCode,
        mode: 'update',
        moduleid: this.editForm.moduleid,
        modulename: this.editForm.modulename
      };
      this.editLoading = true;
      _index.API_Models.setAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.$message({
            message: '新增成功',
            type: 'success',
            center: true
          });

          _this.editFormVisible = false;
          _this.getModels();
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.editLoading = false;
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
        _this.editLoading = false;
      });
    },
    addSubmit: function addSubmit() {
      var _this2 = this;

      if (!this.addForm.modulename && this.addForm.modulename != 0) {
        this.$message.error('名称不可为空！');
        return;
      };
      if (!this.addForm.moduleid && this.addForm.moduleid != 0) {
        this.$message.error('模块ID不可为空！');
        return;
      };
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        moduleid: this.addForm.moduleid,
        modulename: this.addForm.modulename
      };
      this.addLoading = true;
      _index.API_Models.setAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: '新增成功',
            type: 'success',
            center: true
          });

          _this2.addFormVisible = false;
          _this2.getModels();
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.addLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.addLoading = false;
      });
    },

    handleAdd: function handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        name: '',
        modelID: ''
      };
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getModels();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getModels();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getZJ();
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "modulename") {
          this.orderStr = "modulenameOrder";
        } else if (val.prop == "moduleid") {
          this.orderStr = "moduleidOrder";
        } else if (val.prop == "intime") {
          this.orderStr = "intimeOrder";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getModels();
    },
    getModels: function getModels(val) {
      var _this3 = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        searchModuleName: this.souchs.modelName,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,

        orderStr: this.orderStr,
        orderType: this.orderType
      };
      this.listLoading = true;
      _index.API_Models.getAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            _this3.total = res.data.data.totalRow;
            _this3.models = res.data.data.list;
          }
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
        _this3.listLoading = false;
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
        _this3.listLoading = false;
      });
    },

    handleDel: function handleDel(index, row) {
      var _this4 = this;

      this.$confirm('确认删除该模块吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var para = {
          id: row.id,
          token: _this4.token,
          checkCode: _this4.checkCode
        };
        _index.API_Models.delAdminModule(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this4.$message({
              message: '删除成功',
              type: 'success'
            });
            _this4.getModels();
          } else {
            _this4.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this4.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this4.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },

    handleList: function handleList(index, row) {
      this.editListVisible = true;
      this.modulenames = row.modulename;
      this.moduleids = row.moduleid;
      this.getZJ();
    },
    getZJ: function getZJ(val) {
      var _this5 = this;

      if (val == 1) {
        this.pageNumber2 = 1;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        parentid: this.moduleids,
        searchStr: this.editListSouch.name,
        listType: 'page',
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2
      };
      _index.API_Models.getAdminModuleTwo(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.total2 = res.data.data.totalRow;
          _this5.editList = res.data.data.list;
        }
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
      });
    },
    editListDel: function editListDel(index, row) {
      var _this6 = this;

      this.$confirm('确认删除该模块吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this6.token,
          checkCode: _this6.checkCode,
          id: row.id,
          parentid: _this6.moduleids,
          moduleid: row.moduleid
        };
        _index.API_Models.delAdminModule(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this6.$message({
              message: '删除成功',
              type: 'success'
            });
            _this6.getZJ();
          }
        }).catch(function (err) {
          _this6.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },

    editSubmitList: function editSubmitList() {
      var _this7 = this;

      if (!this.editFormList.modulename && this.editFormList.modulename != 0) {
        this.$message.error('名称不可为空！');
        return;
      }
      if (!this.editFormList.moduleid && this.editFormList.moduleid != 0) {
        this.$message.error('模块ID不可为空！');
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,

        id: this.editFormList.id,
        moduleid: this.editFormList.moduleid,
        modulename: this.editFormList.modulename,
        mode: '',
        point: this.editFormList.point
      };
      this.editLoadingList = true;
      _index.API_Models.setAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this7.$message({
            message: '修改成功',
            type: 'success'
          });
          _this7.getZJ();
        } else {
          _this7.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this7.$router.push({ path: 'loginAdmin' });
          }
        }
        _this7.editLoadingList = false;
        _this7.editVisibleList = false;
      }).catch(function (err) {
        _this7.editLoadingList = false;
        _this7.$message.error('数据丢失，试试重新登陆！');
      });
    },

    editListEdit: function editListEdit(index, row) {
      this.editVisibleList = true;
      this.editFormList = (0, _assign2.default)({}, row);
    },
    editListAdd: function editListAdd() {
      this.addListVisible = true;
    },
    addListSubmit: function addListSubmit() {
      var _this8 = this;

      if (!this.addListForm.modulename) {
        this.$message.error('名称不可为空！');
        return;
      }
      if (!this.addListForm.moduleid) {
        this.$message.error('模块ID不可为空！');
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        parentid: this.moduleids,
        moduleid: this.addListForm.moduleid,
        modulename: this.addListForm.modulename,
        mode: 'save',
        point: this.addListForm.point
      };
      this.addListLoading = true;
      _index.API_Models.setAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this8.$message({
            message: '添加成功',
            type: 'success'
          });
          _this8.getZJ();
        } else {
          _this8.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this8.$router.push({ path: 'loginAdmin' });
          }
        }
        _this8.addListLoading = false;
        _this8.addListVisible = false;
      }).catch(function (err) {
        _this8.addListLoading = false;
        _this8.$message.error('数据丢失，试试重新登陆！');
      });
    },
    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }

  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getModels();
  }
};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(168);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(103);

var _index3 = _interopRequireDefault(_index2);

var _PictureList = __webpack_require__(752);

var _PictureList2 = _interopRequireDefault(_PictureList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    productInfo: {
      type: Object,
      default: function _default() {
        return null;
      }
    }

  },

  data: function data() {
    return {

      confirmLoading: false,

      token: '',
      checkCode: '',
      myDetail: null,
      myVisible: false,
      totalPrice: 0
    };
  },


  components: {
    PictureList: _PictureList2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  }), {
    evaluatePrice: function evaluatePrice() {
      var _myDetail = this.myDetail,
          purchaseNum = _myDetail.purchaseNum,
          price = _myDetail.price,
          purchaseMonth = _myDetail.purchaseMonth;

      var money = 0;
      money = purchaseNum * purchaseMonth * price;
      this.totalPrice = money;
      return money;
    }
  }),

  created: function created() {
    this.myVisible = this.visible;
  },
  mounted: function mounted() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    this.token = token;
    this.checkCode = checkCode;
    this.myDetail = JSON.parse((0, _stringify2.default)(this.productInfo));

    this.myDetail.purchaseMonth = 1;
  },


  methods: {
    handleChangeNum: function handleChangeNum(val, data, key) {
      console.log("val==", val, typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val));
    },
    handerSubmit: function handerSubmit(processInfo) {
      var _this = this;

      console.log('processInfo==', processInfo);
      var orderId = processInfo.orderId,
          singlePrice = processInfo.singlePrice,
          productId = processInfo.productId,
          purchaseMonth = processInfo.purchaseMonth;

      var data = {
        id: orderId,
        productId: productId,
        purchaseMonth: purchaseMonth,
        price: this.totalPrice,
        singlePrice: singlePrice
      };
      this.confirmLoading = true;

      _index.API_Order.renewOrder(data).then(function (res) {
        if (res.data.code == 200) {
          _this.$message.success('续订成功');
          _this.$emit('getDetail');
          _this.handerClose();
        }
        _this.confirmLoading = false;
      }).catch(function (err) {
        _this.confirmLoading = false;
      });
    },
    handerClose: function handerClose() {
      this.myVisible = false;
      this.$emit('update:visible', false);
    }
  }
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = __webpack_require__(416);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _index = __webpack_require__(6);

var _index2 = __webpack_require__(103);

var _index3 = _interopRequireDefault(_index2);

var _DetailPage = __webpack_require__(226);

var _DetailPage2 = _interopRequireDefault(_DetailPage);

var _SelectedProduct = __webpack_require__(761);

var _SelectedProduct2 = _interopRequireDefault(_SelectedProduct);

var _vuex = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    var _ref;

    return _ref = {
      searchText: '',
      effectiveTime: new Date(),
      effectiveTimeSfm: '00:00:00',
      proName3: "",
      dynamicTags3: [],
      options3: [{ value: 'ID', label: 'ID' }, { value: '企业名称', label: '企业名称' }, { value: '管理员', label: '管理员' }],

      person: '1',
      persons: [{ value: "1", text: "个人用户" }, { value: "2", text: "企业用户" }],

      orderType: '1',
      orderTypes: [{ value: '1', label: '试用订单' }, { value: '2', label: '正式订单' }],

      mode: 'save',
      orderId: '',
      processDetail: null,

      proList: [],
      selectProList: [],
      listLoading: false,
      totalPrice: 0,

      value3: '',

      souchs2: {},
      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName: "",
      dynamicTags: [],
      optionsSouch: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '软件类型', label: '软件类型' }, { value: '邀请状态', label: '邀请状态' }, { value: '开始日期', label: '开始日期' }, { value: '结束日期', label: '结束日期' }],
      value: '',
      inviValues: [],
      softtypes: [],

      souchs3: {
        name: ''
      },
      personList: [],
      personVisible: false,
      personLoading: false,
      pageNumber3: 1,
      pageSize3: 10,
      total3: 0,
      orderLoading: false,
      checkPerson: '',
      checkPersonId: '',

      checkPerson2: '',
      checkPersonOld: '',
      checkPersonIdOld: '',
      flag2: false,

      orderSubLoading: false,

      token: '',
      checkCode: "",
      id: "",
      isDisabled: true,
      orderVisible: false
    }, (0, _defineProperty3.default)(_ref, 'orderLoading', false), (0, _defineProperty3.default)(_ref, 'userLoading', false), (0, _defineProperty3.default)(_ref, 'pageNumber2', 1), (0, _defineProperty3.default)(_ref, 'pageSize2', 10), (0, _defineProperty3.default)(_ref, 'total2', 0), (0, _defineProperty3.default)(_ref, 'users', []), (0, _defineProperty3.default)(_ref, 'flag', false), (0, _defineProperty3.default)(_ref, 'checkUser', ''), (0, _defineProperty3.default)(_ref, 'checkUser2', ''), (0, _defineProperty3.default)(_ref, 'checkUserOld', ''), (0, _defineProperty3.default)(_ref, 'checkUserId', ''), (0, _defineProperty3.default)(_ref, 'checkUserIdOld', ''), (0, _defineProperty3.default)(_ref, 'dialogLoading', false), _ref;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo']), {
    isOrderTest: function isOrderTest() {
      return this.orderType == 1;
    },
    evaluatePrice: function evaluatePrice() {
      var price = 0;
      price = this.selectProList.reduce(function (previousValue, curItem) {
        return previousValue + curItem.purchaseNum * curItem.purchaseMonth * curItem.price;
      }, 0);

      this.totalPrice = price;
      return price;
    }
  }),

  components: {
    DetailPage: _DetailPage2.default,
    SelectedProduct: _SelectedProduct2.default
  },

  created: function created() {
    var _$route$query = this.$route.query,
        mode = _$route$query.mode,
        orderId = _$route$query.orderId;

    this.orderId = orderId;

    this.getCookie();

    if (mode) {
      this.mode = mode;
      this.getDetail();
    } else {
      this.getProList();
    }
    console.log('this.mode==', this.mode);
  },
  mounted: function mounted() {

    this.getUser();
    this.getPerson();
    this.getCode1();
    this.getCode();
  },


  methods: {
    getDetail: function getDetail() {
      var _this2 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: this.$route.query.orderId
      };
      _index.API_Order.detailOrder(param).then(function (res) {
        if (res.data.code == 200) {
          _this2.processDetail = res.data.data;
          try {
            _this2.processDetail.product = JSON.parse(_this2.processDetail.product);
            _this2.processDetail.product.forEach(function (item) {
              item.price = item.singlePrice;
              item.name = item.productName;
              item.logo = '';
              item.id = item.productId;
            });

            var _res$data$data = res.data.data,
                type = _res$data$data.type,
                effectivetime = _res$data$data.effectivetime,
                userid = _res$data$data.userid,
                username = _res$data$data.username,
                companyid = _res$data$data.companyid,
                companyname = _res$data$data.companyname;

            _this2.person = userid ? '1' : '2';

            _this2.checkUserId = userid;
            _this2.checkUser = username;

            _this2.checkPersonId = companyid;
            _this2.checkPerson = companyname;

            _this2.effectiveTime = effectivetime;

            _this2.orderType = type;

            _this2.selectProList = [].concat((0, _toConsumableArray3.default)(_this2.processDetail.product));
            _this2.getProList();
          } catch (e) {
            _this2.processDetail.product = [];
          }
        }
      });
    },
    handerOrderType: function handerOrderType(type) {
      this.totalPrice = type == 1 ? 0 : this.evaluatePrice;
    },
    handerProduct: function handerProduct(data) {
      var index = this.selectProList.findIndex(function (item) {
        return item.id == data.id;
      });
      if (this.selectProList.length == 0 || index == -1) {
        this.selectProList.push(data);
      }

      if (index > -1) {
        this.selectProList = this.selectProList.filter(function (item) {
          return item.id !== data.id;
        });
      }
    },

    getProList: function getProList() {
      var _this3 = this;

      var param = (0, _defineProperty3.default)({
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: 9999,
        purchasable: 0,
        useful: '1'
      }, 'purchasable', '0');
      this.listLoading = true;
      _index.API_Product.productList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.total = res.data.data.totalRow;
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].purchasable) {
              if (res.data.data.list[i].purchasable == 0) {
                res.data.data.list[i].purchasabled = "是";
              } else {
                res.data.data.list[i].purchasabled = "否";
              }
            }
            if (res.data.data.list[i].logo) {
              res.data.data.list[i].logo2 = res.data.data.list[i].logo;
            }
            if (res.data.data.list[i].price) {
              res.data.data.list[i].price = parseFloat(res.data.data.list[i].price);
            }
          }

          res.data.data.list.forEach(function (item) {
            item.purchaseMonth = 1;
            item.purchaseNum = 1;
          });
          _this3.proList = res.data.data.list;
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
        _this3.listLoading = false;
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
        _this3.listLoading = false;
      });
    },

    changeSouch3: function changeSouch3(val) {
      if (val == "ID") {
        this.proName3 = this.souchs3.id;
      } else if (val == "企业名称") {
        this.proName3 = this.souchs3.company;
      } else if (val == "管理员") {
        this.proName3 = this.souchs3.managername;
      }
    },
    changeSouch: function changeSouch(val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName = this.souchs2.phone;
        this.disSouch = true;
      } else if (val == "姓名") {
        this.proName = this.souchs2.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs2.company;
        this.disSouch = true;
      } else if (val == "软件类型") {
        this.disSofttype = true;
      } else if (val == "邀请状态") {
        this.disinvit = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },

    orderSubmit: function orderSubmit() {
      var _this4 = this;

      if (this.selectProList.length == 0) {
        return;
      }
      this.checkPersonId;
      this.person;
      var userIde = '';

      if (this.person == '1') {
        if (!this.checkUserId) {
          this.$message.error('请选择用户！');
          return;
        } else {
          this.checkPersonId = '';
        }
      } else if (this.person == '2') {
        if (!this.checkPersonId) {
          this.$message.error('请选择用户！');
          return;
        } else {
          this.checkUserId = '';
        }
      }

      this.totalPrice = this.orderType == '1' ? 0 : this.totalPrice;

      if (this.orderType == 2 && this.totalPrice === '') {
        this.$message.error('请填写总价');
        return;
      }

      var pruductJson = [];
      pruductJson = this.selectProList.map(function (item) {
        return {
          "productId": item.id,
          "productName": item.name,
          "purchaseMonth": item.purchaseMonth,
          "purchaseNum": item.purchaseNum,
          "singlePrice": item.price,
          "logo": item.logo
        };
      });

      if (!this.effectiveTime) {
        this.$message.error('请选择生效时间');
        return;
      }
      var effectiveTime = _index3.default.formatDateGu(this.effectiveTime) + ' ' + this.effectiveTimeSfm;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: this.orderType,
        adminuserid: this.id,
        price: this.totalPrice,
        userid: this.checkUserId,
        companyid: this.checkPersonId,
        pruductJson: (0, _stringify2.default)(pruductJson),
        mode: this.mode,
        effectiveTime: effectiveTime
      };

      if (this.mode == 'update') {
        param.id = this.orderId;
      }
      console.log("param==", param);
      this.orderSubLoading = true;
      _index.API_Order.addOrder(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: '提交成功',
            type: 'success'
          });
          _this4.$router.push({ path: 'orderList' });
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
        _this4.orderSubLoading = false;
      }).catch(function (err) {
        _this4.orderSubLoading = false;
        _this4.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getPerson: function getPerson(val) {
      var _this5 = this;

      var _this = this;
      if (this.value3 == "ID") {
        this.souchs3.id = this.proName3;
      }
      if (this.value3 == "企业名称") {
        this.souchs3.company = this.proName3;
      }
      if (this.value3 == "管理员") {
        this.souchs3.managername = this.proName3;
      }
      var flags = true;
      if (val == 1) {
        if (this.value3) {
          if (this.dynamicTags3.length > 0) {
            for (var i = 0; i < this.dynamicTags3.length; i++) {
              if (this.value3 == this.dynamicTags3[i]) {
                flags = false;
              }
            }
          }
          if (flags) {
            this.dynamicTags3.push(this.value3);
          }
        }
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber3,
        pageSize: this.pageSize3,
        userType: '',
        listType: 'page',
        managename: this.souchs3.managename,
        id: this.souchs3.id,
        company: this.souchs3.company,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        isCompanyUser: this.person,
        searchText: this.searchText
      };
      this.dialogLoading = true;
      _index.API_User.companyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            _this.total3 = res.data.data.totalRow;
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i] && _this.checkPersonId && _this.checkPersonId == res.data.data.list[i].id) {
                res.data.data.list[i].checked = true;
              } else {
                res.data.data.list[i].checked = false;
              }
            }
            _this.personList = res.data.data.list;
          }
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }

        _this5.dialogLoading = false;
      }).catch(function (err) {
        _this5.dialogLoading = false;
        _this.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getUser: function getUser(val) {
      var _this6 = this;

      var _this = this;
      if (this.value == "账号") {
        this.souchs2.phone = this.proName;
      }
      if (this.value == "企业") {
        this.souchs2.company = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs2.name = this.proName;
      }
      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber2,
        pageSize: this.pageSize2,
        username: this.souchs2.name,
        phone: this.souchs2.phone,
        company: this.souchs2.company,
        registertimefrom: this.souchs2.fromtime,
        registertimeto: this.souchs2.totime,
        softtype: this.souchs2.softtype,
        invitestatus: this.souchs2.invitValue,
        userType: '',
        listType: 'page',

        role: this.userInfo.type,
        userId: this.userInfo.id,
        isCompanyUser: this.person,
        searchText: this.searchText
      };
      this.dialogLoading = true;
      _index.API_User.userList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {

            _this6.total2 = res.data.data.totalRow;
            for (var i = 0; i < res.data.data.list.length; i++) {
              if (res.data.data.list[i] && _this6.checkUserId && res.data.data.list[i].id == _this6.checkUserId) {
                res.data.data.list[i].checked = true;
              } else {
                res.data.data.list[i].checked = false;
              }
            }
            _this6.users = res.data.data.list;
          }
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
        _this6.dialogLoading = false;
      }).catch(function (err) {
        _this6.dialogLoading = false;
        _this6.$message.error('数据丢失，试试重新登陆！');
      });
    },

    changeFun: function changeFun(e, val) {},
    changeFun3: function changeFun3(e, val) {},
    handleSelectionChange: function handleSelectionChange(row, column, event) {
      var _this7 = this;

      if (event.target.className.indexOf('el-checkbox__inner') > -1) {
        return;
      }
      this.flag = true;
      this.users.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
          _this7.$set(item, 'checked', false);
        }
        if (item.id == row.id) {
          item.checked = true;
          _this7.$set(item, 'checked', true);
        }
      });
      if (row.name == null) {
        row.name = "";
      }
      if (row.phone == null) {
        row.phone = "";
      }
      this.checkUser2 = row.name + ' ' + row.phone;
      this.checkUserOld = row.name + ' ' + row.phone;
      this.checkUserId = row.id;
      this.checkUserIdOld = row.id;
    },
    handleSelectionChange3: function handleSelectionChange3(row, column, event) {
      if (event.target.className.indexOf('el-checkbox__inner') > -1) {
        return;
      }
      this.flag2 = true;
      this.personList.forEach(function (item) {
        if (item.id !== row.id) {
          item.checked = false;
        }
        if (item.id == row.id) {
          item.checked = true;
        }
      });
      this.checkPerson2 = row.name;
      this.checkPersonOld = row.name;
      this.checkPersonId = row.id;
      this.checkPersonIdOld = row.id;
    },
    handleCurrentChange3: function handleCurrentChange3(val) {
      this.pageNumber3 = val;
      this.getPerson();
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this.pageNumber2 = val;
      this.getUser();
    },

    handleUser: function handleUser(val) {
      if (val == 1) {
        this.souchs2 = {};
        this.proName = '';
        this.value = '';
        this.dynamicTags = [];
        this.orderVisible = true;
        this.getUser();
      } else {
        this.souchs3 = {}, this.value3 = '';
        this.proName3 = '';
        this.dynamicTags3 = [];
        this.personVisible = true;
        this.getPerson();
      }
    },
    orderUserSubmit: function orderUserSubmit() {
      if (!this.checkUser2) {
        this.$message.error('请选择用户！');
        return;
      }
      this.checkUser = this.checkUser2;
      this.orderVisible = false;
      this.searchText = '';
    },
    orderPersonSubmit: function orderPersonSubmit() {
      if (!this.checkPerson2) {
        this.$message.error('请选择用户！');
        return;
      }
      this.checkPerson = this.checkPerson2;
      this.personVisible = false;
      this.searchText = '';
    },

    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    bak: function bak() {
      this.$router.push({ path: 'orderList' });
    },
    getCode1: function getCode1() {
      var _this8 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var json = { 'value': res.data.data[i].code, 'label': res.data.data[i].name };
            _this.softtypes.push(json);
          }
        } else {
          _this8.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this8.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    getCode: function getCode() {
      var _this9 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "label": res.data.data[i].name };
            _this.inviValues.push(jsons);
          }
        } else {
          _this9.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this9.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },
    delTags: function delTags() {
      this.souchs2 = {};
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.getUser();
    },
    handleClose: function handleClose(tag) {
      if (tag == "账号") {
        this.souchs2.phone = '';
        if (this.value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs2.name = '';
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs2.company = '';
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "软件类型") {
        this.souchs2.softtype = "";
      }
      if (tag == "邀请状态") {
        this.souchs2.invitValue = "";
      }
      if (tag == "开始日期") {
        this.souchs2.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs2.totime = "";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    delTags3: function delTags3() {
      this.souchs3 = {}, this.value3 = '';
      this.proName3 = '';
      this.dynamicTags3 = [];
      this.getPerson();
    },
    handleClose3: function handleClose3(tag) {
      if (tag == "ID") {
        this.souchs3.id = '';
        if (this.value3 == "ID") {
          this.proName3 = '';
        }
      }
      if (tag == "企业名称") {
        this.souchs3.company = '';
        if (this.value3 == "企业名称") {
          this.proName3 = '';
        }
      }
      if (tag == "管理员") {
        this.souchs3.managername = '';
        if (this.value3 == "管理员") {
          this.proName3 = '';
        }
      }
      this.dynamicTags3.splice(this.dynamicTags3.indexOf(tag), 1);
    }
  }

};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _DetailPage = __webpack_require__(226);

var _DetailPage2 = _interopRequireDefault(_DetailPage);

var _SelectedProduct = __webpack_require__(761);

var _SelectedProduct2 = _interopRequireDefault(_SelectedProduct);

var _ModalFormOrder = __webpack_require__(1697);

var _ModalFormOrder2 = _interopRequireDefault(_ModalFormOrder);

var _index2 = __webpack_require__(103);

var _index3 = _interopRequireDefault(_index2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      pageLoading: true,
      dialogLoading: false,
      orderId: '',
      detailType: '1',

      token: '',
      checkCode: '',

      processDetail: null,
      comments: '',
      isShowComment: false,
      isShowError: false,

      visibleRenew: false,
      productInfo: null,
      productList: [],
      param: {
        searchText: this.$route.query.searchText,
        souType: this.$route.query.souType,
        souAccount: this.$route.query.souAccount,
        fromtime: this.$route.query.fromtime,
        totime: this.$route.query.totime,
        pageNumber: this.$route.query.pageNumber,
        pageSize: this.$route.query.pageSize
      }
    };
  },


  components: {
    DetailPage: _DetailPage2.default,
    SelectedProduct: _SelectedProduct2.default,
    ModalFormOrder: _ModalFormOrder2.default
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  created: function created() {
    var _utils$getParamsByCoo = _index3.default.getParamsByCookie(),
        token = _utils$getParamsByCoo.token,
        checkCode = _utils$getParamsByCoo.checkCode;

    var _$route$query = this.$route.query,
        type = _$route$query.type,
        orderId = _$route$query.orderId;

    this.orderId = orderId;
    this.detailType = type;
    this.token = token;
    this.checkCode = checkCode;

    this.getDetail(token, checkCode);
  },


  methods: {
    getDetail: function getDetail(token, checkCode) {
      var _this = this;

      var param = {
        token: token,
        checkCode: checkCode,
        id: this.$route.query.orderId
      };
      this.pageLoading = true;
      _index.API_Order.detailOrder(param).then(function (res) {
        if (res.data.code == 200) {
          _this.processDetail = res.data.data;
          try {

            _this.processDetail.auProList.forEach(function (item) {
              item.price = item.singlePrice;
              item.name = item.productName;
            });
          } catch (e) {
            _this.processDetail.product = [];
          }
        }
        _this.pageLoading = false;
      });
    },
    handerChangeComments: function handerChangeComments(val) {
      this.isShowError = val ? false : true;
    },
    handerVerify: function handerVerify(status) {
      var _this2 = this;

      if (status == 1 && !this.comments) {
        this.isShowError = true;
        return;
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,

        id: this.$route.query.orderId,
        stateverify: status
      };

      status == 1 && (param.comments = this.comments);
      this.dialogLoading = true;
      _index.API_Order.verifyOrder(param).then(function (res) {
        if (res.data.code == 200) {
          _this2.$message.success('审核成功');
          _this2.$router.push({ path: 'orderList' });
        }
        _this2.dialogLoading = false;
      });
    },
    handleRenewOrder: function handleRenewOrder(product) {
      this.productInfo = product;

      this.productInfo.orderId = this.orderId;
      var _processDetail = this.processDetail,
          companyid = _processDetail.companyid,
          userid = _processDetail.userid,
          companyname = _processDetail.companyname,
          username = _processDetail.username;

      this.productInfo.typeId = companyid || userid;

      this.productInfo.ower = companyid ? companyname : username;
      this.visibleRenew = true;
    }
  }
};

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  data: function data() {
    return {
      proList3: [],
      userType: '',
      checkPerson: '',

      person: '',

      proType: '',
      disCheckBox: false,
      ygPrice: 0,
      allPrice: 0,
      checkList: [],
      proList: [],
      proList2: [],
      listLoading: false,
      token: '',
      checkCode: "",
      id: "",
      isDisabled: true,

      orderVisible: false,
      orderLoading: false,

      userLoading: false,
      pageNumber2: 1,
      pageSize2: 10,
      total2: 0,
      souchs2: {
        modelName: ''
      },
      users: [],
      checkUser: '',
      checkUser2: '',
      checkUserId: '',
      pruductJson: []

    };
  },

  methods: {
    indexMethod: function indexMethod(index) {
      return index + 1;
    },

    getProList: function getProList() {
      var _this2 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: '1',
        pageSize: '9999',
        useful: '1',
        purchasable: '0'
      };
      this.listLoading = true;
      _index.API_Product.productList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.total = res.data.data.totalRow;
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].purchasable) {
              if (res.data.data.list[i].purchasable == 0) {
                res.data.data.list[i].purchasabled = "是";
              } else {
                res.data.data.list[i].purchasabled = "否";
              }
            }
            if (res.data.data.list[i].logo) {
              res.data.data.list[i].logo2 = res.data.data.list[i].logo;
            }
            if (res.data.data.list[i].price) {
              res.data.data.list[i].price = parseFloat(res.data.data.list[i].price);
              res.data.data.list[i].price2 = res.data.data.list[i].price.toLocaleString();
            }
          }
          _this.proList = res.data.data.list;
          if (_this.proList.length > 0 && _this.proList2.length > 0) {
            _this.logoNamePush(_this.proList, _this.proList2);
          }
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
        _this2.listLoading = false;
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    getUser: function getUser(ide) {
      var _this3 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: ide
      };
      _index.API_User.getUserDetail(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.checkUser = '';
          if (res.data.data.name) {
            _this3.checkUser = res.data.data.name;
          }
          if (res.data.data.phone) {
            _this3.checkUser = _this3.checkUser + ' ' + res.data.data.phone;
          }
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },
    getDetail: function getDetail() {
      var _this4 = this;

      var _this = this;

      var myId = this.$route.query.id;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: myId
      };
      _index.API_Order.detailOrder(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.proList2 = JSON.parse(res.data.data.product);
          if (_this.proList2.length > 0 && _this.proList.length > 0) {
            _this.logoNamePush(_this.proList, _this.proList2);
          }
          _this.allPrice = res.data.data.price;
          if (_this.allPrice) {
            _this.allPrice = parseFloat(_this.allPrice);
            _this.allPrice = _this.allPrice.toLocaleString();
          }
          if (res.data.data.companyid) {
            _this.person = '2';
            _this.userType = '企业用户';
            _this.checkPerson = _this4.$route.query.name;
          } else {
            _this.person = '1';
            _this.userType = '个人用户';
            _this.checkUserId = res.data.data.userid;
            _this.getUser(res.data.data.userid);
          }
          _this.getProList();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
      });
    },
    logoNamePush: function logoNamePush(proList, proList2) {
      console.log(proList);
      console.log(proList2);
      this.ygPrice = 0;
      for (var i = 0; i < proList2.length; i++) {
        for (var k = 0; k < proList.length; k++) {
          if (proList2[i].productId == proList[k].id) {
            console.log(222);
            this.proList2[i].logo2 = proList[k].logo2;
            this.proList2[i].name = proList[k].name;
            this.proList2[i].price = proList[k].price;
            if (this.proList2[i].price) {
              this.proList2[i].price = parseFloat(this.proList2[i].price);
              this.proList2[i].price2 = this.proList2[i].price.toLocaleString();
            }
          }
        }

        this.ygPrice = this.ygPrice + this.proList2[i].purchaseNum * this.proList2[i].purchaseMonth * this.proList2[i].price;
      }
      if (this.ygPrice) {
        this.ygPrice = parseFloat(this.ygPrice);
        this.ygPrice = this.ygPrice.toLocaleString();
      }
      this.proList3 = this.proList2;
    },
    bak: function bak() {
      this.$router.push({
        path: '/orderList',
        query: {
          dynamicTags: this.$route.query.dynamicTags,
          souchs: this.$route.query.souchs,
          type: 1,
          pageNumber: this.$route.query.pageNumber
        }
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.getCookie();
    this.getDetail();
  },
  beforeMount: function beforeMount() {}
};

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      disSouch: true,
      disType: false,
      disAccountType: false,
      disTime1: false,
      disTime2: false,
      token: '',
      checkCode: "",
      id: "",
      listLoading: false,
      dataList: [],
      souchs: {
        id: '',
        name: '',
        usercompany: '',
        souType: this.$route.query.souType ? this.$route.query.souType : '',
        adminusername: '',
        souAccount: this.$route.query.souAccount ? this.$route.query.souAccount : '',
        price: '',
        fromtime: this.$route.query.fromtime ? this.$route.query.fromtime : '',
        totime: this.$route.query.totime ? this.$route.query.totime : ''
      },

      proName: '',
      pageNumber: this.$route.query.pageNumber ? this.$route.query.pageNumber : 1,
      pageSize: this.$route.query.pageSize ? this.$route.query.pageSize : 20,
      total: 0,
      options: [{ value: 'ID', label: 'ID' }, { value: '用户', label: '用户' }, { value: '企业', label: '企业' }, { value: '类型', label: '类型' }, { value: '订单', label: '订单' }, { value: '操作人', label: '操作人' }, { value: '价格', label: '价格' }, { value: '开始日期', label: '开始日期' }, { value: '结束日期', label: '结束日期' }],
      value: '',
      types: [{ value: '1', label: '试用' }, { value: '2', label: '正式' }],
      accountType: '',
      accountTypes: [{ value: '0', label: '个人订单' }, { value: '1', label: '企业订单' }],
      typeValue: '',
      dynamicTags: [],

      orderStr: "intimepx",
      orderType: 'desc',
      searchText: this.$route.query.searchText
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "id") {
          this.orderStr = "idpx";
        } else if (val.prop == "name") {
          this.orderStr = "namepx";
        } else if (val.prop == "phone") {
          this.orderStr = "phonepx";
        } else if (val.prop == "typename") {
          this.orderStr = "typepx";
        } else if (val.prop == "intime") {
          this.orderStr = "intimepx";
        } else if (val.prop == "adminusername") {
          this.orderStr = "adminuserpx";
        } else if (val.prop == "price2") {
          this.orderStr = "pricepx";
        } else if (val.prop == "usercompany") {
          this.orderStr = "usercompanypx";
        }

        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },

    changeSouch: function changeSouch(val) {
      this.disAccountType = false;
      this.disSouch = false;
      this.disType = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "类型") {
        this.typeValue = this.souchs.souType;
        this.disType = true;
      } else if (val == "ID") {
        this.proName = this.souchs.id;
        this.disSouch = true;
      } else if (val == "用户") {
        this.proName = this.souchs.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs.usercompany;
        this.disSouch = true;
      } else if (val == "操作人") {
        this.proName = this.souchs.adminusername;
        this.disSouch = true;
      } else if (val == "价格") {
        this.proName = this.souchs.price;
        this.disSouch = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      } else if (val == "订单") {
        this.accountType = this.souchs.souAccount;
        this.disAccountType = true;
      }
    },

    getList: function getList(val) {
      var _this = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      if (this.value == "ID") {
        this.souchs.id = this.proName;
      }
      if (this.value == "用户") {
        this.souchs.name = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.usercompany = this.proName;
      }
      if (this.value == "类型") {
        this.souchs.souType = this.typeValue;
      }
      if (this.value == "订单") {
        this.souchs.souAccount = this.accountType;
      }
      if (this.value == "操作人") {
        this.souchs.adminusername = this.proName;
      }
      if (this.value == "价格") {
        this.souchs.price = this.proName;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        id: this.souchs.id,
        name: this.souchs.name,
        usercompany: this.souchs.usercompany,
        type: this.souchs.souType,
        accountType: this.souchs.souAccount,
        adminusername: this.souchs.adminusername,
        price: this.souchs.price,
        fromtime: this.souchs.fromtime,
        totime: this.souchs.totime,
        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id,
        searchText: this.searchText
      };
      this.listLoading = true;
      _index.API_Order.getOrderList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].price) {
              res.data.data.list[i].price = parseFloat(res.data.data.list[i].price);
              res.data.data.list[i].price2 = res.data.data.list[i].price.toLocaleString();
            } else {
              res.data.data.list[i].price2 = 0;
            }
          }
          _this.dataList = res.data.data.list;
          _this.total = res.data.data.totalRow;
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
        _this.listLoading = false;
      });
    },

    addList: function addList() {
      this.$router.push({ path: '/OrderAdd' });
    },

    handleEdit: function handleEdit(index, row) {

      this.$router.push({ path: 'OrderAdd', query: { orderId: row.id, mode: 'update' } });
    },

    handleDetail: function handleDetail(index, row, flag) {
      this.$router.push({
        path: 'orderDetail',
        query: {
          orderId: row.id,
          type: flag,
          searchText: this.searchText,
          souType: this.souchs.souType,
          souAccount: this.souchs.souAccount,
          fromtime: this.souchs.fromtime,
          totime: this.souchs.totime,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize
        }
      });
    },


    delTags: function delTags() {
      this.souchs = {}, this.souchs.souType = '';
      this.value = '';
      this.typeValue = '';
      this.accountType = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },

    handleClose: function handleClose(tag) {
      if (tag == "类型") {
        this.souchs.souType = "";
        this.typeValue = '';
      }
      if (tag == "订单") {
        this.souchs.souAccount = "";
        this.accountType = '';
      }
      if (tag == "用户") {
        this.souchs.name = "";
        if (this.value == "用户") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.usercompany = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "ID") {
        this.souchs.id = "";
        if (this.value == "ID") {
          this.proName = '';
        }
      }
      if (tag == "操作人") {
        this.souchs.adminusername = "";
        if (this.value == "操作人") {
          this.proName = '';
        }
      }
      if (tag == "价格") {
        this.souchs.price = "";
        if (this.value == "价格") {
          this.proName = '';
        }
      }
      if (tag == "开始日期") {
        this.souchs.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs.totime = "";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm('确认撤销吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this2.userInfo.phone,
          checkCode: _this2.userInfo.checkCode,
          id: row.id,
          role: _this2.userInfo.type,
          userId: _this2.userInfo.id
        };
        _index.API_Order.delOrder(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this2.$message({
              message: '撤销成功',
              type: 'success'
            });
            _this2.getList();
          } else {
            _this2.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this2.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },

  created: function created() {
    this.getCookie();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(168);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {

    productLists: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    isEdit: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {};
  },


  components: {},

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
    userInfo: 'userInfo'
  })),

  mounted: function mounted() {
    console.log('this.productLists==', this.productLists);
  },


  methods: {
    handleChangeNum: function handleChangeNum(val, data, key) {
      console.log("val==", val, typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val));
    },
    handleDel: function handleDel(index, data) {
      console.log("index,data==", index, data);
      this.$emit("del", data);
    },
    handleRenewOrder: function handleRenewOrder(index, row) {
      this.$emit('renew', row);
    }
  }
};

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(23);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = __webpack_require__(20);

var _currency = __webpack_require__(936);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  filters: {
    currency: _currency.currency
  },
  inject: ['reload'],
  data: function data() {
    var _ref;

    return _ref = {
      orderType: '',
      orderStr: '',
      beformAddImg: '',
      editFormVisible: false,
      editForm: {
        useful: '1'
      },
      editLoading: false,
      editImageUrl: '',

      editFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        purchasable: [{ required: true, message: '请选择可购买', trigger: 'blur' }],
        useful: [{ required: true, message: '请选择', trigger: 'blur' }]
      },
      imgs: '',
      userModule: [],
      logo: '',
      cities: [],
      citiesd: [],
      checkedCities: [],
      editCheckedCities: [],
      souchs: {},
      checkCode: '',
      token: '',
      proList: [],
      listLoading: false,
      pageSize: 20,
      pageNumber: 1,
      total: 0,

      addFormVisible: false,
      addForm: {},
      purchasable: '0',
      useful: '1',
      addFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        price: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        purchasable: [{ required: true, message: '请选择', trigger: 'blur' }],
        useful: [{ required: true, message: '请选择', trigger: 'blur' }]
      },
      addLoading: false,
      gms: [{ value: '0', text: '是' }, { value: '1', text: '否' }],

      usefulLists: [{ value: '0', text: '废弃' }, { value: '1', text: '正常' }]

    }, (0, _defineProperty3.default)(_ref, 'editFormVisible', false), (0, _defineProperty3.default)(_ref, 'imageUrl', ''), (0, _defineProperty3.default)(_ref, 'upload', {
      fileList: this.fileList,
      picIds: [],
      postURL: _index.API_Common.setLoglist(),
      dialogImageUrl: '',
      dialogVisible: false,
      data: {
        mode: 'save',
        token: this.token,
        checkCode: this.checkCode,
        type: 1
      }
    }), (0, _defineProperty3.default)(_ref, 'changFalg', false), _ref;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userInfo'])),

  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    priceLose: function priceLose(val) {
      var newPrice;
      if (val == 1) {
        newPrice = this.addForm.price;
      } else {
        newPrice = this.editForm.price;
      }
      if (newPrice) {
        if (isNaN(newPrice)) {
          newPrice = newPrice.replace(/[^\.\d]/g, '');
        }
        if (parseFloat(newPrice).toString() == 'NaN') {
          this.$message.error('指标数为大于0的数, 请重新输入');
          return;
        } else if (newPrice < 0) {
          this.$message.error('指标数为大于0的数, 请重新输入');
          newPrice = 0;
          return;
        } else {
          newPrice = parseFloat(newPrice);
          newPrice = newPrice.toLocaleString();
        }
      } else {
        newPrice = 0;
      }
      if (val == 1) {
        this.addForm.price = newPrice;
      } else {
        this.editForm.price = newPrice;
      }
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;

        this.imageUrl = URL.createObjectURL(file.raw);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error('请选择图片文件');
      }
    },
    closeDialog: function closeDialog() {
      this.$refs['editForm'].clearValidate();
    },

    editSubmit: function editSubmit() {
      var _this2 = this;

      if (!this.editImageUrl && !this.beformAddImg) {
        this.$message.error('请上传图片!');
        return;
      }
      this.$refs['editForm'].validate(function (valid) {
        if (valid) {
          if (_this2.beformAddImg) {
            console.log('xxxxxx');
            var var_this = _this2;
            var formData = new FormData();
            formData.append('pic', _this2.beformAddImg.raw);
            formData.append('token', _this2.token);
            formData.append('checkCode', _this2.checkCode);
            formData.append('oldpicid', _this2.editForm.picid);
            formData.append('mode', 'save');
            var config = {
              'Content-Type': 'multipart/form-data'
            };
            _axios2.default.post(_this2.upload.postURL, formData, config).then(function (res) {
              if (res.data.code == _index.API__code.SUCCESS) {
                var_this.editSave(res.data.data);
                var_this.$refs.upload.clearFiles();
              } else {
                var_this.$message.error(res.data.message);
                if (res.data.code == 403) {
                  var_this.$router.push({ path: 'loginAdmin' });
                }
                return;
              }
            }).catch(function (error) {
              console.log(error);
              return;
            });
          } else {
            _this2.editSave();
          }
        }
      });
    },
    editSave: function editSave(val) {
      var _this3 = this;

      if (val) {
        this.editForm.logo = val.pic;
        this.editForm.picid = val.id;
      }
      if (isNaN(this.editForm.price)) {
        this.editForm.price = this.editForm.price.replace(/[^\.\d]/g, '');
      }
      var param = void 0;
      param = {
        id: this.editForm.id,
        token: this.token,
        checkCode: this.checkCode,
        mode: '',
        name: this.editForm.name,
        price: this.editForm.price,
        purchasable: this.editForm.purchasable,
        module: (0, _stringify2.default)(this.userModule),
        picid: this.editForm.picid,
        useful: this.editForm.useful
      };

      this.editLoading = true;
      _index.API_Product.setProductList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '修改成功',
            type: 'success'
          });
          _this3.getProList();
          _this3.editFormVisible = false;
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
        _this3.editLoading = false;
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
        _this3.editLoading = false;
      });
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      this.userModule = [];
      for (var i = 0; i < value.length; i++) {
        for (var k = 0; k < this.citiesd.length; k++) {
          if (value[i] == this.citiesd[k].modulename) {
            var jsoned = {
              id: this.citiesd[k].id,
              modulename: this.citiesd[k].modulename,
              moduleid: this.citiesd[k].moduleid
            };
            this.userModule.push(jsoned);
          }
        }
      }
    },
    handleCheckedCitiesChange2: function handleCheckedCitiesChange2(value) {
      console.log('value===', value);
      this.changFalg = true;
      this.userModule = [];
      for (var i = 0; i < value.length; i++) {
        for (var k = 0; k < this.citiesd.length; k++) {
          if (value[i] == this.citiesd[k].modulename) {
            var jsoned = {
              id: this.citiesd[k].id,
              modulename: this.citiesd[k].modulename,
              moduleid: this.citiesd[k].moduleid
            };
            console.log(jsoned);
            this.userModule.push(jsoned);
          }
        }
      }
    },

    addSubmit: function addSubmit() {
      var var_this = this;
      if (!this.addForm.name) {
        this.$message.error('请输入名称!');
        return;
      }
      if (!this.addForm.price) {
        this.$message.error('请输入单价!');
        return;
      }
      if (!this.beformAddImg) {
        this.$message.error('请上传图片!');
        return;
      }
      if (!this.purchasable) {
        this.$message.error('请选择可购买!');
        return;
      }
      if (this.userModule.length < 1) {
        this.$message.error('请选择产品模块!');
        return;
      }
      var formData = new FormData();
      formData.append('pic', this.beformAddImg.raw);
      formData.append('token', this.token);
      formData.append('checkCode', this.checkCode);
      formData.append('mode', 'save');
      var config = {
        'Content-Type': 'multipart/form-data'
      };
      _axios2.default.post(this.upload.postURL, formData, config).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var_this.addSave(res.data.data);
          var_this.$refs.upload.clearFiles();
        } else {
          var_this.$message.error(res.data.message);
          if (res.data.code == 403) {
            var_this.$router.push({ path: 'loginAdmin' });
          }
          return;
        }
      }).catch(function (error) {
        console.log(error);
        return;
      });
    },
    addSave: function addSave(val) {
      var _this4 = this;

      var newlbtPath = val.pic;

      var newId = val.id;
      if (isNaN(this.addForm.price)) {
        this.addForm.price = this.addForm.price.replace(/[^\.\d]/g, '');
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        name: this.addForm.name,
        price: this.addForm.price,
        purchasable: this.purchasable,
        module: (0, _stringify2.default)(this.userModule),
        logo: newlbtPath,
        picid: newId,
        useful: this.useful
      };
      this.addLoading = true;
      _index.API_Product.setProductList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: '添加成功',
            type: 'success'
          });
          _this4.purchasable = '0';
          _this4.addFormVisible = false;
          _this4.getProList();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
        _this4.addLoading = false;
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
        _this4.addLoading = false;
      });
    },
    handleAdd: function handleAdd() {
      this.addFormVisible = true;
      this.imageUrl = '';
      this.addForm = {};
      this.beformAddImg = '';
      this.userModule = [];
      this.logo = '';
      this.checkedCities = [];
    },
    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == 'name') {
          this.orderStr = 'namepx';
        } else if (val.prop == 'purchasabled') {
          this.orderStr = 'purchasabledpx';
        } else if (val.prop == 'price') {
          this.orderStr = 'pricepx';
        }
        if (val.order == 'descending') {
          this.orderType = 'desc';
        } else {
          this.orderType = 'asc';
        }
      }
      this.getProList();
    },
    getProList: function getProList(val) {
      var _this5 = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        nameStr: this.souchs.proName,

        orderType: this.orderType,
        orderStr: this.orderStr,
        role: this.userInfo.type,
        userId: this.userInfo.id
      };
      this.listLoading = true;
      _index.API_Product.productList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.total = res.data.data.totalRow;
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].purchasable) {
              if (res.data.data.list[i].purchasable == 0) {
                res.data.data.list[i].purchasabled = '是';
              } else {
                res.data.data.list[i].purchasabled = '否';
              }
            }
            if (res.data.data.list[i].logo) {
              res.data.data.list[i].logo2 = res.data.data.list[i].logo;
            }

            if (res.data.data.list[i].price) {
              res.data.data.list[i].price = parseFloat(res.data.data.list[i].price);
              res.data.data.list[i].price = res.data.data.list[i].price.toLocaleString();
            } else {
              res.data.data.list[i].price = 0;
            }
          }
          _this5.proList = res.data.data.list;
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.listLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.listLoading = false;
      });
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (rowIndex == 0) {
        return 'background:#F5F7FA';
      } else {
        return '';
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getProList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getProList();
    },

    handleEdit: function handleEdit(index, row) {
      this.userModule = [];
      this.beformAddImg = '';
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)({}, row);
      console.log('this.editForm==', this.editForm);

      var cc = JSON.parse(row.module);
      console.log('cc=', cc);
      this.userModule = cc;
      this.editCheckedCities = [];
      this.logo = '';
      for (var i = 0; i < cc.length; i++) {
        this.editCheckedCities.push(cc[i].modulename);
      }
      this.editImageUrl = row.logo2;
    },

    handleDel: function handleDel(index, row) {
      var _this6 = this;

      this.$confirm('确认删除该产品吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var para = {
          id: row.id,
          picid: row.picid,
          token: _this6.token,
          checkCode: _this6.checkCode
        };
        _index.API_Product.delProductList(para).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this6.$message({
              message: '删除成功',
              type: 'success'
            });
            _this6.getProList();
          } else {
            _this6.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this6.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this6.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },
    getModuleList: function getModuleList() {
      var _this7 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Models.getAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this7.models = res.data.data;
          _this7.cities = [];
          _this7.citiesd = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this.cities.push(res.data.data[i].modulename);
            var jsones = {
              modulename: res.data.data[i].modulename,
              id: res.data.data[i].id,
              moduleid: res.data.data[i].moduleid
            };
            _this.citiesd.push(jsones);
          }
        } else {
          _this7.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this7.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this7.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getProList();
    this.getModuleList();
  }
};

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UrlsNumber = __webpack_require__(1705);

var _UrlsNumber2 = _interopRequireDefault(_UrlsNumber);

var _UrlsLBT = __webpack_require__(1704);

var _UrlsLBT2 = _interopRequireDefault(_UrlsLBT);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      activeIndex: '',
      showLBT: true,
      showURL: false
    };
  },

  methods: {
    handleSelect: function handleSelect(key, keyPath) {
      this.showURL = false;
      this.showLBT = false;
      if (key == '1') {
        this.showLBT = true;
        sessionStorage.setItem('admin_menu', '1');
      } else if (key == '2') {
        this.showURL = true;
        sessionStorage.setItem('admin_menu', '2');
      }
    }
  },
  mounted: function mounted() {
    this.activeIndex = sessionStorage.getItem('admin_menu');
    if (this.activeIndex == '2') {
      this.showLBT = false;
      this.showURL = true;
      sessionStorage.setItem('admin_menu', 2);
    } else {
      this.showLBT = true;
      this.showURL = false;
      sessionStorage.setItem('admin_menu', 1);
    }
  },

  components: {
    UrlsLBT: _UrlsLBT2.default,
    UrlsNumber: _UrlsNumber2.default
  }
};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  inject: ['reload'],
  data: function data() {
    return {
      listLoading: false,
      id: '',
      checkCode: '',
      token: '',
      pageSize: 20,
      total: 1,
      pageNumber: 1,
      editImgLoading: false,
      editFormVisible: false,
      editForm: {},
      editImageUrl: '',
      editFormRules: {
        px: [{ required: true, message: '请输入排序', trigger: 'blur' }]
      },
      addFormVisible: false,
      addImgLoading: false,
      lbpic: '',
      lbsltUrl: '',
      imageUrl: '',
      addForm: {},
      addFormRules: {
        px: [{ required: true, message: '请输入排序', trigger: 'blur' }]
      },
      upload: {
        fileList: this.fileList,
        picIds: [],
        postURL: _index.API_Common.upload(),
        dialogImageUrl: '',
        dialogVisible: false,
        data: {
          mode: 'save',
          token: this.token,
          checkCode: this.checkCode,
          type: 1
        }
      },
      rowPX: '',
      imgList: []
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    loseFcous: function loseFcous(index, row) {
      var _this = this;

      var para = {
        token: this.token,
        checkCode: this.checkCode,
        id: row.id
      };
      _index.API_Common.getLBTDetail(para).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data.px) {
            _this.rowPX = res.data.data.px;
            if (!row.px || row.px == _this.rowPX) {
              return row.px = _this.rowPX;
            } else {
              _this.editPx(row.id, row.px);
            }
          }
        }
      });
    },

    editPx: function editPx(id, px) {
      var _this2 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        id: id,
        mode: '',
        px: px
      };
      _index.API_Common.setLBlist(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: '修改成功',
            type: 'success'
          });
          _this2.getlbtList();
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
      });
    },
    imgPreview: function imgPreview(file, fileList) {
      var fileName = file.name;
      var regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;

        this.imageUrl = URL.createObjectURL(file.raw);
        this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error('请选择图片文件');
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getlbtList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getlbtList();
    },

    handleAdd: function handleAdd() {
      this.addFormVisible = true;
      this.addForm = {};
      this.beformAddImg = '';
      this.lbpic = '';
      this.lbsltUrl = '';
      this.imageUrl = '';
    },

    handledel: function handledel(index, row) {
      var _this3 = this;

      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this3.token,
          checkCode: _this3.checkCode,
          id: row.id,
          picid: row.picid
        };
        _index.API_Common.delLBlist(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this3.$message({
              message: '删除成功',
              type: 'success'
            });
            _this3.getlbtList();
          } else {
            _this3.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this3.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this3.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editImageUrl = row.lbtpic2;
      this.editImgId = row.picid;
      this.beformAddImg = '';
      this.editForm = (0, _assign2.default)({}, row);
    },

    addImgSubmit: function addImgSubmit() {
      var var_this = this;
      if (!this.beformAddImg) {
        this.$message.error("请上传图片!");
        return;
      }
      if (!this.addForm.px) {
        this.$message.error("请输入排序号!");
        return;
      }
      var formData = new FormData();
      formData.append('pic', this.beformAddImg.raw);
      formData.append('token', this.token);
      formData.append('checkCode', this.checkCode);
      formData.append('mode', 'save');
      var config = {
        'Content-Type': 'multipart/form-data'
      };
      this.addImgLoading = true;
      _axios2.default.post(this.upload.postURL, formData, config).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          var_this.addSave(res.data.data);
          var_this.$refs.upload.clearFiles();
        } else {
          var_this.$message.error(res.data.message);
          if (res.data.code == 403) {
            var_this.$router.push({ path: 'loginAdmin' });
          }
          return;
        }
      }).catch(function (error) {
        console.log(error);
        return;
      });
    },
    addSave: function addSave(val) {
      var _this4 = this;

      var newId = val.id;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        lbtlink: this.addForm.lbtlink,
        px: this.addForm.px,
        mode: 'save',
        lbtpic: val.pic,
        lbtsltUrl: val.sltUrl,
        lbtfileName: this.addForm.lbtfileName,
        picid: newId,
        type: 1
      };
      _index.API_Common.setLBlist(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.$message({
            message: '保存成功',
            type: 'success'
          });
          _this4.addFormVisible = false;
          _this4.getlbtList();
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
        _this4.addImgLoading = false;
      }).catch(function (err) {
        _this4.$message.error('数据丢失，试试重新登陆！');
        _this4.addImgLoading = false;
      });
    },
    editImgSubmit: function editImgSubmit() {
      if (!this.editImageUrl && !this.beformAddImg) {
        this.$message.error("请上传图片!");
        return;
      }
      if (!this.editForm.px) {
        this.$message.error("请输入排序号!");
        return;
      }
      if (this.beformAddImg) {
        var var_this = this;
        var formData = new FormData();
        formData.append('pic', this.beformAddImg.raw);
        formData.append('token', this.token);
        formData.append('checkCode', this.checkCode);
        formData.append('oldpicid', this.editImgId);
        formData.append('mode', 'save');
        var config = {
          'Content-Type': 'multipart/form-data'
        };
        _axios2.default.post(this.upload.postURL, formData, config).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            var_this.editSave(res.data.data);
            var_this.$refs.upload.clearFiles();
          } else {
            var_this.$message.error(res.data.message);
            if (res.data.code == 403) {
              var_this.$router.push({ path: 'loginAdmin' });
            }
            return;
          }
        }).catch(function (error) {
          console.log(error);
          return;
        });
      } else {
        this.editSave();
      }
    },
    editSave: function editSave(val) {
      var _this5 = this;

      var param = void 0;
      if (val) {
        this.editForm.lbtpic = val.pic;
        this.editForm.lbtsltUrl = val.sltUrl;
        this.editForm.picid = val.id;
        param = {
          token: this.token,
          checkCode: this.checkCode,
          id: this.editForm.id,
          lbtlink: this.editForm.lbtlink,
          px: this.editForm.px,
          mode: '',
          lbtpic: this.editForm.lbtpic,
          lbtsltUrl: this.editForm.lbtsltUrl,
          lbtfileName: this.editForm.lbtfileName,
          picid: this.editForm.picid,
          type: 1
        };
      } else {
        param = {
          token: this.token,
          checkCode: this.checkCode,
          id: this.editForm.id,
          lbtlink: this.editForm.lbtlink,
          lbtfileName: this.editForm.lbtfileName,
          px: this.editForm.px,
          mode: '',
          type: 1
        };
      }
      this.editImgLoading = true;
      _index.API_Common.setLBlist(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.$message({
            message: '修改成功',
            type: 'success'
          });
          _this5.editFormVisible = false;
          _this5.getlbtList();
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
        _this5.editImgLoading = false;
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
        _this5.editImgLoading = false;
      });
    },
    getlbtList: function getlbtList() {
      var _this6 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        type: 0
      };
      _index.API_Common.getLBlist(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this6.total = res.data.data.totalRow;
          for (var i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].lbtpic) {
              res.data.data.list[i].lbtpic2 = res.data.data.list[i].lbtpic;
            }
          }
          _this6.imgList = res.data.data.list;
        } else {
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
          _this6.$message.error(res.data.message);
        }
      }).catch(function (err) {
        _this6.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getlbtList();
  }
};

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(6);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  inject: ['reload'],
  data: function data() {
    return {
      id: '',
      checkCode: '',
      token: '',
      urlList: [],
      pageSize1: 20,
      total1: 1,
      pageNumber1: 1,
      listLoading: false,
      addUrl: {
        cloudserviceurl: '',
        version: '',
        comment: ''
      },
      addUrlRules: {
        cloudserviceurl: [{ required: true, message: '请输入路径', trigger: 'blur' }]
      },
      addUrlVisible: false,
      addUrlLoading: false,

      editUrlVisible: false,
      editUrlLoading: false,
      editUrl: {
        cloudserviceurl: '',
        version: '',
        comment: ''
      },
      editUrlRules: {
        cloudserviceurl: [{ required: true, message: '请输入路径', trigger: 'blur' }]
      }
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    editUrlSubmit: function editUrlSubmit() {
      var _this2 = this;

      if (!this.editUrl.cloudserviceurl) {
        this.$message.error("路径地址不可为空！");
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: '',
        cloudserviceurl: this.editUrl.cloudserviceurl,
        version: this.editUrl.version,
        comment: this.editUrl.comment,
        id: this.editUrl.id
      };
      this.editUrlLoading = true;
      _index.API_Urls.upUrls(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this2.$message({
            message: '修改成功',
            type: 'success'
          });
          _this2.editUrlVisible = false;
          _this2.getUrls();
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
        _this2.editUrlLoading = false;
      }).catch(function (err) {
        _this2.editUrlLoading = false;
        _this2.$message.error('数据丢失，试试重新登陆！');
      });
    },
    addUrlSubmit: function addUrlSubmit() {
      var _this3 = this;

      if (!this.addUrl.cloudserviceurl) {
        this.$message.error("路径地址不可为空！");
        return;
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        mode: 'save',
        cloudserviceurl: this.addUrl.cloudserviceurl,
        version: this.addUrl.version,
        comment: this.addUrl.comment
      };
      this.addUrlLoading = true;
      _index.API_Urls.upUrls(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.$message({
            message: '添加成功',
            type: 'success'
          });
          _this3.addUrlVisible = false;
          _this3.getUrls();
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
        _this3.addUrlLoading = false;
      }).catch(function (err) {
        _this3.addUrlLoading = false;
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },
    handleURLAdd: function handleURLAdd() {
      this.addUrlVisible = true;
      this.addUrl = {};
    },
    handleURLEdit: function handleURLEdit(index, row) {
      this.editUrlVisible = true;
      this.editUrl = (0, _assign2.default)({}, row);
    },
    handleURLDel: function handleURLDel(index, row) {
      var _this4 = this;

      var _this = this;
      this.$confirm('确认删除该用户吗?', '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this4.token,
          checkCode: _this4.checkCode,
          id: row.id
        };
        _index.API_Urls.delUrls(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this4.$message({
              message: '删除成功',
              type: 'success'
            });
            _this4.getUrls();
          } else {
            _this4.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this4.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this4.$message.error('数据丢失，试试重新登陆！');
        });
      });
    },
    handleCurrentChange1: function handleCurrentChange1(val) {
      this.pageNumber1 = val;
      this.getUrls();
    },
    handleSizeChange1: function handleSizeChange1(val) {
      this.pageSize1 = val;
      this.getUrls();
    },

    getUrls: function getUrls() {
      var _this5 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        listType: 'page',
        pageNumber: this.pageNumber1,
        pageSize: this.pageSize1
      };
      _index.API_Urls.getUrlsList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this5.urlList = res.data.data.list;
          _this5.total1 = res.data.data.totalRow;
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this5.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    }
  },
  created: function created() {
    this.getCookie();
  },
  mounted: function mounted() {
    this.getUrls();
  }
};

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

var _jquery = __webpack_require__(359);

var _jquery2 = _interopRequireDefault(_jquery);

var _BaseContainer = __webpack_require__(41);

var _BaseContainer2 = _interopRequireDefault(_BaseContainer);

var _fitTableHeight = __webpack_require__(47);

var _fitTableHeight2 = _interopRequireDefault(_fitTableHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_fitTableHeight2.default],
  data: function data() {
    return {
      downHrefExcel: '',
      downHref: '',
      disSouch: true,
      disinvit: false,
      disSofttype: false,
      disTime1: false,
      disTime2: false,
      proName: "",
      dynamicTags: [],
      optionsSouch: [{ value: '账号', label: '账号' }, { value: '姓名', label: '姓名' }, { value: '企业', label: '企业' }, { value: '软件类型', label: '软件类型' }],
      value: '',
      inviValues: [],
      softtypes: [],
      yhlx: [],
      zhlx: [],
      cities: [],
      citiesd: [],
      userModule: [],
      editForm: {},
      editLoading: false,
      options: [{
        value: '1',
        label: '一个月'
      }, {
        value: '2',
        label: '二个月'
      }, {
        value: '3',
        label: '三个月'
      }, {
        value: '4',
        label: '四个月'
      }, {
        value: '5',
        label: '五个月'
      }, {
        value: '6',
        label: '六个月'
      }],
      id: '',
      token: '',
      checkCode: '',
      listLoading: false,
      souchs: {
        phone: '',
        name: '',
        company: '',

        fromtime: '',
        totime: ''
      },
      orderStr: '',
      orderType: '',
      pageNumber: 1,
      pageSize: 20,
      total: 0,
      users: [],
      companyList: [],

      dateRange: '',
      searchText: ''
    };
  },


  components: {
    BaseContainer: _BaseContainer2.default
  },

  methods: {
    handerChangePicker: function handerChangePicker(dateArr) {
      console.log("dateArr==", dateArr);
      if (dateArr) {
        this.souchs.fromtime = dateArr[0];
        this.souchs.totime = dateArr[1];
        return;
      }

      this.souchs.fromtime = '';
      this.souchs.totime = '';
    },
    handleClose: function handleClose(tag) {
      if (tag == "账号") {
        this.souchs.phone = '';
        if (this.value == "账号") {
          this.proName = '';
        }
      }
      if (tag == "姓名") {
        this.souchs.name = '';
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.company = '';
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "软件类型") {
        this.souchs.softtype = "";
      }
      if (tag == "邀请状态") {
        this.souchs.invitValue = "";
      }
      if (tag == "开始日期") {
        this.souchs.fromtime = "";
      }
      if (tag == "结束日期") {
        this.souchs.totime = "";
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },


    delTags: function delTags() {
      this.souchs = {};
      this.proName = '';
      this.value = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getUser();
    },

    changeSouch: function changeSouch(val) {
      this.disSouch = false;
      this.disinvit = false;
      this.disSofttype = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "账号") {
        this.proName = this.souchs.phone;
        this.disSouch = true;
      } else if (val == "姓名") {
        this.proName = this.souchs.name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs.company;
        this.disSouch = true;
      } else if (val == "软件类型") {
        this.disSofttype = true;
      } else if (val == "邀请状态") {
        this.disinvit = true;
      } else if (val == "开始日期") {
        this.disTime1 = true;
      } else if (val == "结束日期") {
        this.disTime2 = true;
      }
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        if (val.prop == "phone") {
          this.orderStr = "phoneOrder";
        } else if (val.prop == "name") {
          this.orderStr = "nameOrder";
        } else if (val.prop == "point") {
          this.orderStr = "pointOrder";
        } else if (val.prop == "userName") {
          this.orderStr = "usertypeOrder";
        } else if (val.prop == "softtype") {
          this.orderStr = "codeOrder";
        } else if (val.prop == "registertime") {
          this.orderStr = "registertimeOrder";
        } else if (val.prop == "company") {
          this.orderStr = "companyOrder";
        }
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getUser();
    },

    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      return rowIndex == 0 ? "background:#F5F7FA" : '';
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getUser();
    },


    getUser: function getUser(val) {
      var _this2 = this;

      if (this.value == "账号") {
        this.souchs.phone = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.company = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.name = this.proName;
      }

      var flag = true;
      if (val == 1) {
        this.pageNumber = 1;
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        listType: 'page',
        userType: '',

        username: this.souchs.name,
        phone: this.souchs.phone,
        company: this.souchs.company,
        registertimefrom: this.souchs.fromtime,
        registertimeto: this.souchs.totime,
        softtype: this.souchs.softtype,
        invitestatus: this.souchs.invitValue,

        orderType: this.orderType,
        orderStr: this.orderStr,
        searchText: this.searchText
      };

      this.downHrefExcel = _index.API_Integral.exportCreditsExcel() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&registertimefrom=" + (this.souchs.fromtime || '') + "&registertimeto=" + (this.souchs.totime || '') + "&softtype=" + (this.souchs.softtype || '') + "&invitestatus=" + (this.souchs.invitestatus || '') + "&phone=" + (this.souchs.phone || '') + "&company=" + (this.souchs.company || '') + "&username=" + (this.souchs.name || '') + "";

      this.listLoading = true;
      _index.API_Integral.getcreditsPage(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          if (res.data.data) {
            for (var i = 0; i < res.data.data.list.length; i++) {
              res.data.data.list[i].registertimeyuan = res.data.data.list[i].registertime;
              if (res.data.data.list[i].registertime) {
                res.data.data.list[i].registertime = res.data.data.list[i].registertime.substring(0, 10);
              }
            }
            _this2.total = res.data.data.totalRow;
            _this2.users = res.data.data.list;
            _this2.listLoading = false;
          }
        } else {
          _this2.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this2.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this2.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getModels: function getModels() {
      var _this3 = this;

      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Models.getAdminModule(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this3.models = res.data.data;
          _this3.cities = [];
          _this3.citiesd = [];
          for (var i = 0; i < res.data.data.length; i++) {
            _this3.cities.push(res.data.data[i].modulename);
            var jsones = { "modulename": res.data.data[i].modulename, "id": res.data.data[i].id };
            _this3.citiesd.push(jsones);
          }
        } else {
          _this3.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this3.$router.push({ path: 'loginAdmin' });
          }
        }
      }).catch(function (err) {
        _this3.$message.error('数据丢失，试试重新登陆！');
      });
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },

    getCode1: function getCode1() {
      var _this4 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.UserList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.yhlx = [];
          _this.softtypes = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.yhlx.push(jsons);
            var json = { 'value': res.data.data[i].code, 'label': res.data.data[i].name };
            _this.softtypes.push(json);
          }
        } else {
          _this4.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this4.$router.push({ path: 'loginAdmin' });
          }
        }
      });

      _index.API_Admin.tbCompanyList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this4.companyList = res.data.data;
        }
      });
    },

    getCode2: function getCode2() {
      var _this5 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode
      };
      _index.API_Admin.AccList(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.zhlx = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "text": res.data.data[i].name };
            _this.zhlx.push(jsons);
          }
        } else {
          _this5.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this5.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    },

    getCode: function getCode() {
      var _this6 = this;

      var _this = this;
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        type: 7
      };
      _index.API_User.getCode(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.inviValues = [];
          for (var i = 0; i < res.data.data.length; i++) {
            var jsons = { "value": res.data.data[i].code, "label": res.data.data[i].name };
            _this.inviValues.push(jsons);
          }
        } else {
          _this6.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this6.$router.push({ path: 'loginAdmin' });
          }
        }
      });
    }
  },

  created: function created() {

    this.getCookie();
    this.getCode1();
    this.getCode2();

    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getUser();
    this.getModels();
    this.getCode();

    this.downHref = _index.API_Admin.userExcelTemplate() + "?token=" + this.token + "&checkCode=" + this.checkCode;
  }
};

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  data: function data() {
    return {
      downHref: '',
      disSouch: true,
      disType: false,
      disAccountType: false,
      disTime1: false,
      disTime2: false,
      token: '',
      checkCode: "",
      id: "",
      listLoading: false,
      dataList: [],
      souchs: {
        application_time: ''
      },

      proName: '',
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      options: [{ value: '姓名', label: '姓名' }, { value: '手机号', label: '手机号' }, { value: '企业', label: '企业' }, { value: '状态', label: '状态' }, { value: '申请日期', label: '申请日期' }],
      value: '',
      types: [{ value: '0', label: '申请中' }, { value: '1', label: '通过' }, { value: '2', label: '驳回' }],
      accountType: '',
      accountTypes: [{ value: '0', label: '个人订单' }, { value: '1', label: '企业订单' }],
      typeValue: '',
      dynamicTags: [],
      orderStr: "application_time",
      orderType: 'desc'
    };
  },

  methods: {
    handleSortChange: function handleSortChange(val) {
      if (val) {
        this.orderStr = val.prop;
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch: function changeSouch(val) {
      this.disAccountType = false;
      this.disSouch = false;
      this.disType = false;
      this.disTime1 = false;
      this.disTime2 = false;
      if (val == "状态") {
        this.typeValue = this.souchs.status;
        this.disType = true;
      } else if (val == "姓名") {
        this.proName = this.souchs.user_name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs.org_name;
        this.disSouch = true;
      } else if (val == "手机号") {
        this.proName = this.souchs.account;
        this.disSouch = true;
      } else if (val == "申请日期") {
        this.disTime1 = true;
      }
    },
    getList: function getList(val) {
      var _this = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      if (this.value == "手机号") {
        this.souchs.account = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.user_name = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.org_name = this.proName;
      }
      if (this.value == "状态") {
        this.souchs.status = this.typeValue;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,

        status: this.souchs.status,
        user_name: this.souchs.user_name,
        org_name: this.souchs.org_name,
        account: this.souchs.account,
        application_time: this.souchs.application_time,

        orderType: this.orderType,
        orderStr: this.orderStr

      };
      this.listLoading = true;
      _index.API_Integral.getListPage(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.dataList = res.data.data.list;
          _this.total = res.data.data.totalRow;
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
        _this.listLoading = false;
      });
    },
    delTags: function delTags() {
      this.souchs = {}, this.souchs.souType = '';
      this.value = '';
      this.typeValue = '';
      this.accountType = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {
      if (tag == "状态") {
        this.souchs.status = "";
        this.typeValue = '';
      }
      if (tag == "姓名") {
        this.souchs.user_name = "";
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.org_name = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "手机号") {
        this.souchs.account = "";
        if (this.value == "手机号") {
          this.proName = '';
        }
      }

      if (tag == "开始日期") {
        this.souchs.application_time = "";
      }

      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    handleDel: function handleDel(index, row, type) {
      var _this2 = this;

      var title = type == 1 ? '确认通过吗?' : '确认驳回吗?';

      this.$confirm(title, '提示', {
        type: 'warning'
      }).then(function () {
        var param = {
          token: _this2.token,
          checkCode: _this2.checkCode,
          id: row.id,
          status: type
        };
        _index.API_Integral.updateStatus(param).then(function (res) {
          if (res.data.code == _index.API__code.SUCCESS) {
            _this2.$message({
              message: '操作成功',
              type: 'success'
            });
            _this2.getList();
          } else {
            _this2.$message.error(res.data.message);
            if (res.data.code == 403) {
              _this2.$router.push({ path: 'loginAdmin' });
            }
          }
        }).catch(function (err) {
          _this2.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(function (err) {});
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    exportExlsx: function exportExlsx() {
      var link = document.createElement('a');
      var body = document.querySelector('body');

      var href = _index.API_Integral.exportWbs() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&status=" + (this.souchs.status || '') + "&user_name=" + (this.souchs.user_name || '') + "&org_name=" + (this.souchs.org_name || '') + "&account=" + (this.souchs.account || '') + "&application_time=" + (this.souchs.application_time || '') + "&orderStr=" + (this.orderStr || '') + "&orderType=" + (this.orderType || '');

      link.href = href;

      link.download = '积分兑换导出';

      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.getCookie();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(6);

exports.default = {
  data: function data() {
    return {
      downHref: '',
      disSouch: true,
      disType: false,
      disAccountType: false,
      token: '',
      checkCode: "",
      id: "",
      listLoading: false,
      dataList: [],
      souchs: {},

      proName: '',
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      options: [{ value: '姓名', label: '姓名' }, { value: '手机号', label: '手机号' }, { value: '企业', label: '企业' }],
      value: '',
      accountType: '2021',
      accountTypes: [{ value: '2021', label: '2021' }, { value: '2020', label: '2020' }, { value: '2019', label: '2019' }],
      typeValue: '',
      dynamicTags: [],
      orderStr: "",
      orderType: ''
    };
  },

  methods: {
    accountTypeChange: function accountTypeChange() {
      this.getList();
    },

    handleSortChange: function handleSortChange(val) {
      if (val) {
        this.orderStr = val.prop;
        if (val.order == "descending") {
          this.orderType = "desc";
        } else {
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch: function changeSouch(val) {
      this.disAccountType = false;
      this.disSouch = false;
      this.disType = false;
      if (val == "姓名") {
        this.proName = this.souchs.user_name;
        this.disSouch = true;
      } else if (val == "企业") {
        this.proName = this.souchs.org_name;
        this.disSouch = true;
      } else if (val == "手机号") {
        this.proName = this.souchs.account;
        this.disSouch = true;
      }
    },
    getList: function getList(val) {
      var _this = this;

      if (val == 1) {
        this.pageNumber = 1;
      }
      if (this.value == "手机号") {
        this.souchs.account = this.proName;
      }
      if (this.value == "姓名") {
        this.souchs.user_name = this.proName;
      }
      if (this.value == "企业") {
        this.souchs.org_name = this.proName;
      }

      var flag = true;
      if (val == 1) {
        if (this.value) {
          if (this.dynamicTags.length > 0) {
            for (var i = 0; i < this.dynamicTags.length; i++) {
              if (this.value == this.dynamicTags[i]) {
                flag = false;
              }
            }
          }
          if (flag) {
            this.dynamicTags.push(this.value);
          }
        }
      }

      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,

        status: this.souchs.status,
        user_name: this.souchs.user_name,
        org_name: this.souchs.org_name,
        account: this.souchs.account,
        year: this.accountType,
        orderType: this.orderType,
        orderStr: this.orderStr

      };
      this.listLoading = true;
      _index.API_Integral.getListPage(param).then(function (res) {
        if (res.data.code == _index.API__code.SUCCESS) {
          _this.dataList = res.data.data.list;
          _this.total = res.data.data.totalRow;
        } else {
          _this.$message.error(res.data.message);
          if (res.data.code == 403) {
            _this.$router.push({ path: 'loginAdmin' });
          }
        }
        _this.listLoading = false;
      }).catch(function (err) {
        _this.$message.error('数据丢失，试试重新登陆！');
        _this.listLoading = false;
      });
    },
    delTags: function delTags() {
      this.souchs = {}, this.souchs.souType = '';
      this.value = '';
      this.typeValue = '';

      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose: function handleClose(tag) {

      if (tag == "姓名") {
        this.souchs.user_name = "";
        if (this.value == "姓名") {
          this.proName = '';
        }
      }
      if (tag == "企业") {
        this.souchs.org_name = "";
        if (this.value == "企业") {
          this.proName = '';
        }
      }
      if (tag == "手机号") {
        this.souchs.account = "";
        if (this.value == "手机号") {
          this.proName = '';
        }
      }

      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    indexMethod: function indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    getRowClass: function getRowClass(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ');
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=');
          if (arr2[0] == 'dnnyptadmin_token') {
            this.token = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
            this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
            this.id = arr2[1];
          }
        }
      }
    },
    exportExlsx: function exportExlsx() {
      var link = document.createElement('a');
      var body = document.querySelector('body');

      var href = _index.API_Integral.exportWbs() + "?token=" + this.token + "&checkCode=" + this.checkCode + "&status=" + (this.souchs.status || '') + "&user_name=" + (this.souchs.user_name || '') + "&org_name=" + (this.souchs.org_name || '') + "&account=" + (this.souchs.account || '') + "&orderStr=" + (this.orderStr || '') + "&orderType=" + (this.orderType || '') + "&year=" + this.accountType;

      link.href = href;

      link.download = '积分兑换导出';

      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.getCookie();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  }
};

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    getAIRilabList: function getAIRilabList(params) {
        var url = _config.baseURL + '/tbAiriImageOptimize/getAllList';
        return _axios2.default.post(url, _qs2.default.stringify(params));
    },
    getAIRilabStatistics: function getAIRilabStatistics() {
        var url = _config.baseURL + '/tbAiriImageOptimize/getStats';
        return _axios2.default.post(url);
    }
};

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getData: function getData(params) {
    var url = _config.baseURL + '/tbUser/infoCount';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  pointByHour: function pointByHour(params) {
    var url = _config.baseURL + '/tbUser/pointByHour';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  dayVisit: function dayVisit(params) {
    var url = _config.baseURL + '/tbUser/dayVisit';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  yaerVisit: function yaerVisit(params) {
    var url = _config.baseURL + '/tbUser/activeUserByYear';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  registerCount: function registerCount(params) {
    var url = _config.baseURL + '/tbUser/registerCount';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  adminModulePointPie: function adminModulePointPie(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/adminModulePointPie';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getPeiAddress: function getPeiAddress(params) {
    var url = _config.baseURL + '/statistical/getPeiAddressCa';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  accountDetail: function accountDetail(params) {
    var url = _config.baseURL + '/tbUser/getDetail';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  accountUpdate: function accountUpdate(params) {
    var url = _config.baseURL + '/tbUser/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getDaylive: function getDaylive(params) {
    var url = _config.baseURL + '/tbUser/DayLive';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getAdminList: function getAdminList(params) {
    var url = _config.baseURL + '/tbAdminuser/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setAdmin: function setAdmin(params) {
    var url = _config.baseURL + '/tbAdminuser/addAdminUser';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delAdmin: function delAdmin(params) {
    var url = _config.baseURL + '/tbAdminuser/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  editAdmin: function editAdmin(params) {
    var url = _config.baseURL + '/tbAdminuser/adminUserModify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  loginAdmin: function loginAdmin(params) {
    var url = _config.baseURL + '/tbAdminuser/adminUserlogin';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setUserModule: function setUserModule(params) {
    var url = _config.baseURL + '/tbUser/setUserModule';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delUser: function delUser(params) {
    var url = _config.baseURL + '/tbUser/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  modifyUser: function modifyUser(params) {
    var url = _config.baseURL + '/tbUser/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addUserSingle: function addUserSingle(params) {
    var url = _config.baseURL + '/tbUser/addUserSingle';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  checkPhoneUnique: function checkPhoneUnique(param) {
    var url = _config.baseURL + '/tbUser/userPhoneCheck?phone=' + param.phone;
    return _axios2.default.post(url);
  },
  UserList: function UserList(params) {
    var url = _config.baseURL + '/tbType/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  AccList: function AccList(params) {
    var url = _config.baseURL + '/tbCode/getAcountList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getList: function getList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserModulePointPie: function getUserModulePointPie(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserModulePointPie';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  loginRecord: function loginRecord(params) {
    var url = _config.baseURL + '/tbUser/loginRecord';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  pointByPerson: function pointByPerson(params) {
    var url = _config.baseURL + '/tbUser/pointByPerson';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  importUserExcelfile: function importUserExcelfile(param, data) {
    var url = _config.baseURL + '/tbUser/importUserExcel?' + param;
    return _axios2.default.post(url, data);
  },
  tbCompanyList: function tbCompanyList(params) {
    var url = _config.baseURL + '/tbCompany/companyList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyManage: function getCompanyManage(params) {
    var url = _config.baseURL + '/tbCompany/getCompanyManage';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  exportPointExcel: function exportPointExcel(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/exportPointExcel';
    return url;
  },
  setCompanyManager: function setCompanyManager(params) {
    var url = _config.baseURL + '/tbUser/setCompanyManager';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  hardwareBinding: function hardwareBinding(params) {
    var url = _config.baseURL + '/tbCompany/hardwareBinding';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  userExcelTemplate: function userExcelTemplate(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/userExcelTemplate';
    return url;
  },
  getCompany: function getCompany(params) {
    var url = _config.baseURL + '/tbCompany/getCompany';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getAutoList: function getAutoList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delAutoList: function delAutoList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/productOperate';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  autoDetail: function autoDetail(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/productRenew';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  autoOrder: function autoOrder(params) {
    var url = _config.baseURL + '/tbOrder/renewOrder';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDetailByAuthProductId: function getDetailByAuthProductId(params) {
    var url = _config.baseURL + '/tbOrder/getDetailByAuthProductId';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addUserNote: function addUserNote(params) {
    var url = _config.baseURL + '/tbUserNote/add';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserNote: function getUserNote(params) {
    var url = _config.baseURL + '/tbUserNote/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getSelectCommonList: function getSelectCommonList(path, params) {
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "post";

    var url = _config.baseURL + path;
    return _axios2.default[method](url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  upload: function upload(params) {
    var url = _config.baseURL + '/tbPic/modify';
    return url;
  },
  getLBlist: function getLBlist(params) {
    var url = _config.baseURL + '/tbLunbotu/list';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delLBlist: function delLBlist(params) {
    var url = _config.baseURL + '/tbLunbotu/delete';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setLBlist: function setLBlist(params) {
    var url = _config.baseURL + '/tbLunbotu/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setLoglist: function setLoglist() {
    var url = _config.baseURL + '/tbPic/setProductLogo';
    return url;
  },
  setCompanyPic: function setCompanyPic() {
    var url = _config.baseURL + '/tbPic/modify';
    return url;
  },
  getLBTDetail: function getLBTDetail(params) {
    var url = _config.baseURL + '/tbLunbotu/getDetail';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(50);

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getrihuo: function getrihuo(params) {
    var url = _config.baseURL + "/tbClientLogCensus/userCountByDay";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getPageLoad: function getPageLoad(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/pageLoad";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getPageLoad2: function getPageLoad2(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/pageLoadPage";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getmoduleintegral: function getmoduleintegral(params) {
    var url = _config.baseURL + "/tbClientLogModule/listBYmoduleAndLog";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getTbModule: function getTbModule(params) {
    var url = _config.baseURL + "/tbModule/list";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getTbModuleDetails: function getTbModuleDetails(params) {
    var url = _config.baseURL + "/tbClientLogCmd/listBYmoduleCmdAndLog";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getModuleUser: function getModuleUser(params) {
    var url = _config.baseURL + "/tbClientLog/getUserPointWithModByLog";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getMarketPictureCount: function getMarketPictureCount(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/marketPictureCount";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getMarketPictureMap: function getMarketPictureMap(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/marketPictureMap";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getIntegralStatis: function getIntegralStatis(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/IntegralStatistics";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getintegraDetail: function getintegraDetail(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/histogramStatistics";
    params.city = encodeURI((0, _stringify2.default)(params.city));

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserPointExcel: function getUserPointExcel() {
    var url = _config.baseURL + "/tbClientLog/getUserPointWithModByLogExcel";
    return url;
  },
  exportListdata: function exportListdata() {
    var url = _config.baseURL + "/enterprise/loadRatio/exportDoc";
    return url;
  },
  exportmokuaiwai: function exportmokuaiwai() {
    var url = _config.baseURL + "/tbClientLogModule/listBYmoduleAndLogExcel";
    return url;
  },
  exportmodellist: function exportmodellist() {
    var url = _config.baseURL + "/tbClientLogCmd/listBYmoduleCmdAndLogExcel";
    return url;
  },
  exportMarke: function exportMarke() {
    var url = _config.baseURL + "/enterprise/loadRatio/exportMarket";
    return url;
  },
  loadRateSum: function loadRateSum(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/loadRateSum";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  loadRatio: function loadRatio(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/rankingOrg";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  rankingUser: function rankingUser(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/rankingUser";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  zombieUser: function zombieUser(params) {
    var url = _config.baseURL + "/tbUser/MonthLive";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  marketStatisticsCustomer: function marketStatisticsCustomer(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/marketStatisticsCustomer?dateType=" + params.dateType + '&date=' + params.date + '&year=' + params.year;
    return _axios2.default.get(url);
  },
  marketStatisticsCount: function marketStatisticsCount(params) {
    var url = _config.baseURL + "/enterprise/loadRatio/marketStatisticsCount?dateType=" + params.dateType + '&date=' + params.date + '&year=' + params.year;
    return _axios2.default.get(url);
  },
  userStatisticsPie: function userStatisticsPie(params) {
    var url = _config.baseURL + "/tbUser/userStatisticsPie?managerAdminuser=" + params.managerAdminuser + '&status=' + params.status + '&type=' + params.type;
    return _axios2.default.get(url);
  },
  userStatisticsLine: function userStatisticsLine(params) {
    var url = _config.baseURL + "/tbUser/userStatisticsLine?managerAdminuser=" + params.managerAdminuser + '&type=' + params.type;
    return _axios2.default.get(url);
  },
  userStatisticsLineSum: function userStatisticsLineSum(params) {
    var url = _config.baseURL + "/tbUser/userStatisticsLineSum?managerAdminuser=" + params.managerAdminuser + '&type=' + params.type;
    return _axios2.default.get(url);
  }
};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getListPage: function getListPage(params) {
    var url = _config.baseURL + '/tbCreditsExchange/getListPage';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  updateStatus: function updateStatus(params) {
    var url = _config.baseURL + '/tbCreditsExchange/updateStatus';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  exportWbs: function exportWbs(params) {
    var url = _config.baseURL + '/tbCreditsExchange/exportWbs';
    return url;
  },
  getcreditsPage: function getcreditsPage(params) {
    var url = _config.baseURL + '/tbUser/userPointList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  exportCreditsExcel: function exportCreditsExcel(params) {
    var url = _config.baseURL + '/tbUser/userPointExcel';
    return url;
  }
};

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  login: function login(params) {
    var url = _config.baseURL + '/tbUser/login';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  register: function register(params) {
    var url = _config.baseURL + '/tbUser/userRegister';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  forget: function forget(params) {
    var url = _config.baseURL + '/tbUser/userPasswordReset';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  sendSmsCode: function sendSmsCode(params) {
    var url = _config.baseURL + '/tbUser/sendSmsCode';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  loginAdmin: function loginAdmin(params) {
    var url = _config.baseURL + '/tbAdminuser/adminUserlogin';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  CheckTencentCaptcha: function CheckTencentCaptcha(params) {
    var url = _config.baseURL + '/tbUser/CheckTencentCaptcha';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getUserProductSum: function getUserProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getcompanySetUserProductSum: function getcompanySetUserProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getcompanySetUserProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserDueProductSum: function getUserDueProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserDueProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserDueInMonthProductSum: function getUserDueInMonthProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserDueInMonthProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserGroupProductSum: function getUserGroupProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserGroupProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getLoginInfor: function getLoginInfor(params) {
    var url = _config.baseURL + '/tbClientLog/getLoginInfor';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getTypeList: function getTypeList(params) {
    var url = _config.baseURL + '/tbType/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  upTypeList: function upTypeList(params) {
    var url = _config.baseURL + '/tbType/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delTypeList: function delTypeList(params) {
    var url = _config.baseURL + '/tbType/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getAdminModule: function getAdminModule(params) {
    var url = _config.baseURL + '/tbModule/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setAdminModule: function setAdminModule(params) {
    var url = _config.baseURL + '/tbModule/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delAdminModule: function delAdminModule(params) {
    var url = _config.baseURL + '/tbModule/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getAdminModuleTwo: function getAdminModuleTwo(params) {
    var url = _config.baseURL + '/tbModule/getCmdlist';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getOrderList: function getOrderList(params) {
    var url = _config.baseURL + '/tbOrder/getList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addOrder: function addOrder(params) {
    var url = _config.baseURL + '/tbOrder/addOrder';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  detailOrder: function detailOrder(params) {
    var url = _config.baseURL + '/tbOrder/getDetail';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delOrder: function delOrder(params) {
    var url = _config.baseURL + '/tbOrder/deleteBeginAuth';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  verifyOrder: function verifyOrder(params) {
    var url = _config.baseURL + '/tbOrder/examineOrder';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  renewOrder: function renewOrder(params) {
    var url = _config.baseURL + '/tbOrder/renewOrderAuPro';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getPosition: function getPosition(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/requestMap?cityName=' + params.city + '&districtName=' + params.area + '&token=' + params.token + '&checkCode=' + params.checkCode;
    return _axios2.default.get(url);
  },
  getaddressfromposition: function getaddressfromposition(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/requestGetMapByLongitude?location=' + params.pos.toString() + '&token=' + params.token + '&checkCode=' + params.checkCode;
    return _axios2.default.get(url);
  }
};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  productList: function productList(params) {
    var url = _config.baseURL + '/tbProduct/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setProductList: function setProductList(params) {
    var url = _config.baseURL + '/tbProduct/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delProductList: function delProductList(params) {
    var url = _config.baseURL + '/tbProduct/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  listDel: function listDel(params) {
    var url = _config.baseURL + '/tbProduct/listDel';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  sendEmailCode: function sendEmailCode(params) {
    var url = _config.baseURL + "/tbUser/sendEmailCode";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  userPasswordEmail: function userPasswordEmail(params) {
    var url = _config.baseURL + "/tbUser/userPasswordEmail";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  verifyEmailCode: function verifyEmailCode(params) {
    var url = _config.baseURL + "/tbUser/verifyEmailCode";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  registerUserByEmail: function registerUserByEmail(params) {
    var url = _config.baseURL + "/tbUser/addUserByEmail";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  verifyEmail: function verifyEmail(params) {
    var url = _config.baseURL + "/tbUser/verifyEmail";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getGroupProductSum: function getGroupProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getGroupProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getProductSum: function getProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDueProductSum: function getDueProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getDueProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUnusedProductSum: function getUnusedProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUnusedProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDueInMonthProductSum: function getDueInMonthProductSum(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getDueInMonthProductSum';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyUserPointList: function getCompanyUserPointList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getCompanyUserPointList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyUserMonthPointList: function getCompanyUserMonthPointList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getCompanyUserMonthPointList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyMonthPointBrokenLine: function getCompanyMonthPointBrokenLine(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getCompanyMonthPointBrokenLine';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserMonthPointBrokenLine: function getUserMonthPointBrokenLine(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getUserMonthPointBrokenLine';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyMonthModulePointPie: function getCompanyMonthModulePointPie(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getCompanyMonthModulePointPie';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCompanyUserMonthModulePointPie: function getCompanyUserMonthModulePointPie(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getCompanyUserMonthModulePointPie';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getLoginDevice: function getLoginDevice(params) {
    var url = _config.baseURL + '/tbClientLog/hardHashAnalyse';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getUserModule: function getUserModule(params) {
    var url = _config.baseURL + '/tbUser/getUserModule';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setUserModule: function setUserModule(params) {
    var url = _config.baseURL + '/tbUser/setUserModule';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getList: function getList(params) {
    var url = _config.baseURL + '/tbUsingapplication/getList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setList: function setList(params) {
    var url = _config.baseURL + '/tbUsingapplication/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  uploadFiles: function uploadFiles(params) {
    var url = _config.baseURL + '/tbPic/modify';
    return _axios2.default.post(url, params);
  }
};

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getUrlsList: function getUrlsList(params) {
    var url = _config.baseURL + '/tbSysmanage/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  upUrls: function upUrls(params) {
    var url = _config.baseURL + '/tbSysmanage/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delUrls: function delUrls(params) {
    var url = _config.baseURL + '/tbSysmanage/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  }
};

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(51);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _userList$getUserDeta;

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_userList$getUserDeta = {
  userList: function userList(params) {
    var url = _config.baseURL + "/tbUser/userList";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getUserDetail: function getUserDetail(params) {
    var url = _config.baseURL + "/tbUser/getDetail";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  companyList: function companyList(params) {
    var url = _config.baseURL + "/tbCompany/list";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addCompanyList: function addCompanyList(params) {
    var url = _config.baseURL + "/tbCompany/modify";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delCompanyList: function delCompanyList(params) {
    var url = _config.baseURL + "/tbCompany/delete";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  setCompanyManager: function setCompanyManager(params) {
    var url = _config.baseURL + "/tbUser/setCompanyManager";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getCode: function getCode(params) {
    var url = _config.baseURL + "/tbCode/list";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  userListByDay: function userListByDay(params) {
    var url = _config.baseURL + "/tbUser/userListByDay";
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  userListByExcel: function userListByExcel(params) {
    var url = _config.baseURL + "/tbUser/userListByExcel";
    return url;
  },
  allUserByExcel: function allUserByExcel(params) {
    var url = _config.baseURL + "/tbUser/allUserByExcel";
    return url;
  },
  allAdminuser: function allAdminuser(param) {
    var url = _config.baseURL + "/tbAdminuser/list?type=2&token=" + param.token + "&checkCode=" + param.checkCode;
    return _axios2.default.get(url);
  },
  getComputeDetail: function getComputeDetail(id) {
    var url = _config.baseURL + "/tbCompany/getDetail?id=" + id;
    return _axios2.default.get(url);
  },
  getCompanyManage: function getCompanyManage(param) {
    var url = _config.baseURL + "/tbCompany/getCompanyManage?companyId=" + param.companyId + "&token=" + param.token + "&checkCode=" + param.checkCode;
    return _axios2.default.get(url);
  },
  getCompanyUser: function getCompanyUser(param) {
    var url = _config.baseURL + "/tbCompany/getCompanyUser?companyId=" + param.companyId + "&token=" + param.token + "&checkCode=" + param.checkCode;
    return _axios2.default.get(url);
  }
}, (0, _defineProperty3.default)(_userList$getUserDeta, "setCompanyManager", function setCompanyManager(params) {
  var url = _config.baseURL + "/tbUser/setCompanyManager?companyid=" + params.companyid + "&userid=" + params.userid + "&toke=" + params.toke + "&checkCode=" + params.checkCode;
  return _axios2.default.get(url);
}), (0, _defineProperty3.default)(_userList$getUserDeta, "getCompanySearch", function getCompanySearch(param) {
  var url = _config.baseURL + "/tbCompany/companySearch";
  return _axios2.default.post(url, param);
}), (0, _defineProperty3.default)(_userList$getUserDeta, "checkCompanyUnique", function checkCompanyUnique(param) {
  var url = _config.baseURL + "/tbCompany/companyCheck?name=" + param.name;
  return _axios2.default.post(url);
}), _userList$getUserDeta);

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _config = __webpack_require__(30);

var _qs = __webpack_require__(32);

var _qs2 = _interopRequireDefault(_qs);

var _jsCookie = __webpack_require__(360);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  setProduct: function setProduct(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/companyProductDistribute';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  userList: function userList(params) {
    var url = _config.baseURL + '/tbUser/userListFront';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delComUserList: function delComUserList(params) {
    var url = _config.baseURL + '/tbUser/companyManagerRemoveUser';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delProduct: function delProduct(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/companyProductDistributeCancel';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delProductDepart: function delProductDepart(params) {
    var url = _config.baseURL + '/tbDept/deptProductCancle';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getList: function getList(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/getList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  accountDetail: function accountDetail(params) {
    var url = _config.baseURL + '/tbUser/getDetail';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addComList: function addComList(params) {
    var url = _config.baseURL + '/tbUser/companyManagerAddUser';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getSBList: function getSBList(params) {
    var url = _config.baseURL + '/tbComputermanage/list';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addSBList: function addSBList(params) {
    var url = _config.baseURL + '/tbComputermanage/modify';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delSBList: function delSBList(params) {
    var url = _config.baseURL + '/tbComputermanage/delete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addComUserList: function addComUserList(params) {
    var url = _config.baseURL + '/tbUser/adminUserAddUsers';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  companyProductBatchDistribute: function companyProductBatchDistribute(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/companyProductBatchDistribute';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  companyBatchAdd: function companyBatchAdd(params) {
    var url = _config.baseURL + '/tbComputermanage/batchAdd';
    return url;
  },
  companyTemplate: function companyTemplate(params) {
    var url = _config.baseURL + '/tbComputermanage/template' + '?checkCode=' + _jsCookie2.default.get("dnnyptadmin_checkCode") + '&token=' + _jsCookie2.default.get("dnnyptadmin_token");
    return url;
  },
  getCompanyUser: function getCompanyUser(params) {
    var url = _config.baseURL + '/tbUser/getCompanyUser';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDepartList: function getDepartList(params) {
    var url = _config.baseURL + '/tbDept/deptList';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDepartDetail: function getDepartDetail(params) {
    var url = _config.baseURL + '/tbDept/deptDetail';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addDept: function addDept(params) {
    var url = _config.baseURL + '/tbDept/addDept';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  editDept: function editDept(params) {
    var url = _config.baseURL + '/tbDept/modifyDept';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  delDepart: function delDepart(params) {
    var url = _config.baseURL + '/tbDept/deptDelete';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  getDeptListByUserId: function getDeptListByUserId(params) {
    var url = _config.baseURL + '/tbDept/getDeptIdByUserId';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  dispatchProductToDepart: function dispatchProductToDepart(params) {
    var url = _config.baseURL + '/tbAuthorizedproduct/auProToDeptManager';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  checkDepartUnique: function checkDepartUnique(param) {
    var url = _config.baseURL + '/tbDept/deptNameCheck?deptname=' + param.deptname + '&companyid=' + param.companyid;
    return _axios2.default.post(url);
  },
  getTrackList: function getTrackList(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/marketPicturePage';
    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  addTrack: function addTrack(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/marketPicture';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  updateTrack: function updateTrack(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/marketPictureUpdate';

    return _axios2.default.post(url, _qs2.default.stringify(params));
  },
  uploadPic: function uploadPic(params) {
    var url = _config.baseURL + '/tbPic/setPic';
    return (0, _axios2.default)({
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      url: url,
      method: 'post',
      data: params
    });
  },
  delPic: function delPic(params) {
    var url = _config.baseURL + '/enterprise/loadRatio/delPic';
    return _axios2.default.post(url, params);
  },
  getComment: function getComment(marketid) {
    var url = _config.baseURL + "/tbMarketComment/list?marketid=" + marketid;
    return _axios2.default.get(url);
  },
  addComment: function addComment(param) {
    var url = _config.baseURL + "/tbMarketComment/modify?mode=save&marketid=" + param.marketid + '&userid=' + param.userid + '&note=' + param.note;
    return _axios2.default.post(url);
  },
  delComment: function delComment(id) {
    var url = _config.baseURL + "/tbMarketComment/delete?id=" + id;
    return _axios2.default.post(url);
  }
};

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currency = currency;
exports.formatMoney = formatMoney;
var digitsRE = /(\d{3})(?=\d)/g;

function currency(value, currency, decimals) {
  value = parseFloat(value);
  if (!isFinite(value) || !value && value !== 0) return '';
  currency = currency != null ? currency : '$';
  decimals = decimals != null ? decimals : 2;
  var stringified = Math.abs(value).toFixed(decimals);
  var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
  var i = _int.length % 3;
  var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
  var _float = decimals ? stringified.slice(-1 - decimals) : '';
  var sign = value < 0 ? '-' : '';
  return sign + currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
}

function formatMoney(value, type) {
  if (/[^0-9\.]/.test(value)) return "0";
  if (value == null || value == "") return "0";
  value = value.toString().replace(/^(\d*)$/, "$1.");
  value = (value + "00").replace(/(\d*\.\d\d)\d*/, "$1");
  value = value.replace(".", ",");
  var re = /(\d)(\d{3},)/;
  while (re.test(value)) {
    value = value.replace(re, "$1,$2");
  }value = value.replace(/,(\d\d)$/, ".$1");
  if (type == 0) {
    var a = value.split(".");
    if (a[1] == "00") {
      value = a[0];
    }
  }
  return value;
}

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(791);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(49);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(799);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(403);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(792);

__webpack_require__(796);

var _vueRouter = __webpack_require__(800);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(790);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(20);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(789);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(793);

__webpack_require__(795);

var _axios = __webpack_require__(10);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(788);

var _index2 = _interopRequireDefault(_index);

var _vRegion = __webpack_require__(797);

var _vRegion2 = _interopRequireDefault(_vRegion);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _vViewer = __webpack_require__(798);

var _vViewer2 = _interopRequireDefault(_vViewer);

__webpack_require__(794);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.prototype.$moment = _moment2.default;

_vue2.default.use(_vRegion2.default, {});

_vue2.default.config.productionTip = false;
_vue2.default.use(_index2.default);

_vue2.default.prototype.$ajax = _axios2.default;

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

_vue2.default.use(_vViewer2.default);
_vViewer2.default.setDefaults({
  Options: { zIndex: 9999, "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

console.log('process.env==', "production");
var env = "production";

var base = function () {
  var path = location.pathname;

  if (/^\/authorizion/.test(path)) {
    return '/authorizion/';
  }

  if (env === 'test' && /^\/dnnCloud\/exchange/.test(path)) {
    console.log("dnnCloud/exchange/");
    return '/dnnCloud/exchange';
  }
  return '/';
}();

if (sessionStorage.getItem('token')) {
  _store2.default.commit('set__token', sessionStorage.getItem('token'));
}
var router = new _vueRouter2.default({
  mode: 'history',
  base: base,
  routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
  if (to.meta.requireAuth) {
    if (_store2.default.state.token) {
      next();
    } else {
      next({
        path: '/loginAdmin',
        query: { redirect: to.fullPath } });
    }
  } else {
    next();
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 542,
	"./af.js": 542,
	"./ar": 549,
	"./ar-dz": 543,
	"./ar-dz.js": 543,
	"./ar-kw": 544,
	"./ar-kw.js": 544,
	"./ar-ly": 545,
	"./ar-ly.js": 545,
	"./ar-ma": 546,
	"./ar-ma.js": 546,
	"./ar-sa": 547,
	"./ar-sa.js": 547,
	"./ar-tn": 548,
	"./ar-tn.js": 548,
	"./ar.js": 549,
	"./az": 550,
	"./az.js": 550,
	"./be": 551,
	"./be.js": 551,
	"./bg": 552,
	"./bg.js": 552,
	"./bm": 553,
	"./bm.js": 553,
	"./bn": 555,
	"./bn-bd": 554,
	"./bn-bd.js": 554,
	"./bn.js": 555,
	"./bo": 556,
	"./bo.js": 556,
	"./br": 557,
	"./br.js": 557,
	"./bs": 558,
	"./bs.js": 558,
	"./ca": 559,
	"./ca.js": 559,
	"./cs": 560,
	"./cs.js": 560,
	"./cv": 561,
	"./cv.js": 561,
	"./cy": 562,
	"./cy.js": 562,
	"./da": 563,
	"./da.js": 563,
	"./de": 566,
	"./de-at": 564,
	"./de-at.js": 564,
	"./de-ch": 565,
	"./de-ch.js": 565,
	"./de.js": 566,
	"./dv": 567,
	"./dv.js": 567,
	"./el": 568,
	"./el.js": 568,
	"./en-au": 569,
	"./en-au.js": 569,
	"./en-ca": 570,
	"./en-ca.js": 570,
	"./en-gb": 571,
	"./en-gb.js": 571,
	"./en-ie": 572,
	"./en-ie.js": 572,
	"./en-il": 573,
	"./en-il.js": 573,
	"./en-in": 574,
	"./en-in.js": 574,
	"./en-nz": 575,
	"./en-nz.js": 575,
	"./en-sg": 576,
	"./en-sg.js": 576,
	"./eo": 577,
	"./eo.js": 577,
	"./es": 581,
	"./es-do": 578,
	"./es-do.js": 578,
	"./es-mx": 579,
	"./es-mx.js": 579,
	"./es-us": 580,
	"./es-us.js": 580,
	"./es.js": 581,
	"./et": 582,
	"./et.js": 582,
	"./eu": 583,
	"./eu.js": 583,
	"./fa": 584,
	"./fa.js": 584,
	"./fi": 585,
	"./fi.js": 585,
	"./fil": 586,
	"./fil.js": 586,
	"./fo": 587,
	"./fo.js": 587,
	"./fr": 590,
	"./fr-ca": 588,
	"./fr-ca.js": 588,
	"./fr-ch": 589,
	"./fr-ch.js": 589,
	"./fr.js": 590,
	"./fy": 591,
	"./fy.js": 591,
	"./ga": 592,
	"./ga.js": 592,
	"./gd": 593,
	"./gd.js": 593,
	"./gl": 594,
	"./gl.js": 594,
	"./gom-deva": 595,
	"./gom-deva.js": 595,
	"./gom-latn": 596,
	"./gom-latn.js": 596,
	"./gu": 597,
	"./gu.js": 597,
	"./he": 598,
	"./he.js": 598,
	"./hi": 599,
	"./hi.js": 599,
	"./hr": 600,
	"./hr.js": 600,
	"./hu": 601,
	"./hu.js": 601,
	"./hy-am": 602,
	"./hy-am.js": 602,
	"./id": 603,
	"./id.js": 603,
	"./is": 604,
	"./is.js": 604,
	"./it": 606,
	"./it-ch": 605,
	"./it-ch.js": 605,
	"./it.js": 606,
	"./ja": 607,
	"./ja.js": 607,
	"./jv": 608,
	"./jv.js": 608,
	"./ka": 609,
	"./ka.js": 609,
	"./kk": 610,
	"./kk.js": 610,
	"./km": 611,
	"./km.js": 611,
	"./kn": 612,
	"./kn.js": 612,
	"./ko": 613,
	"./ko.js": 613,
	"./ku": 614,
	"./ku.js": 614,
	"./ky": 615,
	"./ky.js": 615,
	"./lb": 616,
	"./lb.js": 616,
	"./lo": 617,
	"./lo.js": 617,
	"./lt": 618,
	"./lt.js": 618,
	"./lv": 619,
	"./lv.js": 619,
	"./me": 620,
	"./me.js": 620,
	"./mi": 621,
	"./mi.js": 621,
	"./mk": 622,
	"./mk.js": 622,
	"./ml": 623,
	"./ml.js": 623,
	"./mn": 624,
	"./mn.js": 624,
	"./mr": 625,
	"./mr.js": 625,
	"./ms": 627,
	"./ms-my": 626,
	"./ms-my.js": 626,
	"./ms.js": 627,
	"./mt": 628,
	"./mt.js": 628,
	"./my": 629,
	"./my.js": 629,
	"./nb": 630,
	"./nb.js": 630,
	"./ne": 631,
	"./ne.js": 631,
	"./nl": 633,
	"./nl-be": 632,
	"./nl-be.js": 632,
	"./nl.js": 633,
	"./nn": 634,
	"./nn.js": 634,
	"./oc-lnc": 635,
	"./oc-lnc.js": 635,
	"./pa-in": 636,
	"./pa-in.js": 636,
	"./pl": 637,
	"./pl.js": 637,
	"./pt": 639,
	"./pt-br": 638,
	"./pt-br.js": 638,
	"./pt.js": 639,
	"./ro": 640,
	"./ro.js": 640,
	"./ru": 641,
	"./ru.js": 641,
	"./sd": 642,
	"./sd.js": 642,
	"./se": 643,
	"./se.js": 643,
	"./si": 644,
	"./si.js": 644,
	"./sk": 645,
	"./sk.js": 645,
	"./sl": 646,
	"./sl.js": 646,
	"./sq": 647,
	"./sq.js": 647,
	"./sr": 649,
	"./sr-cyrl": 648,
	"./sr-cyrl.js": 648,
	"./sr.js": 649,
	"./ss": 650,
	"./ss.js": 650,
	"./sv": 651,
	"./sv.js": 651,
	"./sw": 652,
	"./sw.js": 652,
	"./ta": 653,
	"./ta.js": 653,
	"./te": 654,
	"./te.js": 654,
	"./tet": 655,
	"./tet.js": 655,
	"./tg": 656,
	"./tg.js": 656,
	"./th": 657,
	"./th.js": 657,
	"./tk": 658,
	"./tk.js": 658,
	"./tl-ph": 659,
	"./tl-ph.js": 659,
	"./tlh": 660,
	"./tlh.js": 660,
	"./tr": 661,
	"./tr.js": 661,
	"./tzl": 662,
	"./tzl.js": 662,
	"./tzm": 664,
	"./tzm-latn": 663,
	"./tzm-latn.js": 663,
	"./tzm.js": 664,
	"./ug-cn": 665,
	"./ug-cn.js": 665,
	"./uk": 666,
	"./uk.js": 666,
	"./ur": 667,
	"./ur.js": 667,
	"./uz": 669,
	"./uz-latn": 668,
	"./uz-latn.js": 668,
	"./uz.js": 669,
	"./vi": 670,
	"./vi.js": 670,
	"./x-pseudo": 671,
	"./x-pseudo.js": 671,
	"./yo": 672,
	"./yo.js": 672,
	"./zh-cn": 673,
	"./zh-cn.js": 673,
	"./zh-hk": 674,
	"./zh-hk.js": 674,
	"./zh-mo": 675,
	"./zh-mo.js": 675,
	"./zh-tw": 676,
	"./zh-tw.js": 676
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1563;

/***/ }),
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.470127c.jpg";

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1653 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAYAAAC4wJK5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARxSURBVHgB7VjPbxtVEJ55tus6YDdRhITUAzkheq7UFslWbFpuHNKKFARKml44UcGx4pL2xhGp5UwCNyhN4dJLJTs0RW3Ehb+AXCxVSCWoIVId775hxt5dv7W9PxxvHB/8KdHueN+v7803M/sWYIIJJphgHIEwIBaq5ekM2Auk6C1IEAS0Y2t780Hl6Q4MiIFILFaL3/DlCzhC8IJu/1jZujVgn3gYBYEOaO2nypPrcVvHIrFYLa3wwN95UwDUQPF/ktBQ5sWUjTkq9ypbtThd45GoFas8atkZvmeXPnlcnIFXMGOfhDQMAbLoKwK81jZgO0Mnru6+tr/78MKzl2H9VMS48HG1PNchANAE+7b5fPnZxVkb4I1hCTiLuesZCOcs1SwVmpk3lx9dnI3oFw4b7dWORWtm9vjsj7OZxkFjFhICpfElIN33bKArcm1kG7Orq6uBaw0l0fYCrbh2txd29/KJEXCBSm0Y5mUNkJebP0sPZ4L6hJIwvSDB3O2Fk1M6BwkDkbZZStue3aRWjGRz6ekgb4SSQCMWuLitmc/2rXTu4EBn4AiACu948yJea3lDq1SQNwJJSFplTc45Q+38PP9k3dcRs4lLyUXLG0R1xyxw+r0sN+KNfu0DSXDu9aSkFdwyn3369HzhqLzgza+gs2kaVpyFpBZ/f7dHwn1JRHnBbmRPwRFDEUiA7znmabLwnNycaPQqoL8nsB1MDmrmow9+PTtFKvmA7oakW5bVmmcT3ZCrlbamur3RQyKquOXy+QKMCOyN7z2Di1+QN3pIRBU3lbZGRiKo+Ik3zHTrI3EcxS0KcYqfj8RxFLcoxCl+vpc2KW7k3vP/h5tFj9TuPmSQ7EKfWeqcDjfgECDJ/0SnIxtq3HPft6X48RrXlVZ7jjdeeCT8abWFMupOgLcG6PfmTq2/vFJGEMaAtpCzDX0e6zTgb9IufjyfU/xeeHIa6sys4QbZqegddedqtRUChwMStRXhFL+gM0CNjJObIpLi1tOW5fA+y+kdvi2Qtr/GFCxBDBDZPxiGyPF+ZB+N5yXNdv8u6bYvCSFwb37Ly0wfPS6+Df2H3iCCX0AyBk+gNSxHycqRkec1JrCEKaxDJFjshD0kJN1GHorCIJOza+90Vhguq24ZSd94BMIx9JESM7hONlzijZJdKrBUvgWbHvVry8+uGEad+96FBDA0CQEC3eTM1ZYVwBl2+5nIPipe/MTBUHJy0SOrqPYJychFIp4QiKzAAnnXCU+1hCKjQxXHICRGQoBpqdwDf94dGonI6bgRQAKnYdxAEHgE6JDQsOneoqaVheqFORgTSH3h7Hep8wNtm899Ar5aLf1lnq1JqQd8/ZdfO0Z+jnChSRWwfRjKt5dFdZXB98w2vsDWQNeZVbVt4Rx75MtWv2MIVhcI5LeRbpp7j7j/ny8m5FO6fFJHwB0YN0iFB72EaeVJSVu2ft489XfgFi/+VprnLwxl8zeFlGV3vQ6jBsdA9+Jt0K/+gdzzWqVmwQQTTDDBWOJ/3/ziLJ2CvzIAAAAASUVORK5CYII="

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAwCAYAAAC4wJK5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPeSURBVHgB7Zq/TxRBFMffm9tDD4VALLXAVhuNiYlR9NR/QFoLfzQW/AhHZ2IBFhgbw5kTY6zA0gJiZ4g/LhBjLEzoKKGhMipw5Phxt/N8wzF3u8fu3e7tQE7CNzl2d2Z35vuZzNvdeQvAIRCCYVEq2ZEvypQgukEAyd1u5hHsdGL82yTsg4xBaPNANMiNdnifBEuIcsQ0TGSIQOb3XGQWpmGIWuZ5Gq1weXq7xXqpjuPb9h2BOMw1Xe5GzMCEhghqvjOdXdHly48utXbGTpwCIe/ySQOAeNrdaDSYwBBRzAshE87zJUCPSZi6EI0ErJ/5apmCwUbMq5FHwBWvOQ5IYwLgI4RQVBhPiPW+7hRXDNebNuu93Q88AxZwmf9kBMhpOAAYF4Qa/c2CPV15SIGneV1eN2BNwwBkt+KxHqeHPRDr/dfT/KQdDGo+cMCahUm3js8NeUJspJJdVLAXXa2YDtgQMCIWbyvK4gMiuM8m25x1toDza1v5pdNvf+ZdEPnea4PcadqzRRWwAC8E0gyEUCMwtcyXryYc5cF9d0zgX8zM/RLlCncQZ7lkqXIVdPEvI0F84V8PBBQ3Pi0QbvEoPOZpuVypIYai5872lHmJOFCwi18ZvN8JQEQ5JFgoHyO1q+2WpE5KXegQ3qSUbR2fPSsJHrpgPDo3BeNnnjeZOMFNQvjk1fZmsb1T1Or85Ou5CQUTZCSjwviZF0CvpICcX5tIMl4TIkjnYWHUtOEYOUOI7dV1YcxX+QuuKDD15nwj5h2+wstkwEYxr2VBBCkYvmtNS6CqW6mCAQUzYNvFdmXc+VTdudsgTrD5SYmUkw0NZUWRILRqweyneS0jEFp+MPtl3tGveZVgcEofK4Aocz5Af/+/jiCaRUcQzaIjiGbREUSz6HBB7KRn9D5iEppM7O+c3udEwZqzrpIokNYHR3ky1399BJpAaj1iIzzht+HblVL7s+scvZN4k13iTTllEyMazvd2L270Xb1PEopwwHIupnjk75UriKb4hbK8ECMUBVdMcIrwqfq+Vi7gVA2BmCAhZsMkBKKo1kqQ9cMieOY8/3i8sOqCUKlKzm5cNJWqMWW+lHfCUX6dv+d8nT9mtazi2Pc/Nb9PRMl6S8B+3gzsHmbUegJ8zPtl/PRiypI06TQvRSGfsMRvBtjYcQMB1AhMPQgT5ssuIITCwPhBmDTfEEQYmGoIK2ZNmjYfCSIYzE4+6nKpE1zg5MEZ0+aNQGj5w3jLlHktIxBa9WBMm9cy/g8qSiUY9dkML5RKaJ7v/TP8oHpv0rzWvkD4iYauJHLbdqvab2uJ5aOa1/oHCNFPNQxQe7EAAAAASUVORK5CYII="

/***/ }),
/* 1655 */,
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1503)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(847),
  /* template */
  __webpack_require__(1738),
  /* scopeId */
  "data-v-4e758618",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1542)

var Component = __webpack_require__(5)(
  /* script */
  null,
  /* template */
  __webpack_require__(1767),
  /* scopeId */
  "data-v-9c7bc6a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1511)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(848),
  /* template */
  __webpack_require__(1744),
  /* scopeId */
  "data-v-68ad2087",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1543)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(1768),
  /* scopeId */
  "data-v-a305ba82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1496)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(850),
  /* template */
  __webpack_require__(1731),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1490)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(1727),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1493)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(852),
  /* template */
  __webpack_require__(1729),
  /* scopeId */
  "data-v-327f89bd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1539)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(853),
  /* template */
  __webpack_require__(1764),
  /* scopeId */
  "data-v-911a5e74",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1480)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(1719),
  /* scopeId */
  "data-v-15d24c40",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1504)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(855),
  /* template */
  __webpack_require__(1739),
  /* scopeId */
  "data-v-53979095",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1527)
__webpack_require__(1528)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(856),
  /* template */
  __webpack_require__(1755),
  /* scopeId */
  "data-v-7521d4fe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1538)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(857),
  /* template */
  __webpack_require__(1763),
  /* scopeId */
  "data-v-8da2ba42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1552)
__webpack_require__(1553)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(1776),
  /* scopeId */
  "data-v-f2076b42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1494)
__webpack_require__(1495)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(859),
  /* template */
  __webpack_require__(1730),
  /* scopeId */
  "data-v-350e54af",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1530)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(860),
  /* template */
  __webpack_require__(1757),
  /* scopeId */
  "data-v-79f85968",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1468)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(861),
  /* template */
  __webpack_require__(1709),
  /* scopeId */
  "data-v-02228458",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1547)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(1771),
  /* scopeId */
  "data-v-d7a01e1a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1482)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(863),
  /* template */
  __webpack_require__(1721),
  /* scopeId */
  "data-v-18b9b2cb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1471)
__webpack_require__(1472)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(864),
  /* template */
  __webpack_require__(1712),
  /* scopeId */
  "data-v-0960915a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1531)
__webpack_require__(1532)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(1758),
  /* scopeId */
  "data-v-7a25d8a3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1514)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(866),
  /* template */
  __webpack_require__(1746),
  /* scopeId */
  "data-v-6b886752",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1478)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(1717),
  /* scopeId */
  "data-v-105ee6e3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1516)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(1748),
  /* scopeId */
  "data-v-6d48ba00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1533)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(1759),
  /* scopeId */
  "data-v-7b439a1a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1517)
__webpack_require__(1518)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(871),
  /* template */
  __webpack_require__(1749),
  /* scopeId */
  "data-v-6d7422ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1523)
__webpack_require__(1524)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(872),
  /* template */
  __webpack_require__(1752),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1509)
__webpack_require__(1510)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(873),
  /* template */
  __webpack_require__(1743),
  /* scopeId */
  "data-v-617b035a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1545)
__webpack_require__(1546)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(1770),
  /* scopeId */
  "data-v-ccefbb1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1551)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(1775),
  /* scopeId */
  "data-v-e3b2ce9a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1498)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(877),
  /* template */
  __webpack_require__(1733),
  /* scopeId */
  "data-v-3b692510",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1557)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(1780),
  /* scopeId */
  "data-v-f98c222c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1476)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(879),
  /* template */
  __webpack_require__(1715),
  /* scopeId */
  "data-v-0d76c753",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1529)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(1756),
  /* scopeId */
  "data-v-78c43765",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1488)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(881),
  /* template */
  __webpack_require__(1725),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1487)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(1724),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1555)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(1778),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1501)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(888),
  /* template */
  __webpack_require__(1736),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1549)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(895),
  /* template */
  __webpack_require__(1773),
  /* scopeId */
  "data-v-e1b2b73c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1540)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(896),
  /* template */
  __webpack_require__(1765),
  /* scopeId */
  "data-v-991073e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1537)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(1762),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1512)
__webpack_require__(1513)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(898),
  /* template */
  __webpack_require__(1745),
  /* scopeId */
  "data-v-6b41c27a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1497)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(899),
  /* template */
  __webpack_require__(1732),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1519)
__webpack_require__(1520)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(1750),
  /* scopeId */
  "data-v-6e03159c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1499)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(901),
  /* template */
  __webpack_require__(1734),
  /* scopeId */
  "data-v-45d47950",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1469)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(1710),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1483)
__webpack_require__(1484)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(1722),
  /* scopeId */
  "data-v-19629e46",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1473)
__webpack_require__(1474)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(905),
  /* template */
  __webpack_require__(1713),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1515)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(1747),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1485)
__webpack_require__(1486)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(907),
  /* template */
  __webpack_require__(1723),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1534)
__webpack_require__(1535)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(908),
  /* template */
  __webpack_require__(1760),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1507)
__webpack_require__(1508)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(909),
  /* template */
  __webpack_require__(1742),
  /* scopeId */
  "data-v-5ab42789",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1554)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(1777),
  /* scopeId */
  "data-v-f302e9c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1470)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(911),
  /* template */
  __webpack_require__(1711),
  /* scopeId */
  "data-v-076ff510",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calendar"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("统计年月")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "postion": "relative",
      "top": "-10px"
    },
    attrs: {
      "options": _vm.options
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.valueYearMonth),
      callback: function($$v) {
        _vm.valueYearMonth = $$v
      },
      expression: "valueYearMonth"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_vm._v("登录天数")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', {
    staticClass: "loginRecord"
  }, [_vm._v(_vm._s(_vm.loginRecord) + "天")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "days"
  }, _vm._l((_vm.days), function(dayobject, index) {
    return _c('li', {
      key: index
    }, [(dayobject.day.getMonth() + 1 != _vm.currentMonth) ? _c('span', {
      staticClass: "other-month"
    }, [_vm._v(_vm._s(dayobject.day.getDate()))]) : _c('span', {
      ref: "dayLi",
      refInFor: true,
      staticClass: "curMonthDay",
      on: {
        "click": function($event) {
          return _vm.selectDay($event)
        }
      }
    }, [_vm._v(_vm._s(dayobject.day.getDate()) + "\n      ")])])
  }), 0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "weekdays"
  }, [_c('li', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("周日")]), _vm._v(" "), _c('li', [_vm._v("周一")]), _vm._v(" "), _c('li', [_vm._v("周二")]), _vm._v(" "), _c('li', [_vm._v("周三")]), _vm._v(" "), _c('li', [_vm._v("周四")]), _vm._v(" "), _c('li', [_vm._v("周五")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("周六")])])
}]}

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    staticStyle: {
      "position": "absolute",
      "float": "right",
      "right": "35px",
      "top": "6px"
    },
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.bak
    }
  }, [_vm._v("\n        返回\n      ")]), _vm._v(" "), _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "readonly": "readonly"
    },
    model: {
      value: (_vm.userType),
      callback: function($$v) {
        _vm.userType = $$v
      },
      expression: "userType"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [(_vm.person == '2') ? _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "readonly": "readonly",
      "placeholder": "企业用户"
    },
    model: {
      value: (_vm.checkPerson),
      callback: function($$v) {
        _vm.checkPerson = $$v
      },
      expression: "checkPerson"
    }
  }) : _c('el-input', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "readonly": "readonly",
      "placeholder": "个人用户"
    },
    model: {
      value: (_vm.checkUser),
      callback: function($$v) {
        _vm.checkUser = $$v
      },
      expression: "checkUser"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "aaaaa",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "tooltip-effect": "dark",
      "data": _vm.proList3,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "logo2",
      "header-align": "center",
      "align": "center",
      "min-width": "220px",
      "label": "图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "tpimg",
          attrs: {
            "slot": "reference",
            "src": scope.row.logo2,
            "alt": scope.row.logo2
          },
          slot: "reference"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "min-width": "220",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseMonth",
      "label": "购买时长(月)",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [_c('el-input', {
          staticClass: "input_Border",
          attrs: {
            "type": "number",
            "min": "1",
            "disabled": ""
          },
          model: {
            value: (row.purchaseMonth),
            callback: function($$v) {
              _vm.$set(row, "purchaseMonth", $$v)
            },
            expression: "row.purchaseMonth"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseNum",
      "label": "购买数量",
      "width": "210"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [_c('el-input', {
          staticClass: "input_Border",
          attrs: {
            "type": "number",
            "min": "1",
            "disabled": ""
          },
          model: {
            value: (row.purchaseNum),
            callback: function($$v) {
              _vm.$set(row, "purchaseNum", $$v)
            },
            expression: "row.purchaseNum"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price2",
      "label": "单价(元)",
      "min-width": "200",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-checkbox-group', {
    staticClass: "order-checkbox",
    model: {
      value: (_vm.checkList),
      callback: function($$v) {
        _vm.checkList = $$v
      },
      expression: "checkList"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "试用订单",
      "disabled": ""
    }
  })], 1), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticClass: "allPrice",
    attrs: {
      "label": "总价:"
    }
  }, [_c('el-input', {
    staticClass: "price",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "readonly": "readonly",
      "disabled": _vm.disCheckBox
    },
    model: {
      value: (_vm.allPrice),
      callback: function($$v) {
        _vm.allPrice = $$v
      },
      expression: "allPrice"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('div', {
    staticClass: "ft"
  }, [_c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])])
}]}

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticStyle: {
      "min-width": "1023px"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch),
      expression: "disSouch"
    }],
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList(1)
      }
    },
    model: {
      value: (_vm.proName),
      callback: function($$v) {
        _vm.proName = $$v
      },
      expression: "proName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.getList(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "统计年份"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "change": _vm.accountTypeChange
    },
    model: {
      value: (_vm.accountType),
      callback: function($$v) {
        _vm.accountType = $$v
      },
      expression: "accountType"
    }
  }, _vm._l((_vm.accountTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.exportExlsx()
      }
    }
  }, [_vm._v("批量导出")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v(" \n          " + _vm._s(tag) + " \n      ")])
  }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "账号",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "姓名",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "org_name",
      "label": "企业",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accumulative_integral",
      "label": "累计积分",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "available_integral",
      "label": "可使用积分",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "credits_exchange",
      "label": "已兑换积分",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "border": "1px solid #dfe6ec",
      "margin-top": "0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('div', {
    staticClass: "ft"
  }, [_c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])])
}]}

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-company-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "大区",
            "clearable": true
          },
          model: {
            value: (_vm.regionCode),
            callback: function($$v) {
              _vm.regionCode = $$v
            },
            expression: "regionCode"
          }
        }, _vm._l((_vm.regionCodeList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "企业名称",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.managerAdminuser
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "客户成功经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.successfulManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "经销商",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.agencyManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          attrs: {
            "default-value": _vm.deadTime,
            "type": "date",
            "placeholder": "过期截止日期",
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd"
          },
          model: {
            value: (_vm.deadTime),
            callback: function($$v) {
              _vm.deadTime = $$v
            },
            expression: "deadTime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('div', {
          staticClass: "tips"
        }, [_c('span', [_vm._v("正式客户总数量：")]), _c('span', {
          staticClass: "blueNumber"
        }, [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('span', [_vm._v("甲级正式客户数量：")]), _c('span', {
          staticClass: "redNumber"
        }, [_vm._v(_vm._s(_vm.levelTotal))]), _vm._v(" "), _c('span', [_vm._v("正式用户数：")]), _c('span', {
          staticClass: "purpleNumber"
        }, [_vm._v(_vm._s(_vm.tryTotal))]), _vm._v(" "), _c('span', [_vm._v("高校正式用户数：")]), _c('span', {
          staticClass: "colleges"
        }, [_vm._v(_vm._s(_vm.collegesTotal))]), _vm._v(" "), _c('span', [_vm._v("设计院正式用户数：")]), _c('span', {
          staticClass: "institute"
        }, [_vm._v(_vm._s(_vm.instituteTotal))])]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.proList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight - 36,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "regionCode",
            "label": "大区代号",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.regionCode === '1') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华东大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '2') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '3') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '4') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华南大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '5') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西南大区")]) : _vm._e(), _vm._v(" "), (!scope.row.regionCode) ? _c('span', [_vm._v("-")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "sortable": "custom",
            "min-width": "260",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "grade",
            "label": "资质等级",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.grade === '1') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("综合甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '2') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '3') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '4') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '5') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '6') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '7') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '9') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("高校")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '10') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("施工单位")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '8') ? _c('div', {
                staticClass: "other"
              }, [_vm._v("其他")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "natrue",
            "label": "企业性质",
            "sortable": "custom",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.natrue === '1' ? '央企' : scope.row.natrue === '2' ? '国企' : scope.row.natrue === '3' ? '民营上市' :
                scope.row.natrue === '4' ? '民营' : scope.row.natrue === '5' ? '高校' : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "zsuc",
            "label": "正式用户数",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "showname",
            "label": "地区",
            "sortable": "custom",
            "min-width": "180",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "公司管理员",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managername ? scope.row.managername : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户经理",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managerAdminuserName ? scope.row.managerAdminuserName : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户成功经理",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.successfulManagerName ?
                scope.row.successfulManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "经销商",
            "min-width": "70",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.agencyManagerName ?
                scope.row.agencyManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "正式产品总数",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "blue_num"
              }, [_vm._v(_vm._s(scope.row.ac ? scope.row.ac : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "即将过期产品数量",
            "min-width": "60",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "orange"
              }, [_vm._v(_vm._s(scope.row.dc ? scope.row.dc : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleCom(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (_vm.id == scope.row.createUser && scope.row.delFlg !== '0') ? _c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "width": "850px",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            },
            "close": _vm.closedialog
          }
        }, [(_vm.addFormVisible) ? _c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-autocomplete', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请输入",
            "clearable": "",
            "fetch-suggestions": _vm.querySearch,
            "trigger-on-focus": false
          },
          on: {
            "select": _vm.handleSelect
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地区",
            "prop": "showname"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.showname),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "showname", $$v)
            },
            expression: "addForm.showname"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户地址",
            "required": ""
          }
        }, [_c('GisCommon', {
          attrs: {
            "selected": _vm.selected,
            "address": _vm.address
          },
          on: {
            "backPram": _vm.backPram
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户经理",
            "required": ""
          }
        }, [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业图标",
            "required": ""
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.imageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.imageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              return _vm.handerClose('addFormVisible', 'addForm')
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片"
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.editImageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.editImageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地区",
            "prop": "showname"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.showname),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "showname", $$v)
            },
            expression: "editForm.showname"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.orderVisible) ? _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "选择人员",
            "visible": _vm.orderVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.orderVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px",
            "border": "1px solid #dfe6ec"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs2
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": _vm.changeSouch2
          },
          model: {
            value: (_vm.value2),
            callback: function($$v) {
              _vm.value2 = $$v
            },
            expression: "value2"
          }
        }, _vm._l((_vm.optionsSouch2), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disSouch),
            expression: "disSouch"
          }],
          staticStyle: {
            "width": "200px"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.proName2),
            callback: function($$v) {
              _vm.proName2 = $$v
            },
            expression: "proName2"
          }
        }), _vm._v(" "), _c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disinvit),
            expression: "disinvit"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs2.invitValue),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "invitValue", $$v)
            },
            expression: "souchs2.invitValue"
          }
        }, _vm._l((_vm.inviValues), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disSofttype),
            expression: "disSofttype"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs2.softtype),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "softtype", $$v)
            },
            expression: "souchs2.softtype"
          }
        }, _vm._l((_vm.softtypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-date-picker', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disTime1),
            expression: "disTime1"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "注册开始时间"
          },
          model: {
            value: (_vm.souchs2.fromtime),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "fromtime", $$v)
            },
            expression: "souchs2.fromtime"
          }
        }), _vm._v(" "), _c('el-date-picker', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disTime2),
            expression: "disTime2"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "注册结束时间"
          },
          model: {
            value: (_vm.souchs2.totime),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "totime", $$v)
            },
            expression: "souchs2.totime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags2), function(tag2) {
          return _c('el-tag', {
            key: tag2,
            attrs: {
              "closable": "",
              "disable-transitions": false
            },
            on: {
              "close": function($event) {
                return _vm.handleClose2(tag2)
              }
            }
          }, [_vm._v("\n          " + _vm._s(tag2) + "\n        ")])
        }), _vm._v(" "), (_vm.dynamicTags2 != '') ? _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          on: {
            "click": _vm.delTags2
          }
        }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.userLoading),
            expression: "userLoading"
          }],
          ref: "userList",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "row-key": function (row) { return row.id; },
            "data": _vm.userList,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "current-change": _vm.handleSelectionChange,
            "selection-change": _vm.handleUserSelectionChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "reserve-selection": true,
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "130"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "xshow-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "注册时间",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "border": "1px solid #dfe6ec",
            "margin-top": "0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": " prev, pager, next",
            "current-page": _vm.pageNumber2,
            "page-size": _vm.pageSize2,
            "total": _vm.total2
          },
          on: {
            "current-change": _vm.handleCurrentChange2
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.orderVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.orderLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.clickUserSelection.apply(null, arguments)
            }
          }
        }, [_vm._v("确定")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adminVisible) ? _c('Admin', {
          attrs: {
            "adminVisible": _vm.adminVisible,
            "companyId": _vm.companyId,
            "UserSelection": _vm.UserSelection
          },
          on: {
            "adminVisibleClose": _vm.adminVisibleClose,
            "addAdmin": _vm.addAdmin,
            "orderUserSubmit": _vm.orderUserSubmit
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "update:currentPage": function($event) {
              _vm.pageNumber = $event
            },
            "update:current-page": function($event) {
              _vm.pageNumber = $event
            },
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-account-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "产品名称"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getProList(1)
            }
          },
          model: {
            value: (_vm.souchs.proName),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "proName", $$v)
            },
            expression: "souchs.proName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getProList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.proList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "logo2",
            "header-align": "center",
            "align": "center",
            "width": "200px",
            "label": "图片",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('img', {
                staticClass: "tpimg",
                attrs: {
                  "slot": "reference",
                  "src": scope.row.logo2,
                  "alt": scope.row.logo2
                },
                slot: "reference"
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "产品名称",
            "min-width": "240",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price",
            "label": "单价(元/月)",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "purchasabled",
            "label": "是否可购买",
            "width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag primary"
              }, [_vm._v(_vm._s(scope.row.purchasable == 1 ? "否" : '是'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "useful",
            "label": "是否作废",
            "width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag primary"
              }, [_vm._v(_vm._s(scope.row.useful == 1 ? "否" : '是'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })])], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增产品",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片",
            "required": ""
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.imageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.imageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入",
            "auto-complete": "off"
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "单价",
            "prop": "price"
          }
        }, [_c('el-input', {
          staticStyle: {
            "width": "217px"
          },
          attrs: {
            "placeholder": "请输入"
          },
          on: {
            "blur": function($event) {
              return _vm.priceLose(1)
            }
          },
          model: {
            value: (_vm.addForm.price),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "price", $$v)
            },
            expression: "addForm.price"
          }
        }), _vm._v(" 元/月\n            ")], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "可购买",
            "prop": "purchasable"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.purchasable),
            callback: function($$v) {
              _vm.purchasable = $$v
            },
            expression: "purchasable"
          }
        }, _vm._l((_vm.gms), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "是否废弃",
            "prop": "useful"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.useful),
            callback: function($$v) {
              _vm.useful = $$v
            },
            expression: "useful"
          }
        }, _vm._l((_vm.usefulLists), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "产品模块"
          }
        }, [_c('div', {
          staticClass: "mk_div",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange
          },
          model: {
            value: (_vm.checkedCities),
            callback: function($$v) {
              _vm.checkedCities = $$v
            },
            expression: "checkedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticClass: "mk_elbox",
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑产品",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            },
            "closed": _vm.closeDialog
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片",
            "required": ""
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.editImageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.editImageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "单价",
            "prop": "price"
          }
        }, [_c('el-input', {
          staticStyle: {
            "width": "217px"
          },
          attrs: {
            "placeholder": "请输入"
          },
          on: {
            "blur": function($event) {
              return _vm.priceLose(2)
            }
          },
          model: {
            value: (_vm.editForm.price),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "price", $$v)
            },
            expression: "editForm.price"
          }
        }), _vm._v(" 元/月\n            ")], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "可购买",
            "prop": "purchasable"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.editForm.purchasable),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "purchasable", $$v)
            },
            expression: "editForm.purchasable"
          }
        }, _vm._l((_vm.gms), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "是否废弃",
            "prop": "useful"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.editForm.useful),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "useful", $$v)
            },
            expression: "editForm.useful"
          }
        }, _vm._l((_vm.usefulLists), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "产品模块"
          }
        }, [_c('div', {
          staticClass: "mk_div",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange2
          },
          model: {
            value: (_vm.editCheckedCities),
            callback: function($$v) {
              _vm.editCheckedCities = $$v
            },
            expression: "editCheckedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticClass: "mk_elbox",
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "base-container",
    class: {
      noPageHd: !_vm.isPageHd,
      noMainHd: !_vm.isMainHd,
      noPageFt: !_vm.isHasPageFt,
    }
  }, [(_vm.isPageHd) ? _c('header', {
    staticClass: "base-container-hd"
  }, [_c('span', {
    staticClass: "arrow"
  }), _vm._v(" " + _vm._s(_vm.getCurMenu))]) : _vm._e(), _vm._v(" "), [_c('main', {
    staticClass: "base-container-bd"
  }, [_c('header', {
    staticClass: "content-hd"
  }, [_vm._t("hd")], 2), _vm._v(" "), _c('section', {
    staticClass: "content-bd"
  }, [_vm._t("main")], 2)]), _vm._v(" "), (_vm.isHasPageFt) ? _c('footer', {
    staticClass: "base-container-ft"
  }, [_vm._t("ft")], 2) : _vm._e()]], 2)
},staticRenderFns: []}

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.adminModulePointPie
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "charts-box-copy-lpie"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "账号 / 姓名 / 企业",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "souch_change souch_input",
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "状态",
      "clearable": ""
    },
    model: {
      value: (_vm.typeValue),
      callback: function($$v) {
        _vm.typeValue = $$v
      },
      expression: "typeValue"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticClass: "souch_change souch_input",
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "部门",
      "clearable": ""
    },
    model: {
      value: (_vm.deptId),
      callback: function($$v) {
        _vm.deptId = $$v
      },
      expression: "deptId"
    }
  }, _vm._l((_vm.detpList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.deptname,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.addList
    }
  }, [_vm._v("添加用户")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.userList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55",
      "selectable": _vm.selectInit
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "point",
      "label": "积分",
      "min-width": "100",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "企业",
      "min-width": "200",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.deptname || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invitestatusname",
      "label": "状态",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "operate"
        }, [(!scope.row.delShow) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "删除",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont icondelete",
          on: {
            "click": function($event) {
              return _vm.batchRemove(scope.$index, scope.row)
            }
          }
        })]) : _c('span', {
          staticClass: "dnnfont icondelete icon-disabled"
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "添加",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs2
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch2
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.optionsSouch2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch2),
      expression: "disSouch2"
    }],
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getComUser(1)
      }
    },
    model: {
      value: (_vm.proName2),
      callback: function($$v) {
        _vm.proName2 = $$v
      },
      expression: "proName2"
    }
  }), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSofttype2),
      expression: "disSofttype2"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.souchs2.softtype),
      callback: function($$v) {
        _vm.$set(_vm.souchs2, "softtype", $$v)
      },
      expression: "souchs2.softtype"
    }
  }, _vm._l((_vm.softtypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disTime1),
      expression: "disTime1"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "开始日期时间"
    },
    model: {
      value: (_vm.souchs2.fromtime),
      callback: function($$v) {
        _vm.$set(_vm.souchs2, "fromtime", $$v)
      },
      expression: "souchs2.fromtime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disTime2),
      expression: "disTime2"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "结束日期时间"
    },
    model: {
      value: (_vm.souchs2.totime),
      callback: function($$v) {
        _vm.$set(_vm.souchs2, "totime", $$v)
      },
      expression: "souchs2.totime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getComUser(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags2), function(tag2) {
    return _c('el-tag', {
      key: tag2,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose2(tag2)
        }
      }
    }, [_vm._v(" \n              " + _vm._s(tag2) + " \n          ")])
  }), _vm._v(" "), (_vm.dynamicTags2 != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags2
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    ref: "companyList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companyList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange2,
      "current-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "softtype",
      "label": "软件类型",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "企业",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100, '全部'],
      "page-size": _vm.pageSize2,
      "total": _vm.total2,
      "current-page": _vm.pageNumber2
    },
    on: {
      "current-change": _vm.handleCurrentChange2,
      "size-change": _vm.handleSizeChange2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.adminModulePointPieCopy
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "charts-box-copy-lpie"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("系统设置")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle"
  }, [_vm._v("硬件绑定")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle-switch"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-switch', {
    on: {
      "change": _vm.submit
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("是否启用硬件绑定")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(751)
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "logo_span"
  }, [_vm._v("Delauney")]), _vm._v(" "), _c('div', {
    staticClass: "full"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "login_div"
  }, [_c('span', {
    staticClass: "login_span"
  }, [_vm._v("Reset your password")]), _vm._v(" "), _c('div', {
    staticClass: "sub_desc"
  }, [_vm._v("\n          We will send you an email to reset your password\n        ")]), _vm._v(" "), _c('el-form', {
    ref: "emailForm",
    attrs: {
      "model": _vm.emailForm,
      "rules": _vm.emailRules,
      "hide-required-asterisk": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "Email",
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Email address"
    },
    on: {
      "input": _vm.validateEmail
    },
    model: {
      value: (_vm.emailForm.Email),
      callback: function($$v) {
        _vm.$set(_vm.emailForm, "Email", $$v)
      },
      expression: "emailForm.Email"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "login_submit",
    attrs: {
      "type": "danger"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextStep(1)
      }
    }
  }, [_vm._v("CONTINUE")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }],
    staticClass: "code_div"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "backup",
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("←")]), _vm._v(" "), _c('span', {
    staticClass: "login_span"
  }, [_vm._v("Verify your identity")])]), _vm._v(" "), _c('div', {
    staticClass: "sub_desc"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("Enter the code we've sent to")]), _vm._v(" "), _c('span', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.emailForm.Email))])]), _vm._v(" "), _c('el-form', {
    ref: "codeForm",
    attrs: {
      "model": _vm.codeForm,
      "rules": _vm.codeRules
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "verificationCode",
      "label": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "code"
    },
    model: {
      value: (_vm.codeForm.verificationCode),
      callback: function($$v) {
        _vm.$set(_vm.codeForm, "verificationCode", $$v)
      },
      expression: "codeForm.verificationCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "no_see"
  }, [_c('span', {
    staticClass: "not_see"
  }, [_vm._v("Don't see it? ")]), _vm._v(" "), _c('span', {
    staticClass: "resend"
  }, [_c('el-button', {
    staticClass: "el_reg resend",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [(_vm.time) ? _c('span', [_vm._v(_vm._s(_vm.time) + "s later ")]) : _vm._e(), _vm._v("Resend code\n            ")])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "reset_box"
  }, [_c('span', {
    staticClass: "login_span"
  }, [_vm._v("Change your password")]), _vm._v(" "), _c('div', {
    staticClass: "sub_desc"
  }, [_vm._v("\n          Enter a new password bellow to change your password\n        ")]), _vm._v(" "), _c('el-form', {
    ref: "resetForm",
    attrs: {
      "model": _vm.resetForm,
      "rules": _vm.resetRules,
      "hide-required-asterisk": true
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "newPassword",
      "label": "New password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "newPassword",
      "show-password": ""
    },
    on: {
      "input": _vm.validatePassword
    },
    model: {
      value: (_vm.resetForm.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.resetForm, "newPassword", $$v)
      },
      expression: "resetForm.newPassword"
    }
  })], 1), _vm._v(" "), (_vm.resetForm.newPassword) ? [_c('p', {
    class: {
      'error-text': !_vm.containsAtLeastEightCharacters,
      'true-text': _vm.containsAtLeastEightCharacters,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsAtLeastEightCharacters ? "√" : "X"))]), _vm._v("\n              Contains at least 8 characters\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.containsBothLowerUpper,
      'true-text': _vm.containsBothLowerUpper,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsBothLowerUpper ? "√" : "X"))]), _vm._v("\n              contains both lower (a-z) and upper case letters (A-Z)\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.containsNumberOrSymbol,
      'true-text': _vm.containsNumberOrSymbol,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsNumberOrSymbol ? "√" : "X"))]), _vm._v("\n              contains at least one number (0-9) or a symbol\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.doesNotContainEmail,
      'true-text': _vm.doesNotContainEmail,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.doesNotContainEmail ? "√" : "X"))]), _vm._v("\n              Does not contain your email address\n            ")])] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "confirmPassword",
      "label": "Confirm password "
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "confirmPassword",
      "show-password": ""
    },
    model: {
      value: (_vm.resetForm.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.resetForm, "confirmPassword", $$v)
      },
      expression: "resetForm.confirmPassword"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "submit",
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("CHANGE PASSWORD")])], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 4),
      expression: "step == 4"
    }],
    staticClass: "success_box"
  }, [_c('div', {
    staticClass: "success"
  }, [_vm._v("🥳 Success!")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Your password has been updated successfully")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.delauney.ltd/pc_index",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fwgw"
  }, [_vm._v("Visit official website →")])])
}]}

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.adminVisible) ? _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "企业管理员",
      "width": "950px",
      "visible": _vm.adminVisible,
      "close-on-click-modal": false,
      "before-close": _vm.adminVisibleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.adminVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userLoading),
      expression: "userLoading"
    }],
    ref: "userList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row-key": function (row) { return row.id; },
      "data": _vm.adminList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "xshow-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "softtype",
      "label": "软件类型",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "企业",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "intime",
      "label": "注册时间",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "160",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "plain": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 88714150)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.adminVisibleClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addAdmin.apply(null, arguments)
      }
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.orderUserSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-detail-box"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "font",
    on: {
      "click": _vm.bak
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left icon"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "shu"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "font-text"
  }, [_vm._v(_vm._s(_vm.$route.query.companyName))]), _vm._v(" "), _c('span', {
    staticClass: "export"
  }, [_c('a', {
    attrs: {
      "href": _vm.href
    }
  }, [_c('span', {
    staticClass: "el-icon-download"
  }), _vm._v("导出统计数据")])]), _vm._v(" "), _c('span', {
    staticClass: "export"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.pointByHour
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("用户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6"
    }
  }, [_vm._v("部门管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("产品管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("设备管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }, [_vm._v("跟踪记录")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("分析统计")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [_vm._v("企业设置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-content"
  }, [(_vm.showCom) ? _c('div', [_c('company')], 1) : _vm._e(), _vm._v(" "), (_vm.showWeP) ? _c('div', [_c('weProduct')], 1) : _vm._e(), _vm._v(" "), (_vm.showDev) ? _c('div', [_c('device')], 1) : _vm._e(), _vm._v(" "), (_vm.showFx) ? _c('Static', {
    attrs: {
      "comId": _vm.$route.query.companyId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 6) ? _c('DepartManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 7) ? _c('TrackManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 8) ? _c('CompamySetting', {
    attrs: {
      "editLevel": false
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-order-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "用户 / 企业 / 价格",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "类型",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.souType),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "souType", $$v)
            },
            expression: "souchs.souType"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "订单",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.souAccount),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "souAccount", $$v)
            },
            expression: "souchs.souAccount"
          }
        }, _vm._l((_vm.accountTypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "开始日期时间"
          },
          model: {
            value: (_vm.souchs.fromtime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "fromtime", $$v)
            },
            expression: "souchs.fromtime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "结束日期时间"
          },
          model: {
            value: (_vm.souchs.totime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "totime", $$v)
            },
            expression: "souchs.totime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.addList
          }
        }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
          return _c('el-tag', {
            key: tag,
            attrs: {
              "closable": "",
              "disable-transitions": false
            },
            on: {
              "close": function($event) {
                return _vm.handleClose(tag)
              }
            }
          }, [_vm._v(" \n              " + _vm._s(tag) + " \n          ")])
        }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          on: {
            "click": _vm.delTags
          }
        }, [_vm._v("清除标签")]) : _vm._e()], 2)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "200",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "用户",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userid ? scope.row.name : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usercompany",
            "label": "企业",
            "min-width": "260",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userid ? scope.row.usercompany : scope.row.name))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "时间",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminusername",
            "label": "操作人",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price2",
            "label": "价格(元)",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "typename",
            "label": "类型",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.type == 1 ? 'primary' : 'success'
              }, [_vm._v(_vm._s(scope.row.typename))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "stateverify",
            "label": "订单状态",
            "width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.stateverify == 1 ? 'warning' : 'primary'
              }, [_vm._v(_vm._s(scope.row.stateverify == 1 ? "申请中" : '审核通过'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "isrenew",
            "label": "续订订单",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag-fill",
                class: scope.row.isrenew == 2 ? 'pruple' : 'primary'
              }, [_vm._v(_vm._s(scope.row.isrenew == 2 ? "是" : '否'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "fixed": "right",
            "min-width": "140"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.$index, scope.row, 1)
                  }
                }
              })]), _vm._v(" "), (scope.row.adminuserid == _vm.userInfo.id && scope.row.stateverify == 1) ? [(scope.row.isrenew != 2) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "撤销",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconundo",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })])] : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1 && scope.row.stateverify == 1) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "审核",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconapprove",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.$index, scope.row, 2)
                  }
                }
              })]) : _vm._e()], 2)]
            }
          }])
        })], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-UrlsLBT-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', [_c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.imgList,
            "highlight-current-row": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "prop": "index",
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "lbtfileName",
            "label": "名称",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "lbtpic2",
            "header-align": "center",
            "align": "center",
            "min-width": "200",
            "label": "图片"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('img', {
                staticClass: "tpimg",
                attrs: {
                  "slot": "reference",
                  "src": scope.row.lbtpic2,
                  "alt": scope.row.lbtpic2
                },
                slot: "reference"
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "px",
            "label": "排序",
            "min-width": "140"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var row = ref.row;
              var $index = ref.$index;

              return [(_vm.imgList[$index]) ? _c('el-input', {
                staticStyle: {
                  "width": "100px"
                },
                attrs: {
                  "type": "tel",
                  "onkeypress": "return( /[\\d]/.test(String.fromCharCode(event.keyCode) ) )"
                },
                on: {
                  "blur": function($event) {
                    return _vm.loseFcous($index, row)
                  }
                },
                nativeOn: {
                  "keyup": function($event) {
                    if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
                    return _vm.loseFcous($index, row)
                  }
                },
                model: {
                  value: (row.px),
                  callback: function($$v) {
                    _vm.$set(row, "px", $$v)
                  },
                  expression: "row.px"
                }
              }) : _vm._e(), _vm._v(" "), (!_vm.imgList[$index]) ? _c('span', [_vm._v(_vm._s(row.px))]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "lbtlink",
            "label": "超链接",
            "min-width": "250",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n               " + _vm._s(scope.row.lbtlink || '-') + "\n             ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handledel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片"
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.imageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.imageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "lbtfileName"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.lbtfileName),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "lbtfileName", $$v)
            },
            expression: "addForm.lbtfileName"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "超链接",
            "prop": "lbtlink"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.lbtlink),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "lbtlink", $$v)
            },
            expression: "addForm.lbtlink"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "排序",
            "prop": "px"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.px),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "px", $$v)
            },
            expression: "addForm.px"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addImgLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addImgSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片"
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.editImageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.editImageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "lbtfileName"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.lbtfileName),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "lbtfileName", $$v)
            },
            expression: "editForm.lbtfileName"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "超链接",
            "prop": "lbtlink"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.lbtlink),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "lbtlink", $$v)
            },
            expression: "editForm.lbtlink"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "排序",
            "prop": "px"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.px),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "px", $$v)
            },
            expression: "editForm.px"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editImgLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editImgSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-depart-form",
    attrs: {
      "width": "850px",
      "title": _vm.title,
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handerClose
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "-10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门名称",
      "prop": "deptname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.deptname),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "deptname", $$v)
      },
      expression: "ruleForm.deptname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门管理员",
      "prop": "deptmanager"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.deptmanager),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "deptmanager", $$v)
      },
      expression: "ruleForm.deptmanager"
    }
  }, _vm._l((_vm.allCompanyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门人员",
      "prop": "useridList"
    }
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "姓名 / 账号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getComUser(1)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getComUser(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "companyRef",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companyList,
      "highlight-current-row": "",
      "height": 500
    },
    on: {
      "selection-change": _vm.handerSectionChange,
      "row-click": _vm.handerRowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "软件类型",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "160",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.deptname || '-'))])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "日活用户",
      "visible": _vm.dialogVisible,
      "width": "80%",
      "custom-class": "dialog",
      "footer": false
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('Account')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "tab-detart-manage",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-form', {
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "部门 / 管理员",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "plain": "",
            "icon": "el-icon-plus"
          },
          on: {
            "click": _vm.addForm
          }
        }, [_vm._v("新 增")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          ref: "companyTabRef",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": ""
          },
          on: {
            "selection-change": _vm.handerSectionChange,
            "row-click": _vm.handerRowClick
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "deptname",
            "min-width": "180",
            "label": "部门名称",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n            " + _vm._s(scope.row.deptname || '-') + "\n          ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "deptManagerName",
            "min-width": "180",
            "label": "部门管理员",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n            " + _vm._s(scope.row.deptManagerName || '-') + "\n          ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.hasUser != 1) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), (_vm.visible) ? _c('ModalForm', {
          attrs: {
            "visible": _vm.visible,
            "mode": _vm.mode,
            "processDetail": _vm.processDetail
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            "getList": _vm.getList
          }
        }) : _vm._e(), _vm._v(" "), (_vm.visibleView) ? _c('ModalFormView', {
          attrs: {
            "visible": _vm.visibleView,
            "processDetail": _vm.processDetail
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleView = $event
            }
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "position": "relative"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tmain\n")])
},staticRenderFns: []}

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "addBusinessClass",
      "title": "新增企业",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "100px",
      "rules": _vm.addFormRules,
      "label-position": "right"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "地区",
      "prop": "showname"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.addForm.showname),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "showname", $$v)
      },
      expression: "addForm.showname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "大区代号",
      "prop": "regionCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.regionCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "regionCode", $$v)
      },
      expression: "addForm.regionCode"
    }
  }, _vm._l((_vm.regionCodeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资质等级",
      "prop": "grade"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.grade),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "grade", $$v)
      },
      expression: "addForm.grade"
    }
  }, _vm._l((_vm.gradeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业性质",
      "prop": "natrue"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.natrue),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "natrue", $$v)
      },
      expression: "addForm.natrue"
    }
  }, _vm._l((_vm.natureList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户规模",
      "prop": "userScale"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.userScale),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "userScale", $$v)
      },
      expression: "addForm.userScale"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户地址",
      "prop": "addressInfo"
    }
  }, [_c('GisCommon', {
    attrs: {
      "selected": _vm.selected,
      "address": _vm.addForm.addressInfo
    },
    on: {
      "update:address": function($event) {
        return _vm.$set(_vm.addForm, "addressInfo", $event)
      },
      "backPram": _vm.backPram
    },
    model: {
      value: (_vm.addForm.addressInfo),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "addressInfo", $$v)
      },
      expression: "addForm.addressInfo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "客户经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/manageList",
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.managerAdminuser
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "客户成功经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 3
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.successfulManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "经销商",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 4
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.agencyManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticClass: "ratingClass",
    attrs: {
      "label": "客户分级",
      "prop": "level"
    }
  }, [_c('el-rate', {
    attrs: {
      "max": 3
    },
    model: {
      value: (_vm.addForm.level),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "level", $$v)
      },
      expression: "addForm.level"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业联系人",
      "prop": "linker"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.linker),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "linker", $$v)
      },
      expression: "addForm.linker"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式",
      "prop": "linkerPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.linkerPhone),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "linkerPhone", $$v)
      },
      expression: "addForm.linkerPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业图标"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    attrs: {
      "auto-upload": false,
      "on-change": _vm.imgPreview,
      "action": _vm.upload.postURL,
      "show-file-list": false
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "imger"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "registerForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.registerForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("注册帐号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-dianhua"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.registerForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "phone", $$v)
      },
      expression: "registerForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "smsCode"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-securityCode-b"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone form-control",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.registerForm.smsCode),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "smsCode", $$v)
      },
      expression: "registerForm.smsCode"
    }
  }), _vm._v(" "), (_vm.disabled == false) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v("发送验证码\r\n          ")]) : _vm._e(), _vm._v(" "), (_vm.disabled == true) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v(_vm._s(_vm.btntxt) + "\r\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-mima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.registerForm.password),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "password", $$v)
      },
      expression: "registerForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "conpassword"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-querenmima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "确认密码"
    },
    model: {
      value: (_vm.registerForm.conpassword),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "conpassword", $$v)
      },
      expression: "registerForm.conpassword"
    }
  })], 1), _vm._v(" "), _c('slide-verify', {
    attrs: {
      "slider-text": _vm.texts
    },
    on: {
      "success": _vm.onSuccess,
      "fail": _vm.onFail,
      "refresh": _vm.onRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("注册")])], 1)], 1)], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBar"
  }, [_c('h1'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.jsdnn.com/",
      "target": "_blank"
    }
  }, [_vm._v("狄诺尼官网")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('p', [_vm._v("江苏狄诺尼信息技术有限责任公司")]), _vm._v(" "), _c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])
}]}

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-company-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "大区",
            "clearable": true
          },
          model: {
            value: (_vm.regionCode),
            callback: function($$v) {
              _vm.regionCode = $$v
            },
            expression: "regionCode"
          }
        }, _vm._l((_vm.regionCodeList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "企业名称",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.managerAdminuser
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "客户成功经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.successfulManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "经销商",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.agencyManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "placeholder": "是否分配",
            "clearable": ""
          },
          model: {
            value: (_vm.distributionStatus),
            callback: function($$v) {
              _vm.distributionStatus = $$v
            },
            expression: "distributionStatus"
          }
        }, _vm._l((_vm.distribution), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "资质等级",
            "multiple": "",
            "collapse-tags": "",
            "clearable": ""
          },
          model: {
            value: (_vm.gradeValue),
            callback: function($$v) {
              _vm.gradeValue = $$v
            },
            expression: "gradeValue"
          }
        }, _vm._l((_vm.gradeArr), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [(_vm.userInfo.type == 1) ? _c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")]) : _vm._e()], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('div', {
          staticClass: "tips"
        }, [_c('span', [_vm._v("覆盖率：")]), _c('span', {
          staticClass: "blueNumber"
        }, [_vm._v(_vm._s(_vm.targetTotal))]), _vm._v(" "), _c('span', [_vm._v("甲级目标客户总数量：")]), _c('span', {
          staticClass: "redNumber"
        }, [_vm._v(_vm._s(_vm.qualityTotal))]), _vm._v(" "), _c('span', [_vm._v("高校目标客户总数量："), _c('span', {
          staticClass: "colleges"
        }, [_vm._v(_vm._s(_vm.collegesTotal))])])]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.proList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight - 36,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "企业编号（ID）",
            "sortable": "custom",
            "min-width": "150",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "regionCode",
            "label": "大区代号",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.regionCode === '1') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华东大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '2') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '3') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '4') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华南大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '5') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西南大区")]) : _vm._e(), _vm._v(" "), (!scope.row.regionCode) ? _c('span', [_vm._v("-")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "sortable": "custom",
            "min-width": "240",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "grade",
            "label": "资质等级",
            "sortable": "custom",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.grade == '1') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("综合甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '2') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '3') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '4') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '5') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '6') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '7') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '9') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("高校")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '10') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("施工单位")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '8') ? _c('div', {
                staticClass: "other"
              }, [_vm._v("其他")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "natrue",
            "label": "企业性质",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.natrue === "1" ?
                "央企" :
                scope.row.natrue === "2" ?
                "国企" :
                scope.row.natrue === "3" ?
                "民营上市" :
                scope.row.natrue === "4" ?
                "民营" :
                scope.row.natrue === "5" ?
                "高校" :
                "-") + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "userScale",
            "label": "用户规模",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userScale || "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "showname",
            "label": "地区",
            "sortable": "custom",
            "min-width": "140",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.showname || "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户分级",
            "prop": "level",
            "sortable": "custom",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-rate', {
                attrs: {
                  "value": Number(scope.row.level),
                  "max": Number(scope.row.level)
                }
              }), _vm._v(" "), (!scope.row.level) ? _c('span', [_vm._v("-")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户经理",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managerAdminuserName ?
                scope.row.managerAdminuserName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户成功经理",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.successfulManagerName ?
                scope.row.successfulManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "经销商",
            "min-width": "70",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.agencyManagerName ?
                scope.row.agencyManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "status",
            "width": "100",
            "label": "企业状态",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.status == 0) ? _c('div', {
                staticClass: "visit_gray"
              }, [_vm._v("初始")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('div', {
                staticClass: "orange"
              }, [_vm._v("拜访")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('div', {
                staticClass: "purple_line"
              }, [_vm._v("试用")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('div', {
                staticClass: "blue_line"
              }, [_vm._v("正式")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleCom(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.delFlg !== '0') ? _c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()]
            }
          }])
        })], 1), _vm._v(" "), _c('target-custom-dialog', {
          ref: "targetcustomdialogRef",
          on: {
            "getList": _vm.getList
          }
        }), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "width": "850px",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            },
            "close": _vm.closedialog
          }
        }, [(_vm.addFormVisible) ? _c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-autocomplete', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请输入",
            "clearable": "",
            "fetch-suggestions": _vm.querySearch,
            "trigger-on-focus": false
          },
          on: {
            "select": _vm.handleSelect
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地区",
            "prop": "showname"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.showname),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "showname", $$v)
            },
            expression: "addForm.showname"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户地址",
            "required": ""
          }
        }, [_c('GisCommon', {
          attrs: {
            "selected": _vm.selected,
            "address": _vm.address
          },
          on: {
            "backPram": _vm.backPram
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户经理",
            "required": ""
          }
        }, [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业图标",
            "required": ""
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.imageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.imageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              return _vm.handerClose('addFormVisible', 'addForm')
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片"
          }
        }, [_c('el-upload', {
          ref: "upload",
          staticClass: "avatar-uploader",
          attrs: {
            "auto-upload": false,
            "on-change": _vm.imgPreview,
            "action": _vm.upload.postURL,
            "show-file-list": false
          }
        }, [(_vm.editImageUrl) ? _c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm.editImageUrl
          }
        }) : _c('i', {
          staticClass: "el-icon-plus avatar-uploader-icon"
        })])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地区",
            "prop": "showname"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.showname),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "showname", $$v)
            },
            expression: "editForm.showname"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.orderVisible) ? _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "选择人员",
            "visible": _vm.orderVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.orderVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px",
            "border": "1px solid #dfe6ec"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs2
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          on: {
            "change": _vm.changeSouch2
          },
          model: {
            value: (_vm.value2),
            callback: function($$v) {
              _vm.value2 = $$v
            },
            expression: "value2"
          }
        }, _vm._l((_vm.optionsSouch2), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disSouch),
            expression: "disSouch"
          }],
          staticStyle: {
            "width": "200px"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.proName2),
            callback: function($$v) {
              _vm.proName2 = $$v
            },
            expression: "proName2"
          }
        }), _vm._v(" "), _c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disinvit),
            expression: "disinvit"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs2.invitValue),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "invitValue", $$v)
            },
            expression: "souchs2.invitValue"
          }
        }, _vm._l((_vm.inviValues), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disSofttype),
            expression: "disSofttype"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs2.softtype),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "softtype", $$v)
            },
            expression: "souchs2.softtype"
          }
        }, _vm._l((_vm.softtypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), _c('el-date-picker', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disTime1),
            expression: "disTime1"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "注册开始时间"
          },
          model: {
            value: (_vm.souchs2.fromtime),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "fromtime", $$v)
            },
            expression: "souchs2.fromtime"
          }
        }), _vm._v(" "), _c('el-date-picker', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.disTime2),
            expression: "disTime2"
          }],
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "注册结束时间"
          },
          model: {
            value: (_vm.souchs2.totime),
            callback: function($$v) {
              _vm.$set(_vm.souchs2, "totime", $$v)
            },
            expression: "souchs2.totime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags2), function(tag2) {
          return _c('el-tag', {
            key: tag2,
            attrs: {
              "closable": "",
              "disable-transitions": false
            },
            on: {
              "close": function($event) {
                return _vm.handleClose2(tag2)
              }
            }
          }, [_vm._v("\n          " + _vm._s(tag2) + "\n        ")])
        }), _vm._v(" "), (_vm.dynamicTags2 != '') ? _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          on: {
            "click": _vm.delTags2
          }
        }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.userLoading),
            expression: "userLoading"
          }],
          ref: "userList",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "row-key": function (row) { return row.id; },
            "data": _vm.userList,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "current-change": _vm.handleSelectionChange,
            "selection-change": _vm.handleUserSelectionChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "reserve-selection": true,
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "130"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "xshow-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "注册时间",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "border": "1px solid #dfe6ec",
            "margin-top": "0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": " prev, pager, next",
            "current-page": _vm.pageNumber2,
            "page-size": _vm.pageSize2,
            "total": _vm.total2
          },
          on: {
            "current-change": _vm.handleCurrentChange2
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.orderVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.orderLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.clickUserSelection.apply(null, arguments)
            }
          }
        }, [_vm._v("确定")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adminVisible) ? _c('Admin', {
          attrs: {
            "adminVisible": _vm.adminVisible,
            "companyId": _vm.companyId,
            "UserSelection": _vm.UserSelection
          },
          on: {
            "adminVisibleClose": _vm.adminVisibleClose,
            "addAdmin": _vm.addAdmin,
            "orderUserSubmit": _vm.orderUserSubmit
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "update:currentPage": function($event) {
              _vm.pageNumber = $event
            },
            "update:current-page": function($event) {
              _vm.pageNumber = $event
            },
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dnnCloud-login-box"
  }, [_c('img', {
    staticClass: "icon-dm animate__animated",
    attrs: {
      "src": "static/img/icon_login_csdm.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-jyjj animate__animated",
    attrs: {
      "src": "static/img/icon_login_zyjj.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-erzy animate__animated",
    attrs: {
      "src": "static/img/icon_login_erzy.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-erbz animate__animated",
    attrs: {
      "src": "static/img/icon_login_erbz.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-erdl animate__animated",
    attrs: {
      "src": "static/img/icon_login_erdl.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon-erlj animate__animated",
    attrs: {
      "src": "static/img/icon_login_erlj.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    staticClass: "login-container",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("账号登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-dianhua"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone no-autofill",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号码"
    },
    model: {
      value: (_vm.loginForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "phone", $$v)
      },
      expression: "loginForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-mima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone no-autofill",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('el-button', {
    staticClass: "gradual large",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loginLoading,
      "data-appid": "2014410046",
      "data-cbfn": "callback"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("登 录")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "http://www.jsdnn.com/",
      "target": "_blank"
    }
  }, [_vm._v("狄诺尼官网")])], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "ftBoxs ft-copyright"
  }, [_c('p', [_vm._v("江苏狄诺尼信息技术有限责任公司")]), _vm._v(" "), _c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])
}]}

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-renew-form",
    attrs: {
      "width": "850px",
      "title": "续费",
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.myVisible = $event
      },
      "close": _vm.handerClose
    }
  }, [(_vm.myDetail) ? _c('div', {
    staticClass: "renew-content"
  }, [_c('section', {
    staticClass: "renew-bd"
  }, [_c('el-table', {
    staticClass: "selected-product-tab",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "tooltip-effect": "dark",
      "data": [_vm.myDetail],
      "empty-text": "还没有选择产品"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "logo",
      "header-align": "center",
      "align": "center",
      "width": "100px",
      "label": "产品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "tpimg",
          attrs: {
            "src": scope.row.logo,
            "alt": scope.row.logo
          }
        })]
      }
    }], null, false, 2004791488)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseNum",
      "label": "购买数量",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [_c('span', [_vm._v(_vm._s(row.purchaseNum))])]
      }
    }], null, false, 1458136111)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "单价(元)",
      "min-width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "price"
        }, [_vm._v(_vm._s(scope.row.price.toLocaleString()))])]
      }
    }], null, false, 1758458025)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseMonth",
      "label": "续费时长(月)",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [_c('el-input-number', {
          attrs: {
            "min": 1,
            "size": "small",
            "step-strictly": true,
            "controls-position": "right"
          },
          on: {
            "change": _vm.handleChangeNum
          },
          model: {
            value: (row.purchaseMonth),
            callback: function($$v) {
              _vm.$set(row, "purchaseMonth", $$v)
            },
            expression: "row.purchaseMonth"
          }
        })]
      }
    }], null, false, 1583599189)
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "order-add-ft",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "order-evaluate",
    staticStyle: {
      "color": "#EB6264"
    },
    attrs: {
      "label": "预估价格:"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.evaluatePrice) + " 元\n              ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "order-total",
    attrs: {
      "label": "订单总价:"
    }
  }, [_c('el-input', {
    staticClass: "price",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "oninput": "this.value=this.value.replace(/[^\\d]/g,'');"
    },
    model: {
      value: (_vm.totalPrice),
      callback: function($$v) {
        _vm.totalPrice = $$v
      },
      expression: "totalPrice"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("元")])], 2)], 1)], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.myDetail) ? _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit(_vm.myDetail)
      }
    }
  }, [_vm._v("提交")])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-copy-lbar-census"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DetailPage', {
    staticClass: "order-detail-box",
    attrs: {
      "name": ("订单编号：" + _vm.orderId),
      "backRoute": 'orderList',
      "param": _vm.param
    },
    scopedSlots: _vm._u([{
      key: "detailMain",
      fn: function() {
        return [_c('div', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.pageLoading),
            expression: "pageLoading"
          }],
          staticClass: "detail-content",
          class: {
            'detail-content-verify': _vm.detailType == 2
          }
        }, [(_vm.processDetail) ? [_c('div', {
          staticClass: "detail-content-wrapper"
        }, [_c('el-row', {
          staticClass: "content-item",
          attrs: {
            "gutter": 20
          }
        }, [_c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 8
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("用户类型：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.userid ? '个人用户' : '企业用户'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("企业名称：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.companyname || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("公司管理员：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.companymanagername || '-'))])])]), _vm._v(" "), _c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 8
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("订单类型：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.type == 1 ? '试用订单' : '正式订单'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("生效日期：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.effectivetime || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("订单金额：")]), _vm._v(" "), _c('span', {
          staticClass: "value color-red"
        }, [_vm._v(_vm._s(_vm.processDetail.price ? _vm.processDetail.price.toLocaleString() : 0) + " 元")])])]), _vm._v(" "), _c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 8
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("操作人：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.adminusername || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("操作时间：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.intime || '-'))])]), _vm._v(" "), _c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("订单状态：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_c('span', {
          staticClass: "myTag",
          class: _vm.processDetail.stateverify == 1 ? 'warning' : 'primary'
        }, [_vm._v(_vm._s(_vm.processDetail.stateverify == 1 ? "申请中" : '审核通过'))])])])]), _vm._v(" "), _c('el-col', {
          staticClass: "hd-group",
          attrs: {
            "span": 24
          }
        }, [_c('div', {
          staticClass: "group-item"
        }, [_c('span', {
          staticClass: "key"
        }, [_vm._v("审核意见：")]), _vm._v(" "), _c('span', {
          staticClass: "value"
        }, [_vm._v(_vm._s(_vm.processDetail.comments || '-'))])])])], 1), _vm._v(" "), _c('section', {
          staticClass: "detail-bd"
        }, [_c('header', {
          staticClass: "title"
        }, [_vm._v("产品清单（" + _vm._s(_vm.processDetail.auProList.length) + "）")]), _vm._v(" "), _c('SelectedProduct', {
          attrs: {
            "productLists": _vm.processDetail.auProList
          },
          on: {
            "renew": _vm.handleRenewOrder
          }
        })], 1), _vm._v(" "), (_vm.isShowComment) ? _c('footer', {
          staticClass: "comments-box"
        }, [_c('h4', {
          staticClass: "title"
        }, [_vm._v("请输入审核意见：")]), _vm._v(" "), _c('el-input', {
          attrs: {
            "type": "textarea",
            "rows": 3,
            "placeholder": "请输入"
          },
          on: {
            "change": _vm.handerChangeComments
          },
          model: {
            value: (_vm.comments),
            callback: function($$v) {
              _vm.comments = $$v
            },
            expression: "comments"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isShowError),
            expression: "isShowError"
          }],
          staticClass: "status-text color-red"
        }, [_vm._v("审核意见不能为空")])], 1) : _vm._e()], 1), _vm._v(" "), _c('footer', {
          staticClass: "detail-ft"
        }, [(_vm.isShowComment) ? [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading,
            "plain": ""
          },
          on: {
            "click": function($event) {
              _vm.isShowComment = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading
          },
          on: {
            "click": function($event) {
              return _vm.handerVerify(1)
            }
          }
        }, [_vm._v("提 交")])] : [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading,
            "plain": ""
          },
          on: {
            "click": function($event) {
              _vm.isShowComment = true
            }
          }
        }, [_vm._v("审核不通过")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.dialogLoading
          },
          on: {
            "click": function($event) {
              return _vm.handerVerify(2)
            }
          }
        }, [_vm._v("审核通过")])]], 2)] : _vm._e()], 2), _vm._v(" "), (_vm.visibleRenew) ? _c('ModalFormOrder', {
          attrs: {
            "visible": _vm.visibleRenew,
            "productInfo": _vm.productInfo
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleRenew = $event
            },
            "getDetail": function($event) {
              return _vm.getDetail(_vm.token, _vm.checkCode)
            }
          }
        }) : _vm._e()]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-visit-form-view",
    attrs: {
      "width": "850px",
      "title": "拜访详情",
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.myVisible = $event
      },
      "close": _vm.handerClose
    }
  }, [(_vm.myDetail) ? _c('el-row', {
    staticClass: "toolbar",
    attrs: {
      "gutter": 24
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "110px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访客户："
    }
  }, [_vm._v(" " + _vm._s(_vm.$route.query.companyName || _vm.myDetail.companyName) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.adminUserName) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.successfulManagerName || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.agencyManagerName || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访日期："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.payVisitDate ? _vm.myDetail.payVisitDate.split(" ")[0] : '-'))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.contactUser) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式："
    }
  }, [_vm._v(" " + _vm._s(_vm.myDetail.contactPhone) + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.position || '-'))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访方式："
    }
  }, [_c('span', {
    staticClass: "myTag-fill",
    class: _vm.myDetail.payVisitStatus == 1 ? 'pruple' : (_vm.myDetail.payVisitStatus == 2 ? 'primary' : 'warning')
  }, [_vm._v("\n                " + _vm._s(_vm.myDetail.payVisitStatus == 1 ? "电话沟通" : (_vm.myDetail.payVisitStatus == 2 ? '客户现场' : '视频会议')) + "\n              ")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户地址："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.addressInfo))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访详情："
    }
  }, [_vm._v(_vm._s(_vm.myDetail.payVisitInfo || '-'))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现场照片："
    }
  }, [(_vm.myDetail.picList.length > 0) ? _c('PictureList', {
    attrs: {
      "pictureList": _vm.myDetail.picList
    }
  }) : _c('span', [_vm._v("-")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核状态："
    }
  }, [_c('span', {
    staticClass: "myTag",
    class: [_vm.myDetail.auditStatus == 1 ? 'warning' : 'primary']
  }, [_vm._v("\n                " + _vm._s(_vm.myDetail.auditStatus == 1 ? "待审核" : '已审核') + "\n              ")])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_c('span', {
    staticClass: "dividerSpan"
  }, [_vm._v("评论（" + _vm._s(_vm.commentList.length) + "）")])]), _vm._v(" "), _c('div', {
    staticClass: "commentBox"
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.commentList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "avatar"
    }), _vm._v(" "), _c('div', {
      staticClass: "itemInfo"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.username || '-'))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.intime || '-'))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v(_vm._s(item.note || '-'))]), _vm._v(" "), _c('div', {
      staticClass: "actionBox"
    }, [(item.userid != _vm.userInfo.id) ? _c('span', {
      staticClass: "dnnfont iconcomment-dots",
      on: {
        "click": function($event) {
          return _vm.reply(item)
        }
      }
    }, [_vm._v(" 回复")]) : _vm._e(), _vm._v(" "), (item.userid === _vm.userInfo.id) ? _c('span', {
      staticClass: "dnnfont icondelete",
      on: {
        "click": function($event) {
          return _vm.deleteComment(item)
        }
      }
    }, [_vm._v(" 删除")]) : _vm._e()])])])
  }), 0), _vm._v(" "), (_vm.userInfo.type == 1 && !_vm.isReply) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "3",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.commentNote),
      callback: function($$v) {
        _vm.commentNote = $$v
      },
      expression: "commentNote"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isReply) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "3",
      "placeholder": '回复 ' + _vm.replyObj
    },
    model: {
      value: (_vm.replyNote),
      callback: function($$v) {
        _vm.replyNote = $$v
      },
      expression: "replyNote"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btnBox"
  }, [(_vm.userInfo.type == 1 && !_vm.isReply) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.postLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.postComment.apply(null, arguments)
      }
    }
  }, [_vm._v("发表评论")]) : _vm._e(), _vm._v(" "), (_vm.isReply) ? _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeReply.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isReply) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.postLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.replyComment.apply(null, arguments)
      }
    }
  }, [_vm._v("回复")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.myDetail && _vm.userInfo.type == 1 && _vm.myDetail.auditStatus == 1) ? _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit(_vm.myDetail)
      }
    }
  }, [_vm._v("审核通过")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-visit-form",
    attrs: {
      "width": "850px",
      "title": _vm.title,
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handerClose
    }
  }, [_c('el-row', {
    staticClass: "toolbar",
    attrs: {
      "gutter": 24
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访客户",
      "prop": "companyName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": ""
    },
    model: {
      value: (_vm.ruleForm.companyName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "companyName", $$v)
      },
      expression: "ruleForm.companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理",
      "prop": "adminUser"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": "",
      "defaultVal": _vm.ruleForm.adminUser ? _vm.ruleForm.adminUser : undefined,
      "apiPath": "/tbAdminuser/manageList",
      "keys": {
        label: 'name',
        value: 'id'
      },
      "selectFirst": _vm.userInfo.type == '2',
      "params": {
        ComId: _vm.companyId
      }
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'adminUser'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": true,
      "disabled": "",
      "apiPath": "/tbCompany/getInfoById",
      "params": {
        type: 3,
        id: _vm.companyId
      },
      "keys": {
        label: 'successfulManagerName',
        value: 'successfulManager'
      },
      "defaultVal": _vm.ruleForm.successfulManager,
      "selectFirst": _vm.userInfo.type == '3'
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商"
    }
  }, [_c('SelectCommon', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": true,
      "disabled": "",
      "apiPath": "/tbCompany/getInfoById",
      "params": {
        type: 4,
        id: _vm.companyId
      },
      "keys": {
        label: 'agencyManagerName',
        value: 'agencyManager'
      },
      "defaultVal": _vm.ruleForm.agencyManager,
      "selectFirst": _vm.userInfo.type == '4'
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访日期",
      "prop": "payVisitDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ruleForm.payVisitDate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "payVisitDate", $$v)
      },
      expression: "ruleForm.payVisitDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "contactUser"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.contactUser),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contactUser", $$v)
      },
      expression: "ruleForm.contactUser"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式",
      "prop": "contactPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "oninput": "this.value=this.value.replace(/[^\\d]/g,'');"
    },
    model: {
      value: (_vm.ruleForm.contactPhone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "contactPhone", $$v)
      },
      expression: "ruleForm.contactPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "职位",
      "prop": "position"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.position),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "position", $$v)
      },
      expression: "ruleForm.position"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访详情",
      "prop": "payVisitInfo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "3",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.ruleForm.payVisitInfo),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "payVisitInfo", $$v)
      },
      expression: "ruleForm.payVisitInfo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "拜访方式：",
      "prop": "payVisitStatus"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "拜访状态"
    },
    model: {
      value: (_vm.ruleForm.payVisitStatus),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "payVisitStatus", $$v)
      },
      expression: "ruleForm.payVisitStatus"
    }
  }, _vm._l((_vm.visitStatusList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.ruleForm.payVisitStatus == 2 || _vm.ruleForm.payVisitStatus == 3) ? _c('el-form-item', {
    attrs: {
      "label": "现场照片",
      "prop": "pic"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    attrs: {
      "size": "small",
      "multiple": "",
      "accept": "image/png,image/jpg,image/jpeg,image/gif",
      "auto-upload": false,
      "action": "",
      "on-remove": _vm.handleRemove,
      "on-change": _vm.handerUploadChange,
      "file-list": _vm.fileList,
      "list-type": "picture-card"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerClose.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    staticClass: "selected-product-tab",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "tooltip-effect": "dark",
      "data": _vm.productLists,
      "empty-text": "还没有选择产品"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "logo",
      "header-align": "center",
      "align": "center",
      "width": "100px",
      "label": "产品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "tpimg",
          attrs: {
            "src": scope.row.logo,
            "alt": scope.row.logo
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseNum",
      "label": "购买数量",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [(!_vm.isEdit) ? _c('span', [_vm._v(_vm._s(row.purchaseNum))]) : _c('el-input-number', {
          attrs: {
            "min": 1,
            "size": "small",
            "step-strictly": true,
            "controls-position": "right"
          },
          on: {
            "change": function (val) { return _vm.handleChangeNum(val, row, 'purchaseNum'); }
          },
          model: {
            value: (row.purchaseNum),
            callback: function($$v) {
              _vm.$set(row, "purchaseNum", $$v)
            },
            expression: "row.purchaseNum"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseMonth",
      "label": "购买时长(月)",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var $index = ref.$index;

        return [(!_vm.isEdit) ? _c('span', [_vm._v(_vm._s(row.purchaseMonth))]) : _c('el-input-number', {
          attrs: {
            "min": 1,
            "size": "small",
            "step-strictly": true,
            "controls-position": "right"
          },
          on: {
            "change": _vm.handleChangeNum
          },
          model: {
            value: (row.purchaseMonth),
            callback: function($$v) {
              _vm.$set(row, "purchaseMonth", $$v)
            },
            expression: "row.purchaseMonth"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "单价(元)",
      "min-width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "price"
        }, [_vm._v(_vm._s(scope.row.price.toLocaleString()))])]
      }
    }])
  }), _vm._v(" "), (!_vm.isEdit) ? _c('el-table-column', {
    attrs: {
      "prop": "effectivetime",
      "label": "启用时间",
      "min-width": "130",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.effectivetime || '-'))])]
      }
    }], null, false, 1536076627)
  }) : _vm._e(), _vm._v(" "), (!_vm.isEdit) ? _c('el-table-column', {
    attrs: {
      "prop": "duetime",
      "label": "到期时间",
      "min-width": "130",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.duetime || '-'))])]
      }
    }], null, false, 270402858)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isEdit) ? _c('span', {
          staticClass: "dnnfont icondelete",
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.renewFlg == 1) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "续费",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconclock",
          on: {
            "click": function($event) {
              return _vm.handleRenewOrder(scope.$index, scope.row)
            }
          }
        })]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-verify",
    attrs: {
      "id": "slideVerify",
      "onselectstart": "return false;"
    }
  }, [_c('canvas', {
    ref: "canvas",
    attrs: {
      "width": _vm.w,
      "height": _vm.h
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-verify-refresh-icon",
    on: {
      "click": _vm.refresh
    }
  }), _vm._v(" "), _c('canvas', {
    ref: "block",
    staticClass: "slide-verify-block",
    attrs: {
      "width": _vm.w,
      "height": _vm.h
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slide-verify-slider",
    class: {
      'container-active': _vm.containerActive,
      'container-success': _vm.containerSuccess,
      'container-fail': _vm.containerFail
    }
  }, [_c('div', {
    staticClass: "slide-verify-slider-mask",
    style: ({
      width: _vm.sliderMaskWidth
    })
  }, [_c('div', {
    staticClass: "slide-verify-slider-mask-item",
    style: ({
      left: _vm.sliderLeft
    }),
    on: {
      "mousedown": _vm.sliderDown,
      "touchstart": _vm.touchStartEvent,
      "touchmove": _vm.touchMoveEvent,
      "touchend": _vm.touchEndEvent
    }
  }, [_c('div', {
    staticClass: "slide-verify-slider-mask-item-icon"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "slide-verify-slider-text"
  }, [_vm._v(_vm._s(_vm.sliderText))])])])
},staticRenderFns: []}

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [_c('div', {
    staticClass: "full"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "login_div"
  }, [_c('span', {
    staticClass: "login_span"
  }, [_vm._v("Reset your password")]), _vm._v(" "), _c('div', {
    staticClass: "sub_desc"
  }, [_vm._v("\n          We will send you an email to reset your password\n        ")]), _vm._v(" "), _c('el-form', {
    ref: "emailForm",
    attrs: {
      "model": _vm.emailForm,
      "rules": _vm.emailRules,
      "hide-required-asterisk": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "Email",
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Email address"
    },
    on: {
      "input": _vm.validateEmail
    },
    model: {
      value: (_vm.emailForm.Email),
      callback: function($$v) {
        _vm.$set(_vm.emailForm, "Email", $$v)
      },
      expression: "emailForm.Email"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "login_submit",
    attrs: {
      "type": "danger"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextStep(1)
      }
    }
  }, [_vm._v("CONTINUE")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }],
    staticClass: "code_div"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "backup",
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("←")]), _vm._v(" "), _c('span', {
    staticClass: "login_span"
  }, [_vm._v("Verify your identity")])]), _vm._v(" "), _c('div', {
    staticClass: "sub_desc"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("Enter the code we've sent to")]), _vm._v(" "), _c('span', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.emailForm.Email))])]), _vm._v(" "), _c('el-form', {
    ref: "codeForm",
    attrs: {
      "model": _vm.codeForm,
      "rules": _vm.codeRules
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "verificationCode",
      "label": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "code"
    },
    model: {
      value: (_vm.codeForm.verificationCode),
      callback: function($$v) {
        _vm.$set(_vm.codeForm, "verificationCode", $$v)
      },
      expression: "codeForm.verificationCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "no_see"
  }, [_c('span', {
    staticClass: "not_see"
  }, [_vm._v("Don't see it? ")]), _vm._v(" "), _c('span', {
    staticClass: "resend"
  }, [_c('el-button', {
    staticClass: "el_reg resend",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [(_vm.time) ? _c('span', [_vm._v(_vm._s(_vm.time) + "s later ")]) : _vm._e(), _vm._v("Resend code\n            ")])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "reset_box"
  }, [_c('span', {
    staticClass: "login_span"
  }, [_vm._v("Change your password")]), _vm._v(" "), _c('div', {
    staticClass: "sub_desc"
  }, [_vm._v("\n          Enter a new password bellow to change your password\n        ")]), _vm._v(" "), _c('el-form', {
    ref: "resetForm",
    attrs: {
      "model": _vm.resetForm,
      "rules": _vm.resetRules,
      "hide-required-asterisk": true
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "newPassword",
      "label": "New password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "newPassword",
      "show-password": ""
    },
    on: {
      "input": _vm.validatePassword
    },
    model: {
      value: (_vm.resetForm.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.resetForm, "newPassword", $$v)
      },
      expression: "resetForm.newPassword"
    }
  })], 1), _vm._v(" "), (_vm.resetForm.newPassword) ? [_c('p', {
    class: {
      'error-text': !_vm.containsAtLeastEightCharacters,
      'true-text': _vm.containsAtLeastEightCharacters,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsAtLeastEightCharacters ? "√" : "X"))]), _vm._v("\n              Contains at least 8 characters\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.containsBothLowerUpper,
      'true-text': _vm.containsBothLowerUpper,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsBothLowerUpper ? "√" : "X"))]), _vm._v("\n              contains both lower (a-z) and upper case letters (A-Z)\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.containsNumberOrSymbol,
      'true-text': _vm.containsNumberOrSymbol,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsNumberOrSymbol ? "√" : "X"))]), _vm._v("\n              contains at least one number (0-9) or a symbol\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.doesNotContainEmail,
      'true-text': _vm.doesNotContainEmail,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.doesNotContainEmail ? "√" : "X"))]), _vm._v("\n              Does not contain your email address\n            ")])] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "confirmPassword",
      "label": "Confirm password "
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "confirmPassword",
      "show-password": ""
    },
    model: {
      value: (_vm.resetForm.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.resetForm, "confirmPassword", $$v)
      },
      expression: "resetForm.confirmPassword"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "submit",
    attrs: {
      "type": "danger",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("CHANGE PASSWORD")])], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 4),
      expression: "step == 4"
    }],
    staticClass: "success_box"
  }, [_c('div', {
    staticClass: "success"
  }, [_vm._v("🥳 Success!")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Your password has been updated successfully")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.adminVisible) ? _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "相关订单",
      "width": "950px",
      "visible": _vm.adminVisible,
      "close-on-click-modal": false,
      "before-close": _vm.adminVisibleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.adminVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userLoading),
      expression: "userLoading"
    }],
    ref: "userList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row-key": function (row) { return row.id; },
      "data": _vm.adminList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseMonth",
      "label": "购买时长(月)",
      "min-width": "100",
      "xshow-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "purchaseNum",
      "label": "购买数量",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "singlePrice",
      "label": "单价(元)",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-company-manage"
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "780px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "100px",
      "label-position": "left",
      "rules": _vm.formRules,
      "validate-on-rule-change": false
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "企业名称:",
      "prop": "name"
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入",
      "clearable": "",
      "fetch-suggestions": _vm.querySearch,
      "trigger-on-focus": false
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地区:",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.showname),
      callback: function($$v) {
        _vm.$set(_vm.form, "showname", $$v)
      },
      expression: "form.showname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业图标:"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "size": "small",
      "auto-upload": false,
      "on-change": _vm.imgPreview,
      "action": _vm.upload.postURL,
      "show-file-list": false
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon",
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "line-height": "100px"
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业管理员:"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择企业管理员"
    },
    model: {
      value: (_vm.company),
      callback: function($$v) {
        _vm.company = $$v
      },
      expression: "company"
    }
  }, _vm._l((_vm.companyManages), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "硬件绑定:",
      "required": ""
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#F66B3D",
      "active-value": 1,
      "inactive-value": 0,
      "inactive-color": "#F6F6F6"
    },
    model: {
      value: (_vm.isbinding),
      callback: function($$v) {
        _vm.isbinding = $$v
      },
      expression: "isbinding"
    }
  }), _c('span', {
    staticStyle: {
      "padding-left": "10px",
      "color": "#666666"
    }
  }, [_vm._v("是否启用硬件绑定")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户地址:",
      "required": "",
      "prop": "address"
    }
  }, [_c('GisCommon', {
    ref: "GisCommon",
    attrs: {
      "selected": _vm.selected,
      "address": _vm.form.address
    },
    on: {
      "update:address": function($event) {
        return _vm.$set(_vm.form, "address", $event)
      },
      "backPram": _vm.backPram
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "大区代号:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.loginType != '1'
    },
    model: {
      value: (_vm.form.regionCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "regionCode", $$v)
      },
      expression: "form.regionCode"
    }
  }, _vm._l((_vm.regionCodeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资质等级:",
      "prop": "grade"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }, _vm._l((_vm.gradeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业性质:",
      "prop": "natrue"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.natrue),
      callback: function($$v) {
        _vm.$set(_vm.form, "natrue", $$v)
      },
      expression: "form.natrue"
    }
  }, _vm._l((_vm.natureList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户规模:",
      "prop": "userScale"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.userScale),
      callback: function($$v) {
        _vm.$set(_vm.form, "userScale", $$v)
      },
      expression: "form.userScale"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业联系人:",
      "prop": "linker"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.linker),
      callback: function($$v) {
        _vm.linker = $$v
      },
      expression: "linker"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式:",
      "prop": "linkerPhone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.linkerPhone),
      callback: function($$v) {
        _vm.linkerPhone = $$v
      },
      expression: "linkerPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理:"
    }
  }, [_c('SelectCommon', {
    attrs: {
      "placeholder": "客户经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/manageList",
      "disabled": _vm.loginType !== '1',
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.managerAdminuser
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理:"
    }
  }, [_c('SelectCommon', {
    staticClass: "kuang",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择客户成功经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 3
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "disabled": _vm.loginType !== '1',
      "defaultVal": _vm.successfulManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商:"
    }
  }, [_c('SelectCommon', {
    staticClass: "kuang",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择经销商",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 4
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "disabled": _vm.loginType !== '1',
      "defaultVal": _vm.agencyManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
    }
  })], 1)], 1), _vm._v(" "), (_vm.editLevel) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "ratingClass",
    attrs: {
      "label": "客户分级:",
      "prop": "level"
    }
  }, [_c('el-rate', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "max": 3
    },
    model: {
      value: (_vm.form.level),
      callback: function($$v) {
        _vm.$set(_vm.form, "level", $$v)
      },
      expression: "form.level"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.note),
      callback: function($$v) {
        _vm.note = $$v
      },
      expression: "note"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "background": "#F66B3D",
      "color": "#FFF",
      "width": "140px"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存设置")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-credits-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "账号 / 姓名 /企业"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "软件类型",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.softtype),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "softtype", $$v)
            },
            expression: "souchs.softtype"
          }
        }, _vm._l((_vm.softtypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "position": "relative",
            "top": "2px",
            "width": "260px"
          },
          attrs: {
            "type": "daterange",
            "value-format": "yyyy-MM-dd",
            "range-separator": "~",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期"
          },
          on: {
            "change": _vm.handerChangePicker
          },
          model: {
            value: (_vm.dateRange),
            callback: function($$v) {
              _vm.dateRange = $$v
            },
            expression: "dateRange"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          }
        }, [_c('a', {
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": _vm.downHrefExcel
          }
        }, [_vm._v("导出数据")])])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.users,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "140",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "sumpoint",
            "label": "可用积分",
            "min-width": "140",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "registertime",
            "label": "注册日期",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        })], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-authorizeList-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "姓名 / 账号 / 名称 / 企业"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "类型",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.souType),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "souType", $$v)
            },
            expression: "souchs.souType"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "状态",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.status),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "status", $$v)
            },
            expression: "souchs.status"
          }
        }, _vm._l((_vm.types2), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "200",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productname",
            "label": "名称",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usercompany",
            "label": "企业",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "typename",
            "label": "类型",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.typename == '试用' ? 'success' : 'primary'
              }, [_vm._v(" " + _vm._s(scope.row.typename) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usingstatus",
            "label": "状态",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: ['2', '3'].includes(scope.row.usingstatus) ? '' : 'primary'
              }, [_vm._v(" " + _vm._s(scope.row.usingstatusname) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "effectivetime",
            "label": "生效时间",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "duetime",
            "label": "到期时间",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "fixed": "right",
            "min-width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "相关订单",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-Business",
                on: {
                  "click": function($event) {
                    return _vm.handleAbout(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.usingstatus != 2) ? [(!scope.row.usingstatus2) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "禁用",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondisabled",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "启用",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconaccomplish",
                on: {
                  "click": function($event) {
                    return _vm.handleOpen(scope.$index, scope.row)
                  }
                }
              })])] : _vm._e()], 2)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit model-xf-box",
          attrs: {
            "width": "800px",
            "title": "续费",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "订单账户:"
          }
        }, [_vm._v(_vm._s(_vm.orderUser) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.editlistLoading),
            expression: "editlistLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList2,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod2,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber2 - 1) * _vm.pageSize2 + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "logo2",
            "header-align": "center",
            "align": "center",
            "width": "100px",
            "label": "图片"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('img', {
                staticClass: "tpimg",
                attrs: {
                  "slot": "reference",
                  "src": scope.row.logo2,
                  "alt": scope.row.logo2
                },
                slot: "reference"
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "名称",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productid",
            "label": "订单ID",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price2",
            "label": "单价(元)",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "purchaseMonth",
            "label": "续费时长(月)",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var row = ref.row;
              var $index = ref.$index;

              return [_c('el-input', {
                attrs: {
                  "type": "number",
                  "min": "1"
                },
                on: {
                  "blur": function($event) {
                    return _vm.loseFcousMonth(1, row)
                  }
                },
                model: {
                  value: (row.purchaseMonth),
                  callback: function($$v) {
                    _vm.$set(row, "purchaseMonth", $$v)
                  },
                  expression: "row.purchaseMonth"
                }
              })]
            }
          }])
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "position": "relative",
            "padding-bottom": "0px",
            "margin-top": "0px",
            "height": "80px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-checkbox', {
          staticClass: "el-checkbox1",
          on: {
            "change": _vm.checkboxOnclick
          },
          model: {
            value: (_vm.checked),
            callback: function($$v) {
              _vm.checked = $$v
            },
            expression: "checked"
          }
        }, [_vm._v(" 试用订单")]), _vm._v(" "), _c('el-form-item', {
          staticClass: "Auto_allPrice",
          attrs: {
            "label": "总价:"
          }
        }, [_c('el-input', {
          staticClass: "price",
          staticStyle: {
            "width": "120px",
            "z-index": "9999"
          },
          attrs: {
            "disabled": _vm.disCheckBox
          },
          on: {
            "blur": function($event) {
              return _vm.priceloseF()
            }
          },
          model: {
            value: (_vm.allPrice),
            callback: function($$v) {
              _vm.allPrice = $$v
            },
            expression: "allPrice"
          }
        })], 1), _vm._v(" "), _c('el-form-item', {
          staticClass: "Auto_ygPrice",
          attrs: {
            "label": "预估价格:"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.ygPrice) + " 元\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.adminVisible) ? _c('Detail', {
          attrs: {
            "adminVisible": _vm.adminVisible,
            "authProductId": _vm.detailOrderId
          },
          on: {
            "adminVisibleClose": _vm.adminVisibleClose
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "float_left",
          attrs: {
            "type": "danger",
            "size": "medium",
            "disabled": _vm.sels1.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.handleDel()
            }
          }
        }, [_vm._v(" 禁用 ")]), _vm._v(" "), _c('el-button', {
          staticClass: "float_left",
          attrs: {
            "type": "primary",
            "size": "medium",
            "disabled": _vm.sels3.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.handleOpen()
            }
          }
        }, [_vm._v(" 启用  ")])], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "imger"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "forgetForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.forgetForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("密码重置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-dianhua"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.forgetForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "phone", $$v)
      },
      expression: "forgetForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "smsCode"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-securityCode-b"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone form-control",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.forgetForm.smsCode),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "smsCode", $$v)
      },
      expression: "forgetForm.smsCode"
    }
  }), _vm._v(" "), (_vm.disabled == false) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v("发送验证码\r\n          ")]) : _vm._e(), _vm._v(" "), (_vm.disabled == true) ? _c('el-button', {
    staticClass: "el_reg",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [_vm._v(_vm._s(_vm.btntxt) + "\r\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-mima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.forgetForm.password),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "password", $$v)
      },
      expression: "forgetForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "conpassword"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-querenmima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "确认密码"
    },
    model: {
      value: (_vm.forgetForm.conpassword),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "conpassword", $$v)
      },
      expression: "forgetForm.conpassword"
    }
  })], 1), _vm._v(" "), _c('slide-verify', {
    attrs: {
      "slider-text": _vm.texts
    },
    on: {
      "success": _vm.onSuccess,
      "fail": _vm.onFail,
      "refresh": _vm.onRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBar"
  }, [_c('h1'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.jsdnn.com/",
      "target": "_blank"
    }
  }, [_vm._v("狄诺尼官网")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('p', [_vm._v("江苏狄诺尼信息技术有限责任公司")]), _vm._v(" "), _c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])
}]}

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-module-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "模块名称"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getModels(1)
            }
          },
          model: {
            value: (_vm.souchs.modelName),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "modelName", $$v)
            },
            expression: "souchs.modelName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getModels(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.models,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "modulename",
            "label": "名称",
            "min-width": "220",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "moduleid",
            "label": "模块ID",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "创建时间",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e(), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "命令模块",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconstatistics-all",
                on: {
                  "click": function($event) {
                    return _vm.handleList(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "modulename"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.addForm.modulename),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "modulename", $$v)
            },
            expression: "addForm.modulename"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "模块ID",
            "prop": "moduleid"
          }
        }, [_c('el-input', {
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.addSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.addForm.moduleid),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "moduleid", $$v)
            },
            expression: "addForm.moduleid"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "modulename"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editForm.modulename),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "modulename", $$v)
            },
            expression: "editForm.modulename"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "模块ID",
            "prop": "moduleid"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.editSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.editForm.moduleid),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "moduleid", $$v)
            },
            expression: "editForm.moduleid"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": _vm.modulenames,
            "visible": _vm.editListVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editListVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "名称"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getZJ(1)
            }
          },
          model: {
            value: (_vm.editListSouch.name),
            callback: function($$v) {
              _vm.$set(_vm.editListSouch, "name", $$v)
            },
            expression: "editListSouch.name"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.getZJ(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.editListAdd
          }
        }, [_vm._v("添加")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.editList,
            "highlight-current-row": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "label": "序号",
            "width": "80"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "modulename",
            "label": "名称",
            "min-width": "200",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "moduleid",
            "label": "模块ID",
            "min-width": "120"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "point",
            "label": "分数",
            "min-width": "120"
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "160"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-button', {
                attrs: {
                  "type": "primary",
                  "plain": "",
                  "size": "small"
                },
                on: {
                  "click": function($event) {
                    return _vm.editListEdit(scope.$index, scope.row)
                  }
                }
              }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
                attrs: {
                  "type": "danger",
                  "plain": "",
                  "size": "small"
                },
                on: {
                  "click": function($event) {
                    return _vm.editListDel(scope.$index, scope.row)
                  }
                }
              }, [_vm._v("删除")])]
            }
          }])
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "margin-top": "0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "prev, pager, next",
            "current-page": _vm.pageNumber2,
            "page-size": 10,
            "total": _vm.total2
          },
          on: {
            "current-change": _vm.handleCurrentChange2
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editListVisible = false
            }
          }
        }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "命令新增",
            "visible": _vm.addListVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addListVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addListForm",
          attrs: {
            "model": _vm.addListForm,
            "label-width": "80px"
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "modulename"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.addListForm.modulename),
            callback: function($$v) {
              _vm.$set(_vm.addListForm, "modulename", $$v)
            },
            expression: "addListForm.modulename"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "模块ID",
            "prop": "moduleid"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.addListForm.moduleid),
            callback: function($$v) {
              _vm.$set(_vm.addListForm, "moduleid", $$v)
            },
            expression: "addListForm.moduleid"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "分数",
            "prop": "point"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.addListForm.point),
            callback: function($$v) {
              _vm.$set(_vm.addListForm, "point", $$v)
            },
            expression: "addListForm.point"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addListVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addListLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addListSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "命令修改",
            "visible": _vm.editVisibleList,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editVisibleList = $event
            }
          }
        }, [_c('el-form', {
          ref: "editFormList",
          attrs: {
            "model": _vm.editFormList,
            "label-width": "80px"
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "名称",
            "prop": "modulename"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editFormList.modulename),
            callback: function($$v) {
              _vm.$set(_vm.editFormList, "modulename", $$v)
            },
            expression: "editFormList.modulename"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "模块ID",
            "prop": "moduleid"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editFormList.moduleid),
            callback: function($$v) {
              _vm.$set(_vm.editFormList, "moduleid", $$v)
            },
            expression: "editFormList.moduleid"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "分数",
            "prop": "point"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off"
          },
          model: {
            value: (_vm.editFormList.point),
            callback: function($$v) {
              _vm.$set(_vm.editFormList, "point", $$v)
            },
            expression: "editFormList.point"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editVisibleList = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoadingList
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmitList.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-detail-box"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "font",
    on: {
      "click": _vm.bak
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left icon"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "shu"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "font-text"
  }, [_vm._v(_vm._s(_vm.$route.query.companyName))]), _vm._v(" "), _c('span', {
    staticClass: "export"
  }, [_c('a', {
    attrs: {
      "href": _vm.href
    }
  }, [_c('span', {
    staticClass: "el-icon-download"
  }), _vm._v("导出统计数据")])]), _vm._v(" "), _c('span', {
    staticClass: "export"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.pointByHour
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("用户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6"
    }
  }, [_vm._v("部门管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("产品管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("设备管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }, [_vm._v("跟踪记录")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("分析统计")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [_vm._v("企业设置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-content"
  }, [(_vm.showCom) ? _c('div', [_c('company')], 1) : _vm._e(), _vm._v(" "), (_vm.showWeP) ? _c('div', [_c('weProduct')], 1) : _vm._e(), _vm._v(" "), (_vm.showDev) ? _c('div', [_c('device')], 1) : _vm._e(), _vm._v(" "), (_vm.showFx) ? _c('Static', {
    attrs: {
      "comId": _vm.$route.query.companyId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 6) ? _c('DepartManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 7) ? _c('TrackManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 8) ? _c('CompamySetting', {
    attrs: {
      "editLevel": false
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dnnCloud-sys-box"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("轮播图")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("系统参数")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLBT),
      expression: "showLBT"
    }],
    staticClass: "sys-tab-item"
  }, [_c('UrlsLBT')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showURL),
      expression: "showURL"
    }],
    staticClass: "sys-tab-item"
  }, [_c('UrlsNumber')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-account-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.souchs.value1),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "value1", $$v)
            },
            expression: "souchs.value1"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.souchs.value2),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "value2", $$v)
            },
            expression: "souchs.value2"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.souchs.value3),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "value3", $$v)
            },
            expression: "souchs.value3"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "请输入内容"
          },
          model: {
            value: (_vm.souchs.input),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "input", $$v)
            },
            expression: "souchs.input"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.check()
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.add()
            }
          }
        }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('target-custom-dialog', {
          ref: "targetcustomdialogRef"
        })]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('div', {
          staticClass: "tips"
        }, [_c('span', [_vm._v("目标客户总数量：")]), _c('span', {
          staticClass: "blueNumber"
        }, [_vm._v("600")]), _vm._v(" "), _c('span', [_vm._v("甲级目标客户总数量：")]), _c('span', {
          staticClass: "redNumber"
        }, [_vm._v("600")])]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.tableData,
            "height": _vm.maxTbHeight - 36,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "date",
            "label": "日期",
            "sortable": "",
            "width": "180",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "sortable": "",
            "width": "180",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "address",
            "label": "地址",
            "show-overflow-tooltip": ""
          }
        })], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-admin-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "姓名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.souchs.name),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "name", $$v)
            },
            expression: "souchs.name"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.users,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "220",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "类型",
            "min-width": "220",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.type == '1' ? '系统管理员' : scope.row.type == '2' ? '客户经理' : scope.row.type == '3' ? '客户成功经理' : scope.row.type == '4' ? '经销商' : ''))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "添加日期",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            },
            "closed": _vm.closeAddform
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "账号",
            "prop": "user"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.user),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "user", $$v)
            },
            expression: "addForm.user"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "类型",
            "prop": "type"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.addForm.type),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "type", $$v)
            },
            expression: "addForm.type"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "密码",
            "prop": "password"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "password",
            "placeholder": "请输入"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.addSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.addForm.password),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "password", $$v)
            },
            expression: "addForm.password"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            },
            "closed": _vm.closeeditForm
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "账号",
            "prop": "phone"
          }
        }, [_c('el-input', {
          attrs: {
            "disabled": "",
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.phone),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "phone", $$v)
            },
            expression: "editForm.phone"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "类型",
            "prop": "type"
          }
        }, [_c('el-select', {
          model: {
            value: (_vm.editForm.type),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "type", $$v)
            },
            expression: "editForm.type"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "密码",
            "prop": "password"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "password",
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.password),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "password", $$v)
            },
            expression: "editForm.password"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "确认密码",
            "prop": "conpassword"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "password",
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.editSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.editForm.conpassword),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "conpassword", $$v)
            },
            expression: "editForm.conpassword"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DetailPage', {
    staticClass: "order-add-box",
    attrs: {
      "name": _vm.mode == 'save' ? '新增订单' : '编辑订单'
    },
    scopedSlots: _vm._u([{
      key: "detailMain",
      fn: function() {
        return [_c('div', {
          staticClass: "wrapper"
        }, [_c('header', {
          staticClass: "order-add-hd"
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户类型",
            "required": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          model: {
            value: (_vm.person),
            callback: function($$v) {
              _vm.person = $$v
            },
            expression: "person"
          }
        }, _vm._l((_vm.persons), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "选择用户",
            "required": ""
          }
        }, [(_vm.person == '2') ? _c('el-input', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "readonly": "readonly",
            "placeholder": "请选择",
            "clearable": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.handleUser(2)
            }
          },
          model: {
            value: (_vm.checkPerson),
            callback: function($$v) {
              _vm.checkPerson = $$v
            },
            expression: "checkPerson"
          }
        }) : _c('el-input', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "readonly": "readonly",
            "placeholder": "请选择",
            "clearable": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.handleUser(1)
            }
          },
          model: {
            value: (_vm.checkUser),
            callback: function($$v) {
              _vm.checkUser = $$v
            },
            expression: "checkUser"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "生效时间",
            "required": ""
          }
        }, [_c('el-date-picker', {
          staticStyle: {
            "width": "210px"
          },
          attrs: {
            "type": "date",
            "placeholder": "生效时间",
            "clearable": false
          },
          model: {
            value: (_vm.effectiveTime),
            callback: function($$v) {
              _vm.effectiveTime = $$v
            },
            expression: "effectiveTime"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 6
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "订单类型",
            "required": ""
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "订单类型"
          },
          on: {
            "change": _vm.handerOrderType
          },
          model: {
            value: (_vm.orderType),
            callback: function($$v) {
              _vm.orderType = $$v
            },
            expression: "orderType"
          }
        }, _vm._l((_vm.orderTypes), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('section', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticClass: "order-add-bd"
        }, [_c('div', {
          staticClass: "product-list"
        }, [_c('h4', {
          staticClass: "list-hd title"
        }, [_vm._v("选择产品")]), _vm._v(" "), _c('ul', {
          staticClass: "list-bd fit-w"
        }, _vm._l((_vm.proList), function(item) {
          return _c('li', {
            key: item.id,
            staticClass: "list-item",
            class: {
              active: _vm.selectProList.findIndex(function (data) { return data.id == item.id; }) > -1
            },
            on: {
              "click": function($event) {
                return _vm.handerProduct(item)
              }
            }
          }, [_c('span', {
            staticClass: "dnnfont iconaccomplish-filled"
          }), _vm._v(" "), _c('img', {
            staticClass: "proLogo",
            attrs: {
              "src": item.logo,
              "alt": ""
            }
          }), _vm._v(" "), _c('h4', {
            staticClass: "proName"
          }, [_vm._v(_vm._s(item.name))])])
        }), 0)]), _vm._v(" "), _c('div', {
          staticClass: "product-list-selected"
        }, [_c('h4', {
          staticClass: "title"
        }, [_vm._v("订单清单")]), _vm._v(" "), _c('article', {
          staticClass: "fit-w list-selected-info"
        }, [_c('header', {
          staticClass: "tab-hd"
        }, [_vm._v("已选择" + _vm._s(_vm.selectProList.length) + "个产品")]), _vm._v(" "), _c('SelectedProduct', {
          attrs: {
            "productLists": _vm.selectProList,
            "isEdit": true
          },
          on: {
            "del": function (data) { return _vm.handerProduct(data); }
          }
        })], 1)])])]), _vm._v(" "), _c('footer', {
          staticClass: "order-add-ft",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          staticClass: "order-evaluate",
          staticStyle: {
            "color": "#EB6264"
          },
          attrs: {
            "label": "预估价格:"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.evaluatePrice) + " 元\n          ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          staticClass: "order-total",
          attrs: {
            "label": "订单总价:"
          }
        }, [_c('el-input', {
          staticClass: "price",
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "disabled": _vm.isOrderTest,
            "oninput": "this.value=this.value.replace(/[^\\d]/g,'');"
          },
          model: {
            value: (_vm.totalPrice),
            callback: function($$v) {
              _vm.totalPrice = $$v
            },
            expression: "totalPrice"
          }
        }, [_c('template', {
          slot: "append"
        }, [_vm._v("元")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
          staticClass: "ft-submit",
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', [_c('el-button', {
          staticClass: "gradual",
          attrs: {
            "type": "primary",
            "loading": _vm.orderSubLoading,
            "disabled": _vm.selectProList.length == 0
          },
          on: {
            "click": _vm.orderSubmit
          }
        }, [_vm._v("提交订单")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "订单账户",
            "visible": _vm.orderVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.orderVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs2
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "账号 / 姓名",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.dialogLoading),
            expression: "dialogLoading"
          }],
          ref: "users",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.users,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "row-click": _vm.handleSelectionChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-checkbox', {
                model: {
                  value: (scope.row.checked),
                  callback: function($$v) {
                    _vm.$set(scope.row, "checked", $$v)
                  },
                  expression: "scope.row.checked"
                }
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "130",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "160",
            "show-overflow-tooltip": ""
          }
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding": "10px 0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": " prev, pager, next",
            "current-page": _vm.pageNumber2,
            "page-size": _vm.pageSize2,
            "total": _vm.total2
          },
          on: {
            "current-change": _vm.handleCurrentChange2
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.orderVisible = false, _vm.searchText = ''
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.orderLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.orderUserSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "订单账户",
            "visible": _vm.personVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.personVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs3
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "企业名称",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getPerson(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getPerson(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.dialogLoading),
            expression: "dialogLoading"
          }],
          ref: "personList",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.personList,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "row-click": _vm.handleSelectionChange3
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-checkbox', {
                on: {
                  "change": _vm.changeFun3
                },
                model: {
                  value: (scope.row.checked),
                  callback: function($$v) {
                    _vm.$set(scope.row, "checked", $$v)
                  },
                  expression: "scope.row.checked"
                }
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "managername",
            "label": "公司管理员",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "min-width": "180",
            "show-overflow-tooltip": ""
          }
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding": "10px 0"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": " prev, pager, next",
            "current-page": _vm.pageNumber3,
            "page-size": _vm.pageSize3,
            "total": _vm.total3
          },
          on: {
            "current-change": _vm.handleCurrentChange3
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.personVisible = false, _vm.searchText = ''
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.orderLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.orderPersonSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("确定")])], 1)], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-stastics-box fitSize"
  }, [_c('el-row', {
    staticClass: "company-stastics-wrapper fitSize"
  }, [_c('el-col', {
    staticClass: "company-stastics-item left",
    attrs: {
      "span": 13
    }
  }, [_c('header', {
    staticClass: "left-hd"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": __webpack_require__(1654)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("有效产品")]), _vm._v(" "), _c('span', {
    staticClass: "label_count zs"
  }, [_vm._v(_vm._s(_vm.proNum))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": __webpack_require__(1653)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("闲置产品")]), _vm._v(" "), _c('span', {
    staticClass: "label_count xz"
  }, [_vm._v(_vm._s(_vm.proXZ))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": __webpack_require__(1651)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("已过期产品")]), _vm._v(" "), _c('span', {
    staticClass: "label_count ygq"
  }, [_vm._v(_vm._s(_vm.proGQ))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    staticClass: "x_icon",
    attrs: {
      "src": __webpack_require__(1652)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "span_size"
  }, [_vm._v("即将过期")]), _vm._v(" "), _c('span', {
    staticClass: "label_count jgq"
  }, [_vm._v(_vm._s(_vm.proJGQ))])])], 1)], 1), _vm._v(" "), _c('article', {
    staticClass: "left-bd",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("产品统计")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.productLoading),
      expression: "productLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.products
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "logo",
      "header-align": "center",
      "align": "center",
      "width": "100px",
      "label": "产品图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "tpimg",
          attrs: {
            "slot": "reference",
            "src": scope.row.logo,
            "alt": scope.row.logo
          },
          slot: "reference"
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "产品名称",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "产品数量",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unUsedSum",
      "label": "闲置产品",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dueSum",
      "label": "过期产品",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dueMonthSum",
      "label": "即将过期",
      "width": "90",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "left-ft"
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("模块使用情况")]), _vm._v(" "), _c('el-select', {
    staticClass: "checkName",
    staticStyle: {
      "float": "right"
    },
    on: {
      "change": function($event) {
        return _vm.changeTime('getCompanyMonthModulePointPie')
      }
    },
    model: {
      value: (_vm.moduleTime),
      callback: function($$v) {
        _vm.moduleTime = $$v
      },
      expression: "moduleTime"
    }
  }, _vm._l((_vm.times), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.masg),
      expression: "!masg"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.moduleLoading),
      expression: "moduleLoading"
    }],
    staticClass: "pie-content"
  }, [_c('el-col', {
    staticClass: "pie-chart",
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "echartModule"
    }
  })]), _vm._v(" "), (_vm.modulePieArr.length > 0) ? _c('el-col', {
    staticClass: "pie-legend",
    attrs: {
      "span": 10
    }
  }, _vm._l((_vm.modulePieArr), function(leg, index) {
    return _c('div', {
      key: leg.moduleid,
      staticClass: "legend-list"
    }, [_c('span', {
      staticClass: "circle",
      style: ({
        'background': index < _vm.pieColor.length ? _vm.pieColor[index] : (_vm.pieColor[index - _vm.pieColor.length])
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(leg.modulename))])])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.masg),
      expression: "masg"
    }],
    staticStyle: {
      "height": "50px",
      "text-align": "center",
      "color": "#666",
      "line-height": "20"
    }
  }, [_vm._v(" 暂无数据")])], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "company-stastics-item right",
    attrs: {
      "span": 11
    }
  }, [_c('header', {
    staticClass: "right-hd",
    staticStyle: {
      "position": "relative",
      "margin-bottom": "15px"
    }
  }, [_c('header', {
    staticClass: "module-title",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("登录设备统计")]), _vm._v(" "), _c('el-select', {
    staticClass: "checkName",
    staticStyle: {
      "top": "-8px"
    },
    on: {
      "change": function($event) {
        return _vm.changeTime('getDeviceInfo')
      }
    },
    model: {
      value: (_vm.deviceCount),
      callback: function($$v) {
        _vm.deviceCount = $$v
      },
      expression: "deviceCount"
    }
  }, _vm._l((_vm.times), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.deviceLoading),
      expression: "deviceLoading"
    }],
    staticStyle: {
      "height": "70px"
    },
    attrs: {
      "id": "device-chart"
    }
  })], 1), _vm._v(" "), _c('article', {
    staticClass: "right-bd"
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("积分统计")]), _vm._v(" "), _c('el-select', {
    staticClass: "checkName",
    on: {
      "change": function($event) {
        return _vm.changeTime('getCompanyMonthPointBrokenLine')
      }
    },
    model: {
      value: (_vm.staTime),
      callback: function($$v) {
        _vm.staTime = $$v
      },
      expression: "staTime"
    }
  }, _vm._l((_vm.times), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.creditLoading),
      expression: "creditLoading"
    }],
    staticStyle: {
      "height": "160px"
    },
    attrs: {
      "id": "creditLine"
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "right-ft",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('header', {
    staticClass: "module-title"
  }, [_vm._v("积分排行榜")]), _vm._v(" "), _c('div', {
    staticClass: "operate-btn"
  }, [_c('el-button', {
    staticClass: "jf_button",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.ranking(1)
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-button', {
    staticClass: "jf_button",
    on: {
      "click": function($event) {
        return _vm.ranking(2)
      }
    }
  }, [_vm._v("近30天")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.rankLoading),
      expression: "rankLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.values,
      "height": "200"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "排名",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sumpoint",
      "label": "产生积分",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "label-credit-queue",
          on: {
            "click": function($event) {
              return _vm.handlePie(scope.row.userid, scope.row.name)
            }
          }
        }, [_vm._v("模块使用情况")]), _vm._v(" "), _c('span', {
          staticClass: "label-credit-queue tj",
          on: {
            "click": function($event) {
              return _vm.handleLine(scope.row.userid, scope.row.name)
            }
          }
        }, [_vm._v("积分统计")])]
      }
    }])
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "选择人员",
      "visible": _vm.personVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.personVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch
    },
    model: {
      value: (_vm.souch_value),
      callback: function($$v) {
        _vm.souch_value = $$v
      },
      expression: "souch_value"
    }
  }, _vm._l((_vm.optionsSouch), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.proName),
      callback: function($$v) {
        _vm.proName = $$v
      },
      expression: "proName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v(" \n          " + _vm._s(tag) + " \n      ")])
  }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    ref: "users",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "current-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.checked),
            expression: "scope.row.checked"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(scope.row.checked) ? _vm._i(scope.row.checked, null) > -1 : (scope.row.checked)
          },
          on: {
            "change": [function($event) {
              var $$a = scope.row.checked,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(scope.row, "checked", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(scope.row, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(scope.row, "checked", $$c)
              }
            }, _vm.changeFun]
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "point",
      "label": "积分",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "border": "1px solid #dfe6ec",
      "margin-top": "0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": " prev, pager, next",
      "current-page": _vm.pageNumber2,
      "page-size": _vm.pageSize2,
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.personVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.userSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "近30天模块使用",
      "visible": _vm.pieVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.pieVisible = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "top": "60px"
    }
  }, [_vm._v("当前人员 : " + _vm._s(_vm.pieName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "360px"
    },
    attrs: {
      "id": "echartBT2"
    }
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "近30天积分统计",
      "visible": _vm.lineVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.lineVisible = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "position": "absolute",
      "left": "30px",
      "top": "60px"
    }
  }, [_vm._v("当前人员 : " + _vm._s(_vm.lineName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "360px"
    },
    attrs: {
      "id": "echartZXT2"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-applyTrial-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "姓名 / 电话 / 公司"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getProList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getProList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.proList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usename",
            "label": "姓名",
            "width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "电话",
            "width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "qq",
            "label": "QQ",
            "width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "公司",
            "min-width": "300",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "bumenzhiwei",
            "label": "部门职位",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adress",
            "label": "地址",
            "min-width": "300",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "statusname",
            "label": "处理状态",
            "width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.status == '1' ? 'success' : 'warning'
              }, [_vm._v(" " + _vm._s(scope.row.statusname) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "fixed": "right",
            "min-width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleView(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "处理",
                  "placement": "top"
                }
              }, [(scope.row.status != '0') ? _c('span', {
                staticClass: "dnnfont iconfile-done icon-disabled"
              }) : _c('span', {
                staticClass: "dnnfont iconfile-done",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })])], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "详情",
            "visible": _vm.viewVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.viewVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "viewForm",
          attrs: {
            "model": _vm.viewForm,
            "label-width": "80px"
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名:",
            "prop": "usename"
          }
        }, [_vm._v("\n             " + _vm._s(_vm.viewForm.usename) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "QQ:",
            "prop": "qq"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.viewForm.qq) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "电话:",
            "prop": "phone"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.viewForm.phone) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "部门职位:",
            "prop": "bumenzhiwei"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.viewForm.bumenzhiwei) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "公司:",
            "prop": "company"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.viewForm.company) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "地址:",
            "prop": "adress"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.viewForm.adress) + "\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.viewVisible = false
            }
          }
        }, [_vm._v("确定")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "tab-detart-manage",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-form', {
          attrs: {
            "inline": true
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "联系人电话 / 客户地址"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchVal.searchText),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "searchText", $$v)
            },
            expression: "searchVal.searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "160px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "拜访日期"
          },
          model: {
            value: (_vm.searchVal.payVisitDate),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "payVisitDate", $$v)
            },
            expression: "searchVal.payVisitDate"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "110px"
          },
          attrs: {
            "placeholder": "拜访方式",
            "clearable": ""
          },
          model: {
            value: (_vm.searchVal.payVisitStatus),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "payVisitStatus", $$v)
            },
            expression: "searchVal.payVisitStatus"
          }
        }, _vm._l((_vm.visitStatusList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "110px"
          },
          attrs: {
            "placeholder": "审核状态",
            "clearable": ""
          },
          model: {
            value: (_vm.searchVal.auditStatus),
            callback: function($$v) {
              _vm.$set(_vm.searchVal, "auditStatus", $$v)
            },
            expression: "searchVal.auditStatus"
          }
        }, _vm._l((_vm.checkStatusList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), (_vm.userInfo.type != 1) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium",
            "plain": "",
            "icon": "el-icon-plus"
          },
          on: {
            "click": _vm.addForm
          }
        }, [_vm._v("新\n          增")]) : _vm._e()], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          ref: "companyTabRef",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "row-style": {
              height: '50px'
            }
          },
          on: {
            "selection-change": _vm.handerSectionChange,
            "row-click": _vm.handerRowClick
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "50"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "70"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "payVisitDate",
            "width": "120",
            "label": "拜访日期",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.payVisitDate ? scope.row.payVisitDate.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminUserName",
            "width": "100",
            "label": "客户经理",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.adminUserName ? scope.row.adminUserName.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "successfulManagerName",
            "width": "110",
            "label": "客户成功经理",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.successfulManagerName ? scope.row.successfulManagerName.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "agencyManagerName",
            "width": "100",
            "label": "经销商",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.agencyManagerName ? scope.row.agencyManagerName.split(" ")[0] : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "contactUser",
            "width": "120",
            "label": "联系人",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "contactPhone",
            "width": "120",
            "label": "联系人电话",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.contactPhone ? scope.row.contactPhone : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "payVisitStatus",
            "width": "120",
            "label": "拜访方式",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag-fill",
                class: scope.row.payVisitStatus == 1 ? 'pruple' : (scope.row.payVisitStatus == 2 ? 'primary' : 'warning')
              }, [_vm._v("\n            " + _vm._s(scope.row.payVisitStatus == 1 ? "电话沟通" : (scope.row.payVisitStatus == 2 ? '客户现场' : '视频会议')) + "\n          ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "auditStatus",
            "width": "120",
            "label": "审核状态",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.auditStatus == 1 ? 'warning' : 'primary'
              }, [_vm._v("\n            " + _vm._s(scope.row.auditStatus == 1 ? "待审核" : '已审核') + "\n          ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "position",
            "label": "职位",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.position ? scope.row.position : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "addressInfo",
            "label": "客户地址",
            "min-width": "150",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.addressInfo || '') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.$index, scope.row, 1)
                  }
                }
              })]), _vm._v(" "), (scope.row.auditStatus == 1 && _vm.userInfo.id == scope.row.createUser) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e(), _vm._v(" "), (scope.row.auditStatus == 1 && _vm.userInfo.id == scope.row.createUser) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), (_vm.visible) ? _c('ModalForm', {
          attrs: {
            "visible": _vm.visible,
            "mode": _vm.mode,
            "visitStatusList": _vm.visitStatusList,
            "processDetail": _vm.processDetail
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            },
            "getList": _vm.getList
          }
        }) : _vm._e(), _vm._v(" "), (_vm.visibleView) ? _c('ModalFormView', {
          attrs: {
            "visible": _vm.visibleView,
            "visitStatusList": _vm.visitStatusList,
            "processDetail": _vm.processDetail
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleView = $event
            },
            "getList": _vm.getList
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "position": "relative"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "硬件码 / 备注"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList(1)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getList(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "adds",
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "adds",
    attrs: {
      "type": "text"
    }
  }, [_c('label', {
    attrs: {
      "for": "uploadwxsModal"
    }
  }, [_vm._v("导入")])])], 1), _vm._v(" "), _c('input', {
    ref: "clearFileModal",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "uploadwxsModal",
      "name": "file"
    },
    on: {
      "change": function($event) {
        return _vm.importFile($event)
      }
    }
  }), _vm._v(" "), _c('el-form-item', [_c('a', {
    attrs: {
      "href": _vm.hrefUrl
    }
  }, [_c('el-button', {
    staticClass: "adds",
    attrs: {
      "type": "text"
    }
  }, [_vm._v("下载模板")])], 1)])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "tooltip-effect": "dark",
      "data": _vm.proList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hardHash",
      "label": "设备硬件码",
      "min-width": "240",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "comment",
      "label": "备注",
      "min-width": "300",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.comment || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "300",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "intime",
      "label": "添加时间",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "operate"
        }, [_c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "编辑",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconEdit",
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "删除",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont icondelete",
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "新增设备",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "硬件码",
      "prop": "hardHash"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.hardHash),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "hardHash", $$v)
      },
      expression: "addForm.hardHash"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.deptname),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "deptname", $$v)
      },
      expression: "addForm.deptname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "comment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.comment),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "comment", $$v)
      },
      expression: "addForm.comment"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "编辑设备",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "硬件码",
      "prop": "hardHash"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.hardHash),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hardHash", $$v)
      },
      expression: "editForm.hardHash"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.deptname),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "deptname", $$v)
      },
      expression: "editForm.deptname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "comment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.comment),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "comment", $$v)
      },
      expression: "editForm.comment"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-order-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 18
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "用户名",
            "clearable": ""
          },
          on: {
            "change": function($event) {
              return _vm.getList(1)
            }
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.userName),
            callback: function($$v) {
              _vm.userName = $$v
            },
            expression: "userName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 3
          }
        }, [_c('div', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("提交任务数：" + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 3
          }
        }, [_c('div', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("生图成功数：" + _vm._s(_vm.successCount))])])]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "row-dblclick": _vm.handleRowClick
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "userName",
            "label": "用户名",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userId ? scope.row.userName : "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "companyname",
            "label": "企业",
            "min-width": "240",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.companyname || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "resolution",
            "label": "图片大小",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.resolution || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "通道图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.modelImgThumbnail || scope.row.modelImg) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.modelImgThumbnail || scope.row.modelImg,
                  "preview-src-list": [scope.row.modelImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "原图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.originalImgThumbnail || scope.row.originalImg) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.originalImgThumbnail || scope.row.originalImg,
                  "preview-src-list": [scope.row.originalImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "叠加优化图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.optimizationImgThumbnail || scope.row.optimizationImg) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.optimizationImgThumbnail || scope.row.optimizationImg,
                  "preview-src-list": [scope.row.optimizationImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "原图优化图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.satelliteImgThumbnail || scope.row.satelliteImg) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.satelliteImgThumbnail || scope.row.satelliteImg,
                  "preview-src-list": [scope.row.satelliteImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "createTime",
            "label": "创建时间",
            "width": "160",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" " + _vm._s(_vm.dateTran(scope.row.createTime)) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "生成耗时",
            "width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.generationEndTime && scope.row.generationStartTime) ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDuration(scope.row.generationEndTime - scope.row.generationStartTime)) + " ")]) : _c('span', [_vm._v(" - ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "generationState",
            "label": "状态",
            "width": "80",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.generationState === -1) ? _c('span', [_vm._v("待提交")]) : (scope.row.generationState === 0) ? _c('span', [_vm._v("生成中")]) : (scope.row.generationState === 1) ? _c('span', [_vm._v("完成")]) : (scope.row.generationState === 3) ? _c('span', [_vm._v("错误")]) : (scope.row.generationState === 4) ? _c('span', [_vm._v("取消")]) : _c('span', [_vm._v("-")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "prompt",
            "label": "提示词",
            "min-width": "180",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.prompt || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.row)
                  }
                }
              })])], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          attrs: {
            "title": "生图详情",
            "visible": _vm.dialogVisible,
            "width": "50%",
            "top": "5vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        }, [_c('el-row', {
          attrs: {
            "gutter": 20
          }
        }, [_c('el-form', {
          staticClass: "demo-ruleForm login-container",
          attrs: {
            "label-width": "100px"
          }
        }, [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.companyname || '-') + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户名:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.userName || '-') + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "角色:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.membershipName || '-') + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "创建时间:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.dateTran(_vm.detail.createTime)) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片大小:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.resolution || '-') + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "提示词:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.prompt || '-') + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "生图记录id:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.generationId || '-') + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "通道图:"
          }
        }, [(_vm.detail.modelImgThumbnail || _vm.detail.modelImg) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.modelImgThumbnail || _vm.detail.modelImg,
            "preview-src-list": [_vm.detail.modelImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "原图:"
          }
        }, [(_vm.detail.originalImgThumbnail || _vm.detail.originalImg) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.originalImgThumbnail || _vm.detail.originalImg,
            "preview-src-list": [_vm.detail.originalImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "叠加优化图:"
          }
        }, [(_vm.detail.optimizationImgThumbnail || _vm.detail.optimizationImg) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.optimizationImgThumbnail || _vm.detail.optimizationImg,
            "preview-src-list": [_vm.detail.optimizationImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "原图优化图:"
          }
        }, [(_vm.detail.satelliteImgThumbnail || _vm.detail.satelliteImg) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.satelliteImgThumbnail || _vm.detail.satelliteImg,
            "preview-src-list": [_vm.detail.satelliteImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1)], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "total, sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px",
      "margin-top": "2px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.optionsSouch), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch),
      expression: "disSouch"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.proName),
      callback: function($$v) {
        _vm.proName = $$v
      },
      expression: "proName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    staticStyle: {
      "position": "relative",
      "top": "2px",
      "width": "300px"
    },
    attrs: {
      "type": "daterange",
      "size": "large",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.LogDate),
      callback: function($$v) {
        _vm.LogDate = $$v
      },
      expression: "LogDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_c('a', {
    on: {
      "click": _vm.downFile
    }
  }, [_vm._v("导出")])])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": "",
      "height": "420px",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "point",
      "label": "积分",
      "min-width": "140",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "registertime",
      "label": "注册日期",
      "min-width": "180",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company",
      "label": "企业",
      "min-width": "180",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('br'), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-detail-box"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "font",
    on: {
      "click": _vm.bak
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left icon"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "shu"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "font-text"
  }, [_vm._v(_vm._s(_vm.$route.query.companyName))])]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("用户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }, [_vm._v("跟踪记录")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [_vm._v("企业设置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-content"
  }, [(_vm.activeIndex == 1) ? _c('company') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 7) ? _c('TrackManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 8) ? _c('CompamySetting') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-company-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "大区",
            "clearable": true
          },
          model: {
            value: (_vm.regionCode),
            callback: function($$v) {
              _vm.regionCode = $$v
            },
            expression: "regionCode"
          }
        }, _vm._l((_vm.regionCodeList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "企业名称",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.managerAdminuser
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "客户成功经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.successfulManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "经销商",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.agencyManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('div', {
          staticClass: "tips"
        }, [_c('span', [_vm._v("试用客户总数量：")]), _c('span', {
          staticClass: "blueNumber"
        }, [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('span', [_vm._v("甲级试用客户数量：")]), _c('span', {
          staticClass: "redNumber"
        }, [_vm._v(_vm._s(_vm.levelTotal))]), _vm._v(" "), _c('span', [_vm._v("试用用户数：")]), _c('span', {
          staticClass: "purpleNumber"
        }, [_vm._v(_vm._s(_vm.tryTotal))]), _vm._v(" "), _c('span', [_vm._v("高校试用用户数：")]), _c('span', {
          staticClass: "colleges"
        }, [_vm._v(_vm._s(_vm.collegesTotal))]), _vm._v(" "), _c('span', [_vm._v("设计院试用用户数：")]), _c('span', {
          staticClass: "institute"
        }, [_vm._v(_vm._s(_vm.instituteTotal))])]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "tooltip-effect": "dark",
            "data": _vm.proList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight - 36,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "regionCode",
            "label": "大区代号",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.regionCode === '1') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华东大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '2') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '3') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西北大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '4') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("华南大区")]) : _vm._e(), _vm._v(" "), (scope.row.regionCode === '5') ? _c('div', {
                staticClass: "gray"
              }, [_vm._v("西南大区")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "sortable": "custom",
            "min-width": "340",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "grade",
            "label": "资质等级",
            "sortable": "custom",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.grade === '1') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("综合甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '2') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '3') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '4') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("公路市政甲")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '5') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '6') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '7') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("公路市政乙")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '9') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("高校")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '10') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("施工单位")]) : _vm._e(), _vm._v(" "), (scope.row.grade === '8') ? _c('div', {
                staticClass: "other"
              }, [_vm._v("其他")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "natrue",
            "label": "企业性质",
            "sortable": "custom",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.natrue === '1' ? '央企' : scope.row.natrue === '2' ? '国企' : scope.row.natrue === '3' ? '民营上市' :
                scope.row.natrue === '4' ? '民营' : scope.row.natrue === '5' ? '高校' : '-') + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "syuc",
            "label": "试用用户数",
            "min-width": "140",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "purpleNumber"
              }, [_vm._v(_vm._s(scope.row.syuc ? scope.row.syuc : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "showname",
            "label": "地区",
            "sortable": "custom",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "公司管理员",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managername ? scope.row.managername : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户经理",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.managerAdminuserName ? scope.row.managerAdminuserName : '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "客户成功经理",
            "min-width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.successfulManagerName ?
                scope.row.successfulManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "经销商",
            "min-width": "70",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.agencyManagerName ?
                scope.row.agencyManagerName :
                "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleCom(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (_vm.id == scope.row.createUser && scope.row.delFlg !== '0') ? _c('el-tooltip', {
                staticClass: "caozuo",
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()]
            }
          }])
        })], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "update:currentPage": function($event) {
              _vm.pageNumber = $event
            },
            "update:current-page": function($event) {
              _vm.pageNumber = $event
            },
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-detail-box"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "font",
    on: {
      "click": _vm.back
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left icon"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "shu"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "font-text"
  }, [_vm._v(_vm._s(_vm.$route.query.name))])]), _vm._v(" "), _c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "content-copy"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "content-box-copy",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品管理")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("\n              共" + _vm._s(_vm.sum) + "个产品  "), _c('span', {
    staticClass: "higlight"
  }, [_vm._v("企业产品:" + _vm._s(_vm.company) + ",已过期产品:" + _vm._s(_vm.expired))])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%",
      "margin-top": "10px",
      "height": "auto"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "名称",
      "min-width": "220",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typename",
      "label": "类型",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "usingstatusname",
      "label": "状态",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.usingstatus == 1) ? _c('span', {
          staticStyle: {
            "color": "#2196f3"
          }
        }, [_vm._v(_vm._s(scope.row.usingstatusname))]) : _c('span', [_vm._v(_vm._s(scope.row.usingstatusname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "duetime",
      "label": "到期时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.duetime.split(" ")[0]) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "operate"
        }, [(scope.row.usingstatus == 1) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "禁用",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont icondisabled",
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.usingstatus == 3) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "启用",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconaccomplish",
          on: {
            "click": function($event) {
              return _vm.handleOpen(scope.$index, scope.row)
            }
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "content-box-two-copy",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("登录日历")]), _vm._v(" "), _c('Calendar')], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-copy"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "content-box-copy"
  }, [_c('LeftCharts', {
    attrs: {
      "userid": _vm.$route.query.userId
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "content-box-two-copy"
  }, [_c('RightCharts', {
    attrs: {
      "userid": _vm.$route.query.userId
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    class: _vm.showRecords ? 'content-copy' : 'newstyle'
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": _vm.showRecords ? 16 : 24
    }
  }, [_c('div', {
    class: _vm.showRecords ? 'newstyle' : ''
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("客户备注")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "rows": 3,
      "type": "textarea",
      "placeholder": "填写留言"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.addUserNote
    }
  }, [_vm._v("提交")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#616161",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n              所有备注(" + _vm._s(_vm.allcount) + ")\n            ")]), _vm._v(" "), _vm._l((_vm.notes), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "contextx"
    }, [_c('div', {
      staticClass: "contexss",
      staticStyle: {
        "height": "30px"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block",
        "width": "80px",
        "float": "left",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block",
        "margin-left": "20px",
        "float": "left",
        "color": "#acabab"
      }
    }, [_vm._v(_vm._s(item.intime))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "contexss",
      staticStyle: {
        "color": "#707070"
      }
    }, [_vm._v("\n                " + _vm._s(item.note) + "\n              ")])])
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "0.5px solid #d4d3d3"
    }
  })], 2)]), _vm._v(" "), (_vm.showRecords) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loginInfoLoading),
      expression: "loginInfoLoading"
    }],
    staticClass: "content-box-two-copy"
  }, [_c('div', {
    staticClass: "record_title"
  }, [_vm._v("登录记录统计")]), _vm._v(" "), _c('div', {
    staticClass: "login_info"
  }, [_c('span', {
    staticClass: "login_title"
  }, [_vm._v("总计登录："), _c('span', {
    staticClass: "login_num"
  }, [_vm._v(_vm._s(_vm.countNum) + "次")])])]), _vm._v(" "), _c('div', {
    staticClass: "last_time"
  }, [_vm._v("\n              您上次登陆时间和位置：" + _vm._s(_vm.lastLogin_time) + "，" + _vm._s(_vm.lastLogin_location) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "history"
  }, [_vm._v("历史记录（最近10次）")]), _vm._v(" "), _vm._l((_vm.infos), function(item) {
    return _c('div', {
      staticClass: "history_item"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('span', {
      staticClass: "times"
    }, [_vm._v(_vm._s(item.times))]), _vm._v(" "), _c('span', {
      staticClass: "ip"
    }, [_vm._v(_vm._s(item.ip))]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(item.location))])])
  })], 2)]) : _vm._e()], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-UrlsNumber-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', [_c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleURLAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.urlList,
            "highlight-current-row": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber1 - 1) * _vm.pageSize1 + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "cloudserviceurl",
            "label": "路径",
            "min-width": "200"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "version",
            "label": "版本",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "comment",
            "label": "备注",
            "min-width": "240",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleURLEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleURLDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "visible": _vm.addUrlVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addUrlVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addUrl,
            "label-width": "80px",
            "rules": _vm.addUrlRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "路径",
            "prop": "cloudserviceurl"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addUrl.cloudserviceurl),
            callback: function($$v) {
              _vm.$set(_vm.addUrl, "cloudserviceurl", $$v)
            },
            expression: "addUrl.cloudserviceurl"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "版本",
            "prop": "version"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addUrl.version),
            callback: function($$v) {
              _vm.$set(_vm.addUrl, "version", $$v)
            },
            expression: "addUrl.version"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "备注",
            "prop": "comment"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "textarea",
            "rows": 3,
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addUrl.comment),
            callback: function($$v) {
              _vm.$set(_vm.addUrl, "comment", $$v)
            },
            expression: "addUrl.comment"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addUrlVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addUrlLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addUrlSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editUrlVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editUrlVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.editUrl,
            "label-width": "80px",
            "rules": _vm.editUrlRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "路径",
            "prop": "cloudserviceurl"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editUrl.cloudserviceurl),
            callback: function($$v) {
              _vm.$set(_vm.editUrl, "cloudserviceurl", $$v)
            },
            expression: "editUrl.cloudserviceurl"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "版本",
            "prop": "version"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editUrl.version),
            callback: function($$v) {
              _vm.$set(_vm.editUrl, "version", $$v)
            },
            expression: "editUrl.version"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "备注",
            "prop": "comment"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "textarea",
            "rows": 3,
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editUrl.comment),
            callback: function($$v) {
              _vm.$set(_vm.editUrl, "comment", $$v)
            },
            expression: "editUrl.comment"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editUrlVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editUrlLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editUrlSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber1,
            "page-size": _vm.pageSize1,
            "total": _vm.total1
          },
          on: {
            "current-change": _vm.handleCurrentChange1,
            "size-change": _vm.handleSizeChange1
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "detailPage"
  }, [_c('header', {
    staticClass: "detaiHead"
  }, [_c('span', {
    staticClass: "back",
    on: {
      "click": _vm.backRoute_
    }
  }, [_c('i', {
    staticClass: "dnnfont iconangleleft",
    staticStyle: {
      "position": "relative",
      "margin-right": "8px"
    }
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.getName))]), _vm._v(" "), _c('span', {
    staticClass: "type"
  }, [_vm._t("type")], 2), _vm._v(" "), _c('span', {
    staticClass: "rightQuery"
  }, [_vm._t("right")], 2)]), _vm._v(" "), _c('main', {
    staticClass: "detailMain"
  }, [_vm._t("detailMain")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-menu-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          attrs: {
            "placeholder": "企业名称"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getTypeList(1)
            }
          },
          model: {
            value: (_vm.souchs.name),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "name", $$v)
            },
            expression: "souchs.name"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getTypeList(1)
            }
          }
        }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          staticClass: "adds",
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": _vm.handleAdd
          }
        }, [_vm._v("新增")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.listLoading),
            expression: "listLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.typeList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "企业名称",
            "min-width": "240",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "code",
            "label": "企业ID",
            "min-width": "220",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "intime",
            "label": "创建时间",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "220"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "新增",
            "visible": _vm.addFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "addForm",
          attrs: {
            "model": _vm.addForm,
            "label-width": "80px",
            "rules": _vm.addFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.addForm.name),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "name", $$v)
            },
            expression: "addForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业ID",
            "prop": "code"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.addSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.addForm.code),
            callback: function($$v) {
              _vm.$set(_vm.addForm, "code", $$v)
            },
            expression: "addForm.code"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.addFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.addLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.addSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px",
            "rules": _vm.editFormRules
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业名称",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "name", $$v)
            },
            expression: "editForm.name"
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 22
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业ID",
            "prop": "code"
          }
        }, [_c('el-input', {
          attrs: {
            "auto-complete": "off",
            "placeholder": "请输入"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.editSubmit.apply(null, arguments)
            }
          },
          model: {
            value: (_vm.editForm.code),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "code", $$v)
            },
            expression: "editForm.code"
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "stand"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("注册用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm._f("numberSlice")(_vm.requestData.userCount)) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("企业数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.companyCount) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("企业用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.companyNumByUser) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("上线软件个数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.productCount) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("日活用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number active",
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.userCountByDay) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("月活用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.userCountByMonth) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("季活用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.userCountByQuarter) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("用户总积分数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm._f("numberSlice")(_vm.requestData.userPointCount)) + "\n          ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "charts"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.pointByHour
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading4),
      expression: "loading4"
    }],
    attrs: {
      "id": "charts-box",
      "element-loading-text": "加载中"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.dayVisit
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading5),
      expression: "loading5"
    }],
    attrs: {
      "id": "charts-box-two",
      "element-loading-text": "加载中"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "year",
      "value-format": "yyyy",
      "placeholder": "请选择",
      "picker-options": _vm.yearPickerOptions
    },
    on: {
      "change": _vm.MonthVisit
    },
    model: {
      value: (_vm.visitByMonth_Year),
      callback: function($$v) {
        _vm.visitByMonth_Year = $$v
      },
      expression: "visitByMonth_Year"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading6),
      expression: "loading6"
    }],
    attrs: {
      "id": "charts-box-Three",
      "element-loading-text": "加载中"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "year",
      "value-format": "yyyy",
      "placeholder": "请选择",
      "picker-options": _vm.yearPickerOptions
    },
    on: {
      "change": _vm.QuarterVisit
    },
    model: {
      value: (_vm.visitByQuarter_Year),
      callback: function($$v) {
        _vm.visitByQuarter_Year = $$v
      },
      expression: "visitByQuarter_Year"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading7),
      expression: "loading7"
    }],
    attrs: {
      "id": "charts-box-Four",
      "element-loading-text": "加载中"
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "charts-copy",
    staticStyle: {
      "height": "510px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-copy"
    }
  }, [_c('LeftCharts')], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-two-copy"
    }
  }, [_c('RightCharts')], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "charts",
    staticStyle: {
      "height": "400px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Census', {
    attrs: {
      "userGuishuPie": _vm.userGuishuPie
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('CensusBar', {
    attrs: {
      "userGuishuBar": _vm.userGuishuBar
    }
  })], 1)], 1)], 1)]), _vm._v(" "), (_vm.dialogVisible) ? _c('ActiveModal', {
    attrs: {
      "dialogVisible": _vm.dialogVisible
    },
    on: {
      "update:dialogVisible": function($event) {
        _vm.dialogVisible = $event
      },
      "update:dialog-visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(751)
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "logo_span"
  }, [_vm._v("Delauney")]), _vm._v(" "), _c('div', {
    staticClass: "full"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "login_div"
  }, [_c('span', {
    staticClass: "login_span"
  }, [_vm._v("Create an account")]), _vm._v(" "), _c('el-form', {
    ref: "userForm",
    attrs: {
      "model": _vm.userForm,
      "rules": _vm.userRules,
      "hide-required-asterisk": true
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "FirstName",
      "label": "First name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "First name"
    },
    model: {
      value: (_vm.userForm.FirstName),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "FirstName", $$v)
      },
      expression: "userForm.FirstName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "LastName",
      "label": "Last name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Last name"
    },
    model: {
      value: (_vm.userForm.LastName),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "LastName", $$v)
      },
      expression: "userForm.LastName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "CompanyName",
      "label": "Company name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Company name"
    },
    model: {
      value: (_vm.userForm.CompanyName),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "CompanyName", $$v)
      },
      expression: "userForm.CompanyName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "Email",
      "label": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Email address"
    },
    on: {
      "input": _vm.validateEmail
    },
    model: {
      value: (_vm.userForm.Email),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "Email", $$v)
      },
      expression: "userForm.Email"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "Password",
      "label": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "Password",
      "show-password": ""
    },
    on: {
      "input": _vm.validatePassword
    },
    model: {
      value: (_vm.userForm.Password),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "Password", $$v)
      },
      expression: "userForm.Password"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.userForm.Password) ? _c('div', {
    staticClass: "reset_box"
  }, [_c('p', {
    class: {
      'error-text': !_vm.containsAtLeastEightCharacters,
      'true-text': _vm.containsAtLeastEightCharacters,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsAtLeastEightCharacters ? "√" : "X"))]), _vm._v("\n              Contains at least 8 characters\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.containsBothLowerUpper,
      'true-text': _vm.containsBothLowerUpper,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsBothLowerUpper ? "√" : "X"))]), _vm._v("\n              contains both lower (a-z) and upper case letters (A-Z)\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.containsNumberOrSymbol,
      'true-text': _vm.containsNumberOrSymbol,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.containsNumberOrSymbol ? "√" : "X"))]), _vm._v("\n              contains at least one number (0-9) or a symbol\n            ")]), _vm._v(" "), _c('p', {
    class: {
      'error-text': !_vm.doesNotContainEmail,
      'true-text': _vm.doesNotContainEmail,
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.doesNotContainEmail ? "√" : "X"))]), _vm._v("\n              Does not contain your Email address\n            ")])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "login_submit",
    attrs: {
      "type": "danger"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextStep(1)
      }
    }
  }, [_vm._v("CONTINUE")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }],
    staticClass: "code_div"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    staticClass: "backup",
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("←")]), _vm._v(" "), _c('span', {
    staticClass: "login_span"
  }, [_vm._v("Verify your identity")])]), _vm._v(" "), _c('div', {
    staticClass: "sub_desc"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("Enter the code we've sent to")]), _vm._v(" "), _c('span', {
    staticClass: "Email"
  }, [_vm._v(_vm._s(_vm.userForm.Email))])]), _vm._v(" "), _c('el-form', {
    ref: "codeForm",
    attrs: {
      "model": _vm.codeForm,
      "rules": _vm.codeRules
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticClass: "registerEn",
    attrs: {
      "prop": "verificationCode",
      "label": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "code"
    },
    model: {
      value: (_vm.codeForm.verificationCode),
      callback: function($$v) {
        _vm.$set(_vm.codeForm, "verificationCode", $$v)
      },
      expression: "codeForm.verificationCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "no_see"
  }, [_c('span', {
    staticClass: "not_see"
  }, [_vm._v("Don't see it? ")]), _vm._v(" "), _c('span', {
    staticClass: "resend"
  }, [_c('el-button', {
    staticClass: "el_reg resend",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.smsCode
    }
  }, [(_vm.time) ? _c('span', [_vm._v(_vm._s(_vm.time) + "s later ")]) : _vm._e(), _vm._v("Resend code\n            ")])], 1)])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "success_box"
  }, [_c('div', {
    staticClass: "success"
  }, [_vm._v("🥳 Success!")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n          Congratulations, your account has been successfully created.\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.delauney.ltd/pc_index",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fwgw"
  }, [_vm._v("Visit official website →")])])
}]}

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DetailPage', {
    attrs: {
      "name": _vm.modulename,
      "loading": _vm.loading,
      "backRoute": "moduleIntegral",
      "param": _vm.params
    }
  }, [_c('template', {
    slot: "detailMain"
  }, [_c('span', {
    staticClass: "searchName"
  }, [_vm._v("自定义时间段:")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "kuang",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "daterange",
      "clearable": false,
      "size": "large",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changeData
    },
    model: {
      value: (_vm.tiemSlot),
      callback: function($$v) {
        _vm.tiemSlot = $$v
      },
      expression: "tiemSlot"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#2196F3"
    },
    attrs: {
      "type": "text"
    }
  }, [_c('a', {
    on: {
      "click": _vm.downFile
    }
  }, [_vm._v("导出")])]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("共" + _vm._s(_vm.count) + "人使用")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": "545px",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "用户名",
      "width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "companyname",
      "label": "企业",
      "min-width": "230",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "allpoint",
      "label": "产生积分",
      "width": "130",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#669DF0"
          }
        }, [_vm._v(_vm._s(scope.row.allpoint))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes,prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "page-size": _vm.pageSize,
      "current-page": _vm.pageNumber,
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.pageNumber = $event
      },
      "update:current-page": function($event) {
        _vm.pageNumber = $event
      },
      "current-change": _vm.changeData
    }
  })], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pictureList.length > 0) ? _c('viewer', {
    ref: "viewer",
    staticClass: "picture-view-box",
    attrs: {
      "images": _vm.pictureList,
      "rebuild": "",
      "options": {
        initialViewIndex: 0,
        navbar: false,
        title: function () { return _vm.item.fileTitle; }
      }
    }
  }, _vm._l((_vm.pictureList), function(pic) {
    return _c('div', {
      key: pic.id,
      staticClass: "pic-list"
    }, [_c('img', {
      staticClass: "item-pic",
      attrs: {
        "src": pic.pic,
        "alt": ""
      }
    }), _vm._v(" "), (_vm.isShowFt) ? _c('h4', {
      staticClass: "pic-label"
    }, [_vm._t("default", function() {
      return [_vm._v(_vm._s(pic.fileName))]
    })], 2) : _vm._e()])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "imger"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "loginForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("用户登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-dianhua"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号码"
    },
    model: {
      value: (_vm.loginForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "phone", $$v)
      },
      expression: "loginForm.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-mima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("免费注册")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/forget'
      }
    }
  }, [_vm._v("忘记密码")])], 1)], 1)], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBar"
  }, [_c('h1'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.jsdnn.com/",
      "target": "_blank"
    }
  }, [_vm._v("狄诺尼官网")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('p', [_vm._v("江苏狄诺尼信息技术有限责任公司")]), _vm._v(" "), _c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])
}]}

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', _vm._b({
    staticClass: "select_common",
    attrs: {
      "maxTagCount": 1,
      "maxTagTextLength": 10
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.myDefaultVal),
      callback: function($$v) {
        _vm.myDefaultVal = $$v
      },
      expression: "myDefaultVal"
    }
  }, 'el-select', _vm.$attrs, false), [(_vm.list) ? _vm._l((_vm.list), function(item) {
    return _c('el-option', {
      key: item[_vm.keys.value],
      attrs: {
        "value": item[_vm.keys.value],
        "label": item[_vm.keys.label]
      }
    })
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-comorizeList-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "用户 / 账号 / 名称 / 企业"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.searchText),
            callback: function($$v) {
              _vm.searchText = $$v
            },
            expression: "searchText"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "类型",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.souType),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "souType", $$v)
            },
            expression: "souchs.souType"
          }
        }, _vm._l((_vm.types), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "状态",
            "clearable": ""
          },
          model: {
            value: (_vm.souchs.status),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "status", $$v)
            },
            expression: "souchs.status"
          }
        }, _vm._l((_vm.types2), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "selection-change": _vm.selsChange,
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "selection",
            "width": "55"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "200",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productname",
            "label": "名称",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "companyname",
            "label": "企业",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "userdeptname",
            "label": "部门",
            "min-width": "150",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userdeptname || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "用户",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.name || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "120",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.phone || '-'))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "typename",
            "label": "类型",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: scope.row.typename == '试用' ? 'success' : 'primary'
              }, [_vm._v(" " + _vm._s(scope.row.typename) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "usingstatus",
            "label": "状态",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "myTag",
                class: ['2', '3'].includes(scope.row.usingstatus) ? '' : 'primary'
              }, [_vm._v(" " + _vm._s(scope.row.usingstatusname) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "effectivetime",
            "label": "生效时间",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "duetime",
            "label": "到期时间",
            "min-width": "180",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "fixed": "right",
            "min-width": "120"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "相关订单",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-Business",
                on: {
                  "click": function($event) {
                    return _vm.handleAbout(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.usingstatus != 2) ? [(!scope.row.usingstatus2) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "禁用",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondisabled",
                on: {
                  "click": function($event) {
                    return _vm.handleDel(scope.$index, scope.row)
                  }
                }
              })]) : _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "启用",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconaccomplish",
                on: {
                  "click": function($event) {
                    return _vm.handleOpen(scope.$index, scope.row)
                  }
                }
              })])] : _vm._e()], 2)]
            }
          }])
        })], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit model-xf-box",
          attrs: {
            "width": "800px",
            "title": "续费",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "padding-bottom": "0px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "订单账户:"
          }
        }, [_vm._v(_vm._s(_vm.orderUser) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-table', {
          directives: [{
            name: "loading",
            rawName: "v-loading",
            value: (_vm.editlistLoading),
            expression: "editlistLoading"
          }],
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList2,
            "highlight-current-row": "",
            "header-cell-style": _vm.getRowClass
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod2,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber2 - 1) * _vm.pageSize2 + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "logo2",
            "header-align": "center",
            "align": "center",
            "width": "100px",
            "label": "图片"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('img', {
                staticClass: "tpimg",
                attrs: {
                  "slot": "reference",
                  "src": scope.row.logo2,
                  "alt": scope.row.logo2
                },
                slot: "reference"
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "id",
            "label": "ID",
            "min-width": "120",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "名称",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productid",
            "label": "订单ID",
            "min-width": "140",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price2",
            "label": "单价(元)",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "purchaseMonth",
            "label": "续费时长(月)",
            "min-width": "120",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(ref) {
              var row = ref.row;
              var $index = ref.$index;

              return [_c('el-input', {
                attrs: {
                  "type": "number",
                  "min": "1"
                },
                on: {
                  "blur": function($event) {
                    return _vm.loseFcousMonth(1, row)
                  }
                },
                model: {
                  value: (row.purchaseMonth),
                  callback: function($$v) {
                    _vm.$set(row, "purchaseMonth", $$v)
                  },
                  expression: "row.purchaseMonth"
                }
              })]
            }
          }])
        })], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          staticStyle: {
            "position": "relative",
            "padding-bottom": "0px",
            "margin-top": "0px",
            "height": "80px"
          },
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-checkbox', {
          staticClass: "el-checkbox1",
          on: {
            "change": _vm.checkboxOnclick
          },
          model: {
            value: (_vm.checked),
            callback: function($$v) {
              _vm.checked = $$v
            },
            expression: "checked"
          }
        }, [_vm._v(" 试用订单")]), _vm._v(" "), _c('el-form-item', {
          staticClass: "Auto_allPrice",
          attrs: {
            "label": "总价:"
          }
        }, [_c('el-input', {
          staticClass: "price",
          staticStyle: {
            "width": "120px",
            "z-index": "9999"
          },
          attrs: {
            "disabled": _vm.disCheckBox
          },
          on: {
            "blur": function($event) {
              return _vm.priceloseF()
            }
          },
          model: {
            value: (_vm.allPrice),
            callback: function($$v) {
              _vm.allPrice = $$v
            },
            expression: "allPrice"
          }
        })], 1), _vm._v(" "), _c('el-form-item', {
          staticClass: "Auto_ygPrice",
          attrs: {
            "label": "预估价格:"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.ygPrice) + " 元\n          ")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.adminVisible) ? _c('Detail', {
          attrs: {
            "adminVisible": _vm.adminVisible,
            "authProductId": _vm.detailOrderId
          },
          on: {
            "adminVisibleClose": _vm.adminVisibleClose
          }
        }) : _vm._e()]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "float_left",
          attrs: {
            "type": "danger",
            "size": "medium",
            "disabled": _vm.sels1.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.handleDel()
            }
          }
        }, [_vm._v("\n          禁用\n        ")]), _vm._v(" "), _c('el-button', {
          staticClass: "float_left",
          attrs: {
            "type": "primary",
            "size": "medium",
            "disabled": _vm.sels3.length === 0
          },
          on: {
            "click": function($event) {
              return _vm.handleOpen()
            }
          }
        }, [_vm._v("\n          启用\n        ")])], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.adminModulePointPie
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "charts-box"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingx),
      expression: "loadingx"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.title
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5px"
    },
    attrs: {
      "placeholder": "请输入位置后点击右侧图标确定坐标"
    },
    on: {
      "change": _vm.changeAddres
    },
    model: {
      value: (_vm.address_),
      callback: function($$v) {
        _vm.address_ = $$v
      },
      expression: "address_"
    }
  }, [(_vm.address_ != '') ? _c('i', {
    staticClass: "dnnfont iconrenyuandingwei",
    staticStyle: {
      "cursor": "pointer",
      "color": "#666666"
    },
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.openMap
    },
    slot: "suffix"
  }) : _vm._e()])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.innerVisible,
      "append-to-body": "",
      "fullscreen": true
    },
    on: {
      "update:visible": function($event) {
        _vm.innerVisible = $event
      },
      "opened": _vm.initMap
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('el-select', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading,
      "placeholder": "请输入关键词"
    },
    on: {
      "change": _vm.posChange
    },
    model: {
      value: (_vm.posValue),
      callback: function($$v) {
        _vm.posValue = $$v
      },
      expression: "posValue"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('el-option', {
      key: index + '',
      attrs: {
        "label": item.name + '(' + item.address + ')',
        "value": item.location.toString()
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadings),
      expression: "loadings"
    }],
    staticClass: "map",
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.innerVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.positions(_vm.position)
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DetailPage', {
    attrs: {
      "name": _vm.modulename,
      "loading": _vm.loading,
      "backRoute": "moduleIntegral",
      "param": _vm.params
    }
  }, [_c('template', {
    slot: "detailMain"
  }, [_c('span', {
    staticClass: "searchName"
  }, [_vm._v("自定义时间段:")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "kuang",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "daterange",
      "clearable": false,
      "size": "large",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changeData
    },
    model: {
      value: (_vm.tiemSlot),
      callback: function($$v) {
        _vm.tiemSlot = $$v
      },
      expression: "tiemSlot"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#2196F3"
    },
    attrs: {
      "type": "text"
    }
  }, [_c('a', {
    on: {
      "click": _vm.downFile
    }
  }, [_vm._v("导出")])]), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("共" + _vm._s(_vm.count) + "个命令模块        命令模块分数(总):" + _vm._s(_vm.jifen) + "        已过滤0积分模块")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": "545px",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "moduleid",
      "label": "命令id",
      "width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modulename",
      "label": "命令模块名称",
      "min-width": "230",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cmdpoint",
      "label": "命令模块分数",
      "width": "130",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cmdtotalpoint",
      "label": "总积分",
      "width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "allpoint",
      "label": "累计分数",
      "width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#669DF0"
          }
        }, [_vm._v(_vm._s(scope.row.allpoint))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clicksNum",
      "label": "点击次数",
      "width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes,prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "page-size": _vm.pageSize,
      "current-page": _vm.pageNumber,
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.pageNumber = $event
      },
      "update:current-page": function($event) {
        _vm.pageNumber = $event
      },
      "current-change": _vm.changeData
    }
  })], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "10px",
      "margin-bottom": "-12px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "用户 / 账号 / 名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList(1)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "类型",
      "clearable": ""
    },
    model: {
      value: (_vm.typeValue),
      callback: function($$v) {
        _vm.typeValue = $$v
      },
      expression: "typeValue"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "状态",
      "clearable": ""
    },
    model: {
      value: (_vm.typeValue2),
      callback: function($$v) {
        _vm.typeValue2 = $$v
      },
      expression: "typeValue2"
    }
  }, _vm._l((_vm.types2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getProList(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "medium",
      "disabled": _vm.ProductSelection.length == 0 ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.batch(1)
      }
    }
  }, [_vm._v("批量分配")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "medium",
      "disabled": _vm.ProductSelection.length == 0
    },
    on: {
      "click": function($event) {
        _vm.visibleDispatch = true
      }
    }
  }, [_vm._v("分配部门")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.proList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass,
      "row-key": function (row) { return row.id; }
    },
    on: {
      "sort-change": _vm.handleSortChange,
      "selection-change": _vm.handleProductSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "reserve-selection": true,
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "min-width": "200",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "名称",
      "min-width": "220",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "用户",
      "min-width": "110",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.phone || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "产品所属部门",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.deptname || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userdeptname",
      "label": "用户所属部门",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.userdeptname || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typename",
      "label": "类型",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "usingstatusname",
      "label": "状态",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "duetime1",
      "label": "到期时间",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "operate"
        }, [_c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "分配用户授权",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconclone-more",
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "撤销用户授权",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconundo",
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.deptid) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "撤销部门授权",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconundo2",
          staticStyle: {
            "font-size": "17px"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelDepart(scope.$index, scope.row)
            }
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [3, 10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), (_vm.editFormVisible) ? _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "分配用户",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs2
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch2
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.optionsSouch2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch2),
      expression: "disSouch2"
    }],
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.proName2),
      callback: function($$v) {
        _vm.proName2 = $$v
      },
      expression: "proName2"
    }
  }), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fpTypes2),
      expression: "fpTypes2"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.fpType),
      callback: function($$v) {
        _vm.fpType = $$v
      },
      expression: "fpType"
    }
  }, _vm._l((_vm.fpTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.showDepart) ? _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "部门"
    },
    model: {
      value: (_vm.deptid),
      callback: function($$v) {
        _vm.deptid = $$v
      },
      expression: "deptid"
    }
  }, _vm._l((_vm.departList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.deptname,
        "value": item.id
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags2), function(tag2) {
    return _c('el-tag', {
      key: tag2,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose2(tag2)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tag2) + "\n        ")])
  }), _vm._v(" "), (_vm.dynamicTags2 != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags2
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userLoading),
      expression: "userLoading"
    }],
    ref: "userList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.userList,
      "highlight-current-row": "",
      "height": "400",
      "row-key": function (row) { return row.id; },
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "select": _vm.selectTable,
      "sort-change": _vm.handleSortChange2,
      "current-change": _vm.handleSelectionChange,
      "selection-change": _vm.handleUserSelectionChange
    }
  }, [(_vm.batchType == 0) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.checked),
            expression: "scope.row.checked"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(scope.row.checked) ? _vm._i(scope.row.checked, null) > -1 : (scope.row.checked)
          },
          on: {
            "change": [function($event) {
              var $$a = scope.row.checked,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(scope.row, "checked", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(scope.row, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(scope.row, "checked", $$c)
              }
            }, _vm.changeFun]
          }
        })]
      }
    }], null, false, 19795969)
  }) : _c('el-table-column', {
    attrs: {
      "reserve-selection": true,
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "200",
      "sortable": "deptname",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.deptname ? scope.row.deptname : '-') + "\n          ")]
      }
    }], null, false, 2631811957)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invitestatusname",
      "label": "状态",
      "min-width": "180",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,sizes, prev, pager, next",
      "current-page": _vm.pageNumber2,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize2,
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2,
      "size-change": _vm.handleSizeChange2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.batchType == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit(0)
      }
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (_vm.batchType == 1) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit(1)
      }
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.visibleDispatch) ? _c('el-dialog', {
    staticClass: "model-dispatch",
    attrs: {
      "title": "分配部门",
      "visible": _vm.visibleDispatch,
      "close-on-click-modal": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.visibleDispatch = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "-10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-form', {
    ref: "dispatchForm",
    attrs: {
      "model": _vm.dispatchForm,
      "rules": _vm.dispatchRules,
      "hide-required-asterisk": "",
      "label-position": "left"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px",
      "color": "#666",
      "font-size": "14px"
    },
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n            已选择" + _vm._s(_vm.ProductSelection.length) + "个产品授权，请选择所属部门\n          ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "deptid"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.dispatchForm.deptid),
      callback: function($$v) {
        _vm.$set(_vm.dispatchForm, "deptid", $$v)
      },
      expression: "dispatchForm.deptid"
    }
  }, _vm._l((_vm.departList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.deptname,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerCloseDispatch.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmDispatchLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmitDispatch.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-copy-lpie-census"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-account-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "155px"
          },
          attrs: {
            "placeholder": "账号 / 姓名 / 企业",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.searchName),
            callback: function($$v) {
              _vm.searchName = $$v
            },
            expression: "searchName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "placeholder": "用户类型",
            "clearable": ""
          },
          model: {
            value: (_vm.isCompanyUser),
            callback: function($$v) {
              _vm.isCompanyUser = $$v
            },
            expression: "isCompanyUser"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "个人用户",
            "value": "1"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "企业用户",
            "value": "2"
          }
        })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "开始日期"
          },
          model: {
            value: (_vm.souchs.fromtime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "fromtime", $$v)
            },
            expression: "souchs.fromtime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "结束日期"
          },
          model: {
            value: (_vm.souchs.totime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "totime", $$v)
            },
            expression: "souchs.totime"
          }
        })], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', {
          staticStyle: {
            "width": "130px"
          }
        }, [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.managerAdminuser
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "130px"
          },
          attrs: {
            "placeholder": "客户成功经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.successfulManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "130px"
          },
          attrs: {
            "placeholder": "经销商",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.agencyManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "placeholder": "是否分配",
            "clearable": ""
          },
          model: {
            value: (_vm.distributionStatus),
            callback: function($$v) {
              _vm.distributionStatus = $$v
            },
            expression: "distributionStatus"
          }
        }, _vm._l((_vm.distribution), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.addUser(1)
            }
          }
        }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.addUser(2)
            }
          }
        }, [_vm._v("批量导入")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('a', {
          attrs: {
            "href": _vm.downHref
          }
        }, [_vm._v("下载模板")])]), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('a', {
          attrs: {
            "href": _vm.downHrefExcel
          }
        }, [_vm._v("导出")])]) : _vm._e(), _vm._v(" "), _c('input', {
          ref: "clearFileModal",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "id": "uploadwxsModal",
            "name": "file",
            "accept": "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          },
          on: {
            "change": function($event) {
              return _vm.fileInputChange($event)
            }
          }
        })], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
          return _c('el-tag', {
            key: tag,
            attrs: {
              "closable": "",
              "disable-transitions": false
            },
            on: {
              "close": function($event) {
                return _vm.handleClose(tag)
              }
            }
          }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")])
        }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          on: {
            "click": _vm.delTags
          }
        }, [_vm._v("清除标签")]) : _vm._e()], 2)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          attrs: {
            "data": _vm.users,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "point",
            "label": "积分",
            "width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" " + _vm._s(scope.row.point || '-') + " ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "registertime",
            "label": "注册日期",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productTypeName",
            "label": "类型"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.productType === '1') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v(_vm._s(scope.row.productTypeName))]) : (scope.row.productType === '2') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v(_vm._s(scope.row.productTypeName))]) : _c('div', {
                staticClass: "gray"
              }, [_vm._v(_vm._s(scope.row.productTypeName))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "客户经理",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" " + _vm._s(scope.row.adminName || '-') + " ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "客户成功经理",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" " + _vm._s(scope.row.successfulManagerName || '-') + " ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "经销商",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" " + _vm._s(scope.row.agencyManagerName || '-') + " ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "是否联系过",
            "min-width": "100",
            "sortable": "hasNote",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" " + _vm._s(scope.row.hasNote == 0 ? '否' : '是') + " ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.readUser(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit0(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.canYouDel == 1) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handledel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), (_vm.editFormVisible0) ? _c('el-dialog', {
          staticClass: "model-edit model-user-box",
          attrs: {
            "width": "850px",
            "title": _vm.asTitle,
            "visible": _vm.editFormVisible0,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible0 = $event
            },
            "close": _vm.dialogClose
          }
        }, [_c('el-row', {
          attrs: {
            "gutter": 24
          }
        }, [_c('el-form', {
          ref: "editForm0",
          attrs: {
            "model": _vm.editForm0,
            "label-width": "100px",
            "rules": _vm.rules
          }
        }, [(_vm.modalType != 2) ? _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "账号",
            "prop": "phone"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入邮箱"
          },
          model: {
            value: (_vm.editForm0.phone),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "phone", $$v)
            },
            expression: "editForm0.phone"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.modalType != 2) ? _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm0.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "name", $$v)
            },
            expression: "editForm0.name"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "软件类型",
            "prop": "code"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          model: {
            value: (_vm.editForm0.code),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "code", $$v)
            },
            expression: "editForm0.code"
          }
        }, _vm._l((_vm.yhlx), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户类型",
            "prop": "userType"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          on: {
            "change": function (val) { return _vm.handerChange(val, 'addCode'); }
          },
          model: {
            value: (_vm.editForm0.userType),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "userType", $$v)
            },
            expression: "editForm0.userType"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "个人用户",
            "value": "0"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "企业用户",
            "value": "1"
          }
        })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户经理"
          }
        }, [_c('SelectCommon', {
          key: _vm.curCompanyId || _vm.addCode == 0,
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "disabled": _vm.addCode == 1 || (_vm.addCode == 0 && _vm.userInfo.type != 1),
            "selectFirst": _vm.addCode == 1 && _vm.editForm0.companyuseid != '',
            "defaultVal": _vm.addCode == 0 && _vm.editForm0.managerAdminuser ? _vm.editForm0.managerAdminuser : '',
            "params": {
              ComId: _vm.addCode == 1 ? _vm.editForm0.companyuseid : ''
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户成功经理"
          }
        }, [_c('SelectCommon', {
          key: _vm.curCompanyId || _vm.addCode == 0,
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": true,
            "apiPath": _vm.addCode == 1 ? '/tbAdminuser/getAdminUserByComId' : '/tbAdminuser/list',
            "params": _vm.addCode == 1 ? {
              userType: 3,
              ComId: _vm.addCode == 1 ? _vm.editForm0.companyuseid : ''
            } : {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "disabled": _vm.addCode == 1 || (_vm.addCode == 0 && _vm.userInfo.type != 1),
            "selectFirst": _vm.addCode == 1 && _vm.editForm0.companyuseid != '',
            "defaultVal": _vm.addCode == 0 && _vm.editForm0.successfulManager ? _vm.editForm0.successfulManager : ''
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'successfulManager'); }
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "经销商"
          }
        }, [_c('SelectCommon', {
          key: _vm.curCompanyId || _vm.addCode == 0,
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": true,
            "apiPath": _vm.addCode == 1 ? '/tbAdminuser/getAdminUserByComId' : '/tbAdminuser/list',
            "params": _vm.addCode == 1 ? {
              userType: 4,
              ComId: _vm.addCode == 1 ? _vm.editForm0.companyuseid : ''
            } : {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "disabled": _vm.addCode == 1 || (_vm.addCode == 0 && _vm.userInfo.type != 1),
            "selectFirst": _vm.addCode == 1 && _vm.editForm0.companyuseid != '',
            "defaultVal": _vm.addCode == 0 && _vm.editForm0.agencyManager ? _vm.editForm0.agencyManager : ''
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'agencyManager'); }
          }
        })], 1)], 1), _vm._v(" "), (_vm.addCode == 0) ? _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "所属企业",
            "prop": "company"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm0.company),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "company", $$v)
            },
            expression: "editForm0.company"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addCode == 1) ? _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "所属企业",
            "prop": "companyuseid"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": ""
          },
          on: {
            "change": function (val) { return _vm.handerChange(val, 'curCompanyId'); }
          },
          model: {
            value: (_vm.editForm0.companyuseid),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "companyuseid", $$v)
            },
            expression: "editForm0.companyuseid"
          }
        }, _vm._l((_vm.companyList), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.editForm0.userType && _vm.editForm0.userType == '1' && _vm.modalType == '2'),
            expression: "editForm0.userType && editForm0.userType == '1' && modalType == '2'"
          }],
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "部门"
          }
        }, [_c('el-select', {
          staticClass: "souch_change souch_input",
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "placeholder": "部门",
            "clearable": ""
          },
          model: {
            value: (_vm.deptId),
            callback: function($$v) {
              _vm.deptId = $$v
            },
            expression: "deptId"
          }
        }, _vm._l((_vm.detpList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.deptname,
              "value": item.id
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户地址",
            "prop": "longitudeAndLatitude"
          }
        }, [_c('GisCommon', {
          ref: "GisCommon",
          attrs: {
            "selected": _vm.editForm0.selected,
            "address": _vm.editForm0.address
          },
          on: {
            "backPram": _vm.backPram
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户密码",
            "prop": "passwordMo"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm0.passwordMo),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "passwordMo", $$v)
            },
            expression: "editForm0.passwordMo"
          }
        })], 1)], 1), _vm._v(" "), (_vm.modalType == 2) ? _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "文件",
            "prop": "fileUploadName"
          }
        }, [_c('el-button', {
          staticStyle: {
            "padding-left": "0",
            "padding-right": "0"
          },
          attrs: {
            "type": "primary"
          }
        }, [_c('label', {
          staticStyle: {
            "padding": "12px 20px",
            "cursor": "pointer"
          },
          attrs: {
            "for": "uploadwxsModal"
          }
        }, [_vm._v("选择文件")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.fileUploadName))])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              return _vm.cancelHandler.apply(null, arguments)
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), (_vm.modalType != 2) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading0
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit0('editForm0')
            }
          }
        }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (_vm.modalType == 2) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading0
          },
          nativeOn: {
            "click": function($event) {
              return _vm.importFile('editForm0')
            }
          }
        }, [_vm._v("提交")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "试用模块",
            "prop": "title"
          }
        }, [_c('div', {
          staticStyle: {
            "background": "rgb(244, 255, 243)",
            "width": "90%",
            "height": "300px",
            "overflow": "auto",
            "border": "1px solid #dfe6ec"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange
          },
          model: {
            value: (_vm.editForm.checkedCities),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "checkedCities", $$v)
            },
            expression: "editForm.checkedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticStyle: {
              "float": "left",
              "clear": "left",
              "margin-left": "20px",
              "position": "relative",
              "top": "0px"
            },
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "试用期限",
            "prop": "origin"
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.editForm.value),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "value", $$v)
            },
            expression: "editForm.value"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "审批",
            "visible": _vm.appFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.appFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "appForm",
          attrs: {
            "model": _vm.appForm,
            "label-width": "80px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "试用模块",
            "prop": "title"
          }
        }, [_c('div', {
          staticStyle: {
            "background": "rgb(244, 255, 243)",
            "width": "90%",
            "height": "300px",
            "overflow": "auto"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange
          },
          model: {
            value: (_vm.appForm.checkedCities),
            callback: function($$v) {
              _vm.$set(_vm.appForm, "checkedCities", $$v)
            },
            expression: "appForm.checkedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticStyle: {
              "float": "left",
              "clear": "left",
              "margin-left": "20px",
              "position": "relative",
              "top": "0px"
            },
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "试用期限",
            "prop": "origin"
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.appForm.value),
            callback: function($$v) {
              _vm.$set(_vm.appForm, "value", $$v)
            },
            expression: "appForm.value"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.appLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.appSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("通过")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "loading": _vm.falseLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.falseSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("驳回")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticStyle: {
      "min-width": "1023px"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "border": "1px solid #dfe6ec"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch),
      expression: "disSouch"
    }],
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList(1)
      }
    },
    model: {
      value: (_vm.proName),
      callback: function($$v) {
        _vm.proName = $$v
      },
      expression: "proName"
    }
  }), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disType),
      expression: "disType"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.typeValue),
      callback: function($$v) {
        _vm.typeValue = $$v
      },
      expression: "typeValue"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disAccountType),
      expression: "disAccountType"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.accountType),
      callback: function($$v) {
        _vm.accountType = $$v
      },
      expression: "accountType"
    }
  }, _vm._l((_vm.accountTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disTime1),
      expression: "disTime1"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "申请日期"
    },
    model: {
      value: (_vm.souchs.application_time),
      callback: function($$v) {
        _vm.$set(_vm.souchs, "application_time", $$v)
      },
      expression: "souchs.application_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.getList(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.exportExlsx()
      }
    }
  }, [_vm._v("批量导出")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v(" \n          " + _vm._s(tag) + " \n      ")])
  }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "selection-change": _vm.selsChange,
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "手机号",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "姓名",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "org_name",
      "label": "企业",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activity_name",
      "label": "兑换礼品",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "exchange_count",
      "label": "兑换数量",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "application_time",
      "min-width": "120",
      "label": "申请日期",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row, 1)
            }
          }
        }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "plain": "",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row, 2)
            }
          }
        }, [_vm._v("驳回申请")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', [_vm._v("已通过")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticStyle: {
            "color": "#F66B3D"
          }
        }, [_vm._v("已驳回申请")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "border": "1px solid #dfe6ec",
      "margin-top": "0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "sizes, prev, pager, next",
      "page-sizes": [10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('div', {
    staticClass: "ft"
  }, [_c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])])
}]}

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "model-depart-form-view",
    attrs: {
      "width": "850px",
      "title": "部门详情",
      "visible": _vm.myVisible,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.handerClose
    }
  }, [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticClass: "toolbar",
    staticStyle: {
      "margin-bottom": "-10px"
    }
  }, [(_vm.departDetail) ? _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门名称："
    }
  }, [_vm._v(" " + _vm._s(_vm.departDetail.deptname || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门管理员："
    }
  }, [_vm._v(_vm._s(_vm.departDetail.deptManagerName || '-') + " ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("部门人员(" + _vm._s(_vm.departDetail.userList.length) + ")")]), _vm._v(" "), _c('el-table', {
    ref: "companyRef",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.departDetail.userList,
      "highlight-current-row": "",
      "height": 500
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "账号",
      "width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "软件类型",
      "width": "140",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isRouterAlive) ? _c('router-view') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-copy-l"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "legend"
    }
  }, [_vm._l((_vm.firstLabelList), function(p, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('div', {
      class: 'value' + index
    }, [_vm._v(_vm._s(p.value))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._l((_vm.secondLabelList), function(p, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('div', {
      class: 'second' + index
    }, [_vm._v(_vm._s(p.value))])])
  })], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.registerCount
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "charts-box-copy-lbar"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[937]);


// WEBPACK FOOTER //
// static/js/app.78ae4d6a280b73827726.js